webpackJsonp([1],{

/***/ 1189:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1190:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1191:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1192:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1193:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1194:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1195:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1196:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1197:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1198:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1199:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1200:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1201:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1202:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1203:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1204:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1205:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1206:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1207:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1208:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1209:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1210:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1211:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1207)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(660),
  /* template */
  __webpack_require__(1278),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7b8ca8fe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1225:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 429,
	"./af.js": 429,
	"./ar": 437,
	"./ar-dz": 430,
	"./ar-dz.js": 430,
	"./ar-kw": 431,
	"./ar-kw.js": 431,
	"./ar-ly": 432,
	"./ar-ly.js": 432,
	"./ar-ma": 433,
	"./ar-ma.js": 433,
	"./ar-ps": 434,
	"./ar-ps.js": 434,
	"./ar-sa": 435,
	"./ar-sa.js": 435,
	"./ar-tn": 436,
	"./ar-tn.js": 436,
	"./ar.js": 437,
	"./az": 438,
	"./az.js": 438,
	"./be": 439,
	"./be.js": 439,
	"./bg": 440,
	"./bg.js": 440,
	"./bm": 441,
	"./bm.js": 441,
	"./bn": 443,
	"./bn-bd": 442,
	"./bn-bd.js": 442,
	"./bn.js": 443,
	"./bo": 444,
	"./bo.js": 444,
	"./br": 445,
	"./br.js": 445,
	"./bs": 446,
	"./bs.js": 446,
	"./ca": 447,
	"./ca.js": 447,
	"./cs": 448,
	"./cs.js": 448,
	"./cv": 449,
	"./cv.js": 449,
	"./cy": 450,
	"./cy.js": 450,
	"./da": 451,
	"./da.js": 451,
	"./de": 454,
	"./de-at": 452,
	"./de-at.js": 452,
	"./de-ch": 453,
	"./de-ch.js": 453,
	"./de.js": 454,
	"./dv": 455,
	"./dv.js": 455,
	"./el": 456,
	"./el.js": 456,
	"./en-au": 457,
	"./en-au.js": 457,
	"./en-ca": 458,
	"./en-ca.js": 458,
	"./en-gb": 459,
	"./en-gb.js": 459,
	"./en-ie": 460,
	"./en-ie.js": 460,
	"./en-il": 461,
	"./en-il.js": 461,
	"./en-in": 462,
	"./en-in.js": 462,
	"./en-nz": 463,
	"./en-nz.js": 463,
	"./en-sg": 464,
	"./en-sg.js": 464,
	"./eo": 465,
	"./eo.js": 465,
	"./es": 469,
	"./es-do": 466,
	"./es-do.js": 466,
	"./es-mx": 467,
	"./es-mx.js": 467,
	"./es-us": 468,
	"./es-us.js": 468,
	"./es.js": 469,
	"./et": 470,
	"./et.js": 470,
	"./eu": 471,
	"./eu.js": 471,
	"./fa": 472,
	"./fa.js": 472,
	"./fi": 473,
	"./fi.js": 473,
	"./fil": 474,
	"./fil.js": 474,
	"./fo": 475,
	"./fo.js": 475,
	"./fr": 478,
	"./fr-ca": 476,
	"./fr-ca.js": 476,
	"./fr-ch": 477,
	"./fr-ch.js": 477,
	"./fr.js": 478,
	"./fy": 479,
	"./fy.js": 479,
	"./ga": 480,
	"./ga.js": 480,
	"./gd": 481,
	"./gd.js": 481,
	"./gl": 482,
	"./gl.js": 482,
	"./gom-deva": 483,
	"./gom-deva.js": 483,
	"./gom-latn": 484,
	"./gom-latn.js": 484,
	"./gu": 485,
	"./gu.js": 485,
	"./he": 486,
	"./he.js": 486,
	"./hi": 487,
	"./hi.js": 487,
	"./hr": 488,
	"./hr.js": 488,
	"./hu": 489,
	"./hu.js": 489,
	"./hy-am": 490,
	"./hy-am.js": 490,
	"./id": 491,
	"./id.js": 491,
	"./is": 492,
	"./is.js": 492,
	"./it": 494,
	"./it-ch": 493,
	"./it-ch.js": 493,
	"./it.js": 494,
	"./ja": 495,
	"./ja.js": 495,
	"./jv": 496,
	"./jv.js": 496,
	"./ka": 497,
	"./ka.js": 497,
	"./kk": 498,
	"./kk.js": 498,
	"./km": 499,
	"./km.js": 499,
	"./kn": 500,
	"./kn.js": 500,
	"./ko": 501,
	"./ko.js": 501,
	"./ku": 503,
	"./ku-kmr": 502,
	"./ku-kmr.js": 502,
	"./ku.js": 503,
	"./ky": 504,
	"./ky.js": 504,
	"./lb": 505,
	"./lb.js": 505,
	"./lo": 506,
	"./lo.js": 506,
	"./lt": 507,
	"./lt.js": 507,
	"./lv": 508,
	"./lv.js": 508,
	"./me": 509,
	"./me.js": 509,
	"./mi": 510,
	"./mi.js": 510,
	"./mk": 511,
	"./mk.js": 511,
	"./ml": 512,
	"./ml.js": 512,
	"./mn": 513,
	"./mn.js": 513,
	"./mr": 514,
	"./mr.js": 514,
	"./ms": 516,
	"./ms-my": 515,
	"./ms-my.js": 515,
	"./ms.js": 516,
	"./mt": 517,
	"./mt.js": 517,
	"./my": 518,
	"./my.js": 518,
	"./nb": 519,
	"./nb.js": 519,
	"./ne": 520,
	"./ne.js": 520,
	"./nl": 522,
	"./nl-be": 521,
	"./nl-be.js": 521,
	"./nl.js": 522,
	"./nn": 523,
	"./nn.js": 523,
	"./oc-lnc": 524,
	"./oc-lnc.js": 524,
	"./pa-in": 525,
	"./pa-in.js": 525,
	"./pl": 526,
	"./pl.js": 526,
	"./pt": 528,
	"./pt-br": 527,
	"./pt-br.js": 527,
	"./pt.js": 528,
	"./ro": 529,
	"./ro.js": 529,
	"./ru": 530,
	"./ru.js": 530,
	"./sd": 531,
	"./sd.js": 531,
	"./se": 532,
	"./se.js": 532,
	"./si": 533,
	"./si.js": 533,
	"./sk": 534,
	"./sk.js": 534,
	"./sl": 535,
	"./sl.js": 535,
	"./sq": 536,
	"./sq.js": 536,
	"./sr": 538,
	"./sr-cyrl": 537,
	"./sr-cyrl.js": 537,
	"./sr.js": 538,
	"./ss": 539,
	"./ss.js": 539,
	"./sv": 540,
	"./sv.js": 540,
	"./sw": 541,
	"./sw.js": 541,
	"./ta": 542,
	"./ta.js": 542,
	"./te": 543,
	"./te.js": 543,
	"./tet": 544,
	"./tet.js": 544,
	"./tg": 545,
	"./tg.js": 545,
	"./th": 546,
	"./th.js": 546,
	"./tk": 547,
	"./tk.js": 547,
	"./tl-ph": 548,
	"./tl-ph.js": 548,
	"./tlh": 549,
	"./tlh.js": 549,
	"./tr": 550,
	"./tr.js": 550,
	"./tzl": 551,
	"./tzl.js": 551,
	"./tzm": 553,
	"./tzm-latn": 552,
	"./tzm-latn.js": 552,
	"./tzm.js": 553,
	"./ug-cn": 554,
	"./ug-cn.js": 554,
	"./uk": 555,
	"./uk.js": 555,
	"./ur": 556,
	"./ur.js": 556,
	"./uz": 558,
	"./uz-latn": 557,
	"./uz-latn.js": 557,
	"./uz.js": 558,
	"./vi": 559,
	"./vi.js": 559,
	"./x-pseudo": 560,
	"./x-pseudo.js": 560,
	"./yo": 561,
	"./yo.js": 561,
	"./zh-cn": 274,
	"./zh-cn.js": 274,
	"./zh-hk": 562,
	"./zh-hk.js": 562,
	"./zh-mo": 563,
	"./zh-mo.js": 563,
	"./zh-tw": 564,
	"./zh-tw.js": 564
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1225;

/***/ }),

/***/ 1236:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1237:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIwAAAAoCAYAAAAsTRLGAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTMyIDc5LjE1OTI4NCwgMjAxNi8wNC8xOS0xMzoxMzo0MCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0N2M2ZTM2Yy0xNTM1LTQwNDctYTEyYS00ZTdjMGYzMjQ0ZGEiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MjhCNjk1QkIwMjFBMTFFNzhGOTk5OEJBRDJBQzA3MzYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MjhCNjk1QkEwMjFBMTFFNzhGOTk5OEJBRDJBQzA3MzYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUuNSAoV2luZG93cykiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpmMzExZDE1Zi0xZmZmLTBhNDQtOGNjMC0xYmEwODAzYjMzZGQiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NDdjNmUzNmMtMTUzNS00MDQ3LWExMmEtNGU3YzBmMzI0NGRhIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+prfqSAAAEXNJREFUeNrsnAd0VVUWhu97aYRgKBIQEKwgYkcUxYIglkEUcaGoICiKKLYZHeuMin0cFBgY2wiiDpaxMIINRUQNzCjFgtQAkRIpEgkEMP292Ue/s9ge730leWuWuHLW+ldy7z331H32/vc+575QNBr1kkgZgm6C0wVHCJoJqgSfC54RfE2+PMFgwRmCXMFOwTLBfwT5grVefdotUygJgekuuEZwjiDL57kRiN6CbwTPCy4JKGerYLLgMd6pT7tRSk8gTwPBbYKbBQ1j5OsouAUtMyAgz0zBx4L2ghMFKwQ19dPw29EwewlGCy5KQV33C+7k//0EzQWLBT/UT8NvQ2CaYVrOSkE9ht9cjkm73dQrKBYUCF4VvCGorJ+OXfMiiO5uAjOBSa5rMgT3JEFPwSSf58YkvSa4R7C0joMcFkR+rYOdQDLtT8ORCEpp9C9SyzrSGKtqn/sZ1G3rqEqUw4wQDE3RIHxC5cNjdMBwnmME1wveTqLsIwXXog1NOS8LXlLPuwqu4FkNHCysBjsEVvLekiTqPoW6t9O/jYJHBFuSHJ8+amEW4wx86QjR9dRn2looeEjwXYLlNxb8UXA4QrJD8KhgoZPPtOFiQZmgqeBdaERNPIHpBMENpUhgjMvdAlIcK+0v+BeC9UKCZQ9Wg71N8KTz/CjBpQmS+56UtQzBugJyvkmZCDPgFYQJBgpOVu8bLpaNRs1SYQg7jubeB4JZjLER5hLGuht5tuMImHrbMh5GYG4Q7EueGYJynJEsFkMlguCXDKW4lbaYNB9P9kzBsSoscgSesE1GcEa5HNNvIAeoxqUimZW3B4MZL+WwwtYzsLFSG1adTeuYnNME7Yj5bKLDueSZgjA2Y9LN/ZuYoG6Q+7t5bgTmMN6LgDRl7sJOe4yQ/Z58IWUa05zFN4v41GhVtk1mnB5W16b9awR7qnsHwfsaI3BZCMsjaHM/gbHCUkW+RoKxlOWhwb5ESOw8bfBzSNKV2uqIOu2WQmGpYeU3DojdBKnQx1DVhTHyXYAGselQx5zNEYwRrCJfhAGd4qNR2/O/XSibBU/z7HtBqeAEYlDxNK8VpC30oxRv0wjP+0rrTkZDteNeBe3fzmKwwc5BCJKHhsumPyEE29bXFIEvUm3phnDatBCtNUwJSwntORmtZZNZTK0pvzFCt8EKzIWCLqigvVIoMFHUZcMk3zuY2M/wGATWCGM+GqyKjoW53xYbbOpuoiayF8LQmkmYzLVNlWryxjtC0F5dG/7wlaAzqz+KYBqh7KAG3MSdZvu0/WMEeqoSmKmYOU1GT0JgbJqM2a1kId6iuGFbhKaIMs183uFop6eU9tQL9Fn+hhwT/ZEgE+T8qJXES8oV5AtGC7IEK6KpS9WCPoL+tXz3TOPF1QFDBOUx6jB9vlFQxvXTAeWcLChR7z0jOFFQqO69JbjDKf9VQYOAMvsJKshXKTjDJ8+jqqydgkOd531516QlgjaCbMFUn77OF/QQTHfu76DsoDmoVtej0lFvJ7JqKlgVB6bQTWxQSwKdhgmYGeBmXsgq2MyKCyly2hYOs4XneyvCNxOtYwKH0wXHOao4yPw1Udev0Ka26p5ZyW8KeqDJPMyB8eQ+9QkBDGTlWmpg+tOXMkeiOfurd2bAZw7HvC/BmchQnC6X9xYIDhHso2jHHLSveX81eVcSzjBlPYCXpLnWHbyTQz3L01F7Jp0H4b2KARySogBURh2CcqfQ6ZU+3GuEartf6oz7uR6BiaDS/+bk6xWnDa0c7+EbVHVfx2kwJs5si7ynyjT3evsITCc8FO2RDFZ85CNMzyeYc0Nqn8DbuZzJNgJwH9HzYxCCHUzwvfClV5RQmwWySHC8MjEbINae98t9vUKfdv/Y4SPU9URW6KU0sDMrqyEIKY8hA5vZgHJakb8BIf9CWPYXDjlNlssc6iMwxs7/CYEapgalkJWSxjtN2Iaw2m5/OEYefdiutI+r3bry92wnJJCPW9vKeacBk5BPvxsqr/NrvLg1TNIFqs1LiHRf4misnYprVKL1zXVLFYlfRn1Z9Edr4lLHA8vh+ZoYHqpOzRGsSldgWjgvvYjATEG1baTxnvL9w7DrnZRhg2LD0AijaVg6g9e9DloqL+C+Gai5CI0daBMpfk4FmwYrl9pDew5GECwpz3G0hAfxHyc4GuFMV5rgTUVqdcpkLBegZfpxvwOarRoiPxEKYJNxZ5c7Zrs1wl6pXNsjWaA2vasIe4XP+GQ7oYwan1BAPIcl4qdhyn1W1++8n868GCndiqqrQqukMaBvsTe0Qw3mX+l4jeN1hOsgMNsCNMC5cJhOjqq/i4Gdx7vF2HePifmCyW2IoNUwBlmoebu6Z/P+ap7noimswHxAnMZGetej3quJpVQyJjvQRu1YZOX89RQV6ENsxE7UjWAUnpBJBzgmsAvBt1kBAhNNcouk0mfcq/0E5jOEw29SmjpS7ZqLxk6EMWh/I7uWwrIAouo3GIMhxTrth8BY13Ucq9AKzExWeSdW7hraVsZEhlTUdiauc7EajwiaIxuhesEJ5PVjTLfzLA3hXElZdtXejylshUC2UxrLbsxWslhtaq8WXhRh6YXJnJ7AWFbRth6UtYNFUkWs6XCf+T2X9uTSj43GNesgmFsLt3eNj5vnB+OqP1WL8o2rd36Mck8RPCBYp95ZJhgmuE1wNtionleSx7jIXwr2oawcwVDccHPdVrCYd8riuOZBqZI+1AiKBMOd9jcWHCjIEFyGe2uTaX9YsAd5mwrmBNQzNmB8Ojt9nyhoL5hXhzBJsZG4AkzQ3WymJeoCm1VxNRtbZXE215I9T/MZLl6sSO9HeBHdFHE1K3mCWvVDlDtcAh/rwMpvAomcSWi8H9rsOUXsLW+Loo12Ysoiyo13NV8ZK3k/RXzbsOFXiHtsVb41t0WYlRzMwEZFyq05ahcwDj3gjWvijGkGmjOf/pepMEQVWqe1yr+VyHAETWQ0zAprE7/HvkcUIUwktUhgY6/ai71dHxSDSSQ63Mohn7mY0C1KDduJLydUfxouscfej96Ye0uRSM3t1iL0Nn4RiRFGKGOiL4bT5ai9puMRmFZMdCVeUy/FYdIh8hsRsAI8pGaKvEbIF8KUnJSAwDSiXbdCJcqVmd1OW2924j4DlWPwo5Cl05AxuHXJBNg2E9PYHiefYfMvQZATTV1Y7UPx2oJSukOow861PhuTCzeYoQSmEcR+Gm2crgRWl1OOW7wBJJIehyvpfltyarzQB1UbXW01BExiDFqrBWQE43n4xZHc607MJV68K8QiKvZ55jo/FWqhb9MDPgQCmWwqZCs+Efa9uhblZ+EhzPWJwwR5Aq4rqCfCRpxnOnGSsZDQqjhtaeZs7CWSljpts3UUKC9uPXGeY1RblzNms9TGqk3FLNQ8JTCnYlIWx3GTY6UGPpvAWa4HZllzbVKFj7scCmjcOsxEBSaqUnlPOcDPtB1BLGRlgm2qclzBkI/XZ13rExQXC8cZYLtjm5OAqQxjlkodTuApc282Gj/EvJSyaB9XZRse9gj/7+0EV6vhFwsc77BrAgITS2giPpu7vnGYJrUUmGoVb8lkcvqzUp4kCplBnmkEqDJVMCqKmWhGBLYHBLm5U88eCexVadfzGt5ZgADpMx4DUN1TlcCcjzouxfV9kYnVArw3Lnqp2v+JpfZrqLeTcz9LjV2JMw/pjhaxZ2MOdsrZpkIOm1Tk15jZf6tys5yxyY7DT/fwifz+4rhouuPrJ5N20vHLsaGNmIQWXH+Nr18Nzyl1OEaNijUYDXIdgarn0SpW6jfFIcdhZ2ItN/iEqOpmRRi7wwkMX/kD5DOHCLBJryMwmd7Pz++Elfqvy75adgzBr6TeKrSx8eaG8+wHtHNIxaUW4ykO4N0T2IL50McERrz4n/NUk6+adpT7ad50Kj67FgNgDwtf6Wyk2TB2sgM8F+E7gyhrRzjA4jjEexSqf6dq175wrI8ZuL35uydlF7Ex2Q4Okc4Ky6eM7zAR+/A86tXtyGoYcxN0ivB9XPwMNRY/QI6jLLxM/p+rFtztOBWWHmxw+NO1lBmhz7EclImUXUVbV3h+nwBx5qQ2aYqgueCdFJ6fWUGgrx/XEwhsefX4dSDMiptWy1Xj97lCXdKBqNivuJ6dQAwnMwZxTSY1dGI6mXCrnIC8HX02IN3Ukj75Efo2MYJxiY5/OAV5kq7UqLunveS/5bEubJmX2hQmEDWbDb5YyZjS/yJg5sCUPcV/LxHoCzEtdj/MBKZugkj+3fvpOIbH/tNras/paMyZiXR+6v38bNAJ8KOF1D04wFyNgOgbcvqy9/Ojm+boyCKeP66CdpcSC5oHr5uEYI7GXD5F3W9AhB+lP3YsTFkHMYZj8bTsvLbG+7rNcZ3vJbL+FWVfojZFzRh8Th9m/xhQVOpmbJLm4yX2Ol5PoUkqxxwdyrHIWOrxHPKb46VXC2YLCgRHCT7k/iuUezum7l3BNPZuzH7S8YKr2PcZSbnHsX9UwP7SePaCepM/Sl2m/te4vsZp25Xc/wfHUxdhXvcUvMHRzJsE1wm2cM/s8yxlb+zPgn8K7hEcTvvN3lcEs32fII/+LOUY6GTqvIh3THpMtckeHzX1Hcu9npS5kP6bsVkvOIv2mvQwe3ZmL6qLVpV3s/JOT1AT2AM6TVOoXYoguQUJ5L2V/P3xpD5HM9j9kXJv1+e4Q1m5czEzJbin4/CUBuCShim3nP21VWidAvo6gm2CCyDD04Ahn296u37GJKpMUhFemKmvN+6vIffPqHF8kvrXYb6WQLzf4O9CSOwTBBmfU7vv9xLKqIaoGpJrz9tM5m9T+jOG0MPFjIXdXviAcvoT82nIs+/Il4W2Wxl2/PthAccJ/NIWPIu8FArMlASFZU8meh7CcjR7Ida9L8ZUNsBNno67vQ9u/FaedYSjhNRWwf4E91bx/6Oo+zaEDD5HWDwVlW3pLJxJCFU6ZmIUdTdlnBepvPNprzFV38JrLsVbzPYJvGnOOJv+X4/XNA7XehDtnK8iwYeR337E5tGPEup729v11eVU4nNmjHpihqs9H0K0Ftv1bgKTtpxd1FYpEpZ5rIBE0vcMRh/2nRbQZjNJx6ld5TyEaxyTPYTJacVg9KfO5xnUUrhQVwa1ELvfhU2+OWhgG0ZoTr5ljks7CB42EJ70LeXYTdXzVN6B8ItNTKrhE+acz2Xez394yR6T1ST8U9rbn7JnoUmORwtVKX7TGL5zFkS8J+NkBOMdON+LPOsE6Tf7VuYg+I3EerKD+EGm4C7B1gCu8RmfpzyUIu5SLDg1SRfvED7zMHzjOc70lMINjKv/qWCG4G34y+nUNUZwiaCKzy5MWbPoa3vOnnxB3mfhatvgI234nGMLn4Csgo+4n4hcxPsrGcevBW8KGgnu5Nk0xbEe5AzOTj5N8evvIJ7f4Nwfrs7QNGVuDA85mOf2E5/x8MK+8CBTzwHwwJHqc5rvGJ+HeW8h/Gmt4XFpI0eO9FvBNTDkfNRgNtKaiTq9AFs5Pk7oPpFUTtR1SpLvbcaG202491D9i1gZ+azABWiAtdxfiEewiedb6Gs2/Z6Px9QQDWbe/wsa1fz/Kns355B3kLfraKdNizCDnTlO8R4ruIS836IJ8vDQHiGoto22FASMUxGR3E3OPl0J9a1Gg2oPsw3PH4QfLicKn4vZ2kA/CpnrzXhLq9S+1Wa8to8S+cky+9VfDiSoiEiqOTtySB2FpRQ1OaGO5aSnIB4UQq3rcjLUJpzd+Y6oZ9EE6rXHICM+8aOol/xZoWT7FLRTHUpwF/sXAx0v2c8XLoMkhSBZLX3yTsce3uWzieimhWiWD1MwMKkIHvpNflWM3d5EJ7oi4P7/4weUorV8VieBsR6RYddXe8FfRZbiUXyA5gn6PZhNBKCMi7jRq0+7VUrmVzStV9AVhn20t+tD7+XEEqzdbEas4VxcyTL4wxzct/pfz9xN0/8EGADLm+PPwQE73gAAAABJRU5ErkJggg=="

/***/ }),

/***/ 1238:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1239:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1240:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1241:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1242:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1243:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1244:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1261:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1205)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(646),
  /* template */
  __webpack_require__(1276),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1262:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1203)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(647),
  /* template */
  __webpack_require__(1273),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-457260f4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1263:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(648),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1264:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(650),
  /* template */
  __webpack_require__(1269),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1265:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1210)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(659),
  /* template */
  __webpack_require__(1282),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1266:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1211)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(663),
  /* template */
  __webpack_require__(1283),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e97ee572",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1267:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-row', {
    staticStyle: {
      "width": "70%",
      "margin": "0 auto"
    }
  }, [_c('el-row', [_c('el-row', [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": "/MyBill",
      "mode": "horizontal",
      "background-color": "#545c64",
      "text-color": "#fff",
      "active-text-color": "#ffd04b"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/MyBill"
    }
  }, [_vm._v("新生缴费")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/MyBillHistory"
    }
  }, [_vm._v("新生缴费历史")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/Print"
    }
  }, [_vm._v("打印报到单")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/OfflinePay"
    }
  }, [_vm._v("线下审核")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/Exit"
    }
  }, [_vm._v("退出")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), (_vm.tipText !== '') ? _c('div', {
    staticClass: "notice"
  }, [_c('van-notice-bar', {
    attrs: {
      "left-icon": "volume-o",
      "text": _vm.tipText
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.infoVisible),
      expression: "infoVisible"
    }],
    staticClass: "back-up",
    staticStyle: {
      "background-color": "#fff"
    }
  }, [_c('mt-button', {
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }, [_vm._v("提示")]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "height": "60px",
      "text-align": "center",
      "margin-top": "30px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v(_vm._s(_vm.termMsg))])])], 1), _vm._v(" "), _c('el-row', [_c('BigImg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showImg),
      expression: "showImg"
    }],
    staticStyle: {
      "z-index": "1001"
    },
    attrs: {
      "imgSrc": _vm.imgSrc
    },
    on: {
      "click": function($event) {
        return _vm.viewImg()
      }
    }
  })], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chooseDormVisible),
      expression: "chooseDormVisible"
    }]
  }, [_c('el-row', {
    staticStyle: {
      "background-color": "#fff"
    }
  }, [_c('el-row', {
    staticStyle: {
      "background-color": "#fff",
      "text-align": "center"
    }
  }, [_c('el-form', {
    ref: "dormSetForm",
    staticStyle: {
      "width": "50%",
      "background-color": "#fff",
      "margin": "auto"
    },
    attrs: {
      "model": _vm.dormSetForm,
      "label-width": "90px"
    }
  }, [_c('el-row', [_c('img', {
    staticClass: "banner-img",
    staticStyle: {
      "width": "50%",
      "height": "150px",
      "float": "left"
    },
    attrs: {
      "src": _vm.effectDrawing
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "banner-img",
    staticStyle: {
      "width": "50%",
      "height": "150px",
      "float": "right"
    },
    attrs: {
      "src": _vm.bedDiagram
    }
  })]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item1",
    attrs: {
      "label": "收费标准"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSetForm.price))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item1",
    attrs: {
      "label": "规格"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSetForm.dormStandard))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item1",
    attrs: {
      "label": "宿舍配置"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSetForm.roomSet))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item1",
    attrs: {
      "label": "公共配置"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSetForm.pubAreaSet))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item1",
    attrs: {
      "label": "所在区域"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSetForm.region))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item1",
    attrs: {
      "label": "备注"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSetForm.remark))])])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "background-color": "#fff",
      "text-align": "center"
    }
  }, [_c('el-form', {
    ref: "dormChooseForm",
    staticStyle: {
      "width": "50%",
      "background-color": "#fff",
      "margin": "auto"
    },
    attrs: {
      "inline": _vm.global.editInline,
      "model": _vm.dormChooseForm,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "公寓"
    }
  }, [_c('el-select', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "== 请选择 ==",
      "disabled": _vm.getDisableEdit('flatsName', 'form')
    },
    model: {
      value: (_vm.dormChooseForm['flatsName']),
      callback: function($$v) {
        _vm.$set(_vm.dormChooseForm, 'flatsName', $$v)
      },
      expression: "dormChooseForm['flatsName']"
    }
  }, _vm._l((_vm.modeSelector('Flats')), function(option) {
    return _c('el-option', {
      key: option.modeId,
      attrs: {
        "label": option.modeName,
        "value": option.modeId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "宿舍类型"
    }
  }, [_c('el-select', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "== 请选择 ==",
      "disabled": _vm.getDisableEdit('dormSet', 'form')
    },
    model: {
      value: (_vm.dormChooseForm['dormSet']),
      callback: function($$v) {
        _vm.$set(_vm.dormChooseForm, 'dormSet', $$v)
      },
      expression: "dormChooseForm['dormSet']"
    }
  }, _vm._l((_vm.modeSelector('Dorm_Set')), function(option) {
    return _c('el-option', {
      key: option.modeId,
      attrs: {
        "label": option.modeName,
        "value": option.modeId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "宿舍"
    }
  }, [_c('el-select', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "== 请选择 ==",
      "disabled": _vm.getDisableEdit('roomNo', 'form')
    },
    model: {
      value: (_vm.dormChooseForm['roomNo']),
      callback: function($$v) {
        _vm.$set(_vm.dormChooseForm, 'roomNo', $$v)
      },
      expression: "dormChooseForm['roomNo']"
    }
  }, _vm._l((_vm.modeSelector('Room')), function(option) {
    return _c('el-option', {
      key: option.modeId,
      attrs: {
        "label": option.modeName,
        "value": option.modeId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "床位"
    }
  }, [_c('el-select', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "== 请选择 ==",
      "disabled": _vm.getDisableEdit('bedNo', 'form')
    },
    model: {
      value: (_vm.dormChooseForm['bedNo']),
      callback: function($$v) {
        _vm.$set(_vm.dormChooseForm, 'bedNo', $$v)
      },
      expression: "dormChooseForm['bedNo']"
    }
  }, _vm._l((_vm.modeSelector('Bed')), function(option) {
    return _c('el-option', {
      key: option.modeId,
      attrs: {
        "label": option.modeName,
        "value": option.modeId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('span', {
    staticClass: "deg-title"
  }, [_vm._v("四人间床位  总计: " + _vm._s(_vm.fourBedSum) + "  剩余：" + _vm._s(_vm.fourBedRmi) + "  ")])]), _vm._v(" "), _c('el-form-item', [_c('span', {
    staticClass: "deg-title"
  }, [_vm._v("六人间床位  总计: " + _vm._s(_vm.sixBedSum) + "  剩余：" + _vm._s(_vm.sixBedRmi) + "  ")])]), _vm._v(" "), _c('el-form-item', [_c('span', {
    staticClass: "deg-title"
  }, [_vm._v("所选床位有效期20分钟 ！！！")])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.nextStep('Dorm')
      }
    }
  }, [_vm._v("下一步")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chooseDormConfigVisible),
      expression: "chooseDormConfigVisible"
    }]
  }, [_c('el-row', {
    staticClass: "form_main"
  }, [_c('el-form', {
    ref: "dormConfig",
    staticStyle: {
      "width": "80%",
      "background-color": "#fff",
      "margin": "auto"
    },
    attrs: {
      "model": _vm.curStudent,
      "label-width": "90px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    staticClass: "form-item",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "25px"
    }
  }, [_vm._v("宿舍用品选择")])]), _vm._v(" "), _c('el-checkbox-group', {
    model: {
      value: (_vm.dormConfigCheckList),
      callback: function($$v) {
        _vm.dormConfigCheckList = $$v
      },
      expression: "dormConfigCheckList"
    }
  }, _vm._l((_vm.dormConfigList), function(item) {
    return _c('el-form-item', {
      key: item.modeId,
      staticClass: "form-item"
    }, [_c('el-checkbox', {
      key: item.modeId,
      attrs: {
        "label": item.modeId
      },
      on: {
        "change": _vm.handleDormConfigChange
      }
    }, [_c('span', {
      staticClass: "label_detail"
    }, [_vm._v(_vm._s(item.modeId))]), _vm._v(" "), _c('span', {
      staticClass: "label_value",
      staticStyle: {
        "width": "85%",
        "text-overflow": "ellipsis",
        "white-space": "pre-line",
        "overflow": "hidden"
      }
    }, [_vm._v(_vm._s(item.modeValue + '元' + ' ( ' + item.modeName + ' ) '))])])], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding-top": "30px",
      "padding-left": "350px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.back('07')
      }
    }
  }, [_vm._v(">上一步")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.nextStep('DormConfig')
      }
    }
  }, [_vm._v(">下一步")])], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chooseOtherVisible),
      expression: "chooseOtherVisible"
    }],
    staticStyle: {
      "background-color": "#fff",
      "text-align": "center"
    }
  }, [_c('el-row', {
    staticClass: "back-up"
  }, [_c('img', {
    staticStyle: {
      "height": "40vh",
      "width": "35vw"
    },
    attrs: {
      "src": _vm.size_Img
    }
  })]), _vm._v(" "), _c('el-row', {
    staticClass: "form_main"
  }, [_c('el-form', {
    ref: "clothChooseForm",
    staticStyle: {
      "width": "50%",
      "background-color": "#fff",
      "margin": "auto"
    },
    attrs: {
      "inline": _vm.global.editInline,
      "model": _vm.clothChooseForm,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "衣服尺码"
    }
  }, [_c('el-select', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "== 请选择 =="
    },
    model: {
      value: (_vm.clothChooseForm['coatSize']),
      callback: function($$v) {
        _vm.$set(_vm.clothChooseForm, 'coatSize', $$v)
      },
      expression: "clothChooseForm['coatSize']"
    }
  }, _vm._l((_vm.modeSelector('XF_Coat_Size')), function(option) {
    return _c('el-option', {
      key: option.modeId,
      attrs: {
        "label": option.modeId,
        "value": option.modeId
      }
    })
  }), 1)], 1), _vm._v(" "), (false) ? _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "迷彩衫"
    }
  }, [_c('el-select', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "== 请选择 =="
    },
    model: {
      value: (_vm.clothChooseForm['shirtSize']),
      callback: function($$v) {
        _vm.$set(_vm.clothChooseForm, 'shirtSize', $$v)
      },
      expression: "clothChooseForm['shirtSize']"
    }
  }, _vm._l((_vm.modeSelector('XF_Shirt_Size')), function(option) {
    return _c('el-option', {
      key: option.modeId,
      attrs: {
        "label": option.modeId,
        "value": option.modeId
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "鞋子尺码"
    }
  }, [_c('el-select', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "== 请选择 =="
    },
    model: {
      value: (_vm.clothChooseForm['shoesSize']),
      callback: function($$v) {
        _vm.$set(_vm.clothChooseForm, 'shoesSize', $$v)
      },
      expression: "clothChooseForm['shoesSize']"
    }
  }, _vm._l((_vm.modeSelector('XF_Shoes_Size')), function(option) {
    return _c('el-option', {
      key: option.modeId,
      attrs: {
        "label": option.modeId,
        "value": option.modeId
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.back('09')
      }
    }
  }, [_vm._v("上一步")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.nextStep('Other')
      }
    }
  }, [_vm._v("下一步")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.feeListVisible),
      expression: "feeListVisible"
    }],
    staticStyle: {
      "background-color": "#fff",
      "text-align": "center"
    }
  }, [_c('el-row', [_c('el-form', {
    ref: "curStudent",
    staticStyle: {
      "width": "50%",
      "background-color": "#fff",
      "margin": "auto"
    },
    attrs: {
      "model": _vm.curStudent,
      "label-width": "90px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "姓名"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.curStudent.studentName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "身份证号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.curStudent.uid))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "专业"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.curStudent.majorMatr))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "学年"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.curStudent.enrollmentYear))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "应缴总额"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Ginkgo.format(_vm.feeSum.payableAmount, 'money')))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "减免总额"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Ginkgo.format(_vm.feeSum.reduceAmount, 'money')))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "实缴总额"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Ginkgo.format(_vm.feeSum.feeAmount, 'money')))])]), _vm._v(" "), _c('el-collapse', [_c('el-collapse-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "title": "费用明细",
      "name": "1"
    }
  }, [_c('el-row', _vm._l((_vm.feeList), function(item) {
    return _c('div', {
      key: item.feeNo,
      staticStyle: {
        "display": "flex",
        "text-align": "left"
      }
    }, [_c('span', {
      staticClass: "label_detail",
      staticStyle: {
        "padding-left": "130px"
      }
    }, [_vm._v(_vm._s(item.feeNo))]), _c('span', {
      staticClass: "label_value"
    }, [_vm._v(_vm._s(_vm.Ginkgo.format(item.feeAmount, 'money')))])])
  }), 0)], 1), _vm._v(" "), (_vm.dormConfigCheckList.length > 0) ? _c('el-collapse-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "title": "公寓用品明细",
      "name": "2"
    }
  }, [_c('el-row', _vm._l((_vm.dormConfigCheckList), function(option) {
    return _c('div', {
      key: option,
      staticStyle: {
        "display": "flex",
        "text-align": "left"
      },
      attrs: {
        "value": option
      }
    }, [_c('span', {
      staticClass: "label_detail",
      staticStyle: {
        "padding-left": "20px"
      }
    }, [_vm._v(_vm._s(_vm.getDormLabel(option)))]), (!(_vm.global.dormConfigSet !== 1)) ? _c('span', {
      staticClass: "label_value"
    }, [_vm._v(_vm._s(_vm.global.dormConfigSet === 1 ? _vm.Ginkgo.format(_vm.getDormValue(option), 'money') : '1套'))]) : _vm._e()])
  }), 0)], 1) : _vm._e(), _vm._v(" "), _c('el-collapse-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "title": "军训用品明细",
      "name": "3"
    }
  }, _vm._l((_vm.miliTrainItem), function(item) {
    return _c('el-row', {
      key: "item.modeId"
    }, [_c('div', [_c('span', {
      staticClass: "label_detail"
    }, [_vm._v(_vm._s(item.modeId))]), _c('span', {
      staticClass: "label_value"
    }, [_vm._v(_vm._s(item.modeValue))])])])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('span', {
    staticClass: "deg-title"
  }, [_vm._v("所选床位即将失效，请尽快支付 ！！！")])])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.back('07')
      }
    }
  }, [_vm._v("上一步")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toPay()
      }
    }
  }, [_vm._v("去支付")])], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.feeListHistoryVisible),
      expression: "feeListHistoryVisible"
    }]
  }, [_c('el-table', {
    ref: "resultTable",
    staticStyle: {
      "width": "100%",
      "margin-top": "10px"
    },
    attrs: {
      "data": _vm.tableData,
      "highlight-current-row": "",
      "stripe": "",
      "border": "",
      "height": _vm.global.tableHeight
    },
    on: {
      "sort-change": _vm.handleSortChangeHistory
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "fixed": "",
      "width": "60"
    }
  }), _vm._v(" "), _vm._l((_vm.getUISetQueryResult('01')), function(item) {
    return (_vm.getHeaderVisible(item, 1)) ? _c('el-table-column', {
      key: item.columnName,
      attrs: {
        "prop": item.columnProp,
        "label": item.columnDesc.split('|')[0],
        "min-width": item.colWidth,
        "align": item.alignType,
        "formatter": _vm.dataFormatHistory,
        "fixed": _vm.Ginkgo.getColumnFixed(item),
        "sortable": "custom",
        "header-align": "center"
      }
    }, _vm._l((_vm.getHeaderGroup(item, 2, '01')), function(item2) {
      return (_vm.getHeaderVisible(item2, 2)) ? _c('el-table-column', {
        key: item2.columnName,
        attrs: {
          "prop": item2.columnProp,
          "label": item2.columnDesc.split('|')[1],
          "min-width": item2.colWidth,
          "align": item2.alignType,
          "formatter": _vm.dataFormatHistory,
          "fixed": _vm.Ginkgo.getColumnFixed(item2),
          "sortable": "custom",
          "header-align": "center"
        }
      }, _vm._l((_vm.getHeaderGroup(item2, 3, '01')), function(item3) {
        return (_vm.getHeaderVisible(item3, 3)) ? _c('el-table-column', {
          key: item3.columnName,
          attrs: {
            "prop": item3.columnProp,
            "label": item3.columnDesc.split('|')[2],
            "min-width": item3.colWidth,
            "align": item3.alignType,
            "formatter": _vm.dataFormatHistory,
            "fixed": _vm.Ginkgo.getColumnFixed(item3),
            "sortable": "custom",
            "header-align": "center"
          }
        }) : _vm._e()
      }), 1) : _vm._e()
    }), 1) : _vm._e()
  })], 2), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "current-page": _vm.page.number + 1,
      "page-sizes": _vm.page.pageSizes,
      "page-size": _vm.page.size,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.page.totalElements,
      "page-count": _vm.page.totalPages
    },
    on: {
      "size-change": _vm.handleSizeChangeHistory,
      "current-change": _vm.handleCurrentChangeHistory
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-dialog', {
    attrs: {
      "title": "微信二维码",
      "visible": _vm.dialogFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-row', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.weixin
    }
  })])], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.payVisible),
      expression: "payVisible"
    }]
  }, [_c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buttonVisiblePFWX),
      expression: "buttonVisiblePFWX"
    }]
  }, [_c('mt-cell', {
    staticStyle: {
      "min-height": "65px"
    },
    attrs: {
      "title": "微信支付",
      "value": "使用微信支付，方便快捷",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doPay(_vm.payTypePFWX)
      }
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": _vm.wx,
      "width": "50",
      "height": "45"
    },
    slot: "icon"
  })])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buttonVisiblePFZFB),
      expression: "buttonVisiblePFZFB"
    }]
  }, [_c('mt-cell', {
    staticStyle: {
      "min-height": "65px"
    },
    attrs: {
      "title": "支付宝支付",
      "value": "使用支付宝支付，方便快捷",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doPay(_vm.payTypePFZFB)
      }
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": _vm.zfb,
      "width": "50",
      "height": "45"
    },
    slot: "icon"
  })])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buttonVisibleWX),
      expression: "buttonVisibleWX"
    }]
  }, [_c('mt-cell', {
    staticStyle: {
      "min-height": "65px"
    },
    attrs: {
      "title": "微信支付",
      "value": "使用微信支付，方便快捷",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doPay(_vm.payType)
      }
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": _vm.wx,
      "width": "50",
      "height": "45"
    },
    slot: "icon"
  })])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buttonVisibleZFB),
      expression: "buttonVisibleZFB"
    }]
  }, [_c('mt-cell', {
    staticStyle: {
      "min-height": "65px"
    },
    attrs: {
      "title": "支付宝支付",
      "value": "使用支付宝支付，方便快捷",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doPay(_vm.payTypeZFB)
      }
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": _vm.zfb,
      "width": "50",
      "height": "45"
    },
    slot: "icon"
  })])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buttonVisibleUnion),
      expression: "buttonVisibleUnion"
    }]
  }, [_c('mt-cell', {
    staticStyle: {
      "min-height": "65px"
    },
    attrs: {
      "title": "银联支付",
      "value": "使用银联支付，优惠多多",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doPay(_vm.payTypeUnion)
      }
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": _vm.yl,
      "width": "50",
      "height": "45"
    },
    slot: "icon"
  })])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buttonVisibleUnion),
      expression: "buttonVisibleUnion"
    }]
  }, [_c('mt-cell', {
    staticStyle: {
      "min-height": "65px"
    },
    attrs: {
      "title": "线下缴费",
      "value": "前往财务处现场缴费(现金缴费)",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doPay('09')
      }
    }
  }, [_c('van-icon', {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "slot": "icon",
      "name": "cash-on-deliver",
      "size": "40"
    },
    slot: "icon"
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.back('02')
      }
    }
  }, [_vm._v("上一步")])], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scanVisible),
      expression: "scanVisible"
    }]
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "align-items": "center"
    }
  }, [_c('vue-qr', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "logoSrc": _vm.qrImage,
      "text": _vm.qrContent,
      "size": 200
    }
  }), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.back('10')
      }
    }
  }, [_vm._v("上一步")])], 1)], 1)])], 1), _vm._v(" "), _c('vue-qr', {
    ref: "qrCodeRef",
    staticStyle: {
      "position": "absolute",
      "opacity": "0",
      "width": "90px",
      "height": "90px",
      "z-index": "-1"
    },
    attrs: {
      "text": _vm.curStudent.studentNo,
      "size": 150
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1268:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticStyle: {
      "background": "#fff",
      "height": "1000px"
    }
  }, [_c('el-row', {
    staticStyle: {
      "width": "70%",
      "margin": "0 auto"
    }
  }, [_c('el-row', [_c('el-row', {
    staticClass: "banner"
  }, [_c('el-row', {
    staticClass: "head"
  }, [_c('el-col', {
    staticClass: "head_logo",
    attrs: {
      "span": 22
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.log1,
      "height": "46px"
    }
  })]), _vm._v(" "), _c('el-col', {
    staticClass: "head_right",
    attrs: {
      "span": 2
    }
  }, [_c('div', {
    staticClass: "Head_Link"
  }, [_c('el-button', {
    staticClass: "t",
    staticStyle: {
      "padding-left": "40px"
    },
    style: (_vm.dh),
    attrs: {
      "type": "text"
    }
  }, [_vm._v("\n                 400-878-6390\n              ")])], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content main"
  }, [_c('div', {
    staticClass: "jf"
  }, [_c('div', {
    staticClass: "dlck",
    staticStyle: {
      "float": "left"
    }
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("\n                    西安翻译学院\n              ")]), _vm._v(" "), _c('div'), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "14px"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.global.curUser,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学生类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "== 请选择 =="
    },
    model: {
      value: (_vm.form.studentType),
      callback: function($$v) {
        _vm.$set(_vm.form, "studentType", $$v)
      },
      expression: "form.studentType"
    }
  }, _vm._l((_vm.stuTypeList), function(option) {
    return _c('el-option', {
      key: option.modeId,
      class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
      attrs: {
        "label": option.modeName,
        "value": option.modeId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学生姓名"
    }
  }, [_c('el-input', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.form.studentName),
      callback: function($$v) {
        _vm.$set(_vm.form, "studentName", $$v)
      },
      expression: "form.studentName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.idCardVisible),
      expression: "idCardVisible"
    }],
    attrs: {
      "label": "身份证号"
    }
  }, [_c('el-input', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.form.idCard),
      callback: function($$v) {
        _vm.$set(_vm.form, "idCard", $$v)
      },
      expression: "form.idCard"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.studentNoVisible),
      expression: "studentNoVisible"
    }],
    attrs: {
      "label": "学号"
    }
  }, [_c('el-input', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.form.studentNo),
      callback: function($$v) {
        _vm.$set(_vm.form, "studentNo", $$v)
      },
      expression: "form.studentNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeVisible),
      expression: "codeVisible"
    }],
    attrs: {
      "label": "验证码"
    }
  }, [_c('el-input', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "请输入身份证号后六位"
    },
    model: {
      value: (_vm.form.code),
      callback: function($$v) {
        _vm.$set(_vm.form, "code", $$v)
      },
      expression: "form.code"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "width": "100%",
      "margin": "20px auto"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.loginInit()
      }
    }
  }, [_vm._v("登录")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "545px",
      "height": "330px",
      "float": "right",
      "margin-top": "10px"
    }
  }, [_c('el-carousel', {
    attrs: {
      "indicator-position": "outside"
    }
  }, [_c('el-carousel-item', [_c('img', {
    attrs: {
      "src": _vm.fy1,
      "height": "300px",
      "width": "545px"
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": _vm.fy2,
      "height": "300px",
      "width": "545px"
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": _vm.fy3,
      "height": "300px",
      "width": "545px"
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": _vm.fy4,
      "height": "300px",
      "width": "545px"
    }
  })])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "tybottom"
  }, [_c('div', {
    staticClass: "main_down"
  }, [_c('div', {
    staticClass: "down_gg fl"
  }, [_c('h2', [_vm._v("咨询电话")]), _vm._v(" "), _c('ul', {
    staticClass: "gg"
  }, [(!(_vm.financeOffice.modeName === undefined)) ? _c('li', [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.financeOffice.modeName) + "：" + _vm._s(_vm.financeOffice.modeValue))])]) : _vm._e(), _vm._v(" "), (!(_vm.apartmentOffice.modeName === undefined)) ? _c('li', [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.apartmentOffice.modeName) + "：" + _vm._s(_vm.apartmentOffice.modeValue))])]) : _vm._e(), _vm._v(" "), (!(_vm.deanOffice.modeName === undefined)) ? _c('li', [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.deanOffice.modeName) + "：" + _vm._s(_vm.deanOffice.modeValue))])]) : _vm._e(), _vm._v(" "), (!(_vm.admissionsOffice.modeName === undefined)) ? _c('li', [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.admissionsOffice.modeName) + "：" + _vm._s(_vm.admissionsOffice.modeValue))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "down_gg fr"
  }, [_c('h2', [_vm._v("帮助电话")]), _vm._v(" "), _c('ul', {
    staticClass: "bzzx"
  }, [(!(_vm.technicalSupport.modeName === undefined)) ? _c('li', [_c('span', {
    staticStyle: {
      "font-size": "18px",
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.technicalSupport.modeName) + "：" + _vm._s(_vm.technicalSupport.modeValue))])]) : _vm._e()])])])]), _vm._v(" "), _c('div', [_c('router-view')], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1269:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "todo"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('h3', [_vm._v("前端相关")]), _vm._v("\n  Vue.js官网："), _c('a', {
    attrs: {
      "href": "https://cn.vuejs.org/v2/guide/",
      "target": "_blank"
    }
  }, [_vm._v("https://cn.vuejs.org/v2/guide/")]), _c('br'), _vm._v("\n  Elment-Ui官网："), _c('a', {
    attrs: {
      "href": "http://element-cn.eleme.io/#/zh-CN/",
      "target": "_blank"
    }
  }, [_vm._v("http://element-cn.eleme.io/#/zh-CN/")]), _c('br'), _vm._v("\n  Mint-Ui官网："), _c('a', {
    attrs: {
      "href": "http://mint-ui.github.io/#!/zh-cn",
      "target": "_blank"
    }
  }, [_vm._v("http://mint-ui.github.io/#!/zh-cn")]), _c('br'), _vm._v("   \n  JS菜鸟教程："), _c('a', {
    attrs: {
      "href": "http://www.runoob.com/js/js-intro.html",
      "target": "_blank"
    }
  }, [_vm._v("http://www.runoob.com/js/js-intro.html")]), _c('br'), _vm._v("\n  图表："), _c('a', {
    attrs: {
      "href": "http://blog.gdfengshuo.com/example/#/vue-schart",
      "target": "_blank"
    }
  }, [_vm._v("http://blog.gdfengshuo.com/example/#/vue-schart")]), _c('br')])
},staticRenderFns: []}

/***/ }),

/***/ 1270:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-row', {
    staticStyle: {
      "width": "70%",
      "margin": "0 auto"
    }
  }, [_c('el-row', [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": "/MyBill",
      "mode": "horizontal",
      "background-color": "#545c64",
      "text-color": "#fff",
      "active-text-color": "#ffd04b"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/MyBill"
    }
  }, [_vm._v("学期缴费")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/MyBillHistory"
    }
  }, [_vm._v("学期缴费历史")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/MyBillExam"
    }
  }, [_vm._v("其他缴费")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/MyBillHistoryExam"
    }
  }, [_vm._v("其他缴费历史")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/Card"
    }
  }, [_vm._v("银行卡")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/Exit"
    }
  }, [_vm._v("退出")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.feeTypeVisible),
      expression: "feeTypeVisible"
    }],
    staticClass: "back-up",
    staticStyle: {
      "background-color": "#fff"
    }
  }, [_c('el-row', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "30px"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0",
      "border": ""
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v("按学年")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1",
      "border": ""
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v("按学期")]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "20px auto"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.nextFee()
      }
    }
  }, [_vm._v("下一步")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.semesterPayVisible),
      expression: "semesterPayVisible"
    }],
    staticStyle: {
      "background-color": "#fff"
    }
  }, [(_vm.semesterPayVisible && _vm.tipText !== '') ? _c('div', {
    staticClass: "notice"
  }, [_c('van-notice-bar', {
    attrs: {
      "left-icon": "volume-o",
      "text": _vm.tipText
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticStyle: {
      "background-color": "#fff",
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-top": "12px",
      "border-radius": "8px"
    },
    attrs: {
      "src": "",
      "width": "90",
      "height": "120"
    }
  })]), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.billVisible),
      expression: "billVisible"
    }]
  }, [_c('el-form', {
    ref: "viewForm",
    staticStyle: {
      "width": "50%",
      "background-color": "#fff",
      "margin": "auto"
    },
    attrs: {
      "model": _vm.viewForm,
      "label-width": "100px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "学号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.studentNo))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "姓名"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.studentName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "专业"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.majorMatr))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "班级"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.className))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "学年"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.academicYear))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "应缴总额"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Ginkgo.format(_vm.viewForm.payableAmount, 'money')))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "减免总额"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Ginkgo.format(_vm.viewForm.reduceAmount, 'money')))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "实缴总额"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Ginkgo.format(_vm.viewForm.feeAmount, 'money')))])]), _vm._v(" "), _c('el-collapse', [_c('el-collapse-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "title": "费用明细",
      "name": "1"
    }
  }, [_c('el-row', [_vm._l((_vm.feeData), function(item) {
    return _c('div', {
      key: item.feeNo
    }, [_c('span', {
      staticClass: "label_detail"
    }, [_vm._v(_vm._s(item.feeName))]), _c('span', {
      staticClass: "label_value"
    }, [_vm._v(_vm._s(_vm.Ginkgo.format(item.feeAmount, 'money')))])])
  }), _vm._v(" "), _vm._l((_vm.reduceList), function(item) {
    return _c('div', {
      key: item.feeNo
    }, [_c('span', {
      staticClass: "label_detail"
    }, [_vm._v(_vm._s(item.feeNo))]), _c('span', {
      staticClass: "label_value"
    }, [_vm._v(_vm._s(_vm.Ginkgo.format(item.feeAmount, 'money')))])])
  })], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.examBillVisible),
      expression: "examBillVisible"
    }]
  }, [_c('el-form', {
    ref: "viewForm",
    staticStyle: {
      "width": "50%",
      "background-color": "#fff",
      "margin": "auto"
    },
    attrs: {
      "model": _vm.viewForm,
      "label-width": "100px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "学号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.studentNo))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "姓名"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.studentName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "专业"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.majorMatr))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "班级"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.className))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "学年"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.academicYear))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "学期"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.termNM))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "总额"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Ginkgo.format(_vm.viewForm.totals, 'money')))])]), _vm._v(" "), _c('el-collapse', [_c('el-collapse-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "title": "费用明细"
    }
  }, [_c('el-row', [_c('el-table', {
    ref: "feeResultTable",
    attrs: {
      "data": _vm.feeData
    },
    on: {
      "selection-change": _vm.handleSelectionChange,
      "row-click": _vm.isShow
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "费用项",
      "prop": "feeNo"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "金额",
      "prop": "feeAmount",
      "formatter": _vm.dataFormat,
      "align": "right"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.termVisible),
      expression: "termVisible"
    }]
  }, [_c('span', [_vm._v(_vm._s(_vm.termMsg))])]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [(_vm.backVisible) ? _c('el-button', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.back()
      }
    }
  }, [_vm._v("上一步")]) : _vm._e(), _vm._v(" "), (_vm.feePayType_UN) ? _c('el-button', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "type": "primary",
      "disabled": _vm.payButtonDisable
    },
    on: {
      "click": function($event) {
        return _vm.toPay()
      }
    }
  }, [_vm._v("支 付")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.feeListHistoryVisible),
      expression: "feeListHistoryVisible"
    }]
  }, [_c('el-table', {
    ref: "resultTable",
    staticStyle: {
      "width": "100%",
      "margin-top": "10px"
    },
    attrs: {
      "data": _vm.tableData,
      "highlight-current-row": "",
      "stripe": "",
      "border": "",
      "height": _vm.global.tableHeight
    },
    on: {
      "sort-change": _vm.handleSortChangeHistory
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "fixed": "",
      "width": "60"
    }
  }), _vm._v(" "), _vm._l((_vm.getUISetQueryResult('01')), function(item) {
    return (_vm.getHeaderVisible(item, 1)) ? _c('el-table-column', {
      key: item.columnName,
      attrs: {
        "prop": item.columnProp,
        "label": item.columnDesc.split('|')[0],
        "min-width": item.colWidth,
        "align": item.alignType,
        "formatter": _vm.dataFormatHistory,
        "fixed": _vm.Ginkgo.getColumnFixed(item),
        "sortable": "custom",
        "header-align": "center"
      }
    }, _vm._l((_vm.getHeaderGroup(item, 2, '01')), function(item2) {
      return (_vm.getHeaderVisible(item2, 2)) ? _c('el-table-column', {
        key: item2.columnName,
        attrs: {
          "prop": item2.columnProp,
          "label": item2.columnDesc.split('|')[1],
          "min-width": item2.colWidth,
          "align": item2.alignType,
          "formatter": _vm.dataFormatHistory,
          "fixed": _vm.Ginkgo.getColumnFixed(item2),
          "sortable": "custom",
          "header-align": "center"
        }
      }, _vm._l((_vm.getHeaderGroup(item2, 3, '01')), function(item3) {
        return (_vm.getHeaderVisible(item3, 3)) ? _c('el-table-column', {
          key: item3.columnName,
          attrs: {
            "prop": item3.columnProp,
            "label": item3.columnDesc.split('|')[2],
            "min-width": item3.colWidth,
            "align": item3.alignType,
            "formatter": _vm.dataFormatHistory,
            "fixed": _vm.Ginkgo.getColumnFixed(item3),
            "sortable": "custom",
            "header-align": "center"
          }
        }) : _vm._e()
      }), 1) : _vm._e()
    }), 1) : _vm._e()
  })], 2), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "current-page": _vm.page.number + 1,
      "page-sizes": _vm.page.pageSizes,
      "page-size": _vm.page.size,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.page.totalElements,
      "page-count": _vm.page.totalPages
    },
    on: {
      "size-change": _vm.handleSizeChangeHistory,
      "current-change": _vm.handleCurrentChangeHistory
    }
  })], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.examListHistoryVisible),
      expression: "examListHistoryVisible"
    }]
  }, [_c('el-table', {
    ref: "resultTable",
    staticStyle: {
      "width": "100%",
      "margin-top": "10px"
    },
    attrs: {
      "data": _vm.tableData,
      "highlight-current-row": "",
      "stripe": "",
      "border": "",
      "height": _vm.global.tableHeight
    },
    on: {
      "sort-change": _vm.handleSortChangeHistory
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "fixed": "",
      "width": "60"
    }
  }), _vm._v(" "), _vm._l((_vm.getUISetQueryResult('02')), function(item) {
    return (_vm.getHeaderVisible(item, 1)) ? _c('el-table-column', {
      key: item.columnName,
      attrs: {
        "prop": item.columnProp,
        "label": item.columnDesc.split('|')[0],
        "min-width": item.colWidth,
        "align": item.alignType,
        "formatter": _vm.dataFormatExamHistory,
        "fixed": _vm.Ginkgo.getColumnFixed(item),
        "sortable": "custom",
        "header-align": "center"
      }
    }, _vm._l((_vm.getHeaderGroup(item, 2, '02')), function(item2) {
      return (_vm.getHeaderVisible(item2, 2)) ? _c('el-table-column', {
        key: item2.columnName,
        attrs: {
          "prop": item2.columnProp,
          "label": item2.columnDesc.split('|')[1],
          "min-width": item2.colWidth,
          "align": item2.alignType,
          "formatter": _vm.dataFormatExamHistory,
          "fixed": _vm.Ginkgo.getColumnFixed(item2),
          "sortable": "custom",
          "header-align": "center"
        }
      }, _vm._l((_vm.getHeaderGroup(item2, 3, '02')), function(item3) {
        return (_vm.getHeaderVisible(item3, 3)) ? _c('el-table-column', {
          key: item3.columnName,
          attrs: {
            "prop": item3.columnProp,
            "label": item3.columnDesc.split('|')[2],
            "min-width": item3.colWidth,
            "align": item3.alignType,
            "formatter": _vm.dataFormatExamHistory,
            "fixed": _vm.Ginkgo.getColumnFixed(item3),
            "sortable": "custom",
            "header-align": "center"
          }
        }) : _vm._e()
      }), 1) : _vm._e()
    }), 1) : _vm._e()
  })], 2), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "current-page": _vm.page.number + 1,
      "page-sizes": _vm.page.pageSizes,
      "page-size": _vm.page.size,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.page.totalElements,
      "page-count": _vm.page.totalPages
    },
    on: {
      "size-change": _vm.handleSizeChangeHistory,
      "current-change": _vm.handleCurrentChangeHistory
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-dialog', {
    attrs: {
      "title": "微信二维码",
      "visible": _vm.dialogFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-row', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.weixin
    }
  })])], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.payVisible),
      expression: "payVisible"
    }]
  }, [_c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buttonVisiblePFWX),
      expression: "buttonVisiblePFWX"
    }]
  }, [_c('mt-cell', {
    staticStyle: {
      "min-height": "65px"
    },
    attrs: {
      "title": "微信支付",
      "value": "使用微信支付，方便快捷",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doPay(_vm.payTypePFWX)
      }
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": _vm.wx,
      "width": "50",
      "height": "45"
    },
    slot: "icon"
  })])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buttonVisiblePFZFB),
      expression: "buttonVisiblePFZFB"
    }]
  }, [_c('mt-cell', {
    staticStyle: {
      "min-height": "65px"
    },
    attrs: {
      "title": "支付宝支付",
      "value": "使用支付宝支付，方便快捷",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doPay(_vm.payTypePFZFB)
      }
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": _vm.zfb,
      "width": "50",
      "height": "45"
    },
    slot: "icon"
  })])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buttonVisibleWX),
      expression: "buttonVisibleWX"
    }]
  }, [_c('mt-cell', {
    staticStyle: {
      "min-height": "65px"
    },
    attrs: {
      "title": "微信支付",
      "value": "使用微信支付，方便快捷",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doPay(_vm.payType)
      }
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": _vm.wx,
      "width": "50",
      "height": "45"
    },
    slot: "icon"
  })])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buttonVisibleZFB),
      expression: "buttonVisibleZFB"
    }]
  }, [_c('mt-cell', {
    staticStyle: {
      "min-height": "65px"
    },
    attrs: {
      "title": "支付宝支付",
      "value": "使用支付宝支付，方便快捷",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doPay(_vm.payTypeZFB)
      }
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": _vm.zfb,
      "width": "50",
      "height": "45"
    },
    slot: "icon"
  })])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buttonVisibleUnion),
      expression: "buttonVisibleUnion"
    }]
  }, [_c('mt-cell', {
    staticStyle: {
      "min-height": "65px"
    },
    attrs: {
      "title": "银联支付",
      "value": "使用银联支付，优惠多多",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doPay(_vm.payTypeUnion)
      }
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": _vm.yl,
      "width": "50",
      "height": "45"
    },
    slot: "icon"
  })])], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scanVisible),
      expression: "scanVisible"
    }]
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "align-items": "center"
    }
  }, [_c('vue-qr', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "logoSrc": _vm.qrImage,
      "text": _vm.qrContent,
      "size": 200
    }
  }), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.setVisible('10')
      }
    }
  }, [_vm._v("上一步")])], 1)], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1271:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticStyle: {
      "background": "#fff",
      "height": "1000px"
    }
  }, [_c('el-row', {
    staticStyle: {
      "width": "70%",
      "margin": "0 auto"
    }
  }, [_c('el-row', [_c('el-row', {
    staticClass: "banner"
  }, [_c('el-row', {
    staticClass: "head"
  }, [_c('el-col', {
    staticClass: "head_logo",
    attrs: {
      "span": 22
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.log1,
      "height": "46px"
    }
  })]), _vm._v(" "), _c('el-col', {
    staticClass: "head_right",
    attrs: {
      "span": 2
    }
  }, [_c('div', {
    staticClass: "Head_Link"
  }, [_c('el-button', {
    staticClass: "t",
    staticStyle: {
      "padding-left": "40px"
    },
    style: (_vm.dh),
    attrs: {
      "type": "text"
    }
  }, [_vm._v("\n                 400-878-6390\n              ")])], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content main"
  }, [_c('div', {
    staticClass: "jf"
  }, [_c('div', {
    staticClass: "dlck",
    staticStyle: {
      "float": "left"
    }
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("\n                    西安翻译学院\n              ")]), _vm._v(" "), _c('div'), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "14px"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.global.curUser,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学生姓名"
    }
  }, [_c('el-input', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.form.studentName),
      callback: function($$v) {
        _vm.$set(_vm.form, "studentName", $$v)
      },
      expression: "form.studentName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学号"
    }
  }, [_c('el-input', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.form.studentNo),
      callback: function($$v) {
        _vm.$set(_vm.form, "studentNo", $$v)
      },
      expression: "form.studentNo"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "width": "100%",
      "margin": "20px auto"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.loginInit()
      }
    }
  }, [_vm._v("登录")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "545px",
      "height": "330px",
      "float": "right",
      "margin-top": "10px"
    }
  }, [_c('el-carousel', {
    attrs: {
      "indicator-position": "outside"
    }
  }, [_c('el-carousel-item', [_c('img', {
    attrs: {
      "src": _vm.fy1,
      "height": "300px",
      "width": "545px"
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": _vm.fy2,
      "height": "300px",
      "width": "545px"
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": _vm.fy3,
      "height": "300px",
      "width": "545px"
    }
  })]), _vm._v(" "), _c('el-carousel-item', [_c('img', {
    attrs: {
      "src": _vm.fy4,
      "height": "300px",
      "width": "545px"
    }
  })])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "tybottom"
  }, [_c('div', {
    staticClass: "main_down"
  }, [_c('div', {
    staticClass: "down_gg fl"
  }, [_c('h2', [_vm._v("咨询电话")]), _vm._v(" "), _c('ul', {
    staticClass: "gg"
  }, [(!(_vm.financeOffice.modeName === undefined)) ? _c('li', [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.financeOffice.modeName) + "：" + _vm._s(_vm.financeOffice.modeValue))])]) : _vm._e(), _vm._v(" "), (!(_vm.apartmentOffice.modeName === undefined)) ? _c('li', [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.apartmentOffice.modeName) + "：" + _vm._s(_vm.apartmentOffice.modeValue))])]) : _vm._e(), _vm._v(" "), (!(_vm.deanOffice.modeName === undefined)) ? _c('li', [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.deanOffice.modeName) + "：" + _vm._s(_vm.deanOffice.modeValue))])]) : _vm._e(), _vm._v(" "), (!(_vm.admissionsOffice.modeName === undefined)) ? _c('li', [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.admissionsOffice.modeName) + "：" + _vm._s(_vm.admissionsOffice.modeValue))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "down_gg fr"
  }, [_c('h2', [_vm._v("帮助电话")]), _vm._v(" "), _c('ul', {
    staticClass: "bzzx"
  }, [(!(_vm.technicalSupport.modeName === undefined)) ? _c('li', [_c('span', {
    staticStyle: {
      "font-size": "18px",
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.technicalSupport.modeName) + "：" + _vm._s(_vm.technicalSupport.modeValue))])]) : _vm._e()])])])]), _vm._v(" "), _c('div', [_c('router-view')], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1272:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-row', {
    staticStyle: {
      "width": "70%",
      "margin": "0 auto"
    }
  }, [_c('el-row', [_c('el-row', [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": "/MyLoan",
      "mode": "horizontal",
      "background-color": "#545c64",
      "text-color": "#fff",
      "active-text-color": "#ffd04b"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/MyLoan"
    }
  }, [_vm._v("生源地贷款")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/Exit"
    }
  }, [_vm._v("退出")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chooseVisible),
      expression: "chooseVisible"
    }],
    staticClass: "back-up",
    staticStyle: {
      "background-color": "#fff"
    }
  }, [_c('el-row', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "30px"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0",
      "border": ""
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v("未办理生源地贷款")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1",
      "border": ""
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v("已办理生源地贷款")]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "20px auto"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.nextLoan()
      }
    }
  }, [_vm._v("下一步")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loanInfoVisible),
      expression: "loanInfoVisible"
    }],
    staticStyle: {
      "background-color": "#fff",
      "text-align": "center"
    }
  }, [_c('el-row', [_c('el-form', {
    ref: "loanForm",
    staticStyle: {
      "width": "50%",
      "margin": "20px auto"
    },
    attrs: {
      "inline": _vm.global.editInline,
      "model": _vm.loanForm,
      "label-width": _vm.formLabelWidth,
      "size": "medium",
      "inline-message": true,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "label": "贷款银行"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "== 请选择 =="
    },
    model: {
      value: (_vm.loanForm.bankType),
      callback: function($$v) {
        _vm.$set(_vm.loanForm, "bankType", $$v)
      },
      expression: "loanForm.bankType"
    }
  }, _vm._l((_vm.bankTypeList), function(option) {
    return _c('el-option', {
      key: option.modeId,
      attrs: {
        "label": option.modeName,
        "value": option.modeId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "label": "学生姓名"
    }
  }, [_c('span', {
    staticClass: "label_value"
  }, [_vm._v(_vm._s(_vm.loanForm.studentName))])]), _vm._v(" "), _c('el-form-item', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "label": "学号"
    }
  }, [_c('span', {
    staticClass: "label_value"
  }, [_vm._v(_vm._s(_vm.loanForm.keyInfo))])]), _vm._v(" "), _c('el-form-item', {
    key: "Mobile",
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "label": "联系电话",
      "prop": "mobile"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.loanForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.loanForm, "mobile", $$v)
      },
      expression: "loanForm.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    key: "Loan_Amount",
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "label": "贷款金额",
      "prop": "loanAmount"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.loanForm.loanAmount),
      callback: function($$v) {
        _vm.$set(_vm.loanForm, "loanAmount", $$v)
      },
      expression: "loanForm.loanAmount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.loanForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.loanForm, "remark", $$v)
      },
      expression: "loanForm.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "贷款受理证明或回执单"
    }
  }, [_c('el-upload', {
    attrs: {
      "list-type": "picture-card",
      "action": _vm.uploadAction,
      "headers": _vm.uploadHead,
      "data": _vm.uploadData,
      "before-upload": _vm.beforeUploadLoan,
      "on-success": _vm.successUploadLoan,
      "on-error": _vm.errorUploadLoan,
      "accept": 'image/*',
      "on-remove": _vm.handleRemoveLoan,
      "before-remove": _vm.beforeRemoveLoan,
      "limit": 1,
      "on-exceed": _vm.handleExceedLoan,
      "on-change": _vm.handleUploadChangeLoan,
      "file-list": _vm.loanFileList
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "身份证国徽面照片"
    }
  }, [_c('el-upload', {
    attrs: {
      "list-type": "picture-card",
      "action": _vm.uploadAction,
      "headers": _vm.uploadHead,
      "data": _vm.uploadData,
      "before-upload": _vm.beforeUploadUidJust,
      "on-success": _vm.successUploadUidJust,
      "on-error": _vm.errorUploadUidJust,
      "accept": 'image/*',
      "on-remove": _vm.handleRemoveUidJust,
      "before-remove": _vm.beforeRemoveUidJust,
      "limit": 1,
      "on-exceed": _vm.handleExceedUidJust,
      "on-change": _vm.handleUploadChangeUidJust,
      "file-list": _vm.uidJustFileList
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "身份证人像面图片"
    }
  }, [_c('el-upload', {
    attrs: {
      "list-type": "picture-card",
      "action": _vm.uploadAction,
      "headers": _vm.uploadHead,
      "data": _vm.uploadData,
      "before-upload": _vm.beforeUploadUidBack,
      "on-success": _vm.successUploadUidBack,
      "on-error": _vm.errorUploadUidBack,
      "accept": 'image/*',
      "on-remove": _vm.handleRemoveUidBack,
      "before-remove": _vm.beforeRemoveUidBack,
      "limit": 1,
      "on-exceed": _vm.handleExceedUidBack,
      "on-change": _vm.handleUploadChangeUidBack,
      "file-list": _vm.uidBackFileList
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "其他证明图片"
    }
  }, [_c('el-upload', {
    attrs: {
      "list-type": "picture-card",
      "action": _vm.uploadAction,
      "headers": _vm.uploadHead,
      "data": _vm.uploadDataOther,
      "before-upload": _vm.beforeUploadOther,
      "on-success": _vm.successUploadOther,
      "on-error": _vm.errorUploadOther,
      "accept": 'image/*',
      "on-remove": _vm.handleRemoveOther,
      "before-remove": _vm.beforeRemoveOther,
      "multiple": "",
      "limit": 3,
      "on-exceed": _vm.handleExceedOther,
      "on-change": _vm.handleUploadChangeOther,
      "file-list": _vm.otherFileList
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "margin": "20px auto"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.back()
      }
    }
  }, [_vm._v("上一步")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.nextLoanInfo()
      }
    }
  }, [_vm._v("贷款资料备案上报")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.speedVisible),
      expression: "speedVisible"
    }],
    staticClass: "back-up",
    staticStyle: {
      "background-color": "#fff",
      "text-align": "center"
    }
  }, [_c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addVisible),
      expression: "addVisible"
    }],
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-top": "10px",
      "font-size": "14px"
    }
  }, [_c('span', [_vm._v("状态：提交成功。")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("贷款资料备案上报成功，请等待审核结果。")])]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "20px auto"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.home()
      }
    }
  }, [_vm._v("回首页")])], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.successVisible),
      expression: "successVisible"
    }],
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-top": "10px",
      "font-size": "14px"
    }
  }, [_c('span', [_vm._v("状态：审核通过。")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("恭喜你 " + _vm._s(_vm.dataDt) + " 号上报的贷款资料信息已经通过审核，生源地贷款可抵用学费和住宿费 " + _vm._s(_vm.amount) + " 元。")])]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "20px auto"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.nextPayFee()
      }
    }
  }, [_vm._v("下一步")])], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorVisible),
      expression: "errorVisible"
    }],
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-top": "10px",
      "font-size": "14px"
    }
  }, [_c('span', [_vm._v("状态：审核退回。")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("您可选择修改资料重新上报，或者放弃上报进入缴费流程。")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("原因：" + _vm._s(_vm.memo))])]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "20px auto"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.update()
      }
    }
  }, [_vm._v("修改资料")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.nextPayFee()
      }
    }
  }, [_vm._v("放弃上报")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-dialog', {
    attrs: {
      "title": "微信二维码",
      "visible": _vm.dialogFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-row', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.weixin
    }
  })])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1273:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "img-view",
    on: {
      "click": _vm.bigImg
    }
  }, [_c('div', {
    staticClass: "img-layer"
  }), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgSrc
    }
  })])])])
},staticRenderFns: []}

/***/ }),

/***/ 1274:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-row', [_c('BigImg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showImg),
      expression: "showImg"
    }],
    staticStyle: {
      "z-index": "1001"
    },
    attrs: {
      "imgSrc": _vm.imgSrc
    },
    on: {
      "click": function($event) {
        return _vm.viewImg()
      }
    }
  })], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chooseDormVisible),
      expression: "chooseDormVisible"
    }]
  }, [_c('el-row', {
    staticStyle: {
      "background-color": "#fff",
      "padding-top": "20px"
    }
  }, [_c('el-row', {
    staticStyle: {
      "background-color": "#fff",
      "text-align": "center"
    }
  }, [_c('el-form', {
    ref: "dormSetForm",
    staticStyle: {
      "width": "50%",
      "background-color": "#fff",
      "margin": "auto"
    },
    attrs: {
      "model": _vm.dormSetForm,
      "label-width": "90px"
    }
  }, [_c('el-row', [_c('img', {
    staticClass: "banner-img",
    staticStyle: {
      "width": "50%",
      "height": "150px",
      "float": "left"
    },
    attrs: {
      "src": _vm.effectDrawing
    },
    on: {
      "click": function($event) {
        return _vm.clickImg($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "banner-img",
    staticStyle: {
      "width": "50%",
      "height": "150px",
      "float": "right"
    },
    attrs: {
      "src": _vm.bedDiagram
    },
    on: {
      "click": function($event) {
        return _vm.clickImg($event)
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收费标准"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSetForm.price))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "规格"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSetForm.dormStandard))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "宿舍配置"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSetForm.roomSet))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公共配置"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSetForm.pubAreaSet))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所在区域"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSetForm.region))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSetForm.remark))])])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "background-color": "#fff",
      "text-align": "center"
    }
  }, [_c('el-form', {
    ref: "dormChooseForm",
    staticStyle: {
      "width": "50%",
      "background-color": "#fff",
      "margin": "auto"
    },
    attrs: {
      "inline": _vm.global.editInline,
      "model": _vm.dormChooseForm,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "公寓"
    }
  }, [_c('el-select', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "== 请选择 ==",
      "disabled": _vm.getDisableEdit('flatsName', 'form')
    },
    model: {
      value: (_vm.dormChooseForm['flatsName']),
      callback: function($$v) {
        _vm.$set(_vm.dormChooseForm, 'flatsName', $$v)
      },
      expression: "dormChooseForm['flatsName']"
    }
  }, _vm._l((_vm.modeSelector('Flats')), function(option) {
    return _c('el-option', {
      key: option.modeId,
      attrs: {
        "label": option.modeName,
        "value": option.modeId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "宿舍类型"
    }
  }, [_c('el-select', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "== 请选择 ==",
      "disabled": _vm.getDisableEdit('dormSet', 'form')
    },
    model: {
      value: (_vm.dormChooseForm['dormSet']),
      callback: function($$v) {
        _vm.$set(_vm.dormChooseForm, 'dormSet', $$v)
      },
      expression: "dormChooseForm['dormSet']"
    }
  }, _vm._l((_vm.modeSelector('Dorm_Set')), function(option) {
    return _c('el-option', {
      key: option.modeId,
      attrs: {
        "label": option.modeName,
        "value": option.modeId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "宿舍"
    }
  }, [_c('el-select', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "== 请选择 ==",
      "disabled": _vm.getDisableEdit('roomNo', 'form')
    },
    model: {
      value: (_vm.dormChooseForm['roomNo']),
      callback: function($$v) {
        _vm.$set(_vm.dormChooseForm, 'roomNo', $$v)
      },
      expression: "dormChooseForm['roomNo']"
    }
  }, _vm._l((_vm.modeSelector('Room')), function(option) {
    return _c('el-option', {
      key: option.modeId,
      attrs: {
        "label": option.modeName,
        "value": option.modeId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "床位"
    }
  }, [_c('el-select', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "== 请选择 ==",
      "disabled": _vm.getDisableEdit('bedNo', 'form')
    },
    model: {
      value: (_vm.dormChooseForm['bedNo']),
      callback: function($$v) {
        _vm.$set(_vm.dormChooseForm, 'bedNo', $$v)
      },
      expression: "dormChooseForm['bedNo']"
    }
  }, _vm._l((_vm.modeSelector('Bed')), function(option) {
    return _c('el-option', {
      key: option.modeId,
      attrs: {
        "label": option.modeName,
        "value": option.modeId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('span', {
    staticClass: "deg-title"
  }, [_vm._v("四人间床位  总计: " + _vm._s(_vm.fourBedSum) + "  剩余：" + _vm._s(_vm.fourBedRmi) + "  ")])]), _vm._v(" "), _c('el-form-item', [_c('span', {
    staticClass: "deg-title"
  }, [_vm._v("六人间床位  总计: " + _vm._s(_vm.sixBedSum) + "  剩余：" + _vm._s(_vm.sixBedRmi) + "  ")])]), _vm._v(" "), _c('el-form-item', [_c('span', {
    staticClass: "deg-title"
  }, [_vm._v("八人间床位  总计: " + _vm._s(_vm.eightBedSum) + "  剩余：" + _vm._s(_vm.eightBedRmi) + "  ")])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "disabled": _vm.disabledBtn
    },
    on: {
      "click": function($event) {
        return _vm.addBed()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chooseDormSelectedVisible),
      expression: "chooseDormSelectedVisible"
    }]
  }, [_c('el-row', {
    staticStyle: {
      "background-color": "#fff",
      "padding-top": "20px"
    }
  }, [_c('el-row', {
    staticStyle: {
      "background-color": "#fff",
      "text-align": "center"
    }
  }, [_c('el-form', {
    ref: "dormSelectedSetForm",
    staticStyle: {
      "width": "50%",
      "background-color": "#fff",
      "margin": "auto"
    },
    attrs: {
      "model": _vm.dormSelectedSetForm,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-row', [_c('img', {
    staticClass: "banner-img",
    staticStyle: {
      "width": "50%",
      "height": "150px",
      "float": "left"
    },
    attrs: {
      "src": _vm.effectDrawing
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "banner-img",
    staticStyle: {
      "width": "50%",
      "height": "150px",
      "float": "right"
    },
    attrs: {
      "src": _vm.bedDiagram
    }
  })]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item"
  }), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "公寓："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSelectedSetForm.flatsName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "宿舍类型："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSelectedSetForm.dormSet))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "宿舍："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSelectedSetForm.roomNo))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "床位："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSelectedSetForm.bedNo))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "收费标准："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSelectedSetForm.price))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "宿舍配置："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSelectedSetForm.roomSet))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "公共配置："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSelectedSetForm.pubAreaSet))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "所在区域："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSelectedSetForm.region))])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.toHome()
      }
    }
  }, [_vm._v("去首页")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1275:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v(_vm._s(_vm.msg))])])
},staticRenderFns: []}

/***/ }),

/***/ 1276:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loadingApp),
      expression: "loadingApp",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "id": "app",
      "element-loading-text": "拼命加载中...",
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(0, 0, 0, 0.5)"
    }
  }, [_c('div', [_c('router-view')], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1277:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-row', {
    staticStyle: {
      "width": "70%",
      "margin": "0 auto"
    }
  }, [_c('el-row', [_c('el-row', [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": "/MyBill",
      "mode": "horizontal",
      "background-color": "#545c64",
      "text-color": "#fff",
      "active-text-color": "#ffd04b"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/MyBill"
    }
  }, [_vm._v("新生缴费")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/MyBillHistory"
    }
  }, [_vm._v("新生缴费历史")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/Print"
    }
  }, [_vm._v("打印报到单")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/Card"
    }
  }, [_vm._v("银行卡")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/Exit"
    }
  }, [_vm._v("退出")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), (_vm.tipText !== '') ? _c('div', {
    staticClass: "notice"
  }, [_c('van-notice-bar', {
    attrs: {
      "left-icon": "volume-o",
      "text": _vm.tipText
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.infoVisible),
      expression: "infoVisible"
    }],
    staticClass: "back-up",
    staticStyle: {
      "background-color": "#fff"
    }
  }, [_c('mt-button', {
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }, [_vm._v("提示")]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "height": "60px",
      "text-align": "center",
      "margin-top": "30px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v(_vm._s(_vm.termMsg))])])], 1), _vm._v(" "), _c('el-row', [_c('BigImg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showImg),
      expression: "showImg"
    }],
    staticStyle: {
      "z-index": "1001"
    },
    attrs: {
      "imgSrc": _vm.imgSrc
    },
    on: {
      "click": function($event) {
        return _vm.viewImg()
      }
    }
  })], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chooseDormVisible),
      expression: "chooseDormVisible"
    }]
  }, [_c('el-row', {
    staticStyle: {
      "background-color": "#fff"
    }
  }, [_c('el-row', {
    staticStyle: {
      "background-color": "#fff",
      "text-align": "center"
    }
  }, [_c('el-form', {
    ref: "dormSetForm",
    staticStyle: {
      "width": "50%",
      "background-color": "#fff",
      "margin": "auto"
    },
    attrs: {
      "model": _vm.dormSetForm,
      "label-width": "90px"
    }
  }, [_c('el-row', [_c('img', {
    staticClass: "banner-img",
    staticStyle: {
      "width": "50%",
      "height": "150px",
      "float": "left"
    },
    attrs: {
      "src": _vm.effectDrawing
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "banner-img",
    staticStyle: {
      "width": "50%",
      "height": "150px",
      "float": "right"
    },
    attrs: {
      "src": _vm.bedDiagram
    }
  })]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item1",
    attrs: {
      "label": "收费标准"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSetForm.price))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item1",
    attrs: {
      "label": "规格"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSetForm.dormStandard))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item1",
    attrs: {
      "label": "宿舍配置"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSetForm.roomSet))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item1",
    attrs: {
      "label": "公共配置"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSetForm.pubAreaSet))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item1",
    attrs: {
      "label": "所在区域"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSetForm.region))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item1",
    attrs: {
      "label": "备注"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSetForm.remark))])])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "background-color": "#fff",
      "text-align": "center"
    }
  }, [_c('el-form', {
    ref: "dormChooseForm",
    staticStyle: {
      "width": "50%",
      "background-color": "#fff",
      "margin": "auto"
    },
    attrs: {
      "inline": _vm.global.editInline,
      "model": _vm.dormChooseForm,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "公寓"
    }
  }, [_c('el-select', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "== 请选择 ==",
      "disabled": _vm.getDisableEdit('flatsName', 'form')
    },
    model: {
      value: (_vm.dormChooseForm['flatsName']),
      callback: function($$v) {
        _vm.$set(_vm.dormChooseForm, 'flatsName', $$v)
      },
      expression: "dormChooseForm['flatsName']"
    }
  }, _vm._l((_vm.modeSelector('Flats')), function(option) {
    return _c('el-option', {
      key: option.modeId,
      attrs: {
        "label": option.modeName,
        "value": option.modeId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "宿舍类型"
    }
  }, [_c('el-select', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "== 请选择 ==",
      "disabled": _vm.getDisableEdit('dormSet', 'form')
    },
    model: {
      value: (_vm.dormChooseForm['dormSet']),
      callback: function($$v) {
        _vm.$set(_vm.dormChooseForm, 'dormSet', $$v)
      },
      expression: "dormChooseForm['dormSet']"
    }
  }, _vm._l((_vm.modeSelector('Dorm_Set')), function(option) {
    return _c('el-option', {
      key: option.modeId,
      attrs: {
        "label": option.modeName,
        "value": option.modeId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "宿舍"
    }
  }, [_c('el-select', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "== 请选择 ==",
      "disabled": _vm.getDisableEdit('roomNo', 'form')
    },
    model: {
      value: (_vm.dormChooseForm['roomNo']),
      callback: function($$v) {
        _vm.$set(_vm.dormChooseForm, 'roomNo', $$v)
      },
      expression: "dormChooseForm['roomNo']"
    }
  }, _vm._l((_vm.modeSelector('Room')), function(option) {
    return _c('el-option', {
      key: option.modeId,
      attrs: {
        "label": option.modeName,
        "value": option.modeId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "床位"
    }
  }, [_c('el-select', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "== 请选择 ==",
      "disabled": _vm.getDisableEdit('bedNo', 'form')
    },
    model: {
      value: (_vm.dormChooseForm['bedNo']),
      callback: function($$v) {
        _vm.$set(_vm.dormChooseForm, 'bedNo', $$v)
      },
      expression: "dormChooseForm['bedNo']"
    }
  }, _vm._l((_vm.modeSelector('Bed')), function(option) {
    return _c('el-option', {
      key: option.modeId,
      attrs: {
        "label": option.modeName,
        "value": option.modeId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('span', {
    staticClass: "deg-title"
  }, [_vm._v("四人间床位  总计: " + _vm._s(_vm.fourBedSum) + "  剩余：" + _vm._s(_vm.fourBedRmi) + "  ")])]), _vm._v(" "), _c('el-form-item', [_c('span', {
    staticClass: "deg-title"
  }, [_vm._v("六人间床位  总计: " + _vm._s(_vm.sixBedSum) + "  剩余：" + _vm._s(_vm.sixBedRmi) + "  ")])]), _vm._v(" "), _c('el-form-item', [_c('span', {
    staticClass: "deg-title"
  }, [_vm._v("所选床位有效期20分钟 ！！！")])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.nextStep('Dorm')
      }
    }
  }, [_vm._v("下一步")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chooseDormConfigVisible),
      expression: "chooseDormConfigVisible"
    }]
  }, [_c('el-row', {
    staticClass: "form_main"
  }, [_c('el-form', {
    ref: "dormConfig",
    staticStyle: {
      "width": "80%",
      "background-color": "#fff",
      "margin": "auto"
    },
    attrs: {
      "model": _vm.curStudent,
      "label-width": "90px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    staticClass: "form-item",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "25px"
    }
  }, [_vm._v("宿舍用品选择")])]), _vm._v(" "), _c('el-checkbox-group', {
    model: {
      value: (_vm.dormConfigCheckList),
      callback: function($$v) {
        _vm.dormConfigCheckList = $$v
      },
      expression: "dormConfigCheckList"
    }
  }, _vm._l((_vm.dormConfigList), function(item) {
    return _c('el-form-item', {
      key: item.modeId,
      staticClass: "form-item"
    }, [_c('el-checkbox', {
      key: item.modeId,
      attrs: {
        "label": item.modeId
      },
      on: {
        "change": _vm.handleDormConfigChange
      }
    }, [_c('span', {
      staticClass: "label_detail"
    }, [_vm._v(_vm._s(item.modeId))]), _vm._v(" "), _c('span', {
      staticClass: "label_value",
      staticStyle: {
        "width": "85%",
        "text-overflow": "ellipsis",
        "white-space": "pre-line",
        "overflow": "hidden"
      }
    }, [_vm._v(_vm._s(item.modeValue + '元' + ' ( ' + item.modeName + ' ) '))])])], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding-top": "30px",
      "padding-left": "350px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.back('07')
      }
    }
  }, [_vm._v(">上一步")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.nextStep('DormConfig')
      }
    }
  }, [_vm._v(">下一步")])], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.feeListVisible),
      expression: "feeListVisible"
    }],
    staticStyle: {
      "background-color": "#fff",
      "text-align": "center"
    }
  }, [_c('el-row', [_c('el-form', {
    ref: "curStudent",
    staticStyle: {
      "width": "50%",
      "background-color": "#fff",
      "margin": "auto"
    },
    attrs: {
      "model": _vm.curStudent,
      "label-width": "90px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "姓名"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.curStudent.studentName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "身份证号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.curStudent.uid))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "专业"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.curStudent.majorMatr))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "学年"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.curStudent.enrollmentYear))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "应缴总额"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Ginkgo.format(_vm.feeSum.payableAmount, 'money')))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "减免总额"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Ginkgo.format(_vm.feeSum.reduceAmount, 'money')))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "实缴总额"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Ginkgo.format(_vm.feeSum.feeAmount, 'money')))])]), _vm._v(" "), _c('el-collapse', [_c('el-collapse-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "title": "费用明细",
      "name": "1"
    }
  }, [_c('el-row', _vm._l((_vm.feeList), function(item) {
    return _c('div', {
      key: item.feeNo,
      staticStyle: {
        "display": "flex",
        "text-align": "left"
      }
    }, [_c('span', {
      staticClass: "label_detail",
      staticStyle: {
        "padding-left": "130px"
      }
    }, [_vm._v(_vm._s(item.feeNo))]), _c('span', {
      staticClass: "label_value"
    }, [_vm._v(_vm._s(_vm.Ginkgo.format(item.feeAmount, 'money')))])])
  }), 0)], 1), _vm._v(" "), (false) ? _c('el-collapse-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "title": "公寓用品明细",
      "name": "2"
    }
  }, [_c('el-row', _vm._l((_vm.dormConfigCheckList), function(option) {
    return _c('div', {
      key: option,
      staticStyle: {
        "display": "flex",
        "text-align": "left"
      },
      attrs: {
        "value": option
      }
    }, [_c('span', {
      staticClass: "label_detail",
      staticStyle: {
        "padding-left": "20px"
      }
    }, [_vm._v(_vm._s(_vm.getDormLabel(option)))]), (!(_vm.global.dormConfigSet !== 1)) ? _c('span', {
      staticClass: "label_value"
    }, [_vm._v(_vm._s(_vm.global.dormConfigSet === 1 ? _vm.Ginkgo.format(_vm.getDormValue(option), 'money') : '1套'))]) : _vm._e()])
  }), 0)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('span', {
    staticClass: "deg-title"
  }, [_vm._v("所选床位即将失效，请尽快支付 ！！！")])])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.back('09')
      }
    }
  }, [_vm._v("上一步")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.payButtonDisable
    },
    on: {
      "click": function($event) {
        return _vm.toPay()
      }
    }
  }, [_vm._v("支 付")])], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.feeListHistoryVisible),
      expression: "feeListHistoryVisible"
    }]
  }, [_c('el-table', {
    ref: "resultTable",
    staticStyle: {
      "width": "100%",
      "margin-top": "10px"
    },
    attrs: {
      "data": _vm.tableData,
      "highlight-current-row": "",
      "stripe": "",
      "border": "",
      "height": _vm.global.tableHeight
    },
    on: {
      "sort-change": _vm.handleSortChangeHistory
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "fixed": "",
      "width": "60"
    }
  }), _vm._v(" "), _vm._l((_vm.getUISetQueryResult('01')), function(item) {
    return (_vm.getHeaderVisible(item, 1)) ? _c('el-table-column', {
      key: item.columnName,
      attrs: {
        "prop": item.columnProp,
        "label": item.columnDesc.split('|')[0],
        "min-width": item.colWidth,
        "align": item.alignType,
        "formatter": _vm.dataFormatHistory,
        "fixed": _vm.Ginkgo.getColumnFixed(item),
        "sortable": "custom",
        "header-align": "center"
      }
    }, _vm._l((_vm.getHeaderGroup(item, 2, '01')), function(item2) {
      return (_vm.getHeaderVisible(item2, 2)) ? _c('el-table-column', {
        key: item2.columnName,
        attrs: {
          "prop": item2.columnProp,
          "label": item2.columnDesc.split('|')[1],
          "min-width": item2.colWidth,
          "align": item2.alignType,
          "formatter": _vm.dataFormatHistory,
          "fixed": _vm.Ginkgo.getColumnFixed(item2),
          "sortable": "custom",
          "header-align": "center"
        }
      }, _vm._l((_vm.getHeaderGroup(item2, 3, '01')), function(item3) {
        return (_vm.getHeaderVisible(item3, 3)) ? _c('el-table-column', {
          key: item3.columnName,
          attrs: {
            "prop": item3.columnProp,
            "label": item3.columnDesc.split('|')[2],
            "min-width": item3.colWidth,
            "align": item3.alignType,
            "formatter": _vm.dataFormatHistory,
            "fixed": _vm.Ginkgo.getColumnFixed(item3),
            "sortable": "custom",
            "header-align": "center"
          }
        }) : _vm._e()
      }), 1) : _vm._e()
    }), 1) : _vm._e()
  })], 2), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "current-page": _vm.page.number + 1,
      "page-sizes": _vm.page.pageSizes,
      "page-size": _vm.page.size,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.page.totalElements,
      "page-count": _vm.page.totalPages
    },
    on: {
      "size-change": _vm.handleSizeChangeHistory,
      "current-change": _vm.handleCurrentChangeHistory
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-dialog', {
    attrs: {
      "title": "微信二维码",
      "visible": _vm.dialogFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-row', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.weixin
    }
  })])], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.payVisible),
      expression: "payVisible"
    }]
  }, [_c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buttonVisiblePFWX),
      expression: "buttonVisiblePFWX"
    }]
  }, [_c('mt-cell', {
    staticStyle: {
      "min-height": "65px"
    },
    attrs: {
      "title": "微信支付",
      "value": "使用微信支付，方便快捷",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doPay(_vm.payTypePFWX)
      }
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": _vm.wx,
      "width": "50",
      "height": "45"
    },
    slot: "icon"
  })])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buttonVisiblePFZFB),
      expression: "buttonVisiblePFZFB"
    }]
  }, [_c('mt-cell', {
    staticStyle: {
      "min-height": "65px"
    },
    attrs: {
      "title": "支付宝支付",
      "value": "使用支付宝支付，方便快捷",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doPay(_vm.payTypePFZFB)
      }
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": _vm.zfb,
      "width": "50",
      "height": "45"
    },
    slot: "icon"
  })])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buttonVisibleWX),
      expression: "buttonVisibleWX"
    }]
  }, [_c('mt-cell', {
    staticStyle: {
      "min-height": "65px"
    },
    attrs: {
      "title": "微信支付",
      "value": "使用微信支付，方便快捷",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doPay(_vm.payType)
      }
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": _vm.wx,
      "width": "50",
      "height": "45"
    },
    slot: "icon"
  })])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buttonVisibleZFB),
      expression: "buttonVisibleZFB"
    }]
  }, [_c('mt-cell', {
    staticStyle: {
      "min-height": "65px"
    },
    attrs: {
      "title": "支付宝支付",
      "value": "使用支付宝支付，方便快捷",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doPay(_vm.payTypeZFB)
      }
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": _vm.zfb,
      "width": "50",
      "height": "45"
    },
    slot: "icon"
  })])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buttonVisibleUnion),
      expression: "buttonVisibleUnion"
    }]
  }, [_c('mt-cell', {
    staticStyle: {
      "min-height": "65px"
    },
    attrs: {
      "title": "银联支付",
      "value": "使用银联支付，优惠多多",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doPay(_vm.payTypeUnion)
      }
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": _vm.yl,
      "width": "50",
      "height": "45"
    },
    slot: "icon"
  })])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.back('02')
      }
    }
  }, [_vm._v("上一步")])], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scanVisible),
      expression: "scanVisible"
    }]
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "align-items": "center"
    }
  }, [_c('vue-qr', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "logoSrc": _vm.qrImage,
      "text": _vm.qrContent,
      "size": 200
    }
  }), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.back('10')
      }
    }
  }, [_vm._v("上一步")])], 1)], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1278:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-row', {
    staticStyle: {
      "width": "70%",
      "margin": "0 auto"
    }
  }, [_c('el-row', [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": "/OfflinePay",
      "mode": "horizontal",
      "background-color": "#545c64",
      "text-color": "#fff",
      "active-text-color": "#ffd04b"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/MyBill"
    }
  }, [_vm._v("新生缴费")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/OfflinePay"
    }
  }, [_vm._v("线下审核")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/Exit"
    }
  }, [_vm._v("退出")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), (_vm.curStudent.studentName) ? _c('el-row', {
    staticClass: "content"
  }, [_c('el-row', {
    staticClass: "content-main"
  }, [_c('el-form', {
    staticStyle: {
      "background-color": "#fff"
    },
    attrs: {
      "model": _vm.curStudent,
      "label-width": "90px"
    }
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "姓名"
    }
  }, [_c('span', {
    staticClass: "label_value"
  }, [_vm._v(_vm._s(_vm.curStudent.studentName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "身份证号"
    }
  }, [_c('span', {
    staticClass: "label_value"
  }, [_vm._v(_vm._s(_vm.curStudent.uid))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "专业"
    }
  }, [_c('span', {
    staticClass: "label_value"
  }, [_vm._v(_vm._s(_vm.curStudent.majorMatr))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "学年"
    }
  }, [_c('span', {
    staticClass: "label_value"
  }, [_vm._v(_vm._s(_vm.curStudent.enrollmentYear))])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    staticClass: "content"
  }, [_c('el-row', {
    staticClass: "content-main"
  }, [_c('div', {
    staticClass: "section-title"
  }, [_vm._v("申请记录")]), _vm._v(" "), (_vm.applyList.length === 0) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "20px",
      "color": "#999"
    }
  }, [_vm._v("\n        暂无申请记录\n      ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.applyList), function(item) {
    return _c('div', {
      key: item.orderNo,
      staticClass: "apply-item"
    }, [_c('el-row', {
      staticClass: "apply-row"
    }, [_c('el-col', {
      attrs: {
        "span": 16
      }
    }, [_c('span', {
      staticClass: "apply-label"
    }, [_vm._v("申请单号：")]), _vm._v(" "), _c('span', {
      staticClass: "apply-value"
    }, [_vm._v(_vm._s(item.orderNo))])]), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "text-align": "right"
      },
      attrs: {
        "span": 8
      }
    }, [_c('van-tag', {
      attrs: {
        "type": _vm.getStatusTagType(item.dataStatus)
      }
    }, [_vm._v(_vm._s(_vm.formatStatus(item.dataStatus)))])], 1)], 1), _vm._v(" "), _c('el-row', {
      staticClass: "apply-row"
    }, [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', {
      staticClass: "apply-label"
    }, [_vm._v("申请时间：")]), _vm._v(" "), _c('span', {
      staticClass: "apply-value apply-time"
    }, [_vm._v(_vm._s(_vm.formatTime(item.dataTime)))])])], 1), _vm._v(" "), (item.userName) ? _c('el-row', {
      staticClass: "apply-row"
    }, [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', {
      staticClass: "apply-label"
    }, [_vm._v("申请人：")]), _vm._v(" "), _c('span', {
      staticClass: "apply-value"
    }, [_vm._v(_vm._s(item.userName))])])], 1) : _vm._e(), _vm._v(" "), (item.dataStatus === '02' && item.remark) ? _c('el-row', {
      staticClass: "apply-row"
    }, [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('span', {
      staticClass: "apply-label"
    }, [_vm._v("拒绝原因：")]), _vm._v(" "), _c('span', {
      staticClass: "apply-value reject-reason"
    }, [_vm._v(_vm._s(item.remark))])])], 1) : _vm._e()], 1)
  })], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1279:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-row', {
    staticStyle: {
      "width": "70%",
      "margin": "0 auto"
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "mode": "horizontal",
      "background-color": "#545c64",
      "text-color": "#fff",
      "active-text-color": "#ffd04b"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/Index"
    }
  }, [_vm._v("缴费页")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/Exit"
    }
  }, [_vm._v("退出")])], 1), _vm._v(" "), (_vm.tipText !== '') ? _c('div', {
    staticClass: "notice"
  }, [_c('van-notice-bar', {
    attrs: {
      "left-icon": "volume-o",
      "text": _vm.tipText
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mainVisible),
      expression: "mainVisible"
    }]
  }, [_c('div', {
    staticClass: "content-main"
  }, [_c('div', {
    staticClass: "content-tital"
  }, [_vm._v("公寓用品选择")]), _vm._v(" "), _c('el-checkbox-group', {
    staticClass: "content-group",
    model: {
      value: (_vm.dormConfigCheckList),
      callback: function($$v) {
        _vm.dormConfigCheckList = $$v
      },
      expression: "dormConfigCheckList"
    }
  }, [_vm._l((_vm.dormConfigList), function(item) {
    return [_c('el-checkbox', {
      key: item.modeId,
      staticClass: "content-group-item",
      attrs: {
        "disabled": item.field1 === '01',
        "label": item.modeId
      }
    }, [_c('div', [_c('div', [_vm._v(_vm._s(item.modeName))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "color": "#e6a23c",
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s('价格：' + _vm.Ginkgo.format(item.modeValue, 'money')))])])]), _vm._v(" "), _c('el-divider', {
      key: item.modeId,
      staticClass: "content-divider"
    })]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "content-refund"
  }, [_c('div', [_vm._v(_vm._s('退费金额:' + _vm.Ginkgo.format(_vm.refundMoney, 'money')))])]), _vm._v(" "), (false) ? _c('div', [_c('div', {
    staticClass: "content-tital"
  }, [_vm._v("退款银行卡信息")]), _vm._v(" "), (_vm.cardInfo.length === 0) ? _c('el-row', {
    staticStyle: {
      "height": "60px",
      "text-align": "center",
      "margin-top": "30px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("银行卡信息为空，请先去维护银行卡信息！")])]) : _c('el-form', {
    ref: "form",
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "80px",
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "账户名"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "true"
    },
    model: {
      value: (_vm.form.acnm),
      callback: function($$v) {
        _vm.$set(_vm.form, "acnm", $$v)
      },
      expression: "form.acnm"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "账户号"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "true"
    },
    model: {
      value: (_vm.form.acno),
      callback: function($$v) {
        _vm.$set(_vm.form, "acno", $$v)
      },
      expression: "form.acno"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户行"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "true"
    },
    model: {
      value: (_vm.form.bankNm),
      callback: function($$v) {
        _vm.$set(_vm.form, "bankNm", $$v)
      },
      expression: "form.bankNm"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "width": "100%",
      "margin": "20px auto"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("提 交")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipVisible),
      expression: "tipVisible"
    }]
  }, [_c('div', {
    staticClass: "content-main"
  }, [_c('div', {
    staticClass: "content-tital"
  }, [_vm._v("公寓用品领用项\n          "), (_vm.isClaim === '00') ? _c('el-tag', {
    staticClass: "style-tag",
    attrs: {
      "type": "success"
    }
  }, [_vm._v("已完成")]) : (_vm.isClaim === '01') ? _c('el-tag', {
    staticClass: "style-tag",
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("待确认")]) : _c('el-tag', {
    staticClass: "style-tag",
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("待领取")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "1rem 0 0 0"
    }
  }, [_c('table', {
    staticStyle: {
      "color": "rgb(9, 9, 9)",
      "text-align": "center",
      "border-collapse": "collapse",
      "width": "95%",
      "margin": "auto"
    },
    attrs: {
      "border": "1"
    }
  }, [_c('tr', {
    staticStyle: {
      "line-height": "4vh",
      "font-size": "1rem",
      "font-weight": "500",
      "background": "#409eff"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("项目")]), _vm._v(" "), _c('td', [_vm._v("收费标准(元)")]), _vm._v(" "), _c('td', [_vm._v("是否领取")])]), _vm._v(" "), _vm._l((_vm.claimApplyList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.supplyId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Ginkgo.format(item.feeAmount, 'money')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((item.applyStatus === '00') ? '是' : '否'))])])
  }), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background": "#f8e0bd"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("退款金额")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Ginkgo.format(_vm.refundMoney, 'money')))]), _vm._v(" "), _c('td')])], 2)]), _vm._v(" "), (_vm.isClaim === '01' && _vm.isApplyTime) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "padding": "15px 10px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "46%"
    },
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.update()
      }
    }
  }, [_vm._v("重新提交")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "46%"
    },
    attrs: {
      "type": "success",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.toPrint()
      }
    }
  }, [_vm._v("打印领用单")])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.printVisible),
      expression: "printVisible"
    }],
    ref: "printContent"
  }, [(_vm.claimApplyList.length > 0) ? _c('div', {
    staticClass: "content"
  }, [_c('el-row', {
    staticStyle: {
      "background-color": "#fff",
      "padding": "10px",
      "border-radius": "5px",
      "font-size": "3vw"
    }
  }, [_c('h1', {
    staticStyle: {
      "color": "rgb(9, 9, 9)",
      "text-align": "center",
      "font-size": "4.5vw",
      "padding": "0 0 1vh 0"
    }
  }, [_vm._v("西安翻译学院新生入学公寓用品领用单")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "85%"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "5px 0 0 0"
    }
  }, [_vm._v("姓名：" + _vm._s(_vm.curStudent.studentName))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px 0 0 0"
    }
  }, [_vm._v("性别：" + _vm._s(_vm.curStudent.sex))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px 0 0 0"
    }
  }, [_vm._v("学号：" + _vm._s(_vm.curStudent.studentNo))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px 0 0 0"
    }
  }, [_vm._v("领用点：" + _vm._s(_vm.claimApplyList[0].dealName))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px 0 0 0"
    }
  }, [_vm._v("公寓：" + _vm._s(_vm.dormRow.flatsName))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px 0 0 0"
    }
  }, [_vm._v("宿舍：" + _vm._s(_vm.dormRow.roomNo) + " 号 " + _vm._s(_vm.dormRow.bedNo) + " 床位")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px 0 0 0"
    }
  }, [_vm._v("申请日期：" + _vm._s(_vm.Ginkgo.format(_vm.claimApplyList[0].applyTm, 'time')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px 0 0 0"
    }
  }, [_vm._v("缴费订单号：" + _vm._s(_vm.dormOrderInfo.orderNo))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px 0 0 0"
    }
  }, [_vm._v("缴费日期：" + _vm._s(_vm.Ginkgo.format(_vm.dormOrderInfo.transDt + String(_vm.dormOrderInfo.transTm).padStart(6, '0'), 'time')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "15%"
    }
  }, [_c('vue-qr', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "logoSrc": _vm.imageUrl,
      "text": _vm.curStudent.studentNo,
      "size": 200
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "3px 0 0 0",
      "width": "50%"
    }
  }, [_vm._v("交费金额：" + _vm._s(_vm.Ginkgo.format(_vm.dormOrderInfo.feeAmount, 'money')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "3px 0 0 0",
      "width": "50%"
    }
  }, [_vm._v("退费金额：" + _vm._s(_vm.Ginkgo.format(_vm.refundMoney, 'money')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "15px 0"
    }
  }, [_c('table', {
    staticStyle: {
      "color": "rgb(9, 9, 9)",
      "text-align": "center",
      "border-collapse": "collapse",
      "font-size": "3vw",
      "width": "100%"
    },
    attrs: {
      "border": "1"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("项目")]), _vm._v(" "), _c('td', [_vm._v("收费标准(元)")]), _vm._v(" "), _c('td', [_vm._v("是否领取")])]), _vm._v(" "), _vm._l((_vm.claimApplyList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.supplyId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Ginkgo.format(item.feeAmount, 'money')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((item.applyStatus === '00') ? '是' : '否'))])])
  })], 2)])])], 1) : _vm._e()])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1280:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-row', {
    staticStyle: {
      "width": "70%",
      "margin": "0 auto"
    }
  }, [_c('el-row', [_c('el-row', [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": "/MyLoan",
      "mode": "horizontal",
      "background-color": "#545c64",
      "text-color": "#fff",
      "active-text-color": "#ffd04b"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/MyLoan"
    }
  }, [_vm._v("生源地贷款")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/OfflinePay"
    }
  }, [_vm._v("线下审核")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/Exit"
    }
  }, [_vm._v("退出")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chooseVisible),
      expression: "chooseVisible"
    }],
    staticClass: "back-up",
    staticStyle: {
      "background-color": "#fff"
    }
  }, [_c('el-row', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "30px"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0",
      "border": ""
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v("未办理生源地贷款")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1",
      "border": ""
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v("已办理生源地贷款")]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "20px auto"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.nextLoan()
      }
    }
  }, [_vm._v("下一步")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loanInfoVisible),
      expression: "loanInfoVisible"
    }],
    staticStyle: {
      "background-color": "#fff",
      "text-align": "center"
    }
  }, [_c('el-row', [_c('el-form', {
    ref: "loanForm",
    staticStyle: {
      "width": "50%",
      "margin": "20px auto"
    },
    attrs: {
      "inline": _vm.global.editInline,
      "model": _vm.loanForm,
      "label-width": _vm.formLabelWidth,
      "size": "medium",
      "inline-message": true,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "label": "贷款银行"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "== 请选择 =="
    },
    model: {
      value: (_vm.loanForm.bankType),
      callback: function($$v) {
        _vm.$set(_vm.loanForm, "bankType", $$v)
      },
      expression: "loanForm.bankType"
    }
  }, _vm._l((_vm.bankTypeList), function(option) {
    return _c('el-option', {
      key: option.modeId,
      attrs: {
        "label": option.modeName,
        "value": option.modeId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "label": "学生姓名"
    }
  }, [_c('span', {
    staticClass: "label_value"
  }, [_vm._v(_vm._s(_vm.loanForm.studentName))])]), _vm._v(" "), _c('el-form-item', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "label": "身份证"
    }
  }, [_c('span', {
    staticClass: "label_value"
  }, [_vm._v(_vm._s(_vm.loanForm.keyInfo))])]), _vm._v(" "), _c('el-form-item', {
    key: "Mobile",
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "label": "联系电话",
      "prop": "mobile"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.loanForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.loanForm, "mobile", $$v)
      },
      expression: "loanForm.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    key: "Loan_Amount",
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "label": "贷款金额",
      "prop": "loanAmount"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.loanForm.loanAmount),
      callback: function($$v) {
        _vm.$set(_vm.loanForm, "loanAmount", $$v)
      },
      expression: "loanForm.loanAmount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.loanForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.loanForm, "remark", $$v)
      },
      expression: "loanForm.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "贷款受理证明或回执单"
    }
  }, [_c('el-upload', {
    attrs: {
      "list-type": "picture-card",
      "action": _vm.uploadAction,
      "headers": _vm.uploadHead,
      "data": _vm.uploadData,
      "before-upload": _vm.beforeUploadLoan,
      "on-success": _vm.successUploadLoan,
      "on-error": _vm.errorUploadLoan,
      "accept": 'image/*',
      "on-remove": _vm.handleRemoveLoan,
      "before-remove": _vm.beforeRemoveLoan,
      "limit": 1,
      "on-exceed": _vm.handleExceedLoan,
      "on-change": _vm.handleUploadChangeLoan,
      "file-list": _vm.loanFileList
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "身份证国徽面照片"
    }
  }, [_c('el-upload', {
    attrs: {
      "list-type": "picture-card",
      "action": _vm.uploadAction,
      "headers": _vm.uploadHead,
      "data": _vm.uploadData,
      "before-upload": _vm.beforeUploadUidJust,
      "on-success": _vm.successUploadUidJust,
      "on-error": _vm.errorUploadUidJust,
      "accept": 'image/*',
      "on-remove": _vm.handleRemoveUidJust,
      "before-remove": _vm.beforeRemoveUidJust,
      "limit": 1,
      "on-exceed": _vm.handleExceedUidJust,
      "on-change": _vm.handleUploadChangeUidJust,
      "file-list": _vm.uidJustFileList
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "身份证人像面图片"
    }
  }, [_c('el-upload', {
    attrs: {
      "list-type": "picture-card",
      "action": _vm.uploadAction,
      "headers": _vm.uploadHead,
      "data": _vm.uploadData,
      "before-upload": _vm.beforeUploadUidBack,
      "on-success": _vm.successUploadUidBack,
      "on-error": _vm.errorUploadUidBack,
      "accept": 'image/*',
      "on-remove": _vm.handleRemoveUidBack,
      "before-remove": _vm.beforeRemoveUidBack,
      "limit": 1,
      "on-exceed": _vm.handleExceedUidBack,
      "on-change": _vm.handleUploadChangeUidBack,
      "file-list": _vm.uidBackFileList
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "其他证明图片"
    }
  }, [_c('el-upload', {
    attrs: {
      "list-type": "picture-card",
      "action": _vm.uploadAction,
      "headers": _vm.uploadHead,
      "data": _vm.uploadDataOther,
      "before-upload": _vm.beforeUploadOther,
      "on-success": _vm.successUploadOther,
      "on-error": _vm.errorUploadOther,
      "accept": 'image/*',
      "on-remove": _vm.handleRemoveOther,
      "before-remove": _vm.beforeRemoveOther,
      "multiple": "",
      "limit": 3,
      "on-exceed": _vm.handleExceedOther,
      "on-change": _vm.handleUploadChangeOther,
      "file-list": _vm.otherFileList
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "margin": "20px auto"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.back()
      }
    }
  }, [_vm._v("上一步")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.nextLoanInfo()
      }
    }
  }, [_vm._v("贷款资料备案上报")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.speedVisible),
      expression: "speedVisible"
    }],
    staticClass: "back-up",
    staticStyle: {
      "background-color": "#fff",
      "text-align": "center"
    }
  }, [_c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addVisible),
      expression: "addVisible"
    }],
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-top": "10px",
      "font-size": "14px"
    }
  }, [_c('span', [_vm._v("状态：提交成功。")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("贷款资料备案上报成功，请等待审核结果。")])]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "20px auto"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.home()
      }
    }
  }, [_vm._v("回首页")])], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.successVisible),
      expression: "successVisible"
    }],
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-top": "10px",
      "font-size": "14px"
    }
  }, [_c('span', [_vm._v("状态：审核通过。")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("恭喜你 " + _vm._s(_vm.dataDt) + " 号上报的贷款资料信息已经通过审核，生源地贷款可抵用学费和住宿费 " + _vm._s(_vm.amount) + " 元。")])]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "20px auto"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.nextPayFee()
      }
    }
  }, [_vm._v("下一步")])], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorVisible),
      expression: "errorVisible"
    }],
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-top": "10px",
      "font-size": "14px"
    }
  }, [_c('span', [_vm._v("状态：审核退回。")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("您可选择修改资料重新上报，或者放弃上报进入缴费流程。")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("原因：" + _vm._s(_vm.memo))])]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "20px auto"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.update()
      }
    }
  }, [_vm._v("修改资料")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.nextPayFee()
      }
    }
  }, [_vm._v("放弃上报")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-dialog', {
    attrs: {
      "title": "微信二维码",
      "visible": _vm.dialogFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-row', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.weixin
    }
  })])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1281:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-row', {
    staticStyle: {
      "width": "70%",
      "margin": "0 auto"
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "mode": "horizontal",
      "background-color": "#545c64",
      "text-color": "#fff",
      "active-text-color": "#ffd04b"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/Index"
    }
  }, [_vm._v("缴费页")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/Exit"
    }
  }, [_vm._v("退出")])], 1), _vm._v(" "), _c('div', [(false) ? _c('div', {
    staticClass: "notice"
  }, [_c('van-notice-bar', {
    attrs: {
      "left-icon": "volume-o",
      "text": "当前仅支持浦发银行储蓄卡"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mainVisible),
      expression: "mainVisible"
    }]
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [(_vm.cardList.length === 0) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "30px 10px",
      "background-color": "#fff",
      "border-radius": "5px",
      "width": "100%"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("暂无银行卡信息，请先新增！")])]) : _c('div', _vm._l((_vm.cardList), function(item) {
    return _c('el-card', {
      key: item.id,
      staticClass: "box-card",
      attrs: {
        "shadow": "never"
      }
    }, [_c('div', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleClick('update')
        }
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "center"
      }
    }, [_c('div', {
      staticStyle: {
        "background-color": "#fff",
        "border-radius": "100px"
      }
    }, [_c('i', {
      staticClass: "el-icon-bank-card",
      staticStyle: {
        "font-size": "22px",
        "padding": "5px",
        "color": "#e6a23c"
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "color": "#fff",
        "padding": "5px"
      }
    }, [_c('div', {
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(item.bankNm))]), _vm._v(" "), _c('div', [_vm._v("储蓄卡")])])]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "font-size": "16px",
        "padding": "10px 40px 0 40px",
        "color": "#fff"
      }
    }, [_vm._v(_vm._s(item.acnm))]), _vm._v(" "), _c('div', {
      staticClass: "bank-card-number"
    }, [_c('span', [_vm._v(_vm._s(item.acnoformat))])])])])])
  }), 1), _vm._v(" "), _c('i', {
    staticClass: "el-icon-circle-plus",
    staticStyle: {
      "font-size": "50px",
      "padding": "20px"
    },
    on: {
      "click": function($event) {
        return _vm.handleClick('save')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formVisible),
      expression: "formVisible"
    }],
    staticClass: "my-form"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "size": "mini",
      "rules": _vm.rules,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "账户名称",
      "prop": "acnm",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.form.acnm),
      callback: function($$v) {
        _vm.$set(_vm.form, "acnm", $$v)
      },
      expression: "form.acnm"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "账户号",
      "prop": "acno",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "clearable": ""
    },
    model: {
      value: (_vm.form.acno),
      callback: function($$v) {
        _vm.$set(_vm.form, "acno", $$v)
      },
      expression: "form.acno"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "开户行名称",
      "prop": "bankNm",
      "inline-message": true
    }
  }, [_c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "placement": "top-start",
      "content": "可通过手机银行APP查看账户详情，或致电银行客服获取"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.form.bankNm),
      callback: function($$v) {
        _vm.$set(_vm.form, "bankNm", $$v)
      },
      expression: "form.bankNm"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "开户行联行号",
      "prop": "bankNo",
      "inline-message": true
    }
  }, [_c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "placement": "top-start",
      "content": "一般为12位数字，可拨打对应银行客服电话查询"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.form.bankNo),
      callback: function($$v) {
        _vm.$set(_vm.form, "bankNo", $$v)
      },
      expression: "form.bankNo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "type": "info"
    },
    on: {
      "click": function($event) {
        return _vm.setVisible('01')
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "45%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("确认")])], 1)], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1282:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-row', {
    staticStyle: {
      "width": "70%",
      "margin": "0 auto"
    }
  }, [_c('el-row', [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": "/MyBill",
      "mode": "horizontal",
      "background-color": "#545c64",
      "text-color": "#fff",
      "active-text-color": "#ffd04b"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/MyBill"
    }
  }, [_vm._v("学期缴费")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/MyBillHistory"
    }
  }, [_vm._v("学期缴费历史")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/MyBillExam"
    }
  }, [_vm._v("其他缴费")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/MyBillHistoryExam"
    }
  }, [_vm._v("其他缴费历史")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/Card"
    }
  }, [_vm._v("银行卡")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/Exit"
    }
  }, [_vm._v("退出")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.feeTypeVisible),
      expression: "feeTypeVisible"
    }],
    staticClass: "back-up",
    staticStyle: {
      "background-color": "#fff"
    }
  }, [_c('el-row', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "30px"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0",
      "border": ""
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v("按学年")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1",
      "border": ""
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v("按学期")]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "20px auto"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.nextFee()
      }
    }
  }, [_vm._v("下一步")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.semesterPayVisible),
      expression: "semesterPayVisible"
    }],
    staticStyle: {
      "background-color": "#fff"
    }
  }, [_c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticStyle: {
      "background-color": "#fff",
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-top": "12px",
      "border-radius": "8px"
    },
    attrs: {
      "src": "",
      "width": "90",
      "height": "120"
    }
  })]), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.billVisible),
      expression: "billVisible"
    }]
  }, [_c('el-form', {
    ref: "viewForm",
    staticStyle: {
      "width": "50%",
      "background-color": "#fff",
      "margin": "auto"
    },
    attrs: {
      "model": _vm.viewForm,
      "label-width": "100px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "学号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.studentNo))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "姓名"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.studentName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "专业"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.majorMatr))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "班级"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.className))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "学年"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.academicYear))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "应缴总额"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Ginkgo.format(_vm.viewForm.payableAmount, 'money')))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "减免总额"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Ginkgo.format(_vm.viewForm.reduceAmount, 'money')))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "实缴总额"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Ginkgo.format(_vm.viewForm.feeAmount, 'money')))])]), _vm._v(" "), _c('el-collapse', [_c('el-collapse-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "title": "费用明细",
      "name": "1"
    }
  }, [_c('el-row', [_vm._l((_vm.feeData), function(item) {
    return _c('div', {
      key: item.feeNo
    }, [_c('span', {
      staticClass: "label_detail"
    }, [_vm._v(_vm._s(item.feeName))]), _c('span', {
      staticClass: "label_value"
    }, [_vm._v(_vm._s(_vm.Ginkgo.format(item.feeAmount, 'money')))])])
  }), _vm._v(" "), _vm._l((_vm.reduceList), function(item) {
    return _c('div', {
      key: item.feeNo
    }, [_c('span', {
      staticClass: "label_detail"
    }, [_vm._v(_vm._s(item.feeNo))]), _c('span', {
      staticClass: "label_value"
    }, [_vm._v(_vm._s(_vm.Ginkgo.format(item.feeAmount, 'money')))])])
  })], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.examBillVisible),
      expression: "examBillVisible"
    }]
  }, [_c('el-form', {
    ref: "viewForm",
    staticStyle: {
      "width": "50%",
      "background-color": "#fff",
      "margin": "auto"
    },
    attrs: {
      "model": _vm.viewForm,
      "label-width": "100px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "学号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.studentNo))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "姓名"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.studentName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "专业"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.majorMatr))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "班级"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.className))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "学年"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.academicYear))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "学期"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.viewForm.termNM))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "总额"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Ginkgo.format(_vm.viewForm.totals, 'money')))])]), _vm._v(" "), _c('el-collapse', [_c('el-collapse-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "title": "费用明细"
    }
  }, [_c('el-row', [_c('el-table', {
    ref: "feeResultTable",
    attrs: {
      "data": _vm.feeData
    },
    on: {
      "selection-change": _vm.handleSelectionChange,
      "row-click": _vm.isShow
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "费用项",
      "prop": "feeNo"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "金额",
      "prop": "feeAmount",
      "formatter": _vm.dataFormat,
      "align": "right"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.termVisible),
      expression: "termVisible"
    }]
  }, [_c('span', [_vm._v(_vm._s(_vm.termMsg))])]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [(_vm.backVisible) ? _c('el-button', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.back()
      }
    }
  }, [_vm._v("上一步")]) : _vm._e(), _vm._v(" "), (_vm.feePayType_UN) ? _c('el-button', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "type": "primary",
      "disabled": _vm.payButtonDisable
    },
    on: {
      "click": function($event) {
        return _vm.toPay()
      }
    }
  }, [_vm._v("银联支付")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.feeListHistoryVisible),
      expression: "feeListHistoryVisible"
    }]
  }, [_c('el-table', {
    ref: "resultTable",
    staticStyle: {
      "width": "100%",
      "margin-top": "10px"
    },
    attrs: {
      "data": _vm.tableData,
      "highlight-current-row": "",
      "stripe": "",
      "border": "",
      "height": _vm.global.tableHeight
    },
    on: {
      "sort-change": _vm.handleSortChangeHistory
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "fixed": "",
      "width": "60"
    }
  }), _vm._v(" "), _vm._l((_vm.getUISetQueryResult('01')), function(item) {
    return (_vm.getHeaderVisible(item, 1)) ? _c('el-table-column', {
      key: item.columnName,
      attrs: {
        "prop": item.columnProp,
        "label": item.columnDesc.split('|')[0],
        "min-width": item.colWidth,
        "align": item.alignType,
        "formatter": _vm.dataFormatHistory,
        "fixed": _vm.Ginkgo.getColumnFixed(item),
        "sortable": "custom",
        "header-align": "center"
      }
    }, _vm._l((_vm.getHeaderGroup(item, 2, '01')), function(item2) {
      return (_vm.getHeaderVisible(item2, 2)) ? _c('el-table-column', {
        key: item2.columnName,
        attrs: {
          "prop": item2.columnProp,
          "label": item2.columnDesc.split('|')[1],
          "min-width": item2.colWidth,
          "align": item2.alignType,
          "formatter": _vm.dataFormatHistory,
          "fixed": _vm.Ginkgo.getColumnFixed(item2),
          "sortable": "custom",
          "header-align": "center"
        }
      }, _vm._l((_vm.getHeaderGroup(item2, 3, '01')), function(item3) {
        return (_vm.getHeaderVisible(item3, 3)) ? _c('el-table-column', {
          key: item3.columnName,
          attrs: {
            "prop": item3.columnProp,
            "label": item3.columnDesc.split('|')[2],
            "min-width": item3.colWidth,
            "align": item3.alignType,
            "formatter": _vm.dataFormatHistory,
            "fixed": _vm.Ginkgo.getColumnFixed(item3),
            "sortable": "custom",
            "header-align": "center"
          }
        }) : _vm._e()
      }), 1) : _vm._e()
    }), 1) : _vm._e()
  })], 2), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "current-page": _vm.page.number + 1,
      "page-sizes": _vm.page.pageSizes,
      "page-size": _vm.page.size,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.page.totalElements,
      "page-count": _vm.page.totalPages
    },
    on: {
      "size-change": _vm.handleSizeChangeHistory,
      "current-change": _vm.handleCurrentChangeHistory
    }
  })], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.examListHistoryVisible),
      expression: "examListHistoryVisible"
    }]
  }, [_c('el-table', {
    ref: "resultTable",
    staticStyle: {
      "width": "100%",
      "margin-top": "10px"
    },
    attrs: {
      "data": _vm.tableData,
      "highlight-current-row": "",
      "stripe": "",
      "border": "",
      "height": _vm.global.tableHeight
    },
    on: {
      "sort-change": _vm.handleSortChangeHistory
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "fixed": "",
      "width": "60"
    }
  }), _vm._v(" "), _vm._l((_vm.getUISetQueryResult('02')), function(item) {
    return (_vm.getHeaderVisible(item, 1)) ? _c('el-table-column', {
      key: item.columnName,
      attrs: {
        "prop": item.columnProp,
        "label": item.columnDesc.split('|')[0],
        "min-width": item.colWidth,
        "align": item.alignType,
        "formatter": _vm.dataFormatExamHistory,
        "fixed": _vm.Ginkgo.getColumnFixed(item),
        "sortable": "custom",
        "header-align": "center"
      }
    }, _vm._l((_vm.getHeaderGroup(item, 2, '02')), function(item2) {
      return (_vm.getHeaderVisible(item2, 2)) ? _c('el-table-column', {
        key: item2.columnName,
        attrs: {
          "prop": item2.columnProp,
          "label": item2.columnDesc.split('|')[1],
          "min-width": item2.colWidth,
          "align": item2.alignType,
          "formatter": _vm.dataFormatExamHistory,
          "fixed": _vm.Ginkgo.getColumnFixed(item2),
          "sortable": "custom",
          "header-align": "center"
        }
      }, _vm._l((_vm.getHeaderGroup(item2, 3, '02')), function(item3) {
        return (_vm.getHeaderVisible(item3, 3)) ? _c('el-table-column', {
          key: item3.columnName,
          attrs: {
            "prop": item3.columnProp,
            "label": item3.columnDesc.split('|')[2],
            "min-width": item3.colWidth,
            "align": item3.alignType,
            "formatter": _vm.dataFormatExamHistory,
            "fixed": _vm.Ginkgo.getColumnFixed(item3),
            "sortable": "custom",
            "header-align": "center"
          }
        }) : _vm._e()
      }), 1) : _vm._e()
    }), 1) : _vm._e()
  })], 2), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "current-page": _vm.page.number + 1,
      "page-sizes": _vm.page.pageSizes,
      "page-size": _vm.page.size,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.page.totalElements,
      "page-count": _vm.page.totalPages
    },
    on: {
      "size-change": _vm.handleSizeChangeHistory,
      "current-change": _vm.handleCurrentChangeHistory
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-dialog', {
    attrs: {
      "title": "微信二维码",
      "visible": _vm.dialogFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-row', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.weixin
    }
  })])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1283:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-row', [_c('van-nav-bar', {
    attrs: {
      "fixed": true,
      "left-text": "返回",
      "left-arrow": ""
    },
    on: {
      "click-left": _vm.back
    }
  }), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "38px 0 8px"
    }
  }, [_c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buttonVisiblePFWX),
      expression: "buttonVisiblePFWX"
    }]
  }, [_c('mt-cell', {
    staticStyle: {
      "min-height": "65px"
    },
    attrs: {
      "title": "微信支付",
      "value": "使用微信支付，方便快捷",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doPay(_vm.payTypePFWX)
      }
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": _vm.wx,
      "width": "50",
      "height": "45"
    },
    slot: "icon"
  })])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buttonVisiblePFZFB),
      expression: "buttonVisiblePFZFB"
    }]
  }, [_c('mt-cell', {
    staticStyle: {
      "min-height": "65px"
    },
    attrs: {
      "title": "支付宝支付",
      "value": "使用支付宝支付，方便快捷",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doPay(_vm.payTypePFZFB)
      }
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": _vm.zfb,
      "width": "50",
      "height": "45"
    },
    slot: "icon"
  })])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buttonVisibleWX),
      expression: "buttonVisibleWX"
    }]
  }, [_c('mt-cell', {
    staticStyle: {
      "min-height": "65px"
    },
    attrs: {
      "title": "微信支付",
      "value": "使用微信支付，方便快捷",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doPay(_vm.payType)
      }
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": _vm.wx,
      "width": "50",
      "height": "45"
    },
    slot: "icon"
  })])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buttonVisibleZFB),
      expression: "buttonVisibleZFB"
    }]
  }, [_c('mt-cell', {
    staticStyle: {
      "min-height": "65px"
    },
    attrs: {
      "title": "支付宝支付",
      "value": "使用支付宝支付，方便快捷",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doPay(_vm.payTypeZFB)
      }
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": _vm.zfb,
      "width": "50",
      "height": "45"
    },
    slot: "icon"
  })])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buttonVisibleUnion),
      expression: "buttonVisibleUnion"
    }]
  }, [_c('mt-cell', {
    staticStyle: {
      "min-height": "65px"
    },
    attrs: {
      "title": "银联支付",
      "value": "使用银联支付，优惠多多",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doPay(_vm.payTypeUnion)
      }
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "src": _vm.yl,
      "width": "50",
      "height": "45"
    },
    slot: "icon"
  })])], 1), _vm._v(" "), _c('el-row', [_c('mt-cell', {
    staticStyle: {
      "min-height": "65px"
    },
    attrs: {
      "title": "线下缴费",
      "value": "前往财务处现场缴费(现金缴费)",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.doPay('09')
      }
    }
  }, [_c('van-icon', {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "slot": "icon",
      "name": "cash-on-deliver",
      "size": "40"
    },
    slot: "icon"
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1320:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./assets/images/children/timg.png": 1236,
	"./assets/logo.png": 1237,
	"./assets/logo2.png": 1238,
	"./assets/theme-default/images/1.png": 1239,
	"./assets/theme-default/images/admin.png": 1240,
	"./assets/theme-default/images/admin1.png": 1241,
	"./assets/theme-default/images/logo2.png": 1242,
	"./assets/theme-default/images/yxlogo.png": 1243,
	"./assets/theme-default/images/zftlogo.png": 1244
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1320;

/***/ }),

/***/ 1321:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Nothing.vue": 569,
	"./Todo.vue": 1264,
	"./XiFan/DormOld.vue": 570,
	"./XiFan/LoanXiFan.vue": 277,
	"./XiFan/LoanXiFanNew.vue": 278,
	"./XiFan/LoginDormOld.vue": 571,
	"./XiFan/LoginXiFan.vue": 69,
	"./XiFan/MyBillXiFan.vue": 279,
	"./XiFan/MyBillXiFanNew.vue": 150,
	"./XiFan/MyBillXiFanZSB.vue": 280,
	"./XiFan/MyBillXiFan_bak.vue": 1265,
	"./XiFan/NewStudent/OfflinePay.vue": 122,
	"./XiFan/NewStudent/card.vue": 151,
	"./XiFan/NewStudent/receive.vue": 572,
	"./XiFan/PayType.vue": 1266
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1321;

/***/ }),

/***/ 1322:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(291);
module.exports = __webpack_require__(599);


/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1199)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(657),
  /* template */
  __webpack_require__(1267),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1209)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(661),
  /* template */
  __webpack_require__(1281),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e49cd92e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(652),
  /* template */
  __webpack_require__(1272),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(653),
  /* template */
  __webpack_require__(1280),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1201)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(656),
  /* template */
  __webpack_require__(1270),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1206)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(658),
  /* template */
  __webpack_require__(1277),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 300:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getToken = getToken;
exports.setToken = setToken;
exports.removeToken = removeToken;
exports.getExpires = getExpires;
exports.setExpires = setExpires;

var _jsCookie = __webpack_require__(1213);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TokenKey = 'Auth-Token';
var ExpiresIn = 'Auth-Expires';

function getToken() {
  return _jsCookie2.default.get(TokenKey);
}

function setToken(token) {
  return _jsCookie2.default.set(TokenKey, token);
}

function removeToken() {
  _jsCookie2.default.set(ExpiresIn, 0);
  return _jsCookie2.default.remove(TokenKey);
}

function getExpires() {
  return _jsCookie2.default.get(ExpiresIn);
}

function setExpires() {
  return _jsCookie2.default.set(ExpiresIn, new Date().getTime());
}

/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(649),
  /* template */
  __webpack_require__(1275),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1204)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(651),
  /* template */
  __webpack_require__(1274),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4f038206",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1202)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(654),
  /* template */
  __webpack_require__(1271),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 572:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1208)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(662),
  /* template */
  __webpack_require__(1279),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7e332a9a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 599:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(25);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(1261);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(645);

var _router2 = _interopRequireDefault(_router);

var _elementUi = __webpack_require__(417);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(1190);

var _mintUi = __webpack_require__(1224);

var _mintUi2 = _interopRequireDefault(_mintUi);

__webpack_require__(1189);

__webpack_require__(1197);

__webpack_require__(1198);

__webpack_require__(1195);

__webpack_require__(1196);

__webpack_require__(291);

var _http = __webpack_require__(644);

var _http2 = _interopRequireDefault(_http);

var _vueAxios = __webpack_require__(1259);

var _vueAxios2 = _interopRequireDefault(_vueAxios);

var _Ginkgo = __webpack_require__(643);

var _Ginkgo2 = _interopRequireDefault(_Ginkgo);

var _Global = __webpack_require__(1263);

var _Global2 = _interopRequireDefault(_Global);

var _BigImg = __webpack_require__(1262);

var _BigImg2 = _interopRequireDefault(_BigImg);

var _echarts = __webpack_require__(908);

var _echarts2 = _interopRequireDefault(_echarts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.prototype.Ginkgo = _Ginkgo2.default;
// import AppMobile from './AppMobile'
// import App from './AppPublicDemo'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

_vue2.default.prototype.global = _Global2.default;

// 显示大图（组件）

var BigImg = {
  install: function install(Vue) {
    Vue.component('BigImg', _BigImg2.default);
  }
};
_vue2.default.use(BigImg);

_vue2.default.config.productionTip = false;

_vue2.default.use(_elementUi2.default, { size: 'small' });
_vue2.default.use(_vueAxios2.default, _http2.default);
_vue2.default.use(_mintUi2.default);

_vue2.default.prototype.$echarts = _echarts2.default;
/* eslint-disable no-new */
new _vue2.default({
  el: '#app',
  router: _router2.default,
  template: '<App/>',
  components: { App: _App2.default }
});

// new Vue({
//   el: '#appMobile',
//   router,
//   template: '<AppMobile/>',
//   components: { AppMobile }
// })
// router.beforeEach((to, from, next) => { // 只有页面切换时才生效，第一次不生效
//   console.log(to.meta.title)
//   console.log(from.meta.title)
//   // console.log(next.meta.title)
//   document.title = to.meta.title || 'GSV1'
//   // if (!to.query.url && from.query.url) {
//   //   to.query.url = from.query.url
//   // }
//   next()
// })
// router.afterEach(function (transition) {
//   if (transition.to.meta.title) {
//     document.title = transition.to.meta.title
//   }
// })

/***/ }),

/***/ 643:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(126);

var _typeof3 = _interopRequireDefault(_typeof2);

var _accounting = __webpack_require__(601);

var _accounting2 = _interopRequireDefault(_accounting);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _jsencrypt = __webpack_require__(1216);

__webpack_require__(274);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  // ==========================================================================================================
  //  common
  // ==========================================================================================================
  redirectUrl: function redirectUrl() {
    location.href = '/login';
  },
  // ==========================================================================================================
  //  StringPlus
  // ==========================================================================================================
  // 格式化字符串
  format: function format(s, formatString) {
    if (formatString === '') {
      return s;
    }
    if (formatString === 'money') {
      return _accounting2.default.formatNumber(s, 2);
    }
    if (formatString === 'number') {
      return _accounting2.default.formatNumber(s, 2, '');
    }
    if (formatString === 'time') {
      return (0, _moment2.default)((0, _moment2.default)(s, 'YYYYMMDDHHmmss').toDate()).format('YYYY-MM-DD HH:mm:ss');
    }
  },
  formatTableCell: function formatTableCell(s, columnSet, dept, mode) {
    var cellValue = s;
    var formatString = columnSet.formatString;
    if (formatString === 'money') {
      cellValue = _accounting2.default.formatNumber(s, 2);
    }
    if (dept) {
      if (columnSet.columnProp === 'deptNo') {
        cellValue = dept.deptNo;
      }
      if (columnSet.columnProp === 'deptName') {
        cellValue = dept.shortName;
      }
    }
    if (mode) {
      cellValue = mode.modeName;
    }
    return cellValue;
  },
  // 金额小写转大写
  digitUppercase: function digitUppercase(n) {
    var fraction = ['角', '分'];
    var digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
    var unit = [['元', '万', '亿'], ['', '拾', '佰', '仟']];
    var head = n < 0 ? '欠' : '';
    n = Math.abs(n);
    var s = '';
    for (var i = 0; i < fraction.length; i++) {
      s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
    }
    s = s || '整';
    n = Math.floor(n);
    for (var _i = 0; _i < unit[0].length && n > 0; _i++) {
      var p = '';
      for (var j = 0; j < unit[1].length && n > 0; j++) {
        p = digit[n % 10] + unit[1][j] + p;
        n = Math.floor(n / 10);
      }
      s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][_i] + s;
    }
    return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整');
  },
  // 验证字符串是否是数字
  isNumber: function isNumber(v) {
    var reg = /^[-]?[0-9]+.?[0-9]*$/;
    if (reg.test(v)) {
      return true;
    }
    return false;
  },
  // 验证字符串是否是金额
  isMoney: function isMoney(v) {
    var reg = /(^[-]?[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
    if (reg.test(v)) {
      return true;
    }
    return false;
  },
  // 验证手机号格式
  isMobile: function isMobile(v) {
    var reg = /^1[3-9]{1}[0-9]{9}$/;
    if (reg.test(v)) {
      return true;
    }
    return false;
  },
  // 验证身份证格式
  isUid: function isUid(v) {
    var reg = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
    var reg1 = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$/;
    if (reg.test(v) || reg1.test(v)) {
      return true;
    }
    return false;
  },
  // 验证银行卡号
  validateBankCard: function validateBankCard(cardNumber) {
    // 1. 预处理：移除所有非数字字符（如空格）
    var cleaned = cardNumber.replace(/\D/g, '');
    // 2. 校验长度（13-19 位数字）
    if (cleaned.length < 13 || cleaned.length > 19) {
      return false;
    }
    // 3. Luhn 算法校验
    var sum = 0;
    // 从倒数第二位开始，从右向左遍历（跳过校验位）
    for (var i = cleaned.length - 2; i >= 0; i--) {
      var digit = parseInt(cleaned[i], 10);
      // 对于从右数的奇数位（即从左数时，与校验位相隔奇数个位置的数字），乘以2
      // 计算位置：从右往左数，跳过校验位后，第一个位置是位置1，第二个是位置2，依此类推
      var positionFromRight = cleaned.length - i - 1;
      if (positionFromRight % 2 === 1) {
        digit = digit * 2 > 9 ? digit * 2 - 9 : digit * 2;
      }
      sum += digit;
    }
    // 计算校验和并验证
    var checkDigit = parseInt(cleaned[cleaned.length - 1], 10);
    return (10 - sum % 10) % 10 === checkDigit;
  },
  // 验证开户行联行号
  validateBankNo: function validateBankNo(bankNo) {
    var reg = /^\d{12}$/;
    if (reg.test(bankNo)) {
      return true;
    }
    return false;
  },
  // Excel导入值处理
  validCellValue: function validCellValue(cellValue, dataType) {
    var v = cellValue || '';
    var valid = true;
    switch (dataType) {
      case '02':
        // 结果是数字
        v = v === '' ? '0' : v;
        valid = this.isNumber(v);
        break;
      default:
        break;
    }
    return valid;
  },
  // Excel导入值处理
  getCellValue: function getCellValue(cellValue, dataType) {
    var v = cellValue || '';
    switch (dataType) {
      case '02':
        // 结果是数字
        v = v === '' ? '0' : v;
        break;
      default:
        break;
    }
    return v;
  },
  // ==========================================================================================================
  //  DatePlus
  // ==========================================================================================================
  // 获取系统默认的日期（根据实际系统确定）
  getDefaultDate: function getDefaultDate() {
    return this.dateAdd(new Date(), -1);
  },
  getMonthFirstDay: function getMonthFirstDay(d) {
    var t = new Date(d); // 复制并操作新对象，避免改动原对象
    t.setDate(1);
    return t;
  },
  // 当月首日
  getCurMonthFirstDay: function getCurMonthFirstDay() {
    return new Date();
  },
  // 上月首日
  getPrevMonthFirstDay: function getPrevMonthFirstDay(d) {
    var t = new Date(d); // 复制并操作新对象，避免改动原对象
    return this.monthAdd(this.getMonthFirstDay(t), -1);
  },
  // 上月末
  getPrevMonthEndDay: function getPrevMonthEndDay() {
    return new Date();
  },
  // 年初
  getCurYearFirstDay: function getCurYearFirstDay(d) {
    var result = this.dateToInt(d);
    result = result.toString().substr(0, 4) + '01';

    return this.intToDate(result);
  },
  // 上年末
  getPrevYearEndDay: function getPrevYearEndDay() {
    return new Date();
  },
  // 在当前日期上增加天数 d: 当前日期 n: 增加的天数
  dateAdd: function dateAdd(d, n) {
    var t = new Date(d); // 复制并操作新对象，避免改动原对象
    t.setDate(t.getDate() + n);
    return t;
  },
  monthAdd: function monthAdd(d, n) {
    var t = new Date(d); // 复制并操作新对象，避免改动原对象
    t.setMonth(t.getMonth() + n);
    return t;
  },
  dateToInt: function dateToInt(d) {
    return (0, _moment2.default)(d).format('YYYYMMDD');
  },
  intToDate: function intToDate(d) {
    return (0, _moment2.default)(d, 'YYYYMMDD').toDate();
  },
  getTimeStamp: function getTimeStamp(d) {
    return (0, _moment2.default)(d).format('YYYYMMDDHHmmss');
  },
  getToday: function getToday(d) {
    return (0, _moment2.default)(d).format('YYYY-MM-DD');
  },
  getTodayTime: function getTodayTime(d) {
    return (0, _moment2.default)(d).format('YYYY-MM-DD HH:mm:ss');
  },
  // formatString: YYYYMMDD, YYYY-MM-DD
  getDateByFormat: function getDateByFormat(d, formatString) {
    return (0, _moment2.default)(d).format('YYYY-MM-DD');
  },
  // ==========================================================================================================
  //  TableRender
  // ==========================================================================================================
  // 获取同组记录
  getHeaderGroup: function getHeaderGroup(item, level, uiSetList) {
    var newColumnList = [];
    // 筛选字符串(例：当前列名为【A|B|C】则第2层筛选为 A ; 第3层筛选为 A|B 依此类推)
    var match = '';
    var captions = item.columnDesc.split('|');
    // 标题层数比实际层数大或者相等才开始筛选
    if (captions.length >= level) {
      // 匹配字符串永远比层数少一层
      for (var i = 0; i < level - 1; i++) {
        match = match + captions[i] + '|';
      }
    }
    // match = match.substring(0, match.length - 1) // 去掉最后的'|'号匹配

    // 筛选同组记录
    uiSetList.filter(function (element) {
      // console.log('第 ' + level + ' 层：match=' + match)
      return element.columnDesc.indexOf(match) >= 0 && captions.length >= level;
    }).forEach(function (element) {
      // 同级包含相同match的只加一次
      if (newColumnList.filter(function (newItem) {
        return newItem.columnDesc.split('|')[level - 1] === element.columnDesc.split('|')[level - 1];
      }).length === 0) {
        newColumnList.push(element);
      }
    });
    // console.log('第 ' + level + ' 层：列名： = ' + item.columnDesc + '；新列表数 = ' + newColumnList.length)
    return newColumnList;
  },
  // 列可见性
  getHeaderVisible: function getHeaderVisible(item, level, fixed) {
    var visible = false;
    if (fixed) {
      // 配置为不可见的列不展示在表格中
      if (item.queryVisible === '1' && item.columnType !== '02' && item.isFixCol === fixed) {
        // 第一层只有isGroupStart配置为【1】的列显示
        if (level === 1) {
          visible = item.isGroupStart === '1';
        } else {
          visible = item.columnDesc.split('|').length >= level;
        }
      }
    } else {
      if (item.queryVisible === '1' && item.columnType !== '02') {
        // 第一层只有isGroupStart配置为【1】的列显示
        if (level === 1) {
          visible = item.isGroupStart === '1';
        } else {
          visible = item.columnDesc.split('|').length >= level;
        }
      }
    }

    // if (item.queryVisible === '1' && item.columnType === '03' && item.isFixCol === fixed) {
    //   visible = true
    // }
    return visible;
  },
  // 操作列可见性
  getOpVisible: function getOpVisible(uiSetList) {
    var visible = false;
    if (uiSetList.filter(function (element) {
      return element.columnType === '02' && element.queryVisible === '1';
    }).length > 0) {
      visible = true;
    }
    return visible;
  },
  // 列是否固定设置
  getColumnFixed: function getColumnFixed(item) {
    return item.isFixCol === '1' ? 'left' : false;
  },
  // 对象拷贝
  cloneObj: function cloneObj(obj) {
    var newObj = {};
    if (obj instanceof Array) {
      newObj = [];
    }
    for (var key in obj) {
      var val = obj[key];
      newObj[key] = (typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) === 'object' ? this.cloneObj(val) : val;
    }
    return newObj;
  },
  // 构建交叉表
  createCrossTable1: function createCrossTable1(crossResultList, crossItemList, uiSetList, uiSet) {
    // console.log(uiSet, crossResultList, crossItemList)
    var self = this;
    var resultList = [];
    // ==========================构建固定列===========================
    crossResultList.forEach(function (item) {
      var row = {};
      // 取每一行的固定列
      uiSetList.forEach(function (column) {
        if (column.isCross !== '1') {
          row[column.columnProp] = item[column.columnProp];
        }
      });
      // 去重复
      var t = resultList.filter(function (element) {
        var isMatch = true;
        uiSetList.filter(function (matchKey) {
          return matchKey.isUnique === '1';
        }).forEach(function (key) {
          isMatch = isMatch && element[key.columnProp] === item[key.columnProp];
        });
        return isMatch;
      });

      // 结果集逐行添加固定列部分
      if (t.length === 0) {
        resultList.push(row);
      }
    });
    // console.log('固定列结果集：', resultList)
    // ==========================构建交叉列===========================
    var crossColumnSet = []; // 根据交叉项产生的新列设置
    crossItemList.forEach(function (item) {
      // console.log(':: 当前交叉项：' + item.itemName)

      // 筛选符合当前交叉项的列
      var tmpList = crossResultList.filter(function (element) {
        var isMatch = true;
        uiSet.crossItemNo.split(',').forEach(function (key) {
          // console.log('key:', key, 'item:', item[key])
          isMatch = isMatch && element[key] === item[key];
        });
        return isMatch;
      });
      // console.log('tmpList:length=' + tmpList.length)
      // console.log('当前列结果集tmpList=', tmpList)

      // ==========================填充当前行的当前交叉项的属性(构造新的uiSetList)==============================
      uiSetList.forEach(function (column) {
        // 配置了几个交叉项数据就增加几个属性
        if (column.isCross === '1') {
          // console.log('当前交叉列为：' + column.columnProp)
          // 重构新列名
          var newColumnName = column.columnProp;
          uiSet.crossItemNo.split(',').forEach(function (key) {
            newColumnName = newColumnName + item[key];
          });
          // console.log('当前新列名：' + newColumnName)

          // 将新列的设置加入columnSet
          var newColumnSet = self.cloneObj(column);
          // console.log('当前新列设置：' + newColumnSet.columnDesc)
          // 更新属性（列名、列属性，其他不变）
          newColumnSet.columnProp = newColumnName;
          newColumnSet.columnName = newColumnName;
          newColumnSet.isCross = '0';
          newColumnSet.columnDesc = '';

          uiSet.crossItemName.split(',').forEach(function (key) {
            // console.log('key:', key, 'item:', item[key])
            newColumnSet.columnDesc = newColumnSet.columnDesc + item[key];
            newColumnSet.columnDesc = newColumnSet.columnDesc + '|';
          });
          newColumnSet.columnDesc = newColumnSet.columnDesc.substring(0, newColumnSet.columnDesc.length - 1); // 去掉末尾的‘|’号
          item.sortNo = item.sortNo || '99';

          newColumnSet.sortNo = newColumnSet.sortNo + '|' + item.sortNo; // 编辑界面顺序
          newColumnSet.sortNoResult = newColumnSet.sortNoResult + '|' + item.sortNo; // 查询结果顺序
          // console.log('更改后新列设置：列名：' + newColumnSet.columnDesc + '; 属性名：' + newColumnSet.columnDesc)
          // console.log('原始列设置：列名：' + column.columnDesc + '; 属性名：' + column.columnDesc)

          // 设置多层表头的组起始值
          var a = crossColumnSet.filter(function (element) {
            return element.columnDesc.split('|')[0] === newColumnSet.columnDesc.split('|')[0];
          }).length;

          if (a === 0) {
            newColumnSet.isGroupStart = '1';
          } else {
            newColumnSet.isGroupStart = '0';
          }

          // 添加到columnSet上
          crossColumnSet.push(newColumnSet);

          // ==============================为结果集填充每一行的交叉项数据===================================
          resultList.forEach(function (row) {
            // 找到符合当前固定列的剩余交叉项部分（只有一条）
            var crossItem = tmpList.filter(function (element) {
              var isMatch = true;
              uiSetList.filter(function (matchKey) {
                return matchKey.isUnique === '1';
              }).forEach(function (key) {
                isMatch = isMatch && element[key.columnProp] === row[key.columnProp];
              });
              return isMatch;
            });
            // console.log('crossItem===', crossItem)
            if (crossItem.length > 0) {
              row[newColumnName] = crossItem[0][column.columnProp]; // 交叉列赋值
            }
          });
        }
      });
    });
    // 清除交叉项数据设置
    uiSetList = uiSetList.filter(function (element) {
      return element.isCross !== '1';
    });
    // 合并columnSet和crossColumnSet
    uiSetList = uiSetList.concat(crossColumnSet);

    var obj = {};
    obj.resultList = resultList;
    obj.uiSetList = uiSetList;
    // console.log('obj:', obj)

    return obj;
  },
  // 构建交叉表
  createCrossTable: function createCrossTable(crossResultList, crossItemList, uiSetList, uiSet) {
    // console.log('yyyyyyyyyyy', crossResultList, crossItemList)
    var self = this;
    var resultList = [];
    var row = null;
    // 前提：先按主键排序
    // ==========================构建交叉表===========================
    crossResultList.forEach(function (item) {
      // console.log('xxxxxxxxxx', resultList, row)
      if (row) {
        // 校验当前行是否与当前row主键匹配
        var isMatch = true;
        uiSetList.filter(function (matchKey) {
          return matchKey.isUnique === '1';
        }).forEach(function (key) {
          isMatch = isMatch && row[key.columnProp] === item[key.columnProp];
        });

        if (isMatch) {
          // -----------------------如果匹配上，则赋交叉项的值-----------------
          uiSetList.filter(function (crossItem) {
            return crossItem.isCross === '1';
          }).forEach(function (element) {
            // 每一个交叉项赋值
            // 构建新列属性名
            var newColumnProp = element.columnProp;
            uiSet.crossItemNo.split(',').forEach(function (key) {
              newColumnProp = newColumnProp + item[key]; // item[key]主表肯定有
            });
            row[newColumnProp] = item[element.columnProp];
          });
        } else {
          // ------------------不匹配创建新对象-------------------
          // 先添加原对象
          var tmpObj = self.cloneObj(row);
          resultList.push(tmpObj);
          // 再清空对象重新开始
          row = {};
          // 取每一行的固定列
          uiSetList.forEach(function (column) {
            if (column.isCross !== '1') {
              row[column.columnProp] = item[column.columnProp];
            }
          });
          // 取当前行的交叉项数据
          uiSetList.filter(function (crossItem) {
            return crossItem.isCross === '1';
          }).forEach(function (element) {
            // 每一个交叉项赋值
            // 构建新列属性名
            var newColumnProp = element.columnProp;
            uiSet.crossItemNo.split(',').forEach(function (key) {
              newColumnProp = newColumnProp + item[key]; // item[key]主表肯定有
            });
            row[newColumnProp] = item[element.columnProp];
          });
        }
      } else {
        // 第一次循环
        row = {};
        // 取每一行的固定列
        uiSetList.forEach(function (column) {
          if (column.isCross !== '1') {
            row[column.columnProp] = item[column.columnProp];
          }
        });
        // 取当前行的交叉项数据
        uiSetList.filter(function (crossItem) {
          return crossItem.isCross === '1';
        }).forEach(function (element) {
          // 每一个交叉项赋值
          // 构建新列属性名
          var newColumnProp = element.columnProp;
          uiSet.crossItemNo.split(',').forEach(function (key) {
            newColumnProp = newColumnProp + item[key]; // item[key]主表肯定有
          });
          row[newColumnProp] = item[element.columnProp];
        });
      }
    });
    // 处理最后一条数据
    if (row) {
      resultList.push(row);
    }
    // console.log('固定列结果集：', resultList)
    // ==========================构建交叉列===========================
    var crossColumnSet = []; // 根据交叉项产生的新列设置
    crossItemList.forEach(function (item) {
      // console.log(':: 当前交叉项：' + item.itemName)
      // console.log('tmpList:length=' + tmpList.length)
      // console.log('当前列结果集tmpList=', tmpList)

      // ==========================填充当前行的当前交叉项的属性(构造新的uiSetList)==============================
      uiSetList.forEach(function (column) {
        // 配置了几个交叉项数据就增加几个属性
        if (column.isCross === '1') {
          // console.log('当前交叉列为：' + column.columnProp)
          // 重构新列名
          var newColumnName = column.columnProp;
          uiSet.crossItemNo.split(',').forEach(function (key) {
            newColumnName = newColumnName + item[key];
          });
          // console.log('当前新列名：' + newColumnName)

          // 将新列的设置加入columnSet
          var newColumnSet = self.cloneObj(column);
          // console.log('当前新列设置：' + newColumnSet.columnDesc)
          // 更新属性（列名、列属性，其他不变）
          newColumnSet.columnProp = newColumnName;
          newColumnSet.columnName = newColumnName;
          newColumnSet.isCross = '0';
          newColumnSet.columnDesc = '';

          uiSet.crossItemName.split(',').forEach(function (key) {
            // console.log('key:', key, 'item:', item[key])
            newColumnSet.columnDesc = newColumnSet.columnDesc + item[key];
            newColumnSet.columnDesc = newColumnSet.columnDesc + '|';
          });
          newColumnSet.columnDesc = newColumnSet.columnDesc.substring(0, newColumnSet.columnDesc.length - 1); // 去掉末尾的‘|’号
          item.sortNo = item.sortNo || '99';

          newColumnSet.sortNo = newColumnSet.sortNo + '|' + item.sortNo; // 编辑界面顺序
          newColumnSet.sortNoResult = newColumnSet.sortNoResult + '|' + item.sortNo; // 查询结果顺序
          // console.log('更改后新列设置：列名：' + newColumnSet.columnDesc + '; 属性名：' + newColumnSet.columnDesc)
          // console.log('原始列设置：列名：' + column.columnDesc + '; 属性名：' + column.columnDesc)

          // 设置多层表头的组起始值
          var a = crossColumnSet.filter(function (element) {
            return element.columnDesc.split('|')[0] === newColumnSet.columnDesc.split('|')[0];
          }).length;

          if (a === 0) {
            newColumnSet.isGroupStart = '1';
          } else {
            newColumnSet.isGroupStart = '0';
          }

          // 添加到columnSet上
          crossColumnSet.push(newColumnSet);
        }
      });
    });
    // 清除交叉项数据设置
    uiSetList = uiSetList.filter(function (element) {
      return element.isCross !== '1';
    });
    // 合并columnSet和crossColumnSet
    uiSetList = uiSetList.concat(crossColumnSet);

    var obj = {};
    obj.resultList = resultList;
    obj.uiSetList = uiSetList;
    // console.log('obj:', obj)

    return obj;
  },
  // sorts形如：[{prop: 'id', order: 'ascending'}, {prop: 'name', order: 'descending'}]
  sort: function sort(list, sorts) {
    // console.log('sorts', sorts)
    var match = [];
    var resultList = [];
    var self = this;
    sorts.forEach(function (element) {
      resultList = [];
      // console.log('list', list)
      // 构建排序
      var tmpList = [];
      if (match.length > 0) {
        list.forEach(function (listItem) {
          var obj = {};
          match.forEach(function (matchItem) {
            obj[matchItem.prop] = listItem[matchItem.prop];
          });
          // 只加入不重复的数据
          if (tmpList.length === 0) {
            tmpList.push(obj);
          } else {
            var rep = tmpList.filter(function (tmpItem) {
              var bIsRep = true;
              match.forEach(function (matchItem) {
                bIsRep = bIsRep && tmpItem[matchItem.prop] === obj[matchItem.prop];
              });
              return bIsRep;
            });
            if (rep.length === 0) {
              tmpList.push(obj);
            }
          }
        });
      }
      // 根据tmpList筛选符合条件的子数组排序
      if (tmpList.length > 0) {
        // 递归
        tmpList.forEach(function (tmpItem) {
          var childList = list.filter(function (resultItem) {
            var bIsMatch = true;
            match.forEach(function (matchItem) {
              bIsMatch = bIsMatch && resultItem[matchItem.prop] === tmpItem[matchItem.prop];
            });
            return bIsMatch;
          });
          resultList = resultList.concat(self.sortList(childList, element));
          // console.log('childList:', childList)
        });
        list = resultList;
        // console.log('resultList:', resultList)
      } else {
        // 第一次
        resultList = self.sortList(list, element);
      }
      match.push({ prop: element.prop });
    });
    // console.log('resultList:', resultList)
    return resultList;
  },
  // 单排序
  sortList: function sortList(list, sort) {
    var resultList = [];
    if (sort.order === 'ascending') {
      resultList = list.sort(function (a, b) {
        return a[sort.prop] > b[sort.prop] ? 1 : -1;
      });
    } else {
      resultList = list.sort(function (a, b) {
        return b[sort.prop] > a[sort.prop] ? 1 : -1;
      });
    }
    return resultList;
  },
  // 输出sql初始化脚本
  toSql: function toSql(tableName, uiSetList, resultList) {
    var sqlString = '';
    resultList.forEach(function (element) {
      var insertString = '';
      var valueString = '';
      insertString = insertString + 'insert into ' + tableName + '(';
      valueString = valueString + '    values(';
      uiSetList.forEach(function (column) {
        if (column.columnType !== '02') {
          insertString = insertString + column.columnName + ', ';
          if (element[column.columnProp] === null || element[column.columnProp] === undefined) {
            element[column.columnProp] = '';
          }
          valueString = valueString + '\'' + element[column.columnProp] + '\', ';
        }
      });
      insertString = insertString.substr(0, insertString.length - 2) + ')' + '\r\n';
      valueString = valueString.substr(0, valueString.length - 2) + ');' + '\r\n';
      sqlString = sqlString + insertString + valueString;
    });
    return sqlString;
  },
  // 输出sql初始化脚本
  toJson: function toJson(uiSetList) {
    var self = this;
    var jsonString = '[\r\n';
    var objString = '  {';
    uiSetList.forEach(function (element) {
      if (element.columnType !== '02') {
        objString = objString + element.columnProp + ': \'' + self.getDefaultValue(element) + '\', ';
      }
    });
    objString = objString.substr(0, objString.length - 2) + '}' + '\r\n';
    jsonString = jsonString + objString;
    jsonString = jsonString + ']';
    return jsonString;
  },
  // ==========================================================================================================
  //  UIRender
  // ==========================================================================================================
  getDefaultValue: function getDefaultValue(uiSetColumn) {
    var defaultValue = '';

    defaultValue = uiSetColumn.defaultValue;

    if (uiSetColumn.controlType === '03' || uiSetColumn.controlType === '04') {
      switch (defaultValue) {
        case '':
          defaultValue = new Date();
          break;
        case '01':
          // 系统报表日期
          defaultValue = this.getDefaultDate();
          break;
        case '02':
          // 月初
          defaultValue = this.getDefaultDate();
          break;
        case '03':
          // 年末
          defaultValue = this.getDefaultDate();
          break;
        default:
          if (defaultValue.length > 0) {
            defaultValue = this.intToDate(defaultValue);
          }
          break;
      }
    }
    return defaultValue;
  },
  // 查询条件默认值
  getDefaultValueQuery: function getDefaultValueQuery(uiSetColumn) {
    var defaultValue = '';

    defaultValue = uiSetColumn.defaultValueCond || '';

    if (uiSetColumn.controlType === '03' || uiSetColumn.controlType === '04') {
      switch (defaultValue) {
        case '':
          defaultValue = new Date();
          break;
        case '01':
          defaultValue = new Date();
          break;
        case '02':
          defaultValue = this.getDefaultDate();
          break;
        case '03':
          // 上月初到当日
          defaultValue = [this.getPrevMonthFirstDay(new Date()), new Date()];
          break;
        case '04':
          // 本年初到当日
          defaultValue = [this.getCurYearFirstDay(new Date()), new Date()];
          break;
        case '05':
          // 本月初到当日
          defaultValue = [this.getMonthFirstDay(new Date()), new Date()];
          break;
        default:
          if (defaultValue.length > 0) {
            defaultValue = this.intToDate(defaultValue);
          }
          break;
      }
    }
    return defaultValue;
  },
  // 设置初值，用于导入或者提供给服务使用
  setDefaultValue: function setDefaultValue(uiSetColumn) {
    var defaultValue = '';

    defaultValue = uiSetColumn.defaultValue;

    if (uiSetColumn.controlType === '03' || uiSetColumn.controlType === '04') {
      switch (defaultValue) {
        case '':
          defaultValue = this.dateToInt(new Date());
          break;
        case '01':
          defaultValue = this.dateToInt(new Date());
          break;
        case '02':
          defaultValue = this.dateToInt(this.getDefaultDate());
          break;
        default:
          break;
      }
    }
    return defaultValue.toString();
  },
  // controlType: 01 文本框 02 下拉框 03 日期框 04 日期范围框 05 级联下拉框 06 文本域 07 数字框；
  // selectType: 下拉框类型： 01 数据字典 02 机构
  // item: uiSetItem对象
  getVisibleControlQuery: function getVisibleControlQuery(controlType, item, selectType) {
    var visible = true;
    if (item.controlType === '01' || item.controlType === '06' || item.controlType === '07') {
      // 查询条件窗体03 06 07类型的控件都映射为文本框
      visible = visible && controlType === '01';
    } else {
      visible = visible && item.controlType === controlType;
    }
    if (controlType === '02' || controlType === '05') {
      if (selectType === '01') {
        visible = visible && item.typeId !== 'Dept';
        visible = visible && item.typeId !== 'Project';
        visible = visible && item.typeId !== 'Staff';
        visible = visible && item.typeId !== 'Term';
      }
      if (selectType === '02') {
        visible = visible && item.typeId === 'Dept';
      }
      if (selectType === '03') {
        visible = visible && item.typeId === 'Project';
      }
      if (selectType === '04') {
        visible = visible && item.typeId === 'Staff';
      }
      if (selectType === '05') {
        visible = visible && item.typeId === 'Term';
      }
    }

    return visible;
  },
  // controlType: 01 文本框 02 下拉框 03 日期框 04 日期范围框 05 级联下拉框 06 文本域 07 数字框；
  // selectType: 下拉框类型： 01 数据字典 02 机构 03 项目 04 员工
  // item: uiSetItem对象
  getVisibleControlEdit: function getVisibleControlEdit(controlType, item, selectType) {
    var visible = true;
    if (item.controlType === '03' || item.controlType === '04') {
      // 编辑窗体03 04类型的控件都映射为日期框
      visible = visible && controlType === '03';
    } else {
      visible = visible && item.controlType === controlType;
    }

    if (controlType === '02' || controlType === '05') {
      if (selectType === '01') {
        visible = visible && item.typeId !== 'Dept';
        visible = visible && item.typeId !== 'Project';
        visible = visible && item.typeId !== 'Staff';
        visible = visible && item.typeId !== 'Term';
      }
      if (selectType === '02') {
        visible = visible && item.typeId === 'Dept';
      }
      if (selectType === '03') {
        visible = visible && item.typeId === 'Project';
      }
      if (selectType === '04') {
        visible = visible && item.typeId === 'Staff';
      }
      if (selectType === '05') {
        visible = visible && item.typeId === 'Term';
      }
    }

    return visible;
  },
  // 根据配置初始化窗体对象（用于查询窗体）
  initQueryForm: function initQueryForm(uiSetList, uiSetId) {
    var self = this;
    var obj = {};
    uiSetList.filter(function (item) {
      return item.uiSetId === uiSetId && item.columnType !== '02';
    }).forEach(function (element) {
      if (element.controlType === '05') {
        obj[element.columnProp + 'Cas'] = [];
        obj[element.columnProp] = self.getDefaultValueQuery(element) || '';
      } else if (element.controlType === '04') {
        // 处理日期范围框
        obj[element.columnProp + 'Range'] = [new Date(), new Date()];
        if (element.defaultValueCond !== '') {
          obj[element.columnProp + 'Range'] = self.getDefaultValueQuery(element);
        }
      } else if (element.controlType === '03') {
        // 处理日期框
        if (element.queryCondition === '1') {
          obj[element.columnProp] = new Date();
        } else {
          obj[element.columnProp] = 0;
        }
      } else {
        obj[element.columnProp] = self.getDefaultValueQuery(element) || '';
      }
    });
    return obj;
  },
  // 根据UISet获取默认排序对象
  getDefaultSort: function getDefaultSort(uiSet) {
    var sort = [];
    if (uiSet.sortSet) {
      var sortList = uiSet.sortSet.split(',');

      var obj = {};
      for (var i = 0; i < sortList.length; i++) {
        if (i % 2 === 1) {
          // 每两次添加一个对象
          obj.order = sortList[i] === '01' ? 'ascending' : 'descending';
          sort.push(obj);
        }
        if (i % 2 === 0) {
          // 每两次创建新对象
          obj = {};
          obj.prop = sortList[i];
        }
      }
    }
    return sort;
  },
  // 根据配置初始化窗体对象（用于新增和编辑窗体）
  resetForm: function resetForm(uiSetList, uiSetId) {
    var self = this;
    var obj = {};
    uiSetList.filter(function (item) {
      return item.uiSetId === uiSetId && item.columnType !== '02';
    }).forEach(function (element) {
      if (element.controlType === '05') {
        obj[element.columnProp + 'Cas'] = [];
        obj[element.columnProp] = self.getDefaultValue(element);
      } else {
        obj[element.columnProp] = self.getDefaultValue(element);
      }
    });
    return obj;
  },
  getRuleProp: function getRuleProp(uiSetColumn) {
    var prop = uiSetColumn.columnProp;
    if (uiSetColumn.controlType === '05') {
      prop = prop + 'Cas';
    }
    return prop;
  },

  // 根据选中的行赋值窗体对象（用于编辑）-- 注意05类型的控件需要手工处理
  setFormByRow: function setFormByRow(uiSetList, uiSetId, row) {
    var self = this;
    var obj = {};
    uiSetList.filter(function (item) {
      return item.uiSetId === uiSetId && item.columnType !== '02';
    }).forEach(function (element) {
      if (element.controlType === '03' || element.controlType === '04') {
        if (row[element.columnProp]) {
          obj[element.columnProp] = self.intToDate(row[element.columnProp].toString().replace('-', ''));
        }
      } else {
        obj[element.columnProp] = row[element.columnProp] || '';
        if (element.controlType !== '02' && element.controlType !== '05') {
          obj[element.columnProp] = obj[element.columnProp].toString();
        }
        if (element.controlType === '05') {
          obj[element.columnProp + 'Cas'] = [];
        }
        if (row[element.columnProp] === 0) {
          obj[element.columnProp] = '0';
        }
      }
    });
    return obj;
  },
  getEditItemClass: function getEditItemClass(inline) {
    if (inline) {
      return 'edit-form-item';
    } else {
      return '';
    }
  },
  // 组织树方法
  // pId: 父ID的属性名
  // id: ID的属性名
  // label: 显示属性名
  getTree: function getTree(resultList, parentId, pId, id, label) {
    var self = this;
    var treeList = [];
    resultList.filter(function (element) {
      // 筛选与父ID相同的记录
      if (element[pId] === parentId) {
        return element;
      }
    }).forEach(function (element) {
      var tmpList = resultList.filter(function (e) {
        // 筛选是否有子
        return e[pId] === element[id];
      });

      var node = {};
      node.label = element[label];
      node.value = element[id];

      if (tmpList.length > 0) {
        // 如果有子
        // 递归
        node.children = self.getTree(resultList, element[id], pId, id, label);
        treeList.push(node);
      } else {
        treeList.push(node);
      }
    });
    return treeList;
  },
  // ==========================================================================================================
  //  业务
  // ==========================================================================================================
  // 取当前机构对应的客户信息
  getCustomerByDeptId: function getCustomerByDeptId(deptList, customerList, deptId) {
    var customer = [];

    customer = customerList.filter(function (element) {
      return element.deptId === deptId;
    });

    if (customer.length === 0) {
      var dept = deptList.filter(function (element) {
        return element.deptId === deptId;
      });
      if (dept.length > 0) {
        deptId = dept[0].parentDeptId;
        customer = this.getCustomerByDeptId(deptList, customerList, deptId);
      }
    }
    return customer;
  },
  // 取当前机构对应的客户商户信息
  getMerchantByDeptId: function getMerchantByDeptId(deptList, merchantList, deptId) {
    var merchant = [];

    merchant = merchantList.filter(function (element) {
      return element.deptId === deptId;
    });

    if (merchant.length === 0) {
      var dept = deptList.filter(function (element) {
        return element.deptId === deptId;
      });
      if (dept.length > 0) {
        deptId = dept[0].parentDeptId;
        merchant = this.getMerchantByDeptId(deptList, merchantList, deptId);
      }
    }
    return merchant;
  },
  // 判断当前机构是否是顶级机构(客户映射的机构)
  IsTopDept: function IsTopDept(deptId, customerList) {
    var customer = customerList.filter(function (element) {
      return element.deptId === deptId;
    });
    if (customer.length > 0) {
      return true;
    } else {
      return false;
    }
  },
  // 取有客户对应的机构列表
  getDeptListForSet: function getDeptListForSet(customerList, deptList) {
    var deptListForSet = [];
    customerList.forEach(function (element) {
      var dept = deptList.filter(function (item) {
        return item.deptId === element.deptId;
      });
      if (dept.length > 0) {
        // 只加入不重复的数据
        if (deptListForSet.length === 0) {
          deptListForSet.push(dept[0]);
        } else {
          var rep = deptListForSet.filter(function (deptItem) {
            return deptItem.deptId === element.deptId;
          });
          if (rep.length === 0) {
            deptListForSet.push(dept[0]);
          }
        }
      }
    });
    var sorts = [{ prop: 'deptLevel', order: 'ascending' }, { prop: 'sortNo', order: 'ascending' }];
    deptListForSet = this.sort(deptListForSet, sorts);
    return deptListForSet;
  },
  // 根据传入的机构列表筛选所有叶子节点或者某一个父级节点的所有叶子节点
  // deptList: 传入的机构列表
  // parent： 限制条件，取该机构的所有子(仅叶子)
  getDeptLeaf: function getDeptLeaf(deptList, parent) {
    var leafList = [];
    deptList.forEach(function (dept) {
      var tmpList = deptList.filter(function (element) {
        return element.parentDeptId === dept.deptId;
      });
      if (tmpList.length === 0) {
        // 没有子的才加
        if (parent) {
          if (dept.fullNodeId.indexOf(parent.fullNodeId) >= 0) {
            leafList.push(dept);
          }
        } else {
          leafList.push(dept);
        }
      }
    });
    return leafList;
  },
  // 根据传入的机构列表筛选该机构及其子机构
  // deptList: 传入的机构列表
  // deptId 限制条件，取该机构的所有子
  getDeptChild: function getDeptChild(deptList, deptId) {
    var child = [];
    var dept = deptList.filter(function (element) {
      return element.deptId === deptId;
    });
    if (dept) {
      child = deptList.filter(function (item) {
        return item.fullNodeId.indexOf(dept[0].fullNodeId) >= 0;
      });
    }
    return child;
  },
  // 获取顺序中第一个叶子节点
  getFirstDeptLeaf: function getFirstDeptLeaf(deptList) {
    var leaf = {};
    for (var i = 0; i < deptList.length; i++) {
      var tmpList = deptList.filter(function (element) {
        return element.parentDeptId === deptList[i].deptId;
      });
      if (tmpList.length === 0) {
        // 没有子的才加
        leaf = deptList[i];
        break;
      }
    }
    return leaf;
  },
  // 获取当前叶子机构的级联值（用于赋默认值）
  getDeptCascader: function getDeptCascader(deptList, leaf) {
    var deptIdCas = [];
    if (leaf) {
      var parent = deptList.filter(function (element) {
        return element.deptId === leaf.parentDeptId;
      });
      if (parent) {
        deptIdCas.push(leaf.deptId);
        deptIdCas = this.getDeptCascader(deptList, parent[0]).concat(deptIdCas);
      } else {
        deptIdCas.push(leaf.deptId);
      }
    }
    return deptIdCas;
  },
  // 获取机构列表的最大机构号
  getMaxDeptNo: function getMaxDeptNo(deptleafList) {
    var deptNo = '';
    var list = deptleafList.filter(function (element) {
      return element.deptType === '07';
    });
    if (list.length === 0) {
      deptNo = '001';
    } else {
      var sort = { prop: 'deptNo', order: 'descending' };
      list = this.sortList(list, sort);
      // deptNo = (parseInt(list[0].deptNo) + 1).toString()
      deptNo = (1000 + (parseInt(list[0].deptNo) + 1)).toString().substring(1);
    }
    return deptNo;
  },
  // 获取机构列表的最大排序号
  getMaxSortNo: function getMaxSortNo(deptleafList) {
    var sortNo = '';
    var list = deptleafList.filter(function (element) {
      return element.deptType === '07';
    });
    if (list.length === 0) {
      sortNo = '001';
    } else {
      var sort = { prop: 'sortNo', order: 'descending' };
      list = this.sortList(list, sort);
      sortNo = (1000 + (parseInt(list[0].sortNo) + 1)).toString().substring(1);
    }
    return sortNo;
  },
  getHeaderAlign: function getHeaderAlign(item) {
    var align = 'left';
    if (item.dataType === '02') {
      align = 'right';
    }
    return align;
  },
  getUuid: function getUuid() {
    var s = [];
    var hexDigits = '0123456789abcdef';
    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = '4';
    s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1);
    s[8] = s[13] = s[18] = s[23];
    var uuid = s.join('');
    return uuid;
  },
  // 脱敏-将传入字符串全部替换成*号
  getStar: function getStar(s) {
    return s.replace(/[\w\W]/g, '*');
  },
  // RSA非对称加密
  // @param str 需要加密的数据
  encrypt: function encrypt(str) {
    var publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDAtlteJ0hGQJrOblUPodxeW2sgG1T+IjffZSNz3Y2Ew51VWIElJHoFEQLPS4uvMmoHVO6Lx7SY95qTv0WK4sQkRxhbLSY70pwckyfWwiX5vLNDXIQu9Rc3f7C0GXqnFYtGEsPbbYdKinjujTwz7xcYptG0oQCsRJnJ9q/NFbpTowIDAQAB';
    var encryptor = new _jsencrypt.JSEncrypt();
    str = encodeURIComponent(str);
    // 设置公钥
    encryptor.setPublicKey(publicKey);
    // 加密数据
    var splitStr = [];
    var size = 64;
    if (str.length < size) {
      splitStr[0] = encryptor.encrypt(str);
    } else {
      var count = Math.ceil(str.length / size);
      for (var i = 0; i < count; i++) {
        if (i === 0) {
          splitStr.push(encryptor.encrypt(str.substring(i, size)));
        } else if (i > 0 && i < count - 1) {
          splitStr.push(encryptor.encrypt(str.substring(i * size, (i + 1) * size)));
        } else {
          splitStr.push(encryptor.encrypt(str.substring(i * size, str.length)));
        }
      }
    }
    return splitStr;
  },
  // RSA 解密
  // @param str 需要解密的数据
  rsaDecrypt: function rsaDecrypt(strs) {
    // 私钥，复制对应的私钥用于解密
    var PRIVATE_KEY = 'MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBAMC+c4Ihml7Gv4WRlV+Cm16iPmJ2T4r75jcL9gQO7UzAZzMpCaLH8WuEkO/gQzqUOZogkIA+N1Bb7TFbt3OP1ibJ6WNQ2+Jm0QLYHF5xTFgfI9dAbQlg9eIMMGFigmPVAMz66ng1VbI+364641DhxPKNyIENsilVhEuhNU2tj22lAgMBAAECgYABU8O79wzv6D8Al2XEFafCyVZwhehebAWEFIVIUt8Zxl0sAGcP3IALIafyD8w2tqkiNrqiqhk7hSWjsxd6ky2z7YD1MVdRIVgxtxVtKD86UU1Wc1WooFgI9b0sq+vlM429XeHcC+xYiELFV1BWi1hldxw6jutDkNmfkUX11VDrkwJBAN8YmtroBUGOEWK2PAqjlGOdROpbFMricz5VwtZ9uzaM1nVts/SsxigPZdupCIydWZAUai/z+60O0WqqA/kBxg8CQQDdK9iFjBmIOZy+t9flCdO5tEiGGcscRY8kIUvT1eIRrOS9lSMMV5so874pA5bUAap6dSbjAySMZbwjlmpbKGULAkAyKAf4mx1DZbtG5A2PnsMnuh3aSmvcSRj7tLA/JLlIRFWaxPUmVwmdzAhsYA5J/r46BDzzVvkIKUKvplWKT/nFAkBsMdLOIecrmONw+QaIaPJGWkdQMrYFspF/nzo0+uCIvQd5JsfqdcDVm8de0P6r39TB6yWG0DbE58/NqPuGdJBZAkEA2Rye5KOOroIj4Wo9MO0U27QCyvKdwsqitV1yxHXwyeUCHY3xwJ/pYovumlCD38Pb6aH/r3mRxwblWhmq3VyBig==';
    // 使用私钥解密
    var decrypt = new _jsencrypt.JSEncrypt();
    decrypt.setPrivateKey(PRIVATE_KEY);
    var backStr = '';
    for (var i = 0; i < strs.length; i++) {
      backStr += decrypt.decrypt(strs[i]);
    }
    // console.log(backStr)
    return backStr;
  }
};

/***/ }),

/***/ 644:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(665);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(625);

var _axios2 = _interopRequireDefault(_axios);

var _elementUi = __webpack_require__(417);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 超时时间
/**
 * http配置
 */
// 引入axios以及element ui中的loading和message组件
_axios2.default.defaults.timeout = 50000;
// http请求拦截器
var loadinginstace;
_axios2.default.interceptors.request.use(function (config) {
  // console.log('拦截器传入config', config)
  // element ui Loading方法
  loadinginstace = _elementUi.Loading.service({ fullscreen: true, text: '拼命加载中...', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.5)' });
  return config;
}, function (error) {
  // console.log('request error', error)
  loadinginstace.close();
  // Message.error({
  //   message: '请求超时'
  // })
  return _promise2.default.reject(error);
});
// http响应拦截器
_axios2.default.interceptors.response.use(function (response) {
  // 响应成功关闭loading
  // console.log('response data！！！', response)
  loadinginstace.close();
  return response;
}, function (error) {
  loadinginstace.close();
  // if (error) {
  //   console.log('error！！！', error)
  // }
  console.log(error);
  if (error.response) {
    console.log('response error！！！', error.response);
    switch (error.response.status) {
      case 401:
        // 返回 401 清除token信息并跳转到登录页面
        // store.commit(types.LOGOUT)
        // router.replace({
        //   path: 'login',
        //   query: {redirect: router.currentRoute.fullPath}
        // })
        _elementUi.Message.error({
          message: '授权授权授权授权失败'
        });
    }
  }
  // Message.error({
  //   message: '响应失败'
  // })
  return _promise2.default.reject(error);
});
exports.default = _axios2.default;

/***/ }),

/***/ 645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(25);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(1284);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _Nothing = __webpack_require__(569);

var _Nothing2 = _interopRequireDefault(_Nothing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

// import Todo from '@/components/Todo'
exports.default = new _vueRouter2.default({
  routes: [{
    path: '/',
    component: _Nothing2.default,
    meta: { title: '登录' }
  }]
});

// function generateRoutesFromMenu () {
//   // for (let i = 0, l = menu.length; i < l; i++) {
//   //   let item = menu[i]
//   //   if (item.path) {
//   //     routes.push(item)
//   //   }
//   // }
//   // return routes
//   return [{ path: '/Dept', components: {5: require('../components/Dept/Dept.vue')} }]
// }

/***/ }),

/***/ 646:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'app',
  data: function data() {
    return {
      // profile: 'dev',
      profile: 'prod',
      authenticated: true,
      userName: '',
      deptName: '',

      modeSelectList: [],

      loadingApp: false,
      showMe: true,

      imgUrl: __webpack_require__(1320)(this.global.commonParam.bannerLogo + '.png'),

      collapsed: false,
      leftWidth: '240px',
      rightWidth: 'el-main',
      shrinkstyle: 'menu-toggle',

      shrink: false,
      showshrink: true,

      // dialogFormVisible: false,

      isShow: true,
      functionTitle: '首页',
      // 多标签使用的路由
      route: [],

      // 功能菜单（根据权限加载）
      rightCtrlList: [],

      activeTab: 'default',
      tabList: [{ title: '首页', name: 'default', itemId: '0' }],
      tabCount: 1,
      maxTabCount: 5
    };
  },
  watch: {
    '$route': 'processAccessOut'
  },
  mounted: function mounted() {
    if (this.$route.query.type) {
      this.global.type = this.$route.query.type;
    }
    if (this.$route.query.openId) {
      localStorage.openId = this.$route.query.openId;
    }
    if (this.$route.query.openid) {
      // 兼容旧系统
      localStorage.openId = this.$route.query.openid;
    }
    this.global.curUser.openId = localStorage.openId || 'xafy';
    // 记录本地存储
    var self = this;
    if (true) {
      self.axios.all([self.getMode(), self.getUISet()]).then(self.axios.spread(function (mode, uiSet) {
        if (mode.data.result.success === true) {
          self.modeSelectList = mode.data.modeList;
          self.global.modeList = mode.data.modeList;
          self.global.staticResourceAddr = self.modeSelector('Access_URL_Payment').filter(function (mode) {
            return mode.modeId === '02' && mode.field1 === self.global.appTitle;
          })[0].modeValue;
          self.global.payUrl = self.modeSelector('Access_URL_Payment').filter(function (mode) {
            return mode.modeId === '08' && mode.field1 === self.global.appTitle;
          })[0].modeValue;
          self.global.staticUploadAddr = self.modeSelector('Access_URL_Payment').filter(function (mode) {
            return mode.modeId === '07' && mode.field1 === self.global.appTitle;
          })[0].modeValue;
          self.global.phoneModeList = mode.data.modeList.filter(function (mode) {
            return mode.typeId === 'Phone_Number_Code_XF';
          });
          self.global.insuranceSet = Number(self.modeSelector('App_Param').filter(function (mode) {
            return mode.modeId === 'Insurance_Set';
          })[0].modeValue);
          self.global.dormConfigSet = Number(self.modeSelector('App_Param').filter(function (mode) {
            return mode.modeId === 'Dorm_Config_Set';
          })[0].modeValue);
        }
        if (uiSet.data.result.success === true) {
          self.global.uiSetItemList = uiSet.data.uiSetItemList;
          self.global.uiSetList = uiSet.data.uiSetList;
        }
        self.toRoute();
      }));
    } else {
      this.toRoute();
    }
  },
  methods: {
    // 初始化数据字典
    getMode: function getMode() {
      var self = this;
      return self.axios.get('/college/getModeByTypeList', { params: { typeList: self.global.typeIdList } });
    },
    // 加载界面配置
    getUISet: function getUISet(uiSetIdList) {
      var self = this;
      return self.axios.get('/college/getUISetItemByIDList', { params: { setIdList: self.global.uiSetIdList } });
    },
    // 根据当前机构Id和活动标签获取需要加载的页面
    getPageByDeptId: function getPageByDeptId(type) {
      return this.global.pageMap.filter(function (element) {
        return element.type === type;
      });
    },
    // 标签点击事件
    toRoute: function toRoute() {
      var pageItem = this.getPageByDeptId(this.global.type);
      if (pageItem.length > 0) {
        document.title = pageItem[0].title;
        this.$router.push('/' + pageItem[0].pageName);
        this.route = [{ path: '/' + pageItem[0].pageName, component: __webpack_require__(1321)("./" + pageItem[0].pageUrl + '.vue'), meta: { title: pageItem[0].title } }];
        this.$router.addRoutes(this.route);
      }
    },
    // 数据字典筛选器
    modeSelector: function modeSelector(typeId) {
      return this.modeSelectList.filter(function (element) {
        return element.typeId === typeId;
      });
    },
    // 处理外部访问
    processAccessOut: function processAccessOut() {
      if (this.$route.path === '/') {
        this.toRoute();
      }
    }
  }
};

/***/ }),

/***/ 647:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'BigImg',
  props: ['imgSrc'],
  methods: {
    bigImg: function bigImg() {
      // 发送事件
      this.$emit('click');
    }
  }
};

/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  test1: 'Log',
  curUser: {
    userName: '',
    openId: '',
    keyInfo: '',
    deptId: 1007702,
    schoolYear: 0
  },
  deptId: 1007702,
  loginType: '01', // 01 从本系统登录 02 从外部系统登录
  userRealDept: {},
  userName: '', // 当前登录用户
  curStudent: {},
  userRightDeptList: [{ deptId: 1007702, deptNo: '107702', deptName: '西安翻译学院', parentDeptId: 0, shortName: '西安翻译学院', deptLevel: 1, deptKind: '', deptKindDesc: '', deptType: '', deptTypeDesc: '', sortNo: '', statusCode: '', statusCodeDesc: '', stdt: 0, endt: 0, treeId: '', parentTreeId: '', fullNodeId: '', sumLevel: '' }],
  payUrl: '',
  staticResourceAddr: 'http://static.xafy.edu.cn/images/',
  staticUploadAddr: 'http://static.xafy.edu.cn',
  appTitle: '缴费平台', // 标题 -- 宅付通；海棠通

  tableHeight: 380,
  editInline: false,
  commonParam: {
    curSystem: '01', // 01 通用 02 宅付通
    homePage: './components/Pay/MyBill',
    bannerLogo: './assets/theme-default/images/zftlogo'
  },
  // 分页对象
  page: {
    size: 50,
    totalElements: 0,
    totalPages: 0,
    pageSizes: [15, 50, 100, 500],
    number: 0
  },
  theme: 'theme-default',
  // 用户个性化
  userCustom: {
    isTab: false
  },
  uiSetItemList: [],
  uiSetList: [],
  modeList: [],
  typeIdList: 'Access_URL_Payment,Platform_NO,Extras_Project,CM_OldStuPayTime,Term_XF,CM_NewStuPayTime,CM_OldStuImpPayTime,XF_Coat_Size,XF_Shirt_Size,XF_Shoes_Size,CM_OtherPayTime,XF_Bank_Type,CM_ZSBStuPayTime,Dorm_Supply_Config,Dorm_Supply_Config_Old,Phone_Number_Code_XF,App_Param,Loan_Max_Set,Apart_Supply_Kind,CM_Block_Receive_Time,,A套餐',
  uiSetIdList: 'tbIf_Order_Info_Common,tbIf_Order_Info_XiFan,tbIf_Order_Info_XiFan_New,tbIf_Order_Info_XiFan_Exam',
  pageMap: [{ type: '00', tabName: 'default', pageName: 'LoginXiFan', title: '西安翻译学院', pageUrl: 'XiFan/LoginXiFan' }, { type: '01', tabName: 'default', pageName: 'DormOldLogin', title: '宿舍登录', pageUrl: 'XiFan/LoginDormOld' }],
  type: '00',
  isLoan: '0',
  phoneModeList: [],
  insuranceSet: 0,
  dormConfigSet: 0
};

/***/ }),

/***/ 649:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'notFound',
  data: function data() {
    return {
      msg: ''
    };
  }
};

/***/ }),

/***/ 650:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'todo',
  data: function data() {
    return {
      msg: '新框架参考资料'
    };
  }
};

/***/ }),

/***/ 651:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'DormOld', // ?
  data: function data() {
    return {
      // 选宿舍窗体
      dormList: [], // 当前可选宿舍列表
      chosenDorm: {}, // 当前选择的宿舍列表
      dormSetForm: {}, // 宿舍类型配置信息
      dormSelectedSetForm: {}, // 已选宿舍配置信息
      dormSetList: [], // 宿舍类型下拉框
      dormChooseForm: { // 选宿舍
        dormSet: '',
        flatsName: '',
        roomNo: '',
        bedNo: ''
      },
      route: [],
      curStudent: {},
      fourBedSum: '0', // 四人间总数
      fourBedRmi: '0', // 四人间剩余
      sixBedSum: '0', // 六人间总数
      sixBedRmi: '0', // 六人间剩余
      eightBedSum: '0', // 八人间剩余
      eightBedRmi: '0', // 八人间剩余
      // 查询窗体
      uiSetItemList: [], // 原始
      uiSetList: [],
      modeSelectList: [], // 字典
      chooseDormVisible: false, // 宿舍信息选择
      chooseDormSelectedVisible: false, // 宿舍已选信息展示
      formLabelWidth: '90px',
      // 公寓相关图片
      effectDrawing: this.global.staticResourceAddr + 'gsvxifanvuem/newStu/4rj.jpg',
      bedDiagram: this.global.staticResourceAddr + 'gsvxifanvuem/newStu/10001.png',

      showImg: false, // 获取当前图片地址
      imgSrc: '',

      waitTimeStart: '', // 初始化选宿舍时间
      disabledBtn: false // 确定禁用按钮
    };
  },
  mounted: function mounted() {
    if (true) {
      this.curStudent = this.global.curStudent;
      console.log('进来了', this.curStudent);
      this.getMode();
      this.getViXFDormBed();
      this.initThis();
      this.initWaitTime();
    } else {
      this.getMode();
      this.initThis();
      this.initWaitTime();
    }
  },
  watch: {
    'dormChooseForm.flatsName': 'handleFlatsChange',
    'dormChooseForm.dormSet': 'handleDormSetChange',
    'dormChooseForm.roomNo': 'handleRoomChange'
  },
  methods: {
    getDorm: function getDorm() {
      var self = this;
      return self.axios.post('/college/getViXFDormOldForChoose', {
        schoolYear: self.curStudent.schoolYear,
        deptName: self.curStudent.deptName,
        sex: self.curStudent.sex
      });
    },
    // 初始化数据字典
    getMode: function getMode() {
      this.modeSelectList = this.global.modeList;
    },
    initWaitTime: function initWaitTime() {
      this.waitTimeStart = new Date().getTime();
    },
    getViXFDormBed: function getViXFDormBed() {
      var self = this;
      if (true) {
        this.axios.post('/college/getViXFDormOldBed', {
          schoolYear: self.curStudent.schoolYear,
          keyInfo: this.curStudent.studyNo
        }).then(function (response) {
          if (response.data.result.success) {
            if (response.data.viXFDormList.length > 0 || response.data.viXFDormSetList.length > 0) {
              self.setVisible('01');
              self.dormSelectedSetForm.flatsName = response.data.viXFDormSetList[0].flatsName;
              self.dormSelectedSetForm.dormSet = response.data.viXFDormSetList[0].dormStandard + response.data.viXFDormSetList[0].direction;
              self.dormSelectedSetForm.roomNo = response.data.viXFDormList[0].roomNo;
              self.dormSelectedSetForm.bedNo = response.data.viXFDormList[0].bedNo;
              self.dormSelectedSetForm.price = response.data.viXFDormSetList[0].price;
              self.dormSelectedSetForm.roomSet = response.data.viXFDormSetList[0].roomSet;
              self.dormSelectedSetForm.pubAreaSet = response.data.viXFDormSetList[0].pubAreaSet;
              self.dormSelectedSetForm.region = response.data.viXFDormSetList[0].region;
              self.effectDrawing = self.global.staticUploadAddr + response.data.viXFDormSetList[0].effectDrawing;
              self.bedDiagram = self.global.staticUploadAddr + response.data.viXFDormSetList[0].bedDiagram;
            } else {
              self.setVisible('00');
              self.dormChooseForm.roomNo = '';
              self.dormChooseForm.bedNo = '';
            }
          }
        });
      } else {
        this.dormSelectedSetForm.flatsName = '西区学生公寓十号楼';
        this.dormSelectedSetForm.dormSet = '四人间A朝南';
        this.dormSelectedSetForm.roomNo = '东101';
        this.dormSelectedSetForm.bedNo = '1';
        this.dormSelectedSetForm.price = '2000';
        this.dormSelectedSetForm.roomSet = 'wifi，洗手间';
        this.dormSelectedSetForm.pubAreaSet = '洗衣机、健身房';
        this.dormSelectedSetForm.region = '西区66';
        this.setVisible('01');
      }
    },
    // 加载宿舍信息
    initThis: function initThis() {
      if (true) {
        var self = this;
        self.axios.post('/college/getViXFDormOldBedCount', {
          schoolYear: self.curStudent.schoolYear,
          deptName: self.curStudent.deptName,
          sex: self.curStudent.sex
        }).then(function (response) {
          console.log(response);
          if (response.data.result.success === true) {
            self.sixBedSum = response.data.viXFDormList[0].sixBedSum;
            self.fourBedSum = response.data.viXFDormList[0].fourBedSum;
            self.eightBedSum = response.data.viXFDormList[0].eightBedSum;
            self.sixBedRmi = response.data.viXFDormList[0].sixBedRmi;
            self.fourBedRmi = response.data.viXFDormList[0].fourBedRmi;
            self.eightBedRmi = response.data.viXFDormList[0].eightBedRmi;
          }
        });
        self.axios.all([self.getDorm()]).then(this.axios.spread(function (dorm) {
          if (dorm.data.result.success === true) {
            self.dormList = dorm.data.viXFDormList;
            self.modeSelectList = self.modeSelectList.concat(dorm.data.modeList);
            self.dormSetList = dorm.data.viXFDormSetList;
            if (dorm.data.viXFDormList === null || dorm.data.modeList === null || dorm.data.viXFDormSetList === null) {
              this.disabledBtn = true;
              this.$alert('无可选宿舍');
            }
            // 初始化宿舍选择
            if (self.modeSelector('Flats').length > 0) {
              // 公寓选择初始化成第一个公寓
              self.dormChooseForm.flatsName = self.modeSelector('Flats')[0].modeId;
              // 宿舍配置初始化成该公寓的首个类型
              if (self.modeSelector('Dorm_Set').length > 0) {
                // 初始化宿舍配置为首个公寓首个宿舍类型的信息
                self.dormChooseForm.dormSet = self.modeSelector('Dorm_Set')[0].modeId;
                // 根据所选宿舍类型加载宿舍类型信息
                self.setDormSet(self.dormChooseForm.dormSet);
              }
            }
          }
        }));
      } else {
        this.dormSetForm = {
          dormSet: '',
          price: '1000',
          dormStandard: '',
          roomSet: '',
          pubAreaSet: '',
          region: '',
          remark: ''
        };
        this.fourBedSum = '0';
        this.fourBedRmi = '0';
        this.sixBedSum = '0';
        this.sixBedRmi = '0';
        this.disabledBtn = true;
      }
    },
    // 编辑窗体禁用 01 新增 02 修改
    getDisableEdit: function getDisableEdit(propName, formName) {
      var disabled = false;
      // 宿舍类型
      if (this.dormChooseForm.flatsName === '') {
        if (propName === 'dormSet' || propName === 'roomNo' || propName === 'bedNo') {
          disabled = true;
        }
      } else {
        if (propName === 'dormSet') {
          disabled = false;
        }
      }
      // 宿舍
      if (this.dormChooseForm.dormSet === '') {
        if (propName === 'roomNo' || propName === 'bedNo') {
          disabled = true;
        }
      } else {
        if (propName === 'roomNo') {
          disabled = false;
        }
      }
      // 床位
      if (this.dormChooseForm.roomNo === '') {
        if (propName === 'bedNo') {
          disabled = true;
        }
      } else {
        disabled = false;
      }
      return disabled;
    },
    setVisible: function setVisible(showType) {
      console.log('进来啦。。。。。', showType);
      if (showType === '00') {
        // 宿舍显示
        this.chooseDormVisible = true;
        this.chooseDormSelectedVisible = false;
      }
      if (showType === '01') {
        // 宿舍已选信息展示
        this.chooseDormVisible = false;
        this.chooseDormSelectedVisible = true;
      }
    },
    // 切换dormSetForm的取值
    setDormSet: function setDormSet(dormSet) {
      var listDorm = this.dormSetList.filter(function (item) {
        return item.flatsName + item.dormSet + item.dormStandard + item.direction === dormSet;
      });
      if (listDorm.length > 0) {
        this.dormSetForm = listDorm[0];
        this.effectDrawing = this.global.staticUploadAddr + this.dormSetForm.effectDrawing;
        this.bedDiagram = this.global.staticUploadAddr + this.dormSetForm.bedDiagram;
        this.disabledBtn = false;
      } else {
        this.dormSetForm = {};
        this.effectDrawing = '';
        this.bedDiagram = '';
        this.disabledBtn = true;
        this.$alert('无可选宿舍');
      }
    },
    // 宿舍类型下拉框change
    handleDormSetChange: function handleDormSetChange(val) {
      if (val) {
        this.setDormSet(val);
        this.dormChooseForm.roomNo = '';
        this.dormChooseForm.bedNo = '';
      }
    },
    // 宿舍下拉框change
    handleFlatsChange: function handleFlatsChange() {
      var list = this.modeSelector('Dorm_Set');
      if (list.length > 0) {
        this.dormChooseForm.dormSet = list[0].modeId;
        this.setDormSet(this.dormChooseForm.dormSet);
      }
      this.dormChooseForm.roomNo = '';
      this.dormChooseForm.bedNo = '';
    },
    // 床位下拉框change
    handleRoomChange: function handleRoomChange() {
      this.dormChooseForm.bedNo = '';
    },
    clickImg: function clickImg(e) {
      this.showImg = true;
      // 获取当前图片地址
      this.imgSrc = e.currentTarget.src;
    },
    viewImg: function viewImg() {
      this.showImg = false;
    },
    // 校验选择宿舍窗体
    validForm: function validForm() {
      var valid = true;
      var curTime = new Date().getTime();
      if (curTime - this.waitTimeStart > 1000 * 60 * 20) {
        this.$alert('超时操作，请重新登录');
        this.toHome();
        return false;
      }
      if (this.dormChooseForm.dormSet === '') {
        this.$alert('请选择公寓等级！');
        return false;
      }
      if (this.dormChooseForm.flasName === '') {
        this.$alert('请选择公寓楼！');
        return false;
      }
      if (this.dormChooseForm.roomNo === '') {
        this.$alert('请选择宿舍！');
        return false;
      }
      if (this.dormChooseForm.bedNo === '') {
        this.$alert('请选择床位！');
        return false;
      }
      if (this.bedDiagram === '') {
        this.$alert('选择的床位出现异常！');
        return false;
      }
      return valid;
    },
    addBed: function addBed() {
      var _this = this;

      var self = this;
      this.chosenDorm = this.dormList.filter(function (item) {
        return item.flatsName === _this.dormChooseForm.flatsName && item.roomNo === _this.dormChooseForm.roomNo && item.bedNo === _this.dormChooseForm.bedNo;
      })[0];
      if (true) {
        if (this.validForm()) {
          self.axios.get('/college/processDormOldXF', {
            params: {
              bedId: self.chosenDorm.id,
              keyInfo: self.curStudent.studyNo
            }
          }).then(function (response) {
            if (response.data.result.success === true) {
              self.getViXFDormBed();
            } else {
              self.$alert('您选择的宿舍已被占用');
              self.toHome();
            }
          }, function (response) {
            self.$alert('您选择的宿舍已被占用');
            self.toHome();
          }).catch(function (response) {
            self.$alert('您选择的宿舍已被占用');
            self.toHome();
            console.log(response);
          });
        }
      }
    },
    toHome: function toHome() {
      this.$router.push('/LoginDormOld');
      this.route = [{ path: '/LoginDormOld', component: __webpack_require__(571), meta: { title: '宿舍登录' } }];
      this.$router.addRoutes(this.route);
    },
    // 数据字典筛选器
    modeSelector: function modeSelector(typeId) {
      var _this2 = this;

      var list = [];
      switch (typeId) {
        case 'Dorm_Set':
          list = this.modeSelectList.filter(function (item) {
            return item.typeId === typeId && item.parentModeId === _this2.dormChooseForm.flatsName;
          });
          break;
        case 'Room':
          list = this.modeSelectList.filter(function (item) {
            return item.typeId === typeId && item.parentModeId === _this2.dormChooseForm.dormSet;
          });
          break;
        case 'Bed':
          list = this.modeSelectList.filter(function (item) {
            return item.typeId === typeId && item.parentModeId === _this2.dormChooseForm.roomNo && item.modeValue === _this2.dormChooseForm.flatsName;
          });
          break;
        default:
          list = this.modeSelectList.filter(function (element) {
            return element.typeId === typeId;
          });
          break;
      }
      return list;
    }
  }
};

/***/ }),

/***/ 652:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _auth = __webpack_require__(300);

exports.default = {
  name: 'LoanXiFan', // ?
  data: function data() {
    var _this = this;

    // 特殊的校验
    var checkAmount = function checkAmount(rule, value, callback) {
      if (value) {
        if (!_this.Ginkgo.isMoney(value)) {
          return callback(new Error('请输入正确的金额！'));
        } else if (value === '0') {
          return callback(new Error('请输入大于0金额！'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var checkMobile = function checkMobile(rule, value, callback) {
      if (value) {
        if (!_this.Ginkgo.isMobile(value)) {
          return callback(new Error('请输入正确的手机号！'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      profile: 'prod',
      modeSelectList: [],
      loanForm: {
        dataDt: 0,
        schoolYear: 0,
        studentName: '',
        keyInfo: '',
        mobile: '',
        bankType: '01',
        loanAmount: '',
        loanUrl: '',
        uidJustUrl: '',
        uidBackUrl: '',
        otherUrl: '',
        studentType: '02',
        statusCode: '01'
      }, // 贷款对象
      // 控制属性
      loanInfoVisible: false,
      chooseVisible: false,
      speedVisible: false,
      addVisible: false,
      successVisible: false,
      errorVisible: false,
      formLabelWidth: '155px',

      uiSetItemList: [], // 原始
      uiSetList: [],

      // 贷款
      radio: '0',
      loanFileList: [],
      uidJustFileList: [],
      uidBackFileList: [],
      otherFileList: [],
      fileList: [],
      bankTypeList: [],
      loanInfoList: [], // 贷款查询结果
      dataDt: '2020-01-01',
      amount: 0,
      memo: '上传信息不符合。',
      dialogFormVisible: false,

      // 上传文件相关参数
      uploadAction: 'static/uploadFile',
      uploadHead: {},
      uploadData: {},
      uploadDataOther: {},
      uploadFileNameLoan: '', // 当前上传的文件名（不带扩展名）
      uploadFileNameFullLoan: '', // 当前上传的文件名（带扩展名）
      uploadFileNameUidJust: '', // 当前上传的文件名（不带扩展名）
      uploadFileNameFullUidJust: '', // 当前上传的文件名（带扩展名）
      uploadFileNameUidBack: '', // 当前上传的文件名（不带扩展名）
      uploadFileNameFullUidBack: '', // 当前上传的文件名（带扩展名）
      uploadFileNameOther: '', // 当前上传的文件名（不带扩展名）
      uploadFileNameFullOther: '', // 当前上传的文件名（带扩展名）
      targetPath: '/', // 目标路径，UUID

      financeOffice: {},
      apartmentOffice: {},
      deanOffice: {},
      admissionsOffice: {},
      technicalSupport: {},
      informationManagementCenter: {},
      customerService: {},
      // ！！！校验规则（注意去掉最后一个属性的“,”号）
      rules: {
        mobile: [{ required: true, message: '请输入联系电话', trigger: 'blur' }, { validator: checkMobile, trigger: 'blur' }],
        loanAmount: [{ required: true, message: '请输入贷款金额', trigger: 'blur' }, { validator: checkAmount, trigger: 'blur' }]
      },
      weixin: this.global.staticResourceAddr + 'gsvvuepc/zft2Code.jpg',
      // 队列
      pageItems: [],
      maxSize: 10
    };
  },
  mounted: function mounted() {
    var self = this;
    if (true) {
      self.getMode();
      self.resetForm();
      self.getLoanInfoItem();
    } else {
      self.global.modeList = [{ typeId: 'XF_Bank_Type', modeId: '01', modeName: '国开行', modeValue: '', parentModeId: '', seqNo: '', rank: 1, field1: '' }, { typeId: 'XF_Bank_Type', modeId: '02', modeName: '其他行', modeValue: '', parentModeId: '', seqNo: '', rank: 2, field1: '' }];
      self.getMode();
      self.resetForm();
      self.setVisible('01');
    }
  },
  watch: {
    tabSelected: 'handleSelect'
  },
  methods: {
    setVisible: function setVisible(showType) {
      this.addPage(showType);
      if (showType === '01') {
        // 贷款显示
        this.chooseVisible = true;
        this.loanInfoVisible = false;
        this.speedVisible = false;
        this.addVisible = false;
        this.successVisible = false;
        this.errorVisible = false;
      }
      if (showType === '02') {
        // 贷款信息
        this.chooseVisible = false;
        this.loanInfoVisible = true;
        this.speedVisible = false;
        this.addVisible = false;
        this.successVisible = false;
        this.errorVisible = false;
      }
      if (showType === '03') {
        // 贷款进度(提交)
        this.chooseVisible = false;
        this.loanInfoVisible = false;
        this.speedVisible = true;
        this.addVisible = true;
        this.successVisible = false;
        this.errorVisible = false;
      }
      if (showType === '04') {
        // 贷款进度(通过)
        this.chooseVisible = false;
        this.loanInfoVisible = false;
        this.speedVisible = true;
        this.addVisible = false;
        this.successVisible = true;
        this.errorVisible = false;
      }
      if (showType === '05') {
        // 贷款进度(驳回)
        this.chooseVisible = false;
        this.loanInfoVisible = false;
        this.speedVisible = true;
        this.addVisible = false;
        this.successVisible = false;
        this.errorVisible = true;
      }
    },
    back: function back() {
      this.setVisible(this.pageItems[this.pageItems.length - 2]);
    },
    // 返回结果处理
    getStatusValue: function getStatusValue() {
      var loanInfo = this.loanInfoList[0];
      switch (loanInfo.statusCode) {
        case '00':
          // 通过
          this.dataDt = this.Ginkgo.getToday(this.Ginkgo.intToDate(loanInfo.dataDt));
          this.amount = loanInfo.loanAmount;
          this.setVisible('04');
          break;
        case '01':
          // 新增
          this.setVisible('01');
          break;
        case '02':
          // 提交
          this.setVisible('03');
          break;
        case '03':
          // 驳回
          this.memo = loanInfo.memo;
          this.setVisible('05');
          break;
        default:
          this.setVisible('01');
          break;
      }
    },
    // 获取贷款信息
    getLoanInfoItem: function getLoanInfoItem() {
      var self = this;
      if (true) {
        this.axios.post('/college/getXFLoanInfo', {
          schoolYear: self.global.curUser.schoolYear,
          keyInfo: self.global.curStudent.studentNo
        }).then(function (response) {
          if (response.data.result.success === true) {
            self.loanInfoList = response.data.loanInfoList;
            if (response.data.loanInfoList.length > 0) {
              // 有记录看结果
              self.getStatusValue();
            } else {
              self.setVisible('01');
            }
          } else {
            self.$alert('系统错误！');
          }
        }, function (response) {}).catch(function (error) {
          console.log(error);
        });
      }
    },
    // 下一步 新增
    nextLoan: function nextLoan() {
      if (this.radio === '1') {
        if (this.loanInfoList.length > 0) {
          this.update();
        } else {
          this.loanForm.schoolYear = this.global.curUser.schoolYear;
          this.loanForm.keyInfo = this.global.curStudent.studentNo;
          this.loanForm.studentName = this.global.curStudent.studentName;
          this.setVisible('02');
        }
      } else {
        this.nextPayFee();
      }
    },
    // 下一步
    nextLoanInfo: function nextLoanInfo() {
      var _this2 = this;

      var self = this;
      if (true) {
        self.$refs.loanForm.validate(function (valid) {
          if (valid) {
            if (!_this2.checkLoanMoney()) {
              self.$alert('贷款金额不能超过' + _this2.modeSelector('Loan_Max_Set')[0].modeValue + '元！');
              return false;
            }
            var list = self.checkPhoto();
            if (list.flay) {
              // 处理补充图片
              self.loanForm.otherUrl = '';
              self.fileList.forEach(function (element) {
                if (self.loanForm.otherUrl === '') {
                  self.loanForm.otherUrl = element.url;
                } else {
                  self.loanForm.otherUrl = self.loanForm.otherUrl + ';' + element.url;
                }
              });
              self.loanForm.dataDt = self.Ginkgo.dateToInt(self.Ginkgo.getDefaultDate());
              self.loanForm.statusCode = '02';
              console.log('loanForm', self.loanForm);
              _this2.axios.post('/college/addXFLoanInfo', self.loanForm).then(function (response) {
                if (response.data.result.success === true) {
                  self.$alert('新增贷款信息成功！');
                  self.setVisible('03');
                } else {
                  self.$alert('新增贷款信息失败！');
                  self.setVisible('02');
                }
              }, function (response) {}).catch(function (error) {
                console.log(error);
              });
            } else {
              self.$alert(list.msg);
              self.setVisible('02');
            }
          }
        });
      } else {
        self.$refs.loanForm.validate(function (valid) {
          if (valid) {
            // 处理补充图片
            self.loanForm.otherUrl = '';
            self.fileList.forEach(function (element) {
              if (self.loanForm.otherUrl === '') {
                self.loanForm.otherUrl = element.url;
              } else {
                self.loanForm.otherUrl = self.loanForm.otherUrl + ';' + element.url;
              }
            });
            self.loanForm.dataDt = self.Ginkgo.dateToInt(self.Ginkgo.getDefaultDate());
            self.loanForm.statusCode = '02';
            self.setVisible('03');
          }
        });
      }
    },
    // 检查贷款金额
    checkLoanMoney: function checkLoanMoney() {
      var loanSetList = this.modeSelector('Loan_Max_Set');
      if (loanSetList.length !== 1) {
        this.$alert('贷款上限设置异常，请联系管理员！');
        return false;
      } else {
        var loanSet = loanSetList[0];
        if (Number(loanSet.modeValue) * 100 >= Number(this.loanForm.loanAmount) * 100) {
          return true;
        } else {
          return false;
        }
      }
    },
    // 检查图片上传
    checkPhoto: function checkPhoto() {
      var list = {};
      list.flay = true;
      list.msg = '';
      if (this.loanForm.loanUrl === '') {
        list.flay = false;
        list.msg = '请上传贷款受理证明或回执单！';
      }
      if (this.loanForm.uidJustUrl === '' || this.loanForm.uidBackUrl === '') {
        list.flay = false;
        list.msg = '请上传身份证正反面！';
      }
      return list;
    },
    update: function update() {
      var self = this;
      self.loanFileList = [];
      self.uidJustFileList = [];
      self.uidBackFileList = [];
      self.otherFileList = [];
      self.fileList = [];

      self.setVisible('02');
      self.loanForm = self.loanInfoList[0];
      // 图片特殊处理
      var fileRow = {};
      var nameList = self.loanForm.loanUrl.split('/');
      fileRow.name = nameList.slice(nameList.length - 1, nameList.length)[0];
      fileRow.url = self.global.staticUploadAddr + self.loanForm.loanUrl;
      self.loanFileList.push(fileRow);
      // 身份证国徽面
      fileRow = {};
      nameList = self.loanForm.uidJustUrl.split('/');
      fileRow.name = nameList.slice(nameList.length - 1, nameList.length)[0];
      fileRow.url = self.global.staticUploadAddr + self.loanForm.uidJustUrl;
      self.uidJustFileList.push(fileRow);
      // 身份证人像面
      fileRow = {};
      nameList = self.loanForm.uidBackUrl.split('/');
      fileRow.name = nameList.slice(nameList.length - 1, nameList.length)[0];
      fileRow.url = self.global.staticUploadAddr + self.loanForm.uidBackUrl;
      self.uidBackFileList.push(fileRow);
      // 补充材料
      var otherFileRow = {};
      if (self.loanForm.otherUrl !== '') {
        var otherList = self.loanForm.otherUrl.split(';');
        otherList.forEach(function (element) {
          fileRow = {};
          nameList = element.split('/');
          fileRow.name = nameList.slice(nameList.length - 1, nameList.length)[0];
          fileRow.url = self.global.staticUploadAddr + element;
          console.log('fileRow', fileRow);
          self.otherFileList.push(fileRow);
          // 保存用
          otherFileRow = {};
          otherFileRow.name = nameList.slice(nameList.length - 1, nameList.length)[0];
          otherFileRow.url = element;
          console.log('otherFileRow', otherFileRow);
          self.fileList.push(otherFileRow);
        });
      }
    },
    home: function home() {
      // 登录页面
      this.global.isLoan = '0';
      this.$router.push('/LoginXiFan');
      this.route = [{ path: '/LoginXiFan', component: __webpack_require__(69), meta: { title: '登录页面' } }];
      this.$router.addRoutes(this.route);
    },
    nextPayFee: function nextPayFee() {
      // 老生缴费
      this.global.isLoan = '1';
      this.$router.push('/MyBillXiFan');
      this.route = [{ path: '/MyBillXiFan', component: __webpack_require__(279), meta: { title: '老生缴费' } }];
      this.$router.addRoutes(this.route);
    },
    // 初始化数据字典
    getMode: function getMode() {
      var self = this;
      self.modeSelectList = self.global.modeList;
      self.bankTypeList = self.global.modeList.filter(function (element) {
        return element.typeId === 'XF_Bank_Type';
      });
    },
    // 重置编辑窗体
    resetForm: function resetForm() {
      this.loanForm = {
        dataDt: 0,
        schoolYear: 0,
        studentName: '',
        keyInfo: '',
        mobile: '',
        bankType: '01',
        loanAmount: '',
        remark: '',
        loanUrl: '',
        uidJustUrl: '',
        uidBackUrl: '',
        otherUrl: '',
        studentType: '02',
        statusCode: '01'
        // 本次流程上传的路径
      };this.targetPath = '/images/gsvxifanvuem/loan/' + this.global.curUser.schoolYear + '_' + this.global.curStudent.studentNo;
    },
    // 数据字典筛选器
    modeSelector: function modeSelector(typeId) {
      var list = [];
      list = this.modeSelectList.filter(function (element) {
        return element.typeId === typeId;
      });
      return list;
    },
    showWechatImg: function showWechatImg() {
      this.dialogFormVisible = true;
    },
    handleSelect: function handleSelect(index, indexPath) {
      if (true) {
        if (index === '/MyLoan') {
          this.getLoanInfoItem();
        }
        if (index === '/Exit') {
          this.$router.push('/LoginXiFan');
          this.route = [{ path: '/LoginXiFan', component: __webpack_require__(69), meta: { title: '缴费登录' } }];
          this.$router.addRoutes(this.route);
        }
      } else {
        if (index === '/MyLoan') {
          this.getLoanInfoItem();
        }
        if (index === '/Exit') {
          this.$router.push('/LoginXiFan');
          this.route = [{ path: '/LoginXiFan', component: require('./LoginXiFan.vue'), meta: { title: '缴费登录' } }];
          this.$router.addRoutes(this.route);
        }
      }
    },
    // --------------------------------------------------------贷款证明文件上传------------------------------------------------------
    // 上传文件事件方法
    handleUploadChangeLoan: function handleUploadChangeLoan(file, fileList) {
      console.log(file, fileList);
      if (fileList.length > 0) {
        this.loanFileList = fileList.filter(function (item) {
          return item.name === file.name;
        });
        this.uploadFileNameFullLoan = file.name;
        var s = file.name.split('.');
        // 文件名去掉扩展名
        if (s.length - 1 === 0) {
          // 没有扩展名
          this.uploadFileNameLoan = file.name;
        } else {
          this.uploadFileNameLoan = file.name.substr(0, file.name.length - s[s.length - 1].length - 1);
        }
      }
    },
    // 上传文件前事件方法
    beforeUploadLoan: function beforeUploadLoan(file) {
      // 将cookie中的token取至head。
      var tokenBuffer = document.cookie.substring(document.cookie.indexOf('XSRF-TOKEN' + '='));
      this.uploadHead['X-XSRF-TOKEN'] = tokenBuffer.substring(tokenBuffer.indexOf('=') + 1, tokenBuffer.indexOf(';') > 0 ? tokenBuffer.indexOf(';') : tokenBuffer.length);
      this.uploadHead['Authorization'] = 'Bearer ' + (0, _auth.getToken)();
      this.uploadHead['Expires'] = (0, _auth.getExpires)();
      // 补充上传参数。
      this.uploadData.fileName = this.uploadFileNameLoan;
      this.uploadData.fileDesc = '';
      this.uploadData.targetPath = this.targetPath;
      this.uploadData.isRandomName = false;
      this.uploadData.isOverwrite = true;
      this.uploadData.flag = '01';
    },
    // 上传成功后回调
    successUploadLoan: function successUploadLoan(response, file, fileList) {
      this.loanForm.loanUrl = '';
      if (response.result.success) {
        this.$message({ type: 'success', message: '上传成功!' });
        var fileName = this.uploadFileNameLoan;
        var fileAddress = response.uploadData.url;
        console.log('file：', fileName, fileAddress);
        this.loanForm.loanUrl = fileAddress;
      } else {
        this.$alert(response.result.msg);
      }
    },
    errorUploadLoan: function errorUploadLoan(err, file, fileList) {
      console.log(err);
    },
    // 上传文件
    submitUploadLoan: function submitUploadLoan() {
      this.$refs.upload.submit();
    },

    handleRemoveLoan: function handleRemoveLoan(file, fileList) {
      this.loanForm.loanUrl = '';
      console.log('handleRemoveLoan', file, fileList);
    },
    handleExceedLoan: function handleExceedLoan(files, fileList) {
      this.$message.warning('当前限制选择 1 个文件');
    },
    beforeRemoveLoan: function beforeRemoveLoan(file, fileList) {
      console.log('beforeRemoveLoan', file, fileList);
      return this.$confirm('确定移除');
    },

    // --------------------------------------------------------身份证国徽面上传------------------------------------------------------
    // 上传文件事件方法
    handleUploadChangeUidJust: function handleUploadChangeUidJust(file, fileList) {
      console.log(file, fileList);
      if (fileList.length > 0) {
        this.uidJustFileList = fileList.filter(function (item) {
          return item.name === file.name;
        });
        this.uploadFileNameFullUidJust = file.name;
        var s = file.name.split('.');
        // 文件名去掉扩展名
        if (s.length - 1 === 0) {
          // 没有扩展名
          this.uploadFileNameUidJust = file.name;
        } else {
          this.uploadFileNameUidJust = file.name.substr(0, file.name.length - s[s.length - 1].length - 1);
        }
      }
    },
    // 上传文件前事件方法
    beforeUploadUidJust: function beforeUploadUidJust(file) {
      // 将cookie中的token取至head。
      var tokenBuffer = document.cookie.substring(document.cookie.indexOf('XSRF-TOKEN' + '='));
      this.uploadHead['X-XSRF-TOKEN'] = tokenBuffer.substring(tokenBuffer.indexOf('=') + 1, tokenBuffer.indexOf(';') > 0 ? tokenBuffer.indexOf(';') : tokenBuffer.length);
      this.uploadHead['Authorization'] = 'Bearer ' + (0, _auth.getToken)();
      this.uploadHead['Expires'] = (0, _auth.getExpires)();
      // 补充上传参数。
      this.uploadData.fileName = this.uploadFileNameUidJust;
      this.uploadData.fileDesc = '';
      this.uploadData.targetPath = this.targetPath;
      this.uploadData.isRandomName = false;
      this.uploadData.isOverwrite = true;
      this.uploadData.flag = '01';
    },
    // 上传成功后回调
    successUploadUidJust: function successUploadUidJust(response, file, fileList) {
      this.loanForm.uidJustUrl = '';
      if (response.result.success) {
        this.$message({ type: 'success', message: '上传成功!' });
        var fileName = this.uploadFileNameUidJust;
        var fileAddress = response.uploadData.url;
        console.log('file：', fileName, fileAddress);
        this.loanForm.uidJustUrl = fileAddress;
      } else {
        this.$alert(response.result.msg);
      }
    },
    errorUploadUidJust: function errorUploadUidJust(err, file, fileList) {
      console.log(err);
    },
    // 上传文件
    submitUploadUidJust: function submitUploadUidJust() {
      this.$refs.upload.submit();
    },

    handleRemoveUidJust: function handleRemoveUidJust(file, fileList) {
      this.loanForm.uidJustUrl = '';
      console.log('handleRemoveUidJust', file, fileList);
    },
    handleExceedUidJust: function handleExceedUidJust(files, fileList) {
      this.$message.warning('当前限制选择 1 个文件');
    },
    beforeRemoveUidJust: function beforeRemoveUidJust(file, fileList) {
      console.log('beforeRemoveUidJust', file, fileList);
      return this.$confirm('确定移除');
    },

    // --------------------------------------------------------身份证人像面上传------------------------------------------------------
    // 上传文件事件方法
    handleUploadChangeUidBack: function handleUploadChangeUidBack(file, fileList) {
      console.log(file, fileList);
      if (fileList.length > 0) {
        this.uidBackFileList = fileList.filter(function (item) {
          return item.name === file.name;
        });
        this.uploadFileNameFullUidBack = file.name;
        var s = file.name.split('.');
        // 文件名去掉扩展名
        if (s.length - 1 === 0) {
          // 没有扩展名
          this.uploadFileNameUidBack = file.name;
        } else {
          this.uploadFileNameUidBack = file.name.substr(0, file.name.length - s[s.length - 1].length - 1);
        }
      }
    },
    // 上传文件前事件方法
    beforeUploadUidBack: function beforeUploadUidBack(file) {
      // 将cookie中的token取至head。
      var tokenBuffer = document.cookie.substring(document.cookie.indexOf('XSRF-TOKEN' + '='));
      this.uploadHead['X-XSRF-TOKEN'] = tokenBuffer.substring(tokenBuffer.indexOf('=') + 1, tokenBuffer.indexOf(';') > 0 ? tokenBuffer.indexOf(';') : tokenBuffer.length);
      this.uploadHead['Authorization'] = 'Bearer ' + (0, _auth.getToken)();
      this.uploadHead['Expires'] = (0, _auth.getExpires)();
      // 补充上传参数。
      this.uploadData.fileName = this.uploadFileNameUidBack;
      this.uploadData.fileDesc = '';
      this.uploadData.targetPath = this.targetPath;
      this.uploadData.isRandomName = false;
      this.uploadData.isOverwrite = true;
      this.uploadData.flag = '01';
    },
    // 上传成功后回调
    successUploadUidBack: function successUploadUidBack(response, file, fileList) {
      this.loanForm.uidBackUrl = '';
      if (response.result.success) {
        this.$message({ type: 'success', message: '上传成功!' });
        var fileName = this.uploadFileNameUidBack;
        var fileAddress = response.uploadData.url;
        console.log('file：', fileName, fileAddress);
        this.loanForm.uidBackUrl = fileAddress;
      } else {
        this.$alert(response.result.msg);
      }
    },
    errorUploadUidBack: function errorUploadUidBack(err, file, fileList) {
      console.log(err);
    },
    // 上传文件
    submitUploadUidBack: function submitUploadUidBack() {
      this.$refs.upload.submit();
    },

    handleRemoveUidBack: function handleRemoveUidBack(file, fileList) {
      this.loanForm.uidBackUrl = '';
      console.log('handleRemoveUidBack', file, fileList);
    },
    handleExceedUidBack: function handleExceedUidBack(files, fileList) {
      this.$message.warning('当前限制选择 1 个文件');
    },
    beforeRemoveUidBack: function beforeRemoveUidBack(file, fileList) {
      console.log('beforeRemoveUidBack', file, fileList);
      return this.$confirm('确定移除');
    },

    // --------------------------------------------------------其他证明文件上传------------------------------------------------------
    // 上传文件事件方法
    handleUploadChangeOther: function handleUploadChangeOther(file, fileList) {
      if (fileList.length > 0) {
        // this.fileList = fileList.filter(item => item.name === file.name)
        this.uploadFileNameFullOther = file.name;
        var s = file.name.split('.');
        // 文件名去掉扩展名
        if (s.length - 1 === 0) {
          // 没有扩展名
          this.uploadFileNameOther = file.name;
        } else {
          this.uploadFileNameOther = file.name.substr(0, file.name.length - s[s.length - 1].length - 1);
        }
      }
    },
    // 上传文件前事件方法
    beforeUploadOther: function beforeUploadOther(file) {
      // 将cookie中的token取至head。
      var tokenBuffer = document.cookie.substring(document.cookie.indexOf('XSRF-TOKEN' + '='));
      this.uploadHead['X-XSRF-TOKEN'] = tokenBuffer.substring(tokenBuffer.indexOf('=') + 1, tokenBuffer.indexOf(';') > 0 ? tokenBuffer.indexOf(';') : tokenBuffer.length);
      this.uploadHead['Authorization'] = 'Bearer ' + (0, _auth.getToken)();
      this.uploadHead['Expires'] = (0, _auth.getExpires)();
      // 补充上传参数。
      this.uploadDataOther.fileName = this.uploadFileNameOther;
      this.uploadDataOther.fileDesc = '';
      this.uploadDataOther.targetPath = this.targetPath;
      this.uploadDataOther.isRandomName = false;
      this.uploadDataOther.isOverwrite = true;
      this.uploadDataOther.flag = '01';
    },
    // 上传成功后回调
    successUploadOther: function successUploadOther(response, file, fileList) {
      var self = this;
      if (response.result.success) {
        this.$message({ type: 'success', message: '上传成功!' });
        var fileRow = {};
        fileRow.name = this.uploadFileNameFullOther;
        fileRow.url = response.uploadData.url;
        self.fileList.push(fileRow);
      } else {
        this.$alert(response.result.msg);
      }
    },
    errorUploadOther: function errorUploadOther(err, file, fileList) {
      console.log('errorUploadOther', err);
    },
    // 上传文件
    submitUploadOther: function submitUploadOther() {
      this.$refs.upload.submit();
    },

    handleRemoveOther: function handleRemoveOther(file, fileList) {
      console.log('handleRemoveOther', file, fileList);
      this.fileList = this.fileList.filter(function (item) {
        return item.name !== file.name;
      });
    },
    handleExceedOther: function handleExceedOther(files, fileList) {
      this.$message.warning('当前限制选择 3 个文件');
    },
    beforeRemoveOther: function beforeRemoveOther(file, fileList) {
      return this.$confirm('确定移除');
    },
    addPage: function addPage(val) {
      if (!val) return;
      if (this.pageItems.length >= this.maxSize) {
        this.pageItems.shift();
      }
      this.pageItems.push(val);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _auth = __webpack_require__(300);

exports.default = {
  name: 'LoanXiFan', // ?
  data: function data() {
    var _this = this;

    // 特殊的校验
    var checkAmount = function checkAmount(rule, value, callback) {
      if (value) {
        if (!_this.Ginkgo.isMoney(value)) {
          return callback(new Error('请输入正确的金额！'));
        } else if (value === '0') {
          return callback(new Error('请输入大于0金额！'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var checkMobile = function checkMobile(rule, value, callback) {
      if (value) {
        if (!_this.Ginkgo.isMobile(value)) {
          return callback(new Error('请输入正确的手机号！'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      profile: 'prod',
      modeSelectList: [],
      loanForm: {
        dataDt: 0,
        schoolYear: 0,
        studentName: '',
        keyInfo: '',
        mobile: '',
        bankType: '01',
        loanAmount: '',
        loanUrl: '',
        uidJustUrl: '',
        uidBackUrl: '',
        otherUrl: '',
        studentType: '01',
        statusCode: '01'
      }, // 贷款对象
      // 控制属性
      loanInfoVisible: false,
      chooseVisible: false,
      speedVisible: false,
      addVisible: false,
      successVisible: false,
      errorVisible: false,
      formLabelWidth: '155px',

      uiSetItemList: [], // 原始
      uiSetList: [],

      // 贷款
      radio: '0',
      loanFileList: [],
      uidJustFileList: [],
      uidBackFileList: [],
      otherFileList: [],
      fileList: [],
      bankTypeList: [],
      loanInfoList: [], // 贷款查询结果
      dataDt: '2020-01-01',
      amount: 0,
      memo: '上传信息不符合。',
      dialogFormVisible: false,

      financeOffice: {},
      apartmentOffice: {},
      deanOffice: {},
      admissionsOffice: {},
      technicalSupport: {},
      informationManagementCenter: {},
      customerService: {},

      // 上传文件相关参数
      uploadAction: 'static/uploadFile',
      uploadHead: {},
      uploadData: {},
      uploadDataOther: {},
      uploadFileNameLoan: '', // 当前上传的文件名（不带扩展名）
      uploadFileNameFullLoan: '', // 当前上传的文件名（带扩展名）
      uploadFileNameUidJust: '', // 当前上传的文件名（不带扩展名）
      uploadFileNameFullUidJust: '', // 当前上传的文件名（带扩展名）
      uploadFileNameUidBack: '', // 当前上传的文件名（不带扩展名）
      uploadFileNameFullUidBack: '', // 当前上传的文件名（带扩展名）
      uploadFileNameOther: '', // 当前上传的文件名（不带扩展名）
      uploadFileNameFullOther: '', // 当前上传的文件名（带扩展名）
      targetPath: '/', // 目标路径，UUID

      // ！！！校验规则（注意去掉最后一个属性的“,”号）
      rules: {
        mobile: [{ required: true, message: '请输入联系电话', trigger: 'blur' }, { validator: checkMobile, trigger: 'blur' }],
        loanAmount: [{ required: true, message: '请输入贷款金额', trigger: 'blur' }, { validator: checkAmount, trigger: 'blur' }]
      },
      weixin: this.global.staticResourceAddr + 'gsvvuepc/zft2Code.jpg',
      // 队列
      pageItems: [],
      maxSize: 10
    };
  },
  mounted: function mounted() {
    var self = this;
    if (true) {
      self.getMode();
      self.resetForm();
      self.getLoanInfoItem();
      self.getPhoneMode();
    } else {
      self.global.modeList = [{ typeId: 'XF_Bank_Type', modeId: '01', modeName: '国开行', modeValue: '', parentModeId: '', seqNo: '', rank: 1, field1: '' }, { typeId: 'XF_Bank_Type', modeId: '02', modeName: '其他行', modeValue: '', parentModeId: '', seqNo: '', rank: 2, field1: '' }];
      self.getMode();
      self.resetForm();
      self.setVisible('01');
      self.getPhoneMode();
    }
  },
  watch: {
    tabSelected: 'handleSelect'
  },
  methods: {
    setVisible: function setVisible(showType) {
      this.addPage(showType);
      if (showType === '01') {
        // 贷款显示
        this.chooseVisible = true;
        this.loanInfoVisible = false;
        this.speedVisible = false;
        this.addVisible = false;
        this.successVisible = false;
        this.errorVisible = false;
      }
      if (showType === '02') {
        // 贷款信息
        this.chooseVisible = false;
        this.loanInfoVisible = true;
        this.speedVisible = false;
        this.addVisible = false;
        this.successVisible = false;
        this.errorVisible = false;
      }
      if (showType === '03') {
        // 贷款进度(提交)
        this.chooseVisible = false;
        this.loanInfoVisible = false;
        this.speedVisible = true;
        this.addVisible = true;
        this.successVisible = false;
        this.errorVisible = false;
      }
      if (showType === '04') {
        // 贷款进度(通过)
        this.chooseVisible = false;
        this.loanInfoVisible = false;
        this.speedVisible = true;
        this.addVisible = false;
        this.successVisible = true;
        this.errorVisible = false;
      }
      if (showType === '05') {
        // 贷款进度(驳回)
        this.chooseVisible = false;
        this.loanInfoVisible = false;
        this.speedVisible = true;
        this.addVisible = false;
        this.successVisible = false;
        this.errorVisible = true;
      }
    },
    getPhoneMode: function getPhoneMode() {
      var _this2 = this;

      this.global.phoneModeList.filter(function (item) {
        switch (item.modeId) {
          case '00':
            _this2.financeOffice = item;
            break;
          case '01':
            _this2.apartmentOffice = item;
            break;
          case '02':
            _this2.deanOffice = item;
            break;
          case '03':
            _this2.admissionsOffice = item;
            break;
          case '04':
            _this2.technicalSupport = item;
            break;
          case '05':
            _this2.informationManagementCenter = item;
            break;
          case '06':
            _this2.customerService = item;
            break;
        }
      });
    },
    back: function back() {
      this.setVisible(this.pageItems[this.pageItems.length - 2]);
    },
    // 返回结果处理
    getStatusValue: function getStatusValue() {
      var loanInfo = this.loanInfoList[0];
      switch (loanInfo.statusCode) {
        case '00':
          // 通过
          this.dataDt = this.Ginkgo.getToday(this.Ginkgo.intToDate(loanInfo.dataDt));
          this.amount = loanInfo.loanAmount;
          this.setVisible('04');
          break;
        case '01':
          // 新增
          this.setVisible('01');
          break;
        case '02':
          // 提交
          this.setVisible('03');
          break;
        case '03':
          // 驳回
          this.memo = loanInfo.memo;
          this.setVisible('05');
          break;
        default:
          this.setVisible('01');
          break;
      }
    },
    // 获取贷款信息
    getLoanInfoItem: function getLoanInfoItem() {
      var self = this;
      if (true) {
        this.axios.post('/college/getXFLoanInfo', {
          schoolYear: self.global.curUser.schoolYear,
          keyInfo: self.global.curStudent.uid
        }).then(function (response) {
          if (response.data.result.success === true) {
            self.loanInfoList = response.data.loanInfoList;
            if (response.data.loanInfoList.length > 0) {
              // 有记录看结果
              self.getStatusValue();
            } else {
              self.setVisible('01');
            }
          } else {
            self.$alert('系统错误！');
          }
        }, function (response) {}).catch(function (error) {
          console.log(error);
        });
      }
    },
    // 下一步 新增
    nextLoan: function nextLoan() {
      if (this.radio === '1') {
        if (this.loanInfoList.length > 0) {
          this.update();
        } else {
          this.loanForm.schoolYear = this.global.curUser.schoolYear;
          this.loanForm.keyInfo = this.global.curStudent.uid;
          this.loanForm.studentName = this.global.curStudent.studentName;
          this.setVisible('02');
        }
      } else {
        this.nextPayFee();
      }
    },
    // 下一步
    nextLoanInfo: function nextLoanInfo() {
      var _this3 = this;

      var self = this;
      if (true) {
        self.$refs.loanForm.validate(function (valid) {
          if (valid) {
            if (!_this3.checkLoanMoney()) {
              self.$alert('贷款金额不能超过' + _this3.modeSelector('Loan_Max_Set')[0].modeValue + '元！');
              return false;
            }
            var list = self.checkPhoto();
            if (list.flay) {
              // 处理补充图片
              self.loanForm.otherUrl = '';
              self.fileList.forEach(function (element) {
                if (self.loanForm.otherUrl === '') {
                  self.loanForm.otherUrl = element.url;
                } else {
                  self.loanForm.otherUrl = self.loanForm.otherUrl + ';' + element.url;
                }
              });
              self.loanForm.dataDt = self.Ginkgo.dateToInt(self.Ginkgo.getDefaultDate());
              self.loanForm.statusCode = '02';
              console.log('loanForm', self.loanForm);
              _this3.axios.post('/college/addXFLoanInfo', self.loanForm).then(function (response) {
                if (response.data.result.success === true) {
                  self.$alert('新增贷款信息成功！');
                  self.setVisible('03');
                } else {
                  self.$alert('新增贷款信息失败！');
                  self.setVisible('02');
                }
              }, function (response) {}).catch(function (error) {
                console.log(error);
              });
            } else {
              self.$alert(list.msg);
              self.setVisible('02');
            }
          }
        });
      } else {
        self.$refs.loanForm.validate(function (valid) {
          if (valid) {
            // 处理补充图片
            self.loanForm.otherUrl = '';
            self.fileList.forEach(function (element) {
              if (self.loanForm.otherUrl === '') {
                self.loanForm.otherUrl = element.url;
              } else {
                self.loanForm.otherUrl = self.loanForm.otherUrl + ';' + element.url;
              }
            });
            self.loanForm.dataDt = self.Ginkgo.dateToInt(self.Ginkgo.getDefaultDate());
            self.loanForm.statusCode = '02';
            self.setVisible('03');
          }
        });
      }
    },
    // 检查贷款金额
    checkLoanMoney: function checkLoanMoney() {
      var loanSetList = this.modeSelector('Loan_Max_Set');
      if (loanSetList.length !== 1) {
        this.$alert('贷款上限设置异常，请联系管理员！');
        return false;
      } else {
        var loanSet = loanSetList[0];
        if (Number(loanSet.modeValue) * 100 >= Number(this.loanForm.loanAmount) * 100) {
          return true;
        } else {
          return false;
        }
      }
    },
    // 检查图片上传
    checkPhoto: function checkPhoto() {
      var list = {};
      list.flay = true;
      list.msg = '';
      if (this.loanForm.loanUrl === '') {
        list.flay = false;
        list.msg = '请上传贷款受理证明或回执单！';
      }
      if (this.loanForm.uidJustUrl === '' || this.loanForm.uidBackUrl === '') {
        list.flay = false;
        list.msg = '请上传身份证正反面！';
      }
      return list;
    },
    update: function update() {
      var self = this;
      self.loanFileList = [];
      self.uidJustFileList = [];
      self.uidBackFileList = [];
      self.otherFileList = [];
      self.fileList = [];

      self.setVisible('02');
      self.loanForm = self.loanInfoList[0];
      // 图片特殊处理
      var fileRow = {};
      var nameList = self.loanForm.loanUrl.split('/');
      fileRow.name = nameList.slice(nameList.length - 1, nameList.length)[0];
      fileRow.url = self.global.staticUploadAddr + self.loanForm.loanUrl;
      self.loanFileList.push(fileRow);
      // 身份证国徽面
      fileRow = {};
      nameList = self.loanForm.uidJustUrl.split('/');
      fileRow.name = nameList.slice(nameList.length - 1, nameList.length)[0];
      fileRow.url = self.global.staticUploadAddr + self.loanForm.uidJustUrl;
      self.uidJustFileList.push(fileRow);
      // 身份证人像面
      fileRow = {};
      nameList = self.loanForm.uidBackUrl.split('/');
      fileRow.name = nameList.slice(nameList.length - 1, nameList.length)[0];
      fileRow.url = self.global.staticUploadAddr + self.loanForm.uidBackUrl;
      self.uidBackFileList.push(fileRow);
      // 补充材料
      var otherFileRow = {};
      if (self.loanForm.otherUrl !== '') {
        var otherList = self.loanForm.otherUrl.split(';');
        otherList.forEach(function (element) {
          fileRow = {};
          nameList = element.split('/');
          fileRow.name = nameList.slice(nameList.length - 1, nameList.length)[0];
          fileRow.url = self.global.staticUploadAddr + element;
          console.log('fileRow', fileRow);
          self.otherFileList.push(fileRow);
          // 保存用
          otherFileRow = {};
          otherFileRow.name = nameList.slice(nameList.length - 1, nameList.length)[0];
          otherFileRow.url = element;
          console.log('otherFileRow', otherFileRow);
          self.fileList.push(otherFileRow);
        });
      }
    },
    home: function home() {
      // 登录页面
      this.global.isLoan = '0';
      this.$router.push('/LoginXiFan');
      this.route = [{ path: '/LoginXiFan', component: __webpack_require__(69), meta: { title: '登录页面' } }];
      this.$router.addRoutes(this.route);
    },
    nextPayFee: function nextPayFee() {
      // 新生缴费
      this.global.isLoan = '1';
      if (this.global.curStudent.trainingLevel === '专升本') {
        this.$router.push('/MyBillXiFanZSB');
        this.route = [{ path: '/MyBillXiFanZSB', component: __webpack_require__(280), meta: { title: '新生缴费' } }];
        this.$router.addRoutes(this.route);
      } else {
        this.$router.push('/MyBillXiFanNew');
        this.route = [{ path: '/MyBillXiFanNew', component: __webpack_require__(150), meta: { title: '新生缴费' } }];
        this.$router.addRoutes(this.route);
      }
    },
    // 初始化数据字典
    getMode: function getMode() {
      var self = this;
      self.modeSelectList = self.global.modeList;
      self.bankTypeList = self.global.modeList.filter(function (element) {
        return element.typeId === 'XF_Bank_Type';
      });
    },
    // 重置编辑窗体
    resetForm: function resetForm() {
      this.loanForm = {
        dataDt: 0,
        schoolYear: 0,
        studentName: '',
        keyInfo: '',
        mobile: '',
        bankType: '01',
        loanAmount: '',
        remark: '',
        loanUrl: '',
        uidJustUrl: '',
        uidBackUrl: '',
        otherUrl: '',
        studentType: '01',
        statusCode: '01'
        // 本次流程上传的路径
      };this.targetPath = '/images/gsvxifanvuem/loan/' + this.global.curUser.schoolYear + '_' + this.global.curStudent.uid;
    },
    // 数据字典筛选器
    modeSelector: function modeSelector(typeId) {
      var list = [];
      list = this.modeSelectList.filter(function (element) {
        return element.typeId === typeId;
      });
      return list;
    },
    showWechatImg: function showWechatImg() {
      this.dialogFormVisible = true;
    },
    handleSelect: function handleSelect(index, indexPath) {
      if (true) {
        if (index === '/MyLoan') {
          this.getLoanInfoItem();
        }
        if (index === '/OfflinePay') {
          // 跳转到线下缴费页面
          this.$router.push('/offlinePay');
          this.route = [{ path: '/offlinePay', component: function component() {
              return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 122));
            }, meta: { title: '线下审核' } }];
          this.$router.addRoutes(this.route);
        }
        if (index === '/Exit') {
          this.$router.push('/LoginXiFan');
          this.route = [{ path: '/LoginXiFan', component: __webpack_require__(69), meta: { title: '缴费登录' } }];
          this.$router.addRoutes(this.route);
        }
      } else {
        if (index === '/MyLoan') {
          this.getLoanInfoItem();
        }
        if (index === '/OfflinePay') {
          // 跳转到线下缴费页面
          this.$router.push('/offlinePay');
          this.route = [{ path: '/offlinePay', component: function component() {
              return import('@/components/XiFan/NewStudent/OfflinePay.vue');
            }, meta: { title: '线下审核' } }];
          this.$router.addRoutes(this.route);
        }
        if (index === '/Exit') {
          this.$router.push('/LoginXiFan');
          this.route = [{ path: '/LoginXiFan', component: require('./LoginXiFan.vue'), meta: { title: '缴费登录' } }];
          this.$router.addRoutes(this.route);
        }
      }
    },
    // --------------------------------------------------------贷款证明文件上传------------------------------------------------------
    // 上传文件事件方法
    handleUploadChangeLoan: function handleUploadChangeLoan(file, fileList) {
      console.log(file, fileList);
      if (fileList.length > 0) {
        this.loanFileList = fileList.filter(function (item) {
          return item.name === file.name;
        });
        this.uploadFileNameFullLoan = file.name;
        var s = file.name.split('.');
        // 文件名去掉扩展名
        if (s.length - 1 === 0) {
          // 没有扩展名
          this.uploadFileNameLoan = file.name;
        } else {
          this.uploadFileNameLoan = file.name.substr(0, file.name.length - s[s.length - 1].length - 1);
        }
      }
    },
    // 上传文件前事件方法
    beforeUploadLoan: function beforeUploadLoan(file) {
      // 将cookie中的token取至head。
      var tokenBuffer = document.cookie.substring(document.cookie.indexOf('XSRF-TOKEN' + '='));
      this.uploadHead['X-XSRF-TOKEN'] = tokenBuffer.substring(tokenBuffer.indexOf('=') + 1, tokenBuffer.indexOf(';') > 0 ? tokenBuffer.indexOf(';') : tokenBuffer.length);
      this.uploadHead['Authorization'] = 'Bearer ' + (0, _auth.getToken)();
      this.uploadHead['Expires'] = (0, _auth.getExpires)();
      // 补充上传参数。
      this.uploadData.fileName = this.uploadFileNameLoan;
      this.uploadData.fileDesc = '';
      this.uploadData.targetPath = this.targetPath;
      this.uploadData.isRandomName = false;
      this.uploadData.isOverwrite = true;
      this.uploadData.flag = '01';
    },
    // 上传成功后回调
    successUploadLoan: function successUploadLoan(response, file, fileList) {
      this.loanForm.loanUrl = '';
      if (response.result.success) {
        this.$message({ type: 'success', message: '上传成功!' });
        var fileName = this.uploadFileNameLoan;
        var fileAddress = response.uploadData.url;
        console.log('file：', fileName, fileAddress);
        this.loanForm.loanUrl = fileAddress;
      } else {
        this.$alert(response.result.msg);
      }
    },
    errorUploadLoan: function errorUploadLoan(err, file, fileList) {
      console.log(err);
    },
    // 上传文件
    submitUploadLoan: function submitUploadLoan() {
      this.$refs.upload.submit();
    },

    handleRemoveLoan: function handleRemoveLoan(file, fileList) {
      this.loanForm.loanUrl = '';
      console.log('handleRemoveLoan', file, fileList);
    },
    handleExceedLoan: function handleExceedLoan(files, fileList) {
      this.$message.warning('当前限制选择 1 个文件');
    },
    beforeRemoveLoan: function beforeRemoveLoan(file, fileList) {
      console.log('beforeRemoveLoan', file, fileList);
      return this.$confirm('确定移除');
    },

    // --------------------------------------------------------身份证国徽面上传------------------------------------------------------
    // 上传文件事件方法
    handleUploadChangeUidJust: function handleUploadChangeUidJust(file, fileList) {
      console.log(file, fileList);
      if (fileList.length > 0) {
        this.uidJustFileList = fileList.filter(function (item) {
          return item.name === file.name;
        });
        this.uploadFileNameFullUidJust = file.name;
        var s = file.name.split('.');
        // 文件名去掉扩展名
        if (s.length - 1 === 0) {
          // 没有扩展名
          this.uploadFileNameUidJust = file.name;
        } else {
          this.uploadFileNameUidJust = file.name.substr(0, file.name.length - s[s.length - 1].length - 1);
        }
      }
    },
    // 上传文件前事件方法
    beforeUploadUidJust: function beforeUploadUidJust(file) {
      // 将cookie中的token取至head。
      var tokenBuffer = document.cookie.substring(document.cookie.indexOf('XSRF-TOKEN' + '='));
      this.uploadHead['X-XSRF-TOKEN'] = tokenBuffer.substring(tokenBuffer.indexOf('=') + 1, tokenBuffer.indexOf(';') > 0 ? tokenBuffer.indexOf(';') : tokenBuffer.length);
      this.uploadHead['Authorization'] = 'Bearer ' + (0, _auth.getToken)();
      this.uploadHead['Expires'] = (0, _auth.getExpires)();
      // 补充上传参数。
      this.uploadData.fileName = this.uploadFileNameUidJust;
      this.uploadData.fileDesc = '';
      this.uploadData.targetPath = this.targetPath;
      this.uploadData.isRandomName = false;
      this.uploadData.isOverwrite = true;
      this.uploadData.flag = '01';
    },
    // 上传成功后回调
    successUploadUidJust: function successUploadUidJust(response, file, fileList) {
      this.loanForm.uidJustUrl = '';
      if (response.result.success) {
        this.$message({ type: 'success', message: '上传成功!' });
        var fileName = this.uploadFileNameUidJust;
        var fileAddress = response.uploadData.url;
        console.log('file：', fileName, fileAddress);
        this.loanForm.uidJustUrl = fileAddress;
      } else {
        this.$alert(response.result.msg);
      }
    },
    errorUploadUidJust: function errorUploadUidJust(err, file, fileList) {
      console.log(err);
    },
    // 上传文件
    submitUploadUidJust: function submitUploadUidJust() {
      this.$refs.upload.submit();
    },

    handleRemoveUidJust: function handleRemoveUidJust(file, fileList) {
      this.loanForm.uidJustUrl = '';
      console.log('handleRemoveUidJust', file, fileList);
    },
    handleExceedUidJust: function handleExceedUidJust(files, fileList) {
      this.$message.warning('当前限制选择 1 个文件');
    },
    beforeRemoveUidJust: function beforeRemoveUidJust(file, fileList) {
      console.log('beforeRemoveUidJust', file, fileList);
      return this.$confirm('确定移除');
    },

    // --------------------------------------------------------身份证人像面上传------------------------------------------------------
    // 上传文件事件方法
    handleUploadChangeUidBack: function handleUploadChangeUidBack(file, fileList) {
      console.log(file, fileList);
      if (fileList.length > 0) {
        this.uidBackFileList = fileList.filter(function (item) {
          return item.name === file.name;
        });
        this.uploadFileNameFullUidBack = file.name;
        var s = file.name.split('.');
        // 文件名去掉扩展名
        if (s.length - 1 === 0) {
          // 没有扩展名
          this.uploadFileNameUidBack = file.name;
        } else {
          this.uploadFileNameUidBack = file.name.substr(0, file.name.length - s[s.length - 1].length - 1);
        }
      }
    },
    // 上传文件前事件方法
    beforeUploadUidBack: function beforeUploadUidBack(file) {
      // 将cookie中的token取至head。
      var tokenBuffer = document.cookie.substring(document.cookie.indexOf('XSRF-TOKEN' + '='));
      this.uploadHead['X-XSRF-TOKEN'] = tokenBuffer.substring(tokenBuffer.indexOf('=') + 1, tokenBuffer.indexOf(';') > 0 ? tokenBuffer.indexOf(';') : tokenBuffer.length);
      this.uploadHead['Authorization'] = 'Bearer ' + (0, _auth.getToken)();
      this.uploadHead['Expires'] = (0, _auth.getExpires)();
      // 补充上传参数。
      this.uploadData.fileName = this.uploadFileNameUidBack;
      this.uploadData.fileDesc = '';
      this.uploadData.targetPath = this.targetPath;
      this.uploadData.isRandomName = false;
      this.uploadData.isOverwrite = true;
      this.uploadData.flag = '01';
    },
    // 上传成功后回调
    successUploadUidBack: function successUploadUidBack(response, file, fileList) {
      this.loanForm.uidBackUrl = '';
      if (response.result.success) {
        this.$message({ type: 'success', message: '上传成功!' });
        var fileName = this.uploadFileNameUidBack;
        var fileAddress = response.uploadData.url;
        console.log('file：', fileName, fileAddress);
        this.loanForm.uidBackUrl = fileAddress;
      } else {
        this.$alert(response.result.msg);
      }
    },
    errorUploadUidBack: function errorUploadUidBack(err, file, fileList) {
      console.log(err);
    },
    // 上传文件
    submitUploadUidBack: function submitUploadUidBack() {
      this.$refs.upload.submit();
    },

    handleRemoveUidBack: function handleRemoveUidBack(file, fileList) {
      this.loanForm.uidBackUrl = '';
      console.log('handleRemoveUidBack', file, fileList);
    },
    handleExceedUidBack: function handleExceedUidBack(files, fileList) {
      this.$message.warning('当前限制选择 1 个文件');
    },
    beforeRemoveUidBack: function beforeRemoveUidBack(file, fileList) {
      console.log('beforeRemoveUidBack', file, fileList);
      return this.$confirm('确定移除');
    },

    // --------------------------------------------------------其他证明文件上传------------------------------------------------------
    // 上传文件事件方法
    handleUploadChangeOther: function handleUploadChangeOther(file, fileList) {
      if (fileList.length > 0) {
        // this.fileList = fileList.filter(item => item.name === file.name)
        this.uploadFileNameFullOther = file.name;
        var s = file.name.split('.');
        // 文件名去掉扩展名
        if (s.length - 1 === 0) {
          // 没有扩展名
          this.uploadFileNameOther = file.name;
        } else {
          this.uploadFileNameOther = file.name.substr(0, file.name.length - s[s.length - 1].length - 1);
        }
      }
    },
    // 上传文件前事件方法
    beforeUploadOther: function beforeUploadOther(file) {
      // 将cookie中的token取至head。
      var tokenBuffer = document.cookie.substring(document.cookie.indexOf('XSRF-TOKEN' + '='));
      this.uploadHead['X-XSRF-TOKEN'] = tokenBuffer.substring(tokenBuffer.indexOf('=') + 1, tokenBuffer.indexOf(';') > 0 ? tokenBuffer.indexOf(';') : tokenBuffer.length);
      this.uploadHead['Authorization'] = 'Bearer ' + (0, _auth.getToken)();
      this.uploadHead['Expires'] = (0, _auth.getExpires)();
      // 补充上传参数。
      this.uploadDataOther.fileName = this.uploadFileNameOther;
      this.uploadDataOther.fileDesc = '';
      this.uploadDataOther.targetPath = this.targetPath;
      this.uploadDataOther.isRandomName = false;
      this.uploadDataOther.isOverwrite = true;
      this.uploadDataOther.flag = '01';
    },
    // 上传成功后回调
    successUploadOther: function successUploadOther(response, file, fileList) {
      var self = this;
      if (response.result.success) {
        this.$message({ type: 'success', message: '上传成功!' });
        var fileRow = {};
        fileRow.name = this.uploadFileNameFullOther;
        fileRow.url = response.uploadData.url;
        self.fileList.push(fileRow);
      } else {
        this.$alert(response.result.msg);
      }
    },
    errorUploadOther: function errorUploadOther(err, file, fileList) {
      console.log('errorUploadOther', err);
    },
    // 上传文件
    submitUploadOther: function submitUploadOther() {
      this.$refs.upload.submit();
    },

    handleRemoveOther: function handleRemoveOther(file, fileList) {
      console.log('handleRemoveOther', file, fileList);
      this.fileList = this.fileList.filter(function (item) {
        return item.name !== file.name;
      });
    },
    handleExceedOther: function handleExceedOther(files, fileList) {
      this.$message.warning('当前限制选择 3 个文件');
    },
    beforeRemoveOther: function beforeRemoveOther(file, fileList) {
      return this.$confirm('确定移除');
    },
    addPage: function addPage(val) {
      if (!val) return;
      if (this.pageItems.length >= this.maxSize) {
        this.pageItems.shift();
      }
      this.pageItems.push(val);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ 654:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'LoginDormOld', // ?
  data: function data() {
    return {
      dh: {
        backgroundImage: 'url(' + this.global.staticResourceAddr + 'gsvvuepc/phone' + '.png' + ')',
        backgroundRepeat: 'no-repeat'
      },
      form: {
        studentName: '',
        studentNo: ''
      },
      route: [],
      log1: this.global.staticResourceAddr + 'gsvvuepc/logo1.png',
      fy1: this.global.staticResourceAddr + 'gsvvuepc/fy1.jpg',
      fy2: this.global.staticResourceAddr + 'gsvvuepc/fy2.jpg',
      fy3: this.global.staticResourceAddr + 'gsvvuepc/fy3.jpg',
      fy4: this.global.staticResourceAddr + 'gsvvuepc/fy4.jpg',

      financeOffice: {},
      apartmentOffice: {},
      deanOffice: {},
      admissionsOffice: {},
      technicalSupport: {},
      informationManagementCenter: {},
      customerService: {}
    };
  },
  mounted: function mounted() {
    if (true) {
      // 登录默认
      this.getMode();
      this.getPhoneMode();
      this.form.studentName = '';
      this.form.studentNo = '';
    }
  },
  methods: {
    getMode: function getMode() {
      this.modeSelectList = this.global.modeList;
    },
    getPhoneMode: function getPhoneMode() {
      var _this = this;

      this.global.phoneModeList.filter(function (item) {
        switch (item.modeId) {
          case '00':
            _this.financeOffice = item;
            break;
          case '01':
            _this.apartmentOffice = item;
            break;
          case '02':
            _this.deanOffice = item;
            break;
          case '03':
            _this.admissionsOffice = item;
            break;
          case '04':
            _this.technicalSupport = item;
            break;
          case '05':
            _this.informationManagementCenter = item;
            break;
          case '06':
            _this.customerService = item;
            break;
        }
      });
    },
    // 获取待缴费账单（核准状态）
    loginInit: function loginInit() {
      if (true) {
        if (this.form.studentName === '' || this.form.studentNo === '') {
          this.$alert('学生姓名或者学号不能为空！');
        } else {
          this.logincheck();
        }
      } else {
        if (this.form.studentName === '' || this.form.studentNo === '') {
          this.$alert('学生姓名或者学号不能为空！');
        } else {
          this.toDormOld();
        }
      }
    },
    // 登录前检查否在导入学生表
    logincheck: function logincheck() {
      var self = this;
      if (true) {
        this.axios.get('/college/logincheck', {
          params: {
            schoolYear: self.modeSelector('CM_OldStuPayTime')[0].modeValue,
            studyNo: self.form.studentNo.trim(),
            name: self.form.studentName.trim()
          }
        }).then(function (response) {
          if (response.data.result.success === true) {
            if (response.data.studentList.length > 0) {
              self.global.curStudent = response.data.studentList[0];
              self.toDormOld();
            } else {
              self.$alert('登陆失败!');
            }
          } else {
            self.$alert('服务出错!');
          }
        }, function (response) {}).catch(function (error) {
          console.log(error);
        });
      }
    },
    // 数据字典筛选器
    modeSelector: function modeSelector(typeId) {
      var list = [];
      list = this.modeSelectList.filter(function (element) {
        return element.typeId === typeId;
      });
      return list;
    },
    toDormOld: function toDormOld() {
      this.$router.push('/DormOld');
      this.route = [{ path: '/DormOld', component: __webpack_require__(570), meta: { title: '选宿舍' } }];
      this.$router.addRoutes(this.route);
    }
  }
};

/***/ }),

/***/ 655:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(125);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'LoginXiFan', // ?
  data: function data() {
    return {
      dh: {
        backgroundImage: 'url(' + this.global.staticResourceAddr + 'gsvvuepc/phone' + '.png' + ')',
        backgroundRepeat: 'no-repeat'
      },
      stuTypeList: [{ modeId: '01', modeName: '新生' }, { modeId: '02', modeName: '老生' }],
      form: {
        studentType: '01',
        studentName: '',
        studentNo: '',
        idCard: '',
        code: ''
      },
      idCardVisible: false,
      studentNoVisible: false,
      codeVisible: false,
      route: [],
      log1: this.global.staticResourceAddr + 'gsvvuepc/logo1.png',
      fy1: this.global.staticResourceAddr + 'gsvvuepc/fy1.jpg',
      fy2: this.global.staticResourceAddr + 'gsvvuepc/fy2.jpg',
      fy3: this.global.staticResourceAddr + 'gsvvuepc/fy3.jpg',
      fy4: this.global.staticResourceAddr + 'gsvvuepc/fy4.jpg',

      financeOffice: {},
      apartmentOffice: {},
      deanOffice: {},
      admissionsOffice: {},
      technicalSupport: {},
      informationManagementCenter: {},
      customerService: {}
    };
  },
  mounted: function mounted() {
    this.getPhoneMode();
    if (this.global.curStudent.studentType) {
      this.form.studentType = this.global.curStudent.studentType;
    }
    if (true) {
      // 登录默认
      this.changeStuType();
    } else {
      this.feeList = [{ term: '1', feeAmount01: 1001, feeAmount02: 501, feeAmount03: 5011, feeNo: '01', feeType: '01' }, { term: '2', feeAmount01: 1002, feeAmount02: 502, feeAmount03: 5022, feeNo: '01', feeType: '01' }];
      this.crossItemList = [{ feeNo: '01', deptId: 1000001, feeName: '学费', feeType: '01', feeTypeDesc: '', statusCode: '01', statusCodeDesc: '', remark: '', sortNo: '01' }, { feeNo: '02', deptId: 1000001, feeName: '伙食费', feeType: '02', feeTypeDesc: '', statusCode: '01', statusCodeDesc: '', remark: '', sortNo: '02' }, { feeNo: '03', deptId: 1000001, feeName: '住宿费', feeType: '02', feeTypeDesc: '', statusCode: '01', statusCodeDesc: '', remark: '', sortNo: '03' }];
      // 界面配置表
      this.uiSetList = [{ uiSetId: 'tbPm_Fee_Kd_07', uiSetName: '费用信息管理', uiSetType: '01', uiSetTypeDesc: '', colWidthOpt: '300', exportTextSet: '', crossItemNo: 'feeNo', crossItemName: 'feeName', mergeCell: '', remark: '', itemList: null }];
      // 界面配置子表
      this.uiSetItemList = [{ uiSetId: 'tbPm_Fee_Kd_07', columnName: 'feeAmount01', columnDesc: '主费用', columnProp: 'feeAmount01', isVisible: '1', isVisibleDesc: '', sortNo: '99', queryCondition: '0', queryConditionDesc: '', sortNoQuery: '99', controlType: '02', controlTypeDesc: '', typeId: 'Dept_Type_KD', defaultValue: '01', required: '0', requiredDesc: '', isUnique: '0', isUniqueDesc: '', dataType: '01', dataTypeDesc: '', newDisabled: '0', editDisabled: '0', editDisabledDesc: '', queryVisible: '0', queryVisibleDesc: '', sortNoResult: '11', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '0', isFixColDesc: '', colWidth: '120', isCross: '0', isCrossDesc: '', isGroupStart: '1', isGroupStartDesc: '' }, { uiSetId: 'tbPm_Fee_Kd_07', columnName: 'feeAmount02', columnDesc: '伙食费', columnProp: 'feeAmount02', isVisible: '0', isVisibleDesc: '', sortNo: '99', queryCondition: '0', queryConditionDesc: '', sortNoQuery: '99', controlType: '02', controlTypeDesc: '', typeId: 'Dept_Type_KD', defaultValue: '01', required: '0', requiredDesc: '', isUnique: '0', isUniqueDesc: '', dataType: '01', dataTypeDesc: '', newDisabled: '0', editDisabled: '0', editDisabledDesc: '', queryVisible: '1', queryVisibleDesc: '', sortNoResult: '11', alignType: 'left', formatString: '', columnType: '01', buttonType: '01', commandName: '', isFixCol: '0', isFixColDesc: '', colWidth: '120', isCross: '0', isCrossDesc: '', isGroupStart: '1', isGroupStartDesc: '' }, { uiSetId: 'tbPm_Fee_Kd_07', columnName: 'feeAmount03', columnDesc: '取暖费', columnProp: 'feeAmount03', isVisible: '0', isVisibleDesc: '', sortNo: '99', queryCondition: '0', queryConditionDesc: '', sortNoQuery: '99', controlType: '02', controlTypeDesc: '', typeId: 'Dept_Type_KD', defaultValue: '01', required: '0', requiredDesc: '', isUnique: '0', isUniqueDesc: '', dataType: '01', dataTypeDesc: '', newDisabled: '0', editDisabled: '0', editDisabledDesc: '', queryVisible: '1', queryVisibleDesc: '', sortNoResult: '11', alignType: 'left', formatString: '', columnType: '01', buttonType: '01', commandName: '', isFixCol: '0', isFixColDesc: '', colWidth: '120', isCross: '0', isCrossDesc: '', isGroupStart: '1', isGroupStartDesc: '' }, { uiSetId: 'tbPm_Fee_Kd_07', columnName: 'Term', columnDesc: '账期', columnProp: 'term', isVisible: '1', isVisibleDesc: '', sortNo: '03', queryCondition: '1', queryConditionDesc: '', sortNoQuery: '03', controlType: '01', controlTypeDesc: '', typeId: '', defaultValue: '', required: '1', requiredDesc: '', isUnique: '1', isUniqueDesc: '', dataType: '01', dataTypeDesc: '', newDisabled: '0', editDisabled: '0', editDisabledDesc: '', queryVisible: '1', queryVisibleDesc: '', sortNoResult: '', alignType: 'left', formatString: '', columnType: '01', buttonType: '01', commandName: '', isFixCol: '0', isFixColDesc: '', colWidth: '120', isCross: '0', isCrossDesc: '', isGroupStart: '1', isGroupStartDesc: '' }];
      this.changeStuType();
    }
  },
  watch: {
    'form.studentType': 'changeStuType'
  },
  methods: {
    setVisible: function setVisible(showType) {
      if (showType === '01') {
        // 新生登录显示
        this.idCardVisible = true;
        this.studentNoVisible = false;
        this.codeVisible = false;
      }
      if (showType === '02') {
        // 老生登录显示
        this.idCardVisible = false;
        this.studentNoVisible = true;
        this.codeVisible = true;
      }
    },
    getPhoneMode: function getPhoneMode() {
      var _this = this;

      this.global.phoneModeList.filter(function (item) {
        switch (item.modeId) {
          case '00':
            _this.financeOffice = item;
            break;
          case '01':
            _this.apartmentOffice = item;
            break;
          case '02':
            _this.deanOffice = item;
            break;
          case '03':
            _this.admissionsOffice = item;
            break;
          case '04':
            _this.technicalSupport = item;
            break;
          case '05':
            _this.informationManagementCenter = item;
            break;
          case '06':
            _this.customerService = item;
            break;
        }
      });
    },
    changeStuType: function changeStuType() {
      this.form.studentName = '';
      this.form.studentNo = '';
      this.form.idCard = '';
      this.form.code = '';
      if (this.form.studentType === '01') {
        this.setVisible('01');
      } else {
        this.setVisible('02');
      }
    },
    // 初始化查询条件窗体
    initQueryForm: function initQueryForm() {
      console('暂时不做处理。。。');
    },
    // 获取待缴费账单（核准状态）
    loginInit: function loginInit() {
      if (true) {
        if (this.form.studentType === '01') {
          if (this.form.studentName === '' || this.form.idCard === '') {
            this.$alert('学生姓名或者身份证号不能为空！');
          } else {
            this.newStulogin();
          }
        } else {
          if (this.form.studentName === '' || this.form.studentNo === '' || this.form.code === '') {
            this.$alert('学生姓名或者学号或者验证码不能为空！');
          } else {
            this.oldStulogin();
          }
        }
      } else {
        if (this.form.studentType === '01') {
          if (this.form.studentName === '' || this.form.idCard === '') {
            this.$alert('学生姓名或者身份证号不能为空！');
          } else {
            this.newStulogin();
          }
        } else {
          if (this.form.studentName === '' || this.form.studentNo === '' || this.form.code === '') {
            this.$alert('学生姓名或者学号或者验证码不能为空！');
          } else {
            this.oldStulogin();
          }
        }
      }
    },
    // 老生查询登录
    oldStulogin: function oldStulogin() {
      if (true) {
        var self = this;
        // 初始化
        var request = {};
        request.idIf = '59';
        request.deptId = 0;
        request.itemList = [{ paramName: 'studentNo', paramValue: self.form.studentNo.trim() }, { paramName: 'studentName', paramValue: self.form.studentName.trim() }, { paramName: 'code', paramValue: self.form.code.trim() }];
        var str = (0, _stringify2.default)(request);
        this.axios.post('/iif/accessIfForHttpForEncrypt', this.Ginkgo.encrypt(str)).then(function (response) {
          var backJson = JSON.parse(self.Ginkgo.rsaDecrypt(response.data));
          if (backJson.result.success === true) {
            if (backJson.responseObj.result.success === true) {
              self.global.curStudent = backJson.responseObj.studentList[0];
              // 处理学生信息
              self.addStudent();
              self.global.curStudent.studentType = self.form.studentType;
              // console.log('curStudent:', self.global.curStudent)
              self.$router.push('/MyBillXiFan');
              self.route = [{ path: '/MyBillXiFan', component: __webpack_require__(279), meta: { title: '账单信息' } }];
              self.$router.addRoutes(self.route);
            } else {
              self.$alert(backJson.responseObj.result.msg);
            }
          } else {
            self.$alert(backJson.result.msg);
          }
        }, function (response) {}).catch(function (error) {
          console.log(error);
        });
      } else {
        this.global.curStudent.studentType = this.form.studentType;
        this.$router.push('/MyBillXiFan');
        this.route = [{ path: '/MyBillXiFan', component: require('./MyBillXiFan.vue'), meta: { title: '账单信息' } }];
        this.$router.addRoutes(this.route);
      }
    },
    addStudent: function addStudent() {
      var self = this;
      var str = (0, _stringify2.default)(this.global.curStudent);
      this.axios.post('/college/addViXFStudentForEncrypt', this.Ginkgo.encrypt(str)).then(function (response) {
        var backJson = JSON.parse(self.Ginkgo.rsaDecrypt(response.data));
        if (backJson.result.success === true) {
          console.log('处理学生信息成功！', self.global.curStudent);
        } else {
          console.log('处理学生信息失败！', self.global.curStudent);
        }
      }, function (response) {}).catch(function (error) {
        console.log(error);
      });
    },
    // 新生查询登录
    newStulogin: function newStulogin() {
      var self = this;
      if (true) {
        var obj = {};
        obj.userName = self.form.studentName.trim();
        obj.userPwd = self.form.idCard.trim();
        var str = (0, _stringify2.default)(obj);
        this.axios.post('/college/getViXFStudentForLoginForEncrypt', this.Ginkgo.encrypt(str)).then(function (response) {
          var backJson = JSON.parse(self.Ginkgo.rsaDecrypt(response.data));
          if (backJson.result.success === true) {
            if (backJson.viXFStudentList.length > 0) {
              // 登录成功
              var viXFStudentList = backJson.viXFStudentList.filter(function (item) {
                return item.studentNo !== '' || item.studentNo;
              });
              if (viXFStudentList.length > 0) {
                self.global.curStudent = viXFStudentList[0];
              } else {
                self.global.curStudent = backJson.viXFStudentList[0];
              }
              // console.log('curStudent:', self.global.curStudent)
              // if (self.global.curStudent.enrollmentYear.toString() === self.Ginkgo.getToday().substring(0, 4)) { // 判断学籍
              if (self.global.curStudent.trainingLevel === '专升本') {
                self.$router.push('/MyBillXiFanZSB');
                self.route = [{ path: '/MyBillXiFanZSB', component: __webpack_require__(280), meta: { title: '新生缴费' } }];
                self.$router.addRoutes(self.route);
              } else {
                self.$router.push('/MyBillXiFanNew');
                self.route = [{ path: '/MyBillXiFanNew', component: __webpack_require__(150), meta: { title: '新生缴费' } }];
                self.$router.addRoutes(self.route);
              }
            } else {
              self.$alert('姓名或者身份证号不正确！');
            }
          } else {
            self.$alert('系统错误！');
          }
        }, function (response) {}).catch(function (error) {
          console.log(error);
        });
      } else {
        self.global.curStudent.studentType = self.form.studentType;
        self.$router.push('/MyBillXiFanNew');
        self.route = [{ path: '/MyBillXiFanNew', component: require('./MyBillXiFanNew.vue'), meta: { title: '新生缴费' } }];
        self.$router.addRoutes(self.route);
      }
    }
  }
};

/***/ }),

/***/ 656:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(125);

var _stringify2 = _interopRequireDefault(_stringify);

var _vueQr = __webpack_require__(193);

var _vueQr2 = _interopRequireDefault(_vueQr);

var _noticeBar = __webpack_require__(148);

var _noticeBar2 = _interopRequireDefault(_noticeBar);

__webpack_require__(149);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MyBillXiFan',
  components: { vueQr: _vueQr2.default, vanNoticeBar: _noticeBar2.default },
  data: function data() {
    return {
      form: {
        studentType: '02',
        studentName: '',
        studentNo: '',
        idCard: ''
      },
      viewForm: {
        studentNo: '',
        studentName: '',
        majorMatr: '',
        className: '',
        academicYear: '',
        term: '',
        termNM: '',
        enrollmentYear: 0, // 学籍
        deptName: '', // 院系
        trainingLevel: '', // 培养层次
        tuition: 0,
        houseFees: 0,
        totals: 0,
        payableAmount: 0,
        feeAmount: 0,
        reduceAmount: 0 // 减免总金额
      },
      payTerm: {
        stdt: 0, // 缴费开始日期
        endt: 0, // 缴费结束日期
        academicYear: '', // 学年
        term: '', // 学期
        isPayTerm: ''
      },
      tableData: [], // table绑定数据
      uiSetItemList: [], // 原始
      feeData: [], // 费用明细
      termList: [], // 账期列表
      reduceList: [], // 减免账单
      orderInfoList: [], // 缴费历史
      orderInfoListByType: [], // 各类型缴费历史
      viDeptSetList: [],
      modeSelectList: [],
      multipleSelection: [],
      checked: false,
      feeType: '01', // 学期缴费
      feeTypeVisible: false, // 缴费类型
      feeList: [], // 费用数据
      radio: '0',
      backVisible: false, // 返回按钮
      // 分页对象
      page: this.Ginkgo.cloneObj(this.global.page),
      // ！！！初始排序对象
      sort: {},
      sortSet: [],
      photo: '',
      dialogFormVisible: false,
      semesterPayVisible: false,
      feePayType_UN: false,
      payButtonDisable: false,
      feeListHistoryVisible: false,
      billVisible: false,
      termVisible: false,
      termMsg: '不在缴费期内',
      examBillVisible: false,
      examListHistoryVisible: false,
      weixin: this.global.staticResourceAddr + 'gsvvuepc/zft2Code.jpg',

      financeOffice: {},
      apartmentOffice: {},
      deanOffice: {},
      admissionsOffice: {},
      technicalSupport: {},
      informationManagementCenter: {},
      customerService: {},
      // 支付相关
      payVisible: false,

      scanVisible: false,
      qrContent: '',
      qrImage: '',

      buttonVisibleWX: false,
      buttonVisibleZFB: false,
      buttonVisibleUnion: false,
      buttonVisiblePFWX: false,
      buttonVisiblePFZFB: false,

      payType: '',
      payTypeZFB: '',
      payTypeUnion: '01',
      payTypeHTT: '',
      payTypeZJ: '',
      payTypeUnionWX: '',
      payTypePFWX: '',
      payTypePFZFB: '',

      // 图片
      wx: this.global.staticResourceAddr + 'gsvxifanvuem/' + this.global.theme + '/images/wx.png',
      yl: this.global.staticResourceAddr + 'gsvxifanvuem/' + this.global.theme + '/images/yl.png',
      zfb: this.global.staticResourceAddr + 'gsvxifanvuem/' + this.global.theme + '/images/zfb.png',
      // 通知信息
      tipText: ''
    };
  },
  mounted: function mounted() {
    console.log('====', this.global.curStudent);
    if (true) {
      this.getMode();
      this.getUISet();
      // this.getDeptSet()
      this.getHistory();
      this.viewForm.studentNo = this.global.curStudent.studentNo;
      this.viewForm.studentName = this.global.curStudent.studentName;
      this.viewForm.majorMatr = this.global.curStudent.majorMatr;
      this.viewForm.className = this.global.curStudent.className;
      this.viewForm.enrollmentYear = this.global.curStudent.enrollmentYear;
      this.viewForm.trainingLevel = this.global.curStudent.trainingLevel;
      this.viewForm.deptName = this.global.curStudent.deptName;
      if (this.global.curStudent.studentType === '02') {
        // 老生校验缴费期
        this.checkTerm();
      }
    } else {
      this.viewForm = {
        studentNo: '17611070628',
        studentName: '陈彦羽',
        majorMatr: '学前教育',
        className: '三七班',
        academicYear: '2018',
        term: '0',
        tuition: 1520,
        houseFees: 1200,
        totals: 0,
        payableAmount: 0,
        feeAmount: 0
      };
      this.viewForm.tuition = this.Ginkgo.format(this.viewForm.tuition, 'money');
      this.viewForm.houseFees = this.Ginkgo.format(this.viewForm.houseFees, 'money');
      this.viewForm.payableAmount = this.Ginkgo.format(this.viewForm.tuition + this.viewForm.houseFees, 'money');
      this.viewForm.feeAmount = this.Ginkgo.format(this.viewForm.tuition + this.viewForm.houseFees, 'money');
      this.setVisible('01');
    }
  },
  methods: {
    // 初始化数据字典
    getMode: function getMode() {
      var self = this;
      self.modeSelectList = self.global.modeList;
    },
    // 加载界面配置
    getUISet: function getUISet() {
      var self = this;
      self.uiSetItemList = self.global.uiSetItemList;
      self.uiSetList = self.global.uiSetList;
    },
    setVisible: function setVisible(showType) {
      if (showType === '01') {
        // 基础缴费我的账单，显示账单信息
        this.semesterPayVisible = true;
        this.feePayType_UN = true;
        this.feeListHistoryVisible = false;
        this.billVisible = true;
        this.termVisible = false;
        this.examBillVisible = false;
        this.examListHistoryVisible = false;
        this.payButtonDisable = true;
        this.feeTypeVisible = false;
        this.payVisible = false;
        this.scanVisible = false;
      }
      if (showType === '02') {
        // 提示信息
        this.semesterPayVisible = true;
        this.feePayType_UN = false;
        this.feeListHistoryVisible = false;
        this.billVisible = false;
        this.termVisible = true;
        this.examBillVisible = false;
        this.examListHistoryVisible = false;
        this.payButtonDisable = true;
        this.feeTypeVisible = false;
        this.payVisible = false;
        this.scanVisible = false;
      }
      if (showType === '03') {
        // 历史账单（基础缴费）
        this.feeListHistoryVisible = true;
        this.semesterPayVisible = true;
        this.feePayType_UN = false;
        this.billVisible = false;
        this.termVisible = false;
        this.examBillVisible = false;
        this.examListHistoryVisible = false;
        this.payButtonDisable = true;
        this.feeTypeVisible = false;
        this.payVisible = false;
        this.scanVisible = false;
      }
      if (showType === '04') {
        // 考试缴费账单，显示账单信息
        this.semesterPayVisible = true;
        this.examBillVisible = true;
        this.feePayType_UN = true;
        this.feeListHistoryVisible = false;
        this.billVisible = false;
        this.termVisible = false;
        this.examListHistoryVisible = false;
        this.payButtonDisable = true;
        this.feeTypeVisible = false;
        this.payVisible = false;
        this.scanVisible = false;
      }
      if (showType === '06') {
        // 历史账单（考试缴费）
        this.feeListHistoryVisible = false;
        this.semesterPayVisible = true;
        this.feePayType_UN = false;
        this.billVisible = false;
        this.termVisible = false;
        this.examBillVisible = false;
        this.examListHistoryVisible = true;
        this.payButtonDisable = true;
        this.feeTypeVisible = false;
        this.payVisible = false;
        this.scanVisible = false;
      }
      if (showType === '07') {
        // 账期选择
        this.feeListHistoryVisible = false;
        this.semesterPayVisible = false;
        this.feePayType_UN = false;
        this.billVisible = false;
        this.termVisible = false;
        this.examBillVisible = false;
        this.examListHistoryVisible = false;
        this.payButtonDisable = false;
        this.feeTypeVisible = true;
        this.payVisible = false;
        this.scanVisible = false;
      }
      if (showType === '10') {
        // 支付选择页面
        this.feeListHistoryVisible = false;
        this.semesterPayVisible = false;
        this.feePayType_UN = false;
        this.billVisible = false;
        this.termVisible = false;
        this.examBillVisible = false;
        this.examListHistoryVisible = false;
        this.payButtonDisable = false;
        this.feeTypeVisible = false;
        this.payVisible = true;
        this.scanVisible = false;
      }
      if (showType === '11') {
        // 支付页面
        this.payVisible = false;
        this.scanVisible = true;
      }
    },
    back: function back(type) {
      this.setVisible('07');
    },
    isShow: function isShow(row, event, column) {
      if (row.isExpanded === 0) {
        this.$refs.feeResultTable.toggleRowExpansion(row, true);
        row.isExpanded = 1;
      } else {
        this.$refs.feeResultTable.toggleRowExpansion(row, false);
        row.isExpanded = 0;
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      var self = this;
      self.viewForm.totals = 0;
      self.termList = [];
      val.forEach(function (e) {
        self.viewForm.totals = self.viewForm.totals + Number(e.feeAmount);
        self.termList.push(e.term);
      });
      if (self.viewForm.totals === 0) {
        self.payButtonDisable = true;
      } else {
        self.payButtonDisable = false;
      }
    },

    // 校验是否在缴费期中
    checkTerm: function checkTerm() {
      var self = this;
      var termInfo = this.modeSelectList.filter(function (element) {
        return element.typeId === 'CM_OldStuPayTime';
      });
      if (termInfo.length > 0) {
        self.payTerm.stdt = termInfo[0].field2;
        self.payTerm.endt = termInfo[0].field3;
        self.payTerm.academicYear = termInfo[0].modeValue.substring(0, 4);
        self.viewForm.academicYear = termInfo[0].modeValue;

        self.tipText = termInfo[0].field4;
        var newDate = self.Ginkgo.dateToInt(new Date());
        if (newDate >= self.payTerm.stdt && newDate <= self.payTerm.endt) {
          self.global.curUser.schoolYear = termInfo[0].modeValue.substring(0, 4);
          self.payTerm.isPayTerm = '1'; // 是在缴费期内
          self.checkTermMode('0');
        } else {
          if (!termInfo[0].field4) {
            self.termMsg = '不在缴费期内';
          } else {
            self.termMsg = termInfo[0].field4;
          }
          self.payTerm.isPayTerm = '0';
          console.log('payTerm:', self.payTerm);
          self.setVisible('02');
        }
      } else {
        self.termMsg = '不在缴费期内';
        self.payTerm.isPayTerm = '0';
        console.log('payTerm:', self.payTerm);
        self.setVisible('02');
      }
    },
    toLoan: function toLoan() {
      // 登录页面
      this.$router.push('/LoanXiFan');
      this.route = [{ path: '/LoanXiFan', component: __webpack_require__(277), meta: { title: '生源地贷款' } }];
      this.$router.addRoutes(this.route);
    },
    // 校验学期数据字典
    checkTermMode: function checkTermMode(type) {
      var termRow = this.modeSelectList.filter(function (element) {
        return element.typeId === 'Term_XF' && element.modeId === type;
      })[0];
      console.log('termRow', termRow);
      this.viewForm.term = termRow.modeId;
      this.viewForm.termNM = termRow.modeName;
      this.payTerm.term = termRow.modeId;
      console.log('viewForm', this.viewForm);
      if (this.global.curStudent.isYearFee === '1') {
        // 学年缴费
        this.billGetNew();
      } else {
        this.billGet();
      }
    },
    // 校验老生导入费用是否在缴费期中
    checkTermOldStuImp: function checkTermOldStuImp() {
      var self = this;
      var termInfo = this.modeSelectList.filter(function (element) {
        return element.typeId === 'CM_OldStuImpPayTime';
      });
      if (termInfo.length > 0) {
        console.log('termInfo:', termInfo);
        var stdt = termInfo[0].field2;
        var endt = termInfo[0].field3;

        self.tipText = termInfo[0].field4;
        var newDate = self.Ginkgo.dateToInt(new Date());
        if (newDate >= stdt && newDate <= endt) {
          self.setVisible('04');
          self.examBillGet();
        } else {
          if (!termInfo[0].field4) {
            self.termMsg = '不在缴费期内';
          } else {
            self.termMsg = termInfo[0].field4;
          }
          self.setVisible('02');
        }
      } else {
        self.termMsg = '不在缴费期内';
        self.setVisible('02');
      }
    },
    // 新收费方式
    billGetNew: function billGetNew() {
      // 账单查询
      var self = this;
      // 初始化
      var request = {};
      request.idIf = '60';
      request.deptId = self.global.deptId;
      request.itemList = [{ paramName: 'studentNo', paramValue: self.global.curStudent.studentNo }, { paramName: 'studYear', paramValue: self.payTerm.academicYear }, { paramName: 'studTerm', paramValue: '0' }];
      this.axios.post('/iif/accessIfForHttp', request).then(function (response) {
        if (response.data.result.success === true) {
          var obj = response.data.responseObj;
          if (obj.result.success === true) {
            // 已缴费
            var studBill = obj.studBillList.filter(function (item) {
              return item.feeNo === 'SF01';
            })[0];
            if (studBill.feeAmount > 0 && studBill.paidfeeAmount === studBill.feeAmount) {
              self.termMsg = '已缴费！';
              self.setVisible('02');
            } else if (studBill.paidfeeAmount > 0) {
              self.termMsg = '账单设置不正确，存在已交金额，请联系学校！';
              self.setVisible('02');
            } else {
              if (self.global.isLoan === '1') {
                self.global.isLoan = '0';
                self.setVisible('01');
                self.feeData = obj.studBillList;
                console.log('111111');
                self.reduceGet();
              } else {
                // 进入贷款页面
                self.toLoan();
              }
            }
          } else {
            self.termMsg = obj.result.msg;
            self.setVisible('02');
          }
        } else {
          self.$alert(response.data.result.msg);
        }
      }, function (response) {}).catch(function (error) {
        console.log(error);
      });
    },
    billGet: function billGet() {
      // 账单查询
      var self = this;
      // 初始化
      var request = {};
      request.idIf = '60';
      request.deptId = self.global.deptId;
      request.itemList = [{ paramName: 'studentNo', paramValue: self.global.curStudent.studentNo }, { paramName: 'studYear', paramValue: self.payTerm.academicYear }, { paramName: 'studTerm', paramValue: '0' }];
      this.axios.post('/iif/accessIfForHttp', request).then(function (response) {
        if (response.data.result.success === true) {
          var obj = response.data.responseObj;
          if (obj.result.success === true) {
            self.feeList = obj.studBillList;
            var studBill = obj.studBillList.filter(function (item) {
              return item.feeNo === 'SF01';
            })[0];
            // 选学期未缴费
            if (studBill.paidfeeAmount === 0) {
              if (self.global.isLoan === '0') {
                // 进入贷款页面
                self.toLoan();
              } else {
                // 显示账期选择
                self.global.isLoan = '0';
                self.backVisible = true;
                self.setVisible('07');
              }
            }
            // 第二学期
            if (studBill.paidfeeAmount > 0 && studBill.paidfeeAmount < studBill.feeAmount) {
              // 先校验欠费金额
              var termRow = self.modeSelectList.filter(function (element) {
                return element.typeId === 'Term_XF' && element.modeId === '1';
              })[0];
              console.log('termRow', termRow);
              self.viewForm.term = termRow.modeId;
              self.viewForm.termNM = termRow.modeName;
              self.payTerm.term = termRow.modeId;
              self.queryOrderInfoXiFan('1');
            }
            // 已缴费
            if (studBill.paidfeeAmount === studBill.feeAmount) {
              self.termMsg = '已缴费！';
              self.setVisible('02');
            }
          } else {
            self.termMsg = obj.result.msg;
            self.setVisible('02');
          }
        } else {
          self.$alert(response.data.result.msg);
        }
      }, function (response) {}).catch(function (error) {
        console.log(error);
      });
    },
    // 下一步 显示账单
    nextFee: function nextFee() {
      var self = this;
      this.feeData = [];
      // 选学年
      if (this.radio === '0') {
        this.feeData = this.feeList;
        console.log('2222222');
        this.reduceGet();
        this.setVisible('01');
      }
      // 选学期
      if (this.radio === '1') {
        // 显示账单
        var tmpList = [];
        var feeListTemp = this.Ginkgo.cloneObj(this.feeList);
        feeListTemp.forEach(function (ele) {
          if (ele.feeNo === 'SF01' || ele.feeNo === 'SF02') {
            ele.feeAmount = ele.feeAmount / 2;
            tmpList.push(ele);
          } else {
            tmpList.push(ele);
          }
        });
        self.feeData = tmpList;
        console.log('33333333');
        self.reduceGet();
        self.setVisible('01');
        // 新增西翻账单
        self.addOrderInfoXiFan();
      }
    },
    // 获取订单信息
    queryOrderInfoXiFan: function queryOrderInfoXiFan(term) {
      var self = this;
      if (true) {
        this.axios.post('/college/getStudBillXiFan', {
          studNo: self.global.curStudent.studentNo,
          studYear: self.payTerm.academicYear,
          studTerm: term
        }).then(function (response) {
          if (response.data.result.success === true) {
            var feeList = response.data.studBillXiFanList;
            if (feeList.length !== 0) {
              var feeAmountSum = 0;
              var feeAmountSum2 = 0;
              // 本地库账单
              for (var index = 0; index < feeList.length; index++) {
                feeAmountSum = feeAmountSum + Number(feeList[index].feeAmount);
              }
              // 西翻库账单
              for (var _index = 0; _index < self.feeList.length; _index++) {
                if (self.feeList[_index].feeNo === 'SF01' || self.feeList[_index].feeNo === 'SF02') {
                  feeAmountSum2 = feeAmountSum2 + (Number(self.feeList[_index].feeAmount) - Number(self.feeList[_index].paidfeeAmount));
                }
              }
              if (feeAmountSum === feeAmountSum2) {
                self.feeData = feeList;
                console.log('44444444444');
                self.reduceGet();
                self.setVisible('01');
              } else {
                self.termMsg = '欠费金额有变动，请联系学校！';
                self.setVisible('02');
              }
            } else {
              self.termMsg = '找不到本地订单！';
              self.setVisible('02');
            }
          } else {
            self.$alert('Error 服务异常！');
          }
        }, function (response) {}).catch(function (error) {
          console.log(error);
        });
      }
    },
    // 新增订单信息
    addOrderInfoXiFan: function addOrderInfoXiFan() {
      var self = this;
      var tmpList = [];
      var tmpRow = {};
      var feeListTemp = this.Ginkgo.cloneObj(this.feeList);
      feeListTemp.forEach(function (ele) {
        tmpRow = {};
        tmpRow.studNo = self.global.curStudent.studentNo;
        tmpRow.studYear = ele.studYear;
        tmpRow.studTerm = '0';
        tmpRow.feeNo = ele.feeNo;
        tmpRow.feeName = ele.feeName;
        if (ele.feeNo === 'SF01' || ele.feeNo === 'SF02') {
          tmpRow.feeAmount = ele.feeAmount / 2;
        } else {
          tmpRow.feeAmount = ele.feeAmount;
        }
        tmpList.push(tmpRow);
        if (ele.feeNo === 'SF01' || ele.feeNo === 'SF02') {
          tmpRow = {};
          tmpRow.studNo = self.global.curStudent.studentNo;
          tmpRow.studYear = ele.studYear;
          tmpRow.studTerm = '1';
          tmpRow.feeNo = ele.feeNo;
          tmpRow.feeName = ele.feeName;
          tmpRow.feeAmount = ele.feeAmount / 2;
          tmpList.push(tmpRow);
        }
      });
      if (true) {
        this.axios.post('/college/addStudBillXiFan', tmpList).then(function (response) {
          if (response.data.result.success === true) {
            console.log('订单新增成功');
          }
        }, function (response) {}).catch(function (error) {
          console.log(error);
        });
      }
    },
    // 减免账单查询
    reduceGet: function reduceGet() {
      if (true) {
        var self = this;
        self.axios.get('/college/getOrderInfoXiFan', { params: {
            deptId: self.global.deptId,
            term: '',
            keyInfo: self.global.curStudent.studentNo,
            statusCode: '02',
            field1: '',
            field2: '减免',
            field3: '',
            field4: self.viewForm.academicYear,
            field5: '',
            field6: '',
            field7: '',
            field8: '',
            field9: '',
            field10: ''
          } }).then(function (response) {
          if (response.data.result.success === true) {
            self.reduceList = response.data.orderInfoList;
            self.viewForm.payableAmount = 0;
            self.viewForm.feeAmount = 0;
            self.viewForm.reduceAmount = 0;
            for (var index = 0; index < self.feeData.length; index++) {
              self.viewForm.payableAmount = self.viewForm.payableAmount + Number(self.feeData[index].feeAmount);
              self.viewForm.feeAmount = self.viewForm.feeAmount + Number(self.feeData[index].feeAmount);
            }
            if (self.reduceList.length !== 0) {
              // 如果减免账单不为空，根据减免信息计算实缴金额
              for (var _index2 = 0; _index2 < self.reduceList.length; _index2++) {
                self.viewForm.feeAmount = self.viewForm.feeAmount - Math.abs(Number(self.reduceList[_index2].feeAmount));
                self.viewForm.reduceAmount = self.viewForm.reduceAmount + Number(self.reduceList[_index2].feeAmount);
              }
              console.log('self.viewForm:', self.viewForm);
            }
            if (self.viewForm.feeAmount < 0) {
              self.$alert('实缴金额为负值，' + self.viewForm.feeAmount + ' 元，不允许支付！');
              self.payButtonDisable = true;
            } else if (self.viewForm.feeAmount === 0) {
              self.$alert('实缴金额为 ' + self.viewForm.feeAmount + ' 元，不允许支付！');
              self.payButtonDisable = true;
            } else {
              self.payButtonDisable = false;
            }
          }
        }, function (response) {}).catch(function (error) {
          console.log(error);
        });
      }
    },
    toPay: function toPay() {
      this.checkPayTime();
    },
    checkPayTime: function checkPayTime() {
      var self = this;
      // self.buttonLoad = true
      self.axios.get('/pay/checkToPay', { params: {
          deptId: self.global.deptId // 1000003
        } }).then(function (response) {
        if (response.data.return_msg === 'SUCCESS') {
          if (self.feeType === '01') {
            // 学期缴费创建订单
            self.createOrderInfo();
          } else {
            // 考试缴费
            self.getDeptSet();
          }
          // self.buttonLoad = false
        } else {
          // self.buttonLoad = false
          self.$alert(response.data.prop);
        }
      }, function (response) {}).catch(function (error) {
        console.log(error);
      });
    },
    // 生成订单信息
    createOrderInfo: function createOrderInfo() {
      var _this = this;

      var self = this;
      var orderInfoList = [];
      this.termList = [];
      this.feeData.forEach(function (element) {
        var orderInfo = _this.Ginkgo.resetForm(_this.uiSetItemList, 'tbIf_Order_Info_Common');
        orderInfo.id = 0;
        orderInfo.transDt = 0;
        orderInfo.term = _this.Ginkgo.getTimeStamp() + _this.viewForm.academicYear + _this.viewForm.term + element.feeName; // 处理账期
        orderInfo.statusCode = '02'; // 初始核准状态
        orderInfo.field12 = '01'; // 老生学期缴费
        orderInfo.deptId = self.global.deptId;
        orderInfo.keyInfo = _this.viewForm.studentNo;
        orderInfo.field1 = _this.viewForm.studentName;
        orderInfo.field2 = _this.viewForm.majorMatr;
        orderInfo.field3 = _this.viewForm.className;
        orderInfo.field4 = _this.viewForm.academicYear;
        orderInfo.field5 = _this.viewForm.term;
        orderInfo.field6 = _this.viewForm.termNM;
        orderInfo.field7 = _this.viewForm.enrollmentYear;
        orderInfo.field8 = _this.viewForm.trainingLevel;
        orderInfo.field9 = _this.viewForm.deptName;
        orderInfo.feeNo = element.feeName;
        orderInfo.field10 = element.feeNo;
        orderInfo.payableAmount = element.feeAmount;
        orderInfo.feeAmount = element.feeAmount;
        orderInfo.remark = '银行数据导入';
        orderInfo.idIf = 60;
        orderInfoList.push(orderInfo);
        _this.termList.push(orderInfo.term);
      });
      if (this.reduceList.length > 0) {
        this.reduceList.forEach(function (ele) {
          self.termList.push(ele.term);
        });
      }
      this.axios.post('/iif/addOrderInfoList', orderInfoList).then(function (response) {
        if (response.data.result.success === true) {
          self.getDeptSet();
          // self.buttonLoad = false
        } else {
          // self.buttonLoad = false
          self.$alert('生成账单失败！');
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    // 获取机构支付配置
    getDeptSet: function getDeptSet() {
      var self = this;
      self.axios.get('/college/getBaseDeptSetByDeptID', { params: {
          deptId: self.global.deptId
        } }).then(function (response) {
        // 机构配置信息
        if (response.data.result.success === true) {
          self.viDeptSetList = response.data.viDeptSetList;
          if (self.viDeptSetList.length > 0) {
            self.setVisiblePayButton(self.viDeptSetList);
          }
        }
        self.buttonLoad = false;
      }, function (response) {}).catch(function (error) {
        console.log(error);
      });
    },
    setVisiblePayButton: function setVisiblePayButton(merchantList) {
      var self = this;
      // 取微信支付相关参数
      var wxPayType = merchantList.filter(function (item) {
        return item.payKind === '02';
      }); // payKind：01 银联; 02 微信; 03 支付宝; 04 代扣;
      if (wxPayType.length > 0) {
        // 有且仅有一个
        self.channelFlag = wxPayType[0].channelFlag;
        self.merchantCode = wxPayType[0].merchantCode;
      }
      // 设置支付方式的显示隐藏
      self.buttonVisibleUnion = false;
      self.buttonVisibleWX = false;
      self.buttonVisibleZFB = false;
      // 商户配置信息
      if (merchantList.length > 0) {
        merchantList.forEach(function (e) {
          if (e.payKind === '01') {
            // 银联
            self.payTypeUnion = e.payType;
            self.buttonVisibleUnion = true;
          }
          if (e.payKind === '02') {
            // 微信
            self.payType = e.payType;
            self.buttonVisibleWX = true;
          }
          if (e.payKind === '03') {
            // 支付宝
            self.payTypeZFB = e.payType;
            self.buttonVisibleZFB = true;
          }
          if (e.payKind === '07') {
            // 浦发新微信
            self.payTypePFWX = e.payType;
            self.buttonVisiblePFWX = true;
          }
          if (e.payKind === '08') {
            // 浦发新支付宝
            self.payTypePFZFB = e.payType;
            self.buttonVisiblePFZFB = true;
          }
          if (e.payType === '98') {
            // 暂无用
            self.payTypeHTT = e.payType;
            self.buttonVisibleHTT = true;
          }
          if (e.payKind === '04') {
            // 代扣
            self.payTypeZJ = e.payType;
            self.buttonVisibleZJ = true;
          }
        });
      }
      self.setVisible('10');
    },
    doPay: function doPay(payType) {
      if (true) {
        var self = this;
        var payUrl = '';
        var validType = '01';
        if (this.feeType === '01') {
          // 学期缴费
          validType = '02';
        }
        // 根据不同支付方式访问不同的发起交易服务
        self.axios.post('/pay/toPay', {
          keyInfo: self.viewForm.studentNo,
          deptId: self.global.deptId,
          payType: payType,
          feeTermList: self.termList,
          channelType: '02',
          validType: validType
        }).then(function (response) {
          if (response.data.result.success) {
            var payKind = self.viDeptSetList.filter(function (item) {
              return item.payType === payType;
            })[0].payKind;
            if (payKind === '02') {
              // 微信支付
              payUrl += self.global.payUrl + 'pay/doPayForUrl?';
              payUrl += 'payType=' + payType;
              payUrl += '&orderNo=' + response.data.orderNo;
              payUrl += '&deptId=' + response.data.deptId;
              payUrl += '&openId=' + self.global.curUser.openId;
              payUrl += '&qrCodeType=' + 'WXPAY';
              payUrl += '&payChannel=01';
              // 二维码
              console.log('===wx支付地址===', payUrl);
              self.qrContent = payUrl;
              self.setVisible('11');
            } else if (payKind === '03') {
              payUrl += self.global.payUrl + 'pay/doPayForUrl?';
              payUrl += 'payType=' + payType;
              payUrl += '&orderNo=' + response.data.orderNo;
              payUrl += '&deptId=' + response.data.deptId;
              payUrl += '&openId=' + self.global.curUser.openId;
              payUrl += '&qrCodeType=' + 'ALIPAY';
              payUrl += '&payChannel=01';
              // 二维码
              console.log('===支付宝支付地址===', payUrl);
              self.qrContent = payUrl;
              self.setVisible('11');
            } else if (payKind === '07') {
              // 浦发微信支付 新版 opNJK1tn-GZEhIudaMdrRmr4wYs0
              payUrl += self.global.payUrl + 'pay/doPayForUrl?';
              payUrl += 'payType=' + payType;
              payUrl += '&orderNo=' + response.data.orderNo;
              payUrl += '&deptId=' + response.data.deptId;
              payUrl += '&openId=' + self.global.curUser.openId;
              payUrl += '&qrCodeType=' + 'WXPAY';
              payUrl += '&payChannel=01';
              console.log('===pfwx支付地址===', payUrl);
              self.qrContent = payUrl;
              self.setVisible('11');
            } else if (payKind === '08') {
              // 浦发支付宝支付 新版 opNJK1tn-GZEhIudaMdrRmr4wYs0
              payUrl += self.global.payUrl + 'pay/doPayForUrl?';
              payUrl += 'payType=' + payType;
              payUrl += '&orderNo=' + response.data.orderNo;
              payUrl += '&deptId=' + response.data.deptId;
              payUrl += '&openId=' + self.global.curUser.openId;
              payUrl += '&qrCodeType=' + 'ALIPAY';
              payUrl += '&payChannel=01';
              console.log('===pfzfb支付地址===', payUrl);
              self.qrContent = payUrl;
              self.setVisible('11');
            } else {
              payUrl = self.global.payUrl + 'pay/doPay?' + 'payType=' + self.payTypeUnion + '&orderNo=' + response.data.orderNo + '&deptId=' + response.data.deptId + '&openId=&payChannel=02';
              window.location.href = payUrl;
            }
          } else {
            self.$alert(response.data.result.msg);
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        this.setVisible('01');
      }
    },
    showWechatImg: function showWechatImg() {
      this.dialogFormVisible = true;
    },
    handleSelect: function handleSelect(index, indexPath) {
      if (true) {
        if (index === '/MyBill') {
          this.feeType = '01';
          if (this.payTerm.isPayTerm === '1') {
            this.viewForm.totals = 0;
            this.viewForm.feeAmount = 0;
            this.viewForm.reduceAmount = 0;
            this.viewForm.payableAmount = 0;
            this.feeData = [];
            this.setVisible('01');
            this.checkTermMode('0');
          } else {
            this.setVisible('02');
          }
        }
        if (index === '/MyBillExam') {
          this.feeType = '02';
          this.viewForm.totals = 0;
          this.feeData = [];
          this.checkTermOldStuImp();
        }
        if (index === '/MyBillHistory') {
          this.tableData = [];
          this.setVisible('03');
          this.getHistoryByType('');
        }
        if (index === '/MyBillHistoryExam') {
          this.tableData = [];
          this.setVisible('06');
          this.getHistoryByType('02');
        }
        if (index === '/Card') {
          this.$router.push('/card');
          this.route = [{ path: '/card', component: __webpack_require__(151), meta: { title: '银行卡信息维护' } }];
          this.$router.addRoutes(this.route);
        }
        if (index === '/Exit') {
          this.$router.push('/LoginXiFan');
          this.route = [{ path: '/LoginXiFan', component: __webpack_require__(69), meta: { title: '缴费登录' } }];
          this.$router.addRoutes(this.route);
        }
      } else {
        if (index === '/MyBill') {
          this.setVisible('02');
        }
        if (index === '/Exit') {
          this.$router.push('/LoginXiFan');
          this.route = [{ path: '/LoginXiFan', component: require('./LoginXiFan.vue'), meta: { title: '缴费登录' } }];
          this.$router.addRoutes(this.route);
        }
      }
    },
    // 获取学生历史缴费信息
    getHistory: function getHistory() {
      if (true) {
        var self = this;
        var request = {};
        request.deptId = self.global.deptId;
        request.keyInfo = self.global.curStudent.studentNo;
        var str = (0, _stringify2.default)(request);
        this.axios.post('/iif/getOrderInfoForHistoryByEncrypt', this.Ginkgo.encrypt(str)).then(function (response) {
          var backJson = JSON.parse(self.Ginkgo.rsaDecrypt(response.data));
          if (backJson.result.success === true) {
            self.orderInfoList = backJson.orderInfoList;
          }
        }, function (response) {}).catch(function (error) {
          console.log(error);
        });
      } else {
        this.uiSetItemList = [{ uiSetId: 'tbIf_Order_Info_XiFan', columnName: 'transDt', columnDesc: '日期', columnProp: 'transDt', isVisible: '1', isVisibleDesc: '', sortNo: '99', queryCondition: '0', queryConditionDesc: '', sortNoQuery: '99', controlType: '02', controlTypeDesc: '', typeId: 'Dept_Type_KD', defaultValue: '01', required: '0', requiredDesc: '', isUnique: '0', isUniqueDesc: '', dataType: '01', dataTypeDesc: '', newDisabled: '0', editDisabled: '0', editDisabledDesc: '', queryVisible: '1', queryVisibleDesc: '', sortNoResult: '11', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '0', isFixColDesc: '', colWidth: '120', isCross: '0', isCrossDesc: '', isGroupStart: '1', isGroupStartDesc: '' }, { uiSetId: 'tbIf_Order_Info_XiFan', columnName: 'feeAmount', columnDesc: '费用', columnProp: 'feeAmount', isVisible: '1', isVisibleDesc: '', sortNo: '99', queryCondition: '0', queryConditionDesc: '', sortNoQuery: '99', controlType: '02', controlTypeDesc: '', typeId: 'Dept_Type_KD', defaultValue: '01', required: '0', requiredDesc: '', isUnique: '0', isUniqueDesc: '', dataType: '01', dataTypeDesc: '', newDisabled: '0', editDisabled: '0', editDisabledDesc: '', queryVisible: '1', queryVisibleDesc: '', sortNoResult: '11', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '0', isFixColDesc: '', colWidth: '120', isCross: '0', isCrossDesc: '', isGroupStart: '1', isGroupStartDesc: '' }, { uiSetId: 'tbIf_Order_Info_XiFan', columnName: 'orderNo', columnDesc: '订单号', columnProp: 'orderNo', isVisible: '1', isVisibleDesc: '', sortNo: '99', queryCondition: '0', queryConditionDesc: '', sortNoQuery: '99', controlType: '02', controlTypeDesc: '', typeId: 'Dept_Type_KD', defaultValue: '01', required: '0', requiredDesc: '', isUnique: '0', isUniqueDesc: '', dataType: '01', dataTypeDesc: '', newDisabled: '0', editDisabled: '0', editDisabledDesc: '', queryVisible: '1', queryVisibleDesc: '', sortNoResult: '11', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '0', isFixColDesc: '', colWidth: '120', isCross: '0', isCrossDesc: '', isGroupStart: '1', isGroupStartDesc: '' }];
        this.orderInfoList = [{ transDt: '20180730', feeAmount: 100, orderNo: 'xxxxxxxxxxxxxxxx' }];
        this.page.totalElements = this.orderInfoList.length;
        this.loadCurrentPageHistory();
        this.setVisible('03');
      }
    },
    // 根据费用类型获取对应的缴费历史记录
    getHistoryByType: function getHistoryByType(type) {
      var self = this;
      if (type === '') {
        this.orderInfoListByType = this.orderInfoList;
      } else {
        this.orderInfoListByType = this.orderInfoList.filter(function (item) {
          return type === item.field12;
        });
      }
      // 首次默认排序
      self.handleSortChangeHistory(self.sort);
      // 分页处理
      self.page.totalElements = self.orderInfoListByType.length;
      self.loadCurrentPageHistory();
      // 设置当前选中行
      self.setCurrentRowHistory();
    },
    // 获取考试缴费账单
    examBillGet: function examBillGet() {
      if (true) {
        var self = this;
        self.axios.get('/iif/getOrderInfoCheck', { params: {
            deptId: self.global.deptId,
            keyInfo: self.global.curStudent.studentNo
          } }).then(function (response) {
          if (response.data.result.success === true) {
            if (response.data.orderInfoList.length > 0) {
              self.feeData = response.data.orderInfoList.filter(function (item) {
                return item.field12 === '02';
              });
              for (var index = 0; index < self.feeData.length; index++) {
                self.feeData[index].field6 = false;
              }
            } else {
              self.payButtonDisable = true;
            }
          }
        }, function (response) {}).catch(function (error) {
          console.log(error);
        });
      }
    },
    // 获取查询结果配置
    getUISetQueryResult: function getUISetQueryResult(form) {
      var setId = form === '01' ? 'tbIf_Order_Info_XiFan' : 'tbIf_Order_Info_XiFan_Exam';
      var sort = { prop: 'sortNoResult', order: 'ascending' };

      var list = this.uiSetItemList.filter(function (element) {
        return element.uiSetId === setId && element.queryVisible === '1';
      });

      return this.Ginkgo.sortList(list, sort);
    },
    // 列数据格式化
    dataFormatHistory: function dataFormatHistory(row, column, cellValue) {
      var columnProp = column.property;
      // 根据列的property(绑定的字段属性)回查列设置
      var formatString = this.getUISetQueryResult('01').filter(function (element) {
        return element.columnProp === columnProp;
      })[0].formatString;

      return this.Ginkgo.format(cellValue, formatString);
    },
    dataFormatExamHistory: function dataFormatExamHistory(row, column, cellValue) {
      var columnProp = column.property;
      // 根据列的property(绑定的字段属性)回查列设置
      var formatString = this.getUISetQueryResult('02').filter(function (element) {
        return element.columnProp === columnProp;
      })[0].formatString;

      return this.Ginkgo.format(cellValue, formatString);
    },
    // 列可见性
    getHeaderVisible: function getHeaderVisible(item, level, fixed) {
      return this.Ginkgo.getHeaderVisible(item, level, fixed);
    },
    // 获取同组记录
    getHeaderGroup: function getHeaderGroup(item, level, form) {
      return this.Ginkgo.getHeaderGroup(item, level, this.getUISetQueryResult(form));
    },
    // 排序(参数var={prop,order}) order: ascending  descending
    handleSortChangeHistory: function handleSortChangeHistory(val) {
      this.sort = val;
      var sorts = this.Ginkgo.cloneObj(this.sortSet);
      sorts.pop(); // 删除最后一个对象（最后一个对象根据界面列点击改变）
      sorts.push(val);
      this.orderInfoListByType = this.Ginkgo.sort(this.orderInfoListByType, sorts);
      this.loadCurrentPageHistory();
    },
    // 选中当前行
    setCurrentRowHistory: function setCurrentRowHistory() {
      if (this.currentIndex !== -1) {
        this.$refs.resultTable.setCurrentRow(this.tableData[this.currentIndex]);
      }
    },
    // 加载当前页内容
    loadCurrentPageHistory: function loadCurrentPageHistory() {
      this.tableData = this.orderInfoListByType.slice(this.page.number * this.page.size, (this.page.number + 1) * this.page.size);
    },
    // 查询结果每页显示条数改变事件
    handleSizeChangeHistory: function handleSizeChangeHistory(val) {
      this.page.size = val;
      this.loadCurrentPageHistory();
    },
    // 页码改变事件
    handleCurrentChangeHistory: function handleCurrentChangeHistory(val) {
      this.page.number = val - 1;
      this.loadCurrentPageHistory();
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ 657:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(125);

var _stringify2 = _interopRequireDefault(_stringify);

var _vueQr = __webpack_require__(193);

var _vueQr2 = _interopRequireDefault(_vueQr);

var _noticeBar = __webpack_require__(148);

var _noticeBar2 = _interopRequireDefault(_noticeBar);

__webpack_require__(149);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MyBillXiFanNew', // ?
  components: { vueQr: _vueQr2.default, vanNoticeBar: _noticeBar2.default },
  data: function data() {
    return {
      profile: 'prod',

      termMsg: '无欠费信息！',
      imgSrc: '',
      dormList: [], // 当前可选宿舍列表
      chosenDorm: {}, // 当前选择的宿舍列表
      modeSelectList: [],

      curStudent: {},
      payTerm: {
        stdt: 0, // 缴费开始日期
        endt: 0, // 缴费结束日期
        academicYear: '', // 学年
        term: '', // 学期
        isPayTerm: ''
      },
      tableData: [], // table绑定数据
      uiSetItemList: [], // 原始
      termList: [], // 账期列表
      totalFeeAmount: 0, // 所有支付账单的总金额
      orderInfoList: [], // 缴费历史
      orderInfoListByType: [], // 各类型缴费历史
      viDeptSetList: [],
      // 控制属性
      feeListVisible: false,
      queryFormVisible: false,
      isAllTermPay: false,
      feeListHistoryVisible: false,
      tabSelected: 'default', // 默认显示本期账单
      formLabelWidth: '80px',
      // 标签图片
      infoVisible: false,

      feeList: [],
      feeSum: {},

      // 选择公寓用品窗体
      dormConfigCheckList: [], // 当前已选列
      dormConfigList: [], // 所有可选的=列
      dormConfigOptions: [],

      payRule: '',
      channelFlag: '01',
      merchantCode: '',
      // 分页对象
      page: this.Ginkgo.cloneObj(this.global.page),
      payTypeVisible: false,
      feePayType_WX: false,
      feePayType_UN: true,
      // 查询窗体
      uiSetList: [],
      route: [],
      // ！！！初始排序对象
      sort: {},
      sortSet: [],
      // 选宿舍窗体
      dormSetForm: {}, // 宿舍类型配置信息
      dormSetList: [], // 宿舍类型下拉框
      dormChooseForm: { // 选宿舍
        dormSet: '',
        flatsName: '',
        roomNo: '',
        bedNo: ''
      },
      // 选服装窗体
      clothChooseForm: {
        coatSize: '',
        shirtSize: '',
        shoesSize: ''
      },
      // 属性
      dialogFormVisible: false,
      chooseDormVisible: true,
      chooseOtherVisible: false,
      showImg: false,
      // 打印报到单
      orderInfoRow: {},
      classRow: {},
      dormRow: {},
      // 公寓相关图片
      effectDrawing: this.global.staticResourceAddr + 'gsvxifanvuem/newStu/4rj.jpg',
      bedDiagram: this.global.staticResourceAddr + 'gsvxifanvuem/newStu/10001.png',
      size_Img: this.global.staticResourceAddr + 'gsvxifanvuem/newStu/sgcm.jpg',
      weixin: this.global.staticResourceAddr + 'gsvvuepc/zft2Code.jpg',

      financeOffice: {},
      apartmentOffice: {},
      deanOffice: {},
      admissionsOffice: {},
      technicalSupport: {},
      informationManagementCenter: {},
      customerService: {},
      fourBedSum: '0', // 四人间总数
      fourBedRmi: '0', // 六人间剩余
      sixBedSum: '0', // 六人间总数
      sixBedRmi: '0', // 四人间剩余
      selectedDormConfigList: [], // 所选宿舍配置订单信息
      dormConfig: '', // 所选宿舍配置信息
      // 支付相关
      payVisible: false,

      scanVisible: false,
      qrContent: '',
      qrImage: '',

      buttonVisibleWX: false,
      buttonVisibleZFB: false,
      buttonVisibleUnion: false,
      buttonVisiblePFWX: false,
      buttonVisiblePFZFB: false,

      payType: '',
      payTypeZFB: '',
      payTypeUnion: '01',
      payTypeHTT: '',
      payTypeZJ: '',
      payTypeUnionWX: '',
      payTypePFWX: '',
      payTypePFZFB: '',
      // 图片
      wx: this.global.staticResourceAddr + 'gsvxifanvuem/' + this.global.theme + '/images/wx.png',
      yl: this.global.staticResourceAddr + 'gsvxifanvuem/' + this.global.theme + '/images/yl.png',
      zfb: this.global.staticResourceAddr + 'gsvxifanvuem/' + this.global.theme + '/images/zfb.png',
      // 提示信息
      tipText: '',
      miliTrainConfig: '',
      miliTrainItem: []
    };
  },
  mounted: function mounted() {
    if (true) {
      var self = this;
      this.curStudent = this.global.curStudent;
      self.getMode();
      self.getUISet();
      // 验证缴费期限
      var isPayTerm = this.validPayTerm();
      if (isPayTerm) {
        // 判断是否从贷款页面跳转过来
        if (this.global.isLoan === '1') {
          this.global.isLoan = '0';
          this.initThis();
        } else {
          // 检查是否有待审核的线下缴费申请
          this.checkPendingApply();
        }
      } else {
        this.setVisible('06'); // 提示信息
      }
    } else {
      this.getUISet();
      if (this.global.isLoan === '1') {
        // 从贷款页面过来
        // 进入缴费流程
        this.global.isLoan = '0';
        this.initThis();
      } else {
        this.validPayTerm(); // 校验该学生是否交过费用
      }
    }
  },
  watch: {
    'dormChooseForm.dormSet': 'handleDormSetChange',
    'dormChooseForm.flatsName': 'handleFlatsChange',
    'dormChooseForm.roomNo': 'handleRoomChange',
    tabSelected: 'handleSelect'
  },
  methods: {
    // 检查是否有线下缴费申请记录
    checkPendingApply: function checkPendingApply() {
      var self = this;
      self.axios.post('/pay/queryAllFeeApply', {
        uid: self.curStudent.uid,
        dataStatus: '01'
      }).then(function (response) {
        if (response.data.result && response.data.result.success === true) {
          var applyList = response.data.applyList || [];
          if (applyList.length > 0) {
            // 有申请记录,跳转到线下缴费页面
            self.$alert('您有线下缴费申请记录!');
            self.$router.push('/offlinePay');
            self.route = [{ path: '/offlinePay', component: function component() {
                return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 122));
              }, meta: { title: '线下缴费' } }];
            self.$router.addRoutes(self.route);
          } else {
            // 没有申请记录,继续正常流程
            self.validOrderInfo();
          }
        } else {
          // 查询失败,继续正常流程
          self.validOrderInfo();
        }
      }).catch(function (error) {
        console.log(error);
        // 出错时继续正常流程
        self.validOrderInfo();
      });
    },
    // 校验是否在缴费期中
    validPayTerm: function validPayTerm() {
      var _this = this;

      var self = this;
      var termInfo = [];
      if (this.global.curStudent.trainingLevel === '专升本') {
        termInfo = this.modeSelector('CM_ZSBStuPayTime').filter(function (item) {
          return item.modeValue.substring(0, 4) === _this.curStudent.enrollmentYear.toString();
        });
      } else {
        termInfo = this.modeSelector('CM_NewStuPayTime').filter(function (item) {
          return item.modeValue.substring(0, 4) === _this.curStudent.enrollmentYear.toString();
        });
      }
      if (termInfo.length > 0) {
        self.payTerm.stdt = termInfo[0].field2;
        self.payTerm.endt = termInfo[0].field3;
        self.payTerm.academicYear = termInfo[0].modeValue;
        self.payTerm.term = termInfo[0].field1;

        // 添加通知信息
        self.tipText = termInfo[0].field4;
        var newDate = self.Ginkgo.dateToInt(new Date());
        if (newDate >= self.payTerm.stdt && newDate <= self.payTerm.endt) {
          self.global.curUser.schoolYear = termInfo[0].modeValue.substring(0, 4);
          return true;
        } else {
          self.termMsg = termInfo[0].field4 || termInfo[0].field4 !== '' ? termInfo[0].field4 : '缴费未开始！';
          return false;
        }
      } else {
        self.termMsg = '缴费未开始！';
        return false;
      }
    },
    // 获取学生历史缴费信息
    getOrderInfoList: function getOrderInfoList() {
      var self = this;
      var request = {};
      request.deptId = self.global.deptId;
      request.keyInfo = self.global.curStudent.uid;
      var str = (0, _stringify2.default)(request);
      return self.axios.post('/iif/getOrderInfoForHistoryByEncrypt', this.Ginkgo.encrypt(str)).then(function (response) {
        var backJson = JSON.parse(self.Ginkgo.rsaDecrypt(response.data));
        if (backJson.result.success === true) {
          var curYear = self.Ginkgo.getTimeStamp(new Date()).substr(0, 4);
          self.orderInfoList = backJson.orderInfoList.filter(function (item) {
            return item.field4 === curYear;
          });
          self.orderInfoListByType = self.orderInfoList.filter(function (item) {
            return item.field12 === '04';
          });
          if (self.orderInfoListByType.length > 0) {
            self.orderInfoRow = self.orderInfoListByType[0];
            self.getDormConfigInfo();
          } else {
            self.$alert('请先缴费！');
          }
        }
      }, function (response) {}).catch(function (error) {
        console.log(error);
      });
    },
    // 获取打印所需数据
    getPrintList: function getPrintList() {
      var self = this;
      self.axios.all([self.getClassList(), self.getDormList()]).then(self.axios.spread(function (classDivd, dorm) {
        if (classDivd.data.result.success === true && dorm.data.result.success === true) {
          self.classRow = classDivd.data.classDivdList[0];
          self.dormRow = dorm.data.viXFDormOneList[0];
          self.toPrint();
        } else {
          self.$alert('报到单信息获取失败！');
        }
      }));
    },
    // 获取学生所选班级
    getClassList: function getClassList() {
      var self = this;
      return self.axios.get('/college/getClassDivdOne', { params: {
          keyInfo: self.global.curStudent.uid,
          schoolYear: self.curStudent.enrollmentYear
        } });
    },
    // 获取学生所选床位
    getDormList: function getDormList() {
      var self = this;
      return self.axios.get('/college/getViXFDorm', { params: {
          bedId: self.orderInfoRow.field13
        } });
    },
    // 获取公寓用品配置
    getDormConfigInfo: function getDormConfigInfo() {
      var self = this;
      self.axios.get('/college/getSelectedDormConfig', { params: {
          studentName: self.global.curStudent.studentName,
          uid: self.global.curStudent.uid
        } }).then(function (response) {
        if (response.data.result.success === true) {
          self.selectedDormConfigList = response.data.dormConfigList;
          self.dormConfig = '';
          if (self.selectedDormConfigList.length > 0) {
            self.selectedDormConfigList.filter(function (item) {
              if (item.goods === self.selectedDormConfigList[self.selectedDormConfigList.length - 1].goods) {
                self.dormConfig += item.goods.substring(1);
              } else {
                self.dormConfig += item.goods.substring(1);
                self.dormConfig += '、';
              }
            });
          }
          self.getPrintList();
        }
      });
    },
    toPrint: function toPrint() {
      var _this2 = this;

      var sort = { prop: 'field10', order: 'ascending' };
      var feelist = this.Ginkgo.sortList(this.orderInfoListByType, sort);
      var feeReducelist = this.orderInfoList.filter(function (item) {
        return item.field12 === '05';
      });
      // 计算金额
      var feeAmount = 0.0;
      for (var index = 0; index < feelist.length; index++) {
        feeAmount = feeAmount + parseFloat(feelist[index].feeAmount) * 100;
      }
      feeAmount = feeAmount / 100;
      var codestr = '';
      codestr += '';
      codestr += '<div style="width: 85%; margin: 0 auto;font-size:14px;">';
      codestr += '<h1 style="color: rgb(9, 9, 9);height: 60px;line-height: 60px;text-align: center;margin:10px 0;font-size: 26px;font-weight:bold;">西安翻译学院新生入学报到单</h1>';
      codestr += '<div style="display:flex;justify-content:space-between;align-items:flex-start;flex-wrap:nowrap;gap:15px;">' + '<div style="flex:1;overflow:hidden;">' + '<div style="display:grid;grid-template-columns: 280px 280px;gap:6px;line-height:35px;">' + '<span style="text-align:left;">学号：' + this.curStudent.studentNo + '</span>' + '<span style="text-align:left;">专业：' + this.curStudent.majorMatr + '</span>' + '<span style="text-align:left;">姓名：' + this.curStudent.studentName + '</span>' + '<span style="text-align:left;">班级：' + this.classRow.className + '</span>' + '<span style="text-align:left;">性别：' + this.curStudent.sex + '</span>' + '<span style="text-align:left;">培养类别：' + this.curStudent.trainingLevel + '</span>' + '<span style="text-align:left;">考生号：' + this.curStudent.examNo + '</span>' + '<span style="text-align:left;">培养对象：' + this.curStudent.trainingObject + '</span>' + '<span style="text-align:left;">校园E卡通号：' + this.curStudent.studentNo + '</span>' + '<span style="text-align:left;">联系电话：' + this.curStudent.phone + '</span>' + '<span style="text-align:left;">年级：' + this.curStudent.enrollmentYear + '</span>' + '<span style="text-align:left;">缴费日期：' + this.Ginkgo.getToday(feelist[0].transDt.toString()) + '</span>' + '<span style="text-align:left;">院/系部：' + this.orderInfoRow.field9 + '</span>' + '<span style="text-align:left;">交费金额：' + feeAmount + '</span>' + '</div>' + '</div>' + '<div style="width:150px;height:150px;"><img src="' + this.$refs.qrCodeRef.$el.src + '" style="width:100%;height:100%;"/></div>' + '</div>';
      codestr += '</div>';
      codestr += '<div style="margin-top:10px;"><table style="color: rgb(9, 9, 9);width: 85%; margin: 0 auto; text-align: center;border-collapse:collapse;" border="1">' + '<tr style="height:36px;font-size:14px;"><td>收费项目</td><td>收费标准(元)</td><td>收费项目</td><td>收费标准(元)</td></tr>';

      for (var i = 0; i < feelist.length; i++) {
        if (i % 2 === 0) {
          codestr = codestr + '<tr style="height:36px;font-size:12px;">';
        }
        codestr = codestr + '<td>' + feelist[i].feeNo + '</td><td>' + feelist[i].feeAmount + '</td>';
        if (i % 2 === 1) {
          codestr = codestr + '</tr>';
        }
        if (i % 2 === 0 && i === feelist.length - 1) {
          codestr = codestr + '<td></td><td></td>' + '</tr>';
        }
      }
      // codestr += feelist.length > 0 ? ('<tr style="height:36px;font-size:12px;"><td>' + feelist[0].feeNo + '</td><td>' + feelist[0].feeAmount + '</td>' + (feelist.length > 1 ? ('<td>' + feelist[1].feeNo + '</td><td>' + feelist[1].feeAmount + '</td>') : '<td></td><td></td>') + '</tr>') : ''
      // codestr += feelist.length > 2 ? ('<tr style="height:36px;font-size:12px;"><td>' + feelist[2].feeNo + '</td><td>' + feelist[2].feeAmount + '</td>' + (feelist.length > 3 ? ('<td>' + feelist[3].feeNo + '</td><td>' + feelist[3].feeAmount + '</td>') : '<td></td><td></td>') + '</tr>') : ''
      // codestr += feelist.length > 4 ? ('<tr style="height:36px;font-size:12px;"><td>' + feelist[4].feeNo + '</td><td>' + feelist[4].feeAmount + '</td>' + (feelist.length > 5 ? ('<td>' + feelist[5].feeNo + '</td><td>' + feelist[5].feeAmount + '</td>') : '<td></td><td></td>') + '</tr>') : ''
      // codestr += feelist.length > 6 ? ('<tr style="height:36px;font-size:12px;"><td>' + feelist[6].feeNo + '</td><td>' + feelist[6].feeAmount + '</td>' + (feelist.length > 7 ? ('<td>' + feelist[7].feeNo + '</td><td>' + feelist[7].feeAmount + '</td>') : '<td></td><td></td>') + '</tr>') : ''

      if (feeReducelist.length > 0) {
        codestr += '<tr style="height:36px;font-size:12px;"><td>' + feeReducelist[0].feeNo + '</td><td>' + feeReducelist[0].feeAmount + '</td>';
        if (feeReducelist.length > 1) {
          codestr += '<td>' + feeReducelist[1].feeNo + '</td><td>' + feeReducelist[1].feeAmount + '</td></tr>';
        } else {
          codestr += '<td></td><td></td></tr>';
        }
      }
      if (feeReducelist.length > 2) {
        codestr += '<tr style="height:36px;font-size:12px;"><td>' + feeReducelist[2].feeNo + '</td><td>' + feeReducelist[2].feeAmount + '</td>';
        if (feeReducelist.length > 3) {
          codestr += '<td>' + feeReducelist[3].feeNo + '</td><td>' + feeReducelist[3].feeAmount + '</td></tr>';
        } else {
          codestr += '<td></td><td></td></tr>';
        }
      }

      // 新生明細
      codestr += '</table></div>' + '<table style="width: 85%; margin: 0 auto;color: rgb(9, 9, 9);text-align: center;border-collapse:collapse;font-size:12px;margin-top:20px;" border="1">' + '<tr><td style="width: 20%;height: 80px;padding:6px;">01</td><td style="width:40%;padding:6px;">公寓中心<br/>(分配宿舍)</td><td style="text-align:left;padding:6px;">公寓楼：' + this.dormRow.flatsName + '<br/>房间号：' + this.dormRow.roomNo + '<br/>床位号：' + this.dormRow.bedNo + '</td></tr>' + '<tr><td style="width: 20%;height: 160px;padding:6px;">02</td><td style="width:40%;padding:6px;">公寓用品<br/>(领取公寓用品)</td><td style="text-align:left;padding:6px;">' + this.dormConfig + '</td></tr>' + '<tr><td style="width: 20%;height: 80px;padding:6px;">03</td><td style="width:40%;padding:6px;">军训服装<br/>(领取军服用品)</td><td style="text-align:left;padding:6px;">' + this.miliTrainConfig + '</td></tr>' + '<tr><td style="width: 20%;height: 80px;padding:6px;">04</td><td style="width:40%;padding:6px;">其他<br/>(到辅导员处报到)</td><td></td></tr></table>';

      this.$confirm('确定要打印学号为' + this.curStudent.studentNo + '，姓名为' + this.curStudent.studentName + '的报到单吗?(请使用谷歌浏览器打印)', '提示', {
        confirmButtonText: '确定（请打印两份）',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var newWindow = window.open('_blank'); // 打开新窗口
        newWindow.document.write(codestr); // 向文档写入HTML表达式或者JavaScript代码
        newWindow.document.close(); // 关闭document的输出流, 显示选定的数据
        newWindow.print(); // 打印当前窗口
        setTimeout(newWindow.close(), 0);
        _this2.termMsg = '打印完成！';
        return true;
      }).catch(function (error) {
        console.log(error);
      });
    },
    setVisible: function setVisible(showType) {
      if (showType === '01') {
        // 登录显示
        this.queryFormVisible = true;
        this.feeListVisible = false;
        this.infoVisible = false;
        this.payTypeVisible = false;
        this.feeListHistoryVisible = false;
        this.chooseDormVisible = false;
        this.chooseOtherVisible = false;
        this.chooseDormConfigVisible = false;
      }
      if (showType === '02') {
        // 费用信息
        this.queryFormVisible = false;
        this.feeListVisible = true;
        this.infoVisible = false;
        this.payTypeVisible = false;
        this.feeListHistoryVisible = false;
        this.chooseDormVisible = false;
        this.chooseOtherVisible = false;
        this.chooseDormConfigVisible = false;
        this.payVisible = false;
      }
      if (showType === '03') {
        // 支付按钮
        this.queryFormVisible = false;
        this.feeListVisible = false;
        this.infoVisible = false;
        this.payTypeVisible = true;
        this.feeListHistoryVisible = false;
        this.chooseDormVisible = false;
        this.chooseOtherVisible = false;
        this.chooseDormConfigVisible = false;
      }
      if (showType === '04') {
        // 缴费历史
        this.queryFormVisible = false;
        this.feeListVisible = false;
        this.infoVisible = false;
        this.payTypeVisible = false;
        this.feeListHistoryVisible = true;
        this.chooseDormVisible = false;
        this.chooseOtherVisible = false;
        this.chooseDormConfigVisible = false;
      }
      if (showType === '06') {
        // 提示信息
        this.queryFormVisible = false;
        this.feeListVisible = false;
        this.infoVisible = true;
        this.payTypeVisible = false;
        this.feeListHistoryVisible = false;
        this.chooseDormVisible = false;
        this.chooseOtherVisible = false;
        this.chooseDormConfigVisible = false;
      }
      if (showType === '07') {
        // 选宿舍
        this.queryFormVisible = false;
        this.feeListVisible = false;
        this.infoVisible = false;
        this.payTypeVisible = false;
        this.feeListHistoryVisible = false;
        this.chooseDormVisible = true;
        this.chooseOtherVisible = false;
        this.chooseDormConfigVisible = false;
      }
      if (showType === '08') {
        // 选服装
        this.queryFormVisible = false;
        this.feeListVisible = false;
        this.infoVisible = false;
        this.payTypeVisible = false;
        this.feeListHistoryVisible = false;
        this.chooseDormVisible = false;
        this.chooseOtherVisible = true;
        this.chooseDormConfigVisible = false;
      }
      if (showType === '09') {
        // 选宿舍用品
        this.queryFormVisible = false;
        this.feeListVisible = false;
        this.infoVisible = false;
        this.payTypeVisible = false;
        this.feeListHistoryVisible = false;
        this.chooseDormVisible = false;
        this.chooseOtherVisible = false;
        this.chooseDormConfigVisible = true;
      }
      if (showType === '10') {
        // 支付页面
        this.queryFormVisible = false;
        this.feeListVisible = false;
        this.infoVisible = false;
        this.payTypeVisible = false;
        this.feeListHistoryVisible = false;
        this.chooseDormVisible = false;
        this.chooseOtherVisible = false;
        this.chooseDormConfigVisible = false;
        this.payVisible = true;
        this.scanVisible = false;
      }
      if (showType === '11') {
        // 支付页面
        this.payVisible = false;
        this.scanVisible = true;
      }
    },
    // 初始化数据字典
    getMode: function getMode() {
      var self = this;
      self.modeSelectList = self.global.modeList;
      var packItem = self.modeSelectList.filter(function (item) {
        return item.typeId === 'A套餐';
      });
      self.miliTrainItem = packItem.filter(function (item) {
        return item.field2 === '01';
      });
      self.miliTrainConfig = packItem.filter(function (item) {
        return item.field2 === '01';
      }).map(function (item) {
        return item.modeId + item.modeValue;
      }).join('、');
    },
    // 加载界面配置
    getUISet: function getUISet() {
      if (true) {
        var self = this;
        self.uiSetItemList = self.global.uiSetItemList;
        self.uiSetList = self.global.uiSetList;
      } else {
        this.uiSetList = [{ uiSetId: 'vi_House_PayFeeOif', uiSetName: '范例', uiSetType: '01', uiSetTypeDesc: '管理', colWidthOpt: '125', exportTextSet: '', crossItemNo: 'feeNo', crossItemName: 'feeName', mergeCell: '', sortSet: 'building,01', remark: '', itemList: null }];
        this.uiSetItemList = [{ uiSetId: 'vi_House_PayFeeOif', columnName: 'Dept_ID', columnDesc: '机构ID', columnProp: 'deptId', isVisible: '0', sortNo: '01', queryCondition: '0', sortNoQuery: '01', controlType: '02', controlTypeDesc: null, typeId: 'Dept', defaultValue: '', required: '0', isUnique: '1', dataType: '01', dataTypeDesc: null, matchType: '01', matchTypeDesc: null, newDisabled: '0', editDisabled: '0', queryVisible: '0', sortNoResult: '01', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '1', colWidth: '120', isCross: '0', isGroupStart: '1', defaultValueCond: '', exportSql: '1', placeHolder: '', setIdList: null }, { uiSetId: 'vi_House_PayFeeOif', columnName: 'Dept_NO', columnDesc: '机构号', columnProp: 'deptNo', isVisible: '0', sortNo: '01|01', queryCondition: '0', sortNoQuery: '01', controlType: '02', controlTypeDesc: null, typeId: 'Dept', defaultValue: '', required: '0', isUnique: '1', dataType: '01', dataTypeDesc: null, matchType: '01', matchTypeDesc: null, newDisabled: '0', editDisabled: '0', queryVisible: '0', sortNoResult: '01|01', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '1', colWidth: '120', isCross: '0', isGroupStart: '1', defaultValueCond: '', exportSql: '1', placeHolder: '', setIdList: null }, { uiSetId: 'vi_House_PayFeeOif', columnName: 'Dept_Name', columnDesc: '机构', columnProp: 'deptName', isVisible: '0', sortNo: '01|02', queryCondition: '0', sortNoQuery: '01', controlType: '02', controlTypeDesc: null, typeId: 'Dept', defaultValue: '', required: '0', isUnique: '1', dataType: '01', dataTypeDesc: null, matchType: '01', matchTypeDesc: null, newDisabled: '0', editDisabled: '0', queryVisible: '1', sortNoResult: '01|02', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '1', colWidth: '120', isCross: '0', isGroupStart: '1', defaultValueCond: '', exportSql: '1', placeHolder: '', setIdList: null }, { uiSetId: 'vi_House_PayFeeOif', columnName: 'Room_Type', columnDesc: '公寓等级', columnProp: 'dormSet', isVisible: '1', sortNo: '02', queryCondition: '0', sortNoQuery: '02', controlType: '02', controlTypeDesc: null, typeId: 'House_Info', defaultValue: '', required: '0', isUnique: '1', dataType: '01', dataTypeDesc: null, matchType: '01', matchTypeDesc: null, newDisabled: '0', editDisabled: '0', queryVisible: '1', sortNoResult: '02', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '1', colWidth: '120', isCross: '0', isGroupStart: '1', defaultValueCond: '', exportSql: '1', placeHolder: '', setIdList: null }, { uiSetId: 'vi_House_PayFeeOif', columnName: 'Building', columnDesc: '公寓楼', columnProp: 'building', isVisible: '1', sortNo: '03', queryCondition: '0', sortNoQuery: '02', controlType: '02', controlTypeDesc: null, typeId: 'House_Info', defaultValue: '', required: '0', isUnique: '1', dataType: '01', dataTypeDesc: null, matchType: '01', matchTypeDesc: null, newDisabled: '0', editDisabled: '0', queryVisible: '1', sortNoResult: '03', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '1', colWidth: '120', isCross: '0', isGroupStart: '1', defaultValueCond: '', exportSql: '1', placeHolder: '', setIdList: null }, { uiSetId: 'vi_House_PayFeeOif', columnName: 'Room', columnDesc: '宿舍号', columnProp: 'room', isVisible: '1', sortNo: '04', queryCondition: '0', sortNoQuery: '02', controlType: '02', controlTypeDesc: null, typeId: 'House_Info', defaultValue: '', required: '0', isUnique: '1', dataType: '01', dataTypeDesc: null, matchType: '01', matchTypeDesc: null, newDisabled: '0', editDisabled: '1', queryVisible: '1', sortNoResult: '04', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '1', colWidth: '120', isCross: '0', isGroupStart: '1', defaultValueCond: '', exportSql: '1', placeHolder: '', setIdList: null }, { uiSetId: 'vi_House_PayFeeOif', columnName: 'Beds', columnDesc: '床位号', columnProp: 'beds', isVisible: '1', sortNo: '05', queryCondition: '0', sortNoQuery: '02', controlType: '02', controlTypeDesc: null, typeId: 'House_Info', defaultValue: '', required: '0', isUnique: '1', dataType: '01', dataTypeDesc: null, matchType: '01', matchTypeDesc: null, newDisabled: '0', editDisabled: '0', queryVisible: '1', sortNoResult: '05', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '1', colWidth: '120', isCross: '0', isGroupStart: '1', defaultValueCond: '', exportSql: '1', placeHolder: '', setIdList: null }, { uiSetId: 'vi_Clothing_PayFeeOif', columnName: 'Clothes', columnDesc: '迷彩服号', columnProp: 'clothes', isVisible: '1', sortNo: '01', queryCondition: '0', sortNoQuery: '02', controlType: '02', controlTypeDesc: null, typeId: 'Clothes_Size', defaultValue: '', required: '0', isUnique: '1', dataType: '01', dataTypeDesc: null, matchType: '01', matchTypeDesc: null, newDisabled: '0', editDisabled: '0', queryVisible: '1', sortNoResult: '05', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '1', colWidth: '120', isCross: '0', isGroupStart: '1', defaultValueCond: '', exportSql: '1', placeHolder: '', setIdList: null }, { uiSetId: 'vi_Clothing_PayFeeOif', columnName: 'Dress', columnDesc: '迷彩衫号', columnProp: 'dress', isVisible: '1', sortNo: '02', queryCondition: '0', sortNoQuery: '02', controlType: '02', controlTypeDesc: null, typeId: 'Dress_Size', defaultValue: '', required: '0', isUnique: '1', dataType: '01', dataTypeDesc: null, matchType: '01', matchTypeDesc: null, newDisabled: '0', editDisabled: '0', queryVisible: '1', sortNoResult: '05', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '1', colWidth: '120', isCross: '0', isGroupStart: '1', defaultValueCond: '', exportSql: '1', placeHolder: '', setIdList: null }, { uiSetId: 'vi_Clothing_PayFeeOif', columnName: 'Shoes', columnDesc: '鞋子尺码', columnProp: 'shoes', isVisible: '1', sortNo: '05', queryCondition: '0', sortNoQuery: '02', controlType: '02', controlTypeDesc: null, typeId: 'Shoes_Size', defaultValue: '', required: '0', isUnique: '1', dataType: '01', dataTypeDesc: null, matchType: '01', matchTypeDesc: null, newDisabled: '0', editDisabled: '0', queryVisible: '1', sortNoResult: '05', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '1', colWidth: '120', isCross: '0', isGroupStart: '1', defaultValueCond: '', exportSql: '1', placeHolder: '', setIdList: null }];
      }
    },
    // 加载所有可选宿舍，并进行数据字典化（宿舍类型Type_ID:Dorm_Set;公寓Type_ID:Flats;房间Type_ID:Room;床位Type_ID:Bed;）
    getDorm: function getDorm() {
      var self = this;
      return self.axios.post('/college/getViXFDormForChoose', {
        enrollmentYear: this.curStudent.enrollmentYear,
        majorName: this.curStudent.majorName,
        trainingLevel: this.curStudent.trainingLevel,
        sex: this.curStudent.sex,
        keyInfo: this.curStudent.uid
      });
    },
    // 校验该学生是否缴过费
    validOrderInfo: function validOrderInfo() {
      var self = this;
      if (true) {
        this.axios.post('/college/getXFOrderInfoForCheck', {
          field1: this.curStudent.studentName,
          keyInfo: this.curStudent.uid,
          field12: '04',
          statusCode: '00'
        }).then(function (response) {
          if (response.data.result.success === true) {
            if (response.data.orderInfoList.length > 0) {
              // 有缴费记录
              self.termMsg = '已缴费！';
              self.setVisible('06'); // 提示信息
            } else {
              // 进入贷款页面
              self.toLoan();
            }
          } else {
            self.$alert('系统错误！');
          }
        }, function (response) {}).catch(function (error) {
          console.log(error);
        });
      } else {
        this.toLoan();
      }
    },
    toLoan: function toLoan() {
      // 登录页面
      this.$router.push('/LoanXiFanNew');
      this.route = [{ path: '/LoanXiFanNew', component: __webpack_require__(278), meta: { title: '生源地贷款' } }];
      this.$router.addRoutes(this.route);
    },
    // 加载缴费基础信息
    initThis: function initThis() {
      if (true) {
        var self = this;
        self.getDormConfig();
        self.axios.post('/college/getViXFDormBedCountForNew', {
          schoolYear: self.curStudent.enrollmentYear,
          majorName: self.curStudent.majorName,
          trainingLevel: self.curStudent.trainingLevel,
          sex: self.curStudent.sex
        }).then(function (response) {
          console.log(response);
          if (response.data.result.success === true) {
            self.fourBedSum = response.data.viXFDormList[0].fourBedSum;
            self.fourBedRmi = response.data.viXFDormList[0].fourBedRmi;
            self.sixBedSum = response.data.viXFDormList[0].sixBedSum;
            self.sixBedRmi = response.data.viXFDormList[0].sixBedRmi;
          }
        });
        self.axios.all([self.getDorm()]).then(this.axios.spread(function (dorm) {
          if (dorm.data.result.success === true) {
            self.dormList = dorm.data.viXFDormList;
            self.modeSelectList = self.modeSelectList.concat(dorm.data.modeList);
            self.dormSetList = dorm.data.viXFDormSetList;
            // 初始化宿舍选择
            if (self.modeSelector('Flats').length > 0) {
              // 公寓选择初始化成第一个公寓
              self.dormChooseForm.flatsName = self.modeSelector('Flats')[0].modeId;
              // 宿舍配置初始化成该公寓的首个类型
              if (self.modeSelector('Dorm_Set').length > 0) {
                // 初始化宿舍配置为首个公寓首个宿舍类型的信息
                self.dormChooseForm.dormSet = self.modeSelector('Dorm_Set')[0].modeId;
                // 根据所选宿舍类型加载宿舍类型信息
                self.setDormSet(self.dormChooseForm.dormSet);
              }
            }
          }
          if (self.dormList.length > 0) {
            self.setVisible('07'); // 选宿舍
          } else {
            self.termMsg = '无可选宿舍床位！';
            self.setVisible('06'); // 提示信息
          }
        }));
      } else {
        this.dormSetForm = {
          dormSet: '',
          price: '1000',
          dormStandard: '',
          roomSet: '',
          pubAreaSet: '',
          region: '',
          remark: ''
        };
        this.fourBedSum = '0';
        this.fourBedRmi = '0';
        this.sixBedSum = '0';
        this.sixBedRmi = '0';
      }
    },
    getDormValue: function getDormValue(option) {
      var dormConfigList = this.dormConfigList.filter(function (item) {
        return item.modeId === option;
      });
      if (dormConfigList.length > 0) {
        return dormConfigList[0].modeValue;
      }
      return '';
    },
    getDormLabel: function getDormLabel(option) {
      var dormConfigList = this.dormConfigList.filter(function (item) {
        return item.modeId === option;
      });
      if (dormConfigList.length > 0) {
        return dormConfigList[0].modeId + '：(' + dormConfigList[0].modeName + ')';
      }
      return '';
    },
    getDormConfig: function getDormConfig() {
      var self = this;
      self.dormConfigList = self.modeSelectList.filter(function (item) {
        return item.typeId === 'Dorm_Supply_Config';
      });
      self.dormConfigList.filter(function (item) {
        if (item.field1 === '01') {
          self.dormConfigCheckList.push(item.value);
        }
      });
    },
    handleDormConfigChange: function handleDormConfigChange() {
      var mustSelectList = this.dormConfigList.filter(function (item) {
        return item.field1 === '01';
      });
      var selectedList = this.dormConfigCheckList.filter(function (item) {
        return mustSelectList.filter(function (item1) {
          return item1.modeId === item;
        }).length;
      });
      if (selectedList.length < mustSelectList.length) {
        var dormConfigCheckList = [];
        mustSelectList.forEach(function (item) {
          dormConfigCheckList.push(item.modeId);
        });
        this.dormConfigCheckList.forEach(function (item) {
          var tmpList = mustSelectList.filter(function (item1) {
            return item === item1.modeId;
          });
          if (tmpList.length > 0) {
            if (tmpList[0].field1 === '00') {
              dormConfigCheckList.push(item);
            }
          } else {
            dormConfigCheckList.push(item);
          }
        });
        this.dormConfigCheckList = dormConfigCheckList;
        var str = '';
        mustSelectList.filter(function (item) {
          str = str + item.modeId + '、';
        });
        if (str.length > 0) {
          str = str.substr(0, str.length - 1);
        }
        this.$alert(str + '选项为必选选项');
      }
    },
    // 重置编辑窗体
    resetForm: function resetForm() {
      this.setVisible('01');
    },
    // 获取学生历史缴费信息
    getHistory: function getHistory() {
      if (true) {
        var self = this;
        var request = {};
        request.deptId = self.global.deptId;
        request.keyInfo = self.global.curStudent.uid;
        var str = (0, _stringify2.default)(request);
        self.axios.post('/iif/getOrderInfoForHistoryByEncrypt', this.Ginkgo.encrypt(str)).then(function (response) {
          var backJson = JSON.parse(self.Ginkgo.rsaDecrypt(response.data));
          if (backJson.result.success === true) {
            var curYear = self.Ginkgo.getTimeStamp(new Date()).substr(0, 4);
            self.orderInfoList = backJson.orderInfoList.filter(function (item) {
              return item.field4 === curYear;
            });
            self.getHistoryByType('04');
            self.setVisible('04');
          }
        }, function (response) {}).catch(function (error) {
          console.log(error);
        });
      } else {
        this.uiSetItemList = [{ uiSetId: 'tbIf_Order_Info_XiFan_New', columnName: 'transDt', columnDesc: '日期', columnProp: 'transDt', isVisible: '1', isVisibleDesc: '', sortNo: '99', queryCondition: '0', queryConditionDesc: '', sortNoQuery: '99', controlType: '02', controlTypeDesc: '', typeId: 'Dept_Type_KD', defaultValue: '01', required: '0', requiredDesc: '', isUnique: '0', isUniqueDesc: '', dataType: '01', dataTypeDesc: '', newDisabled: '0', editDisabled: '0', editDisabledDesc: '', queryVisible: '1', queryVisibleDesc: '', sortNoResult: '11', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '0', isFixColDesc: '', colWidth: '120', isCross: '0', isCrossDesc: '', isGroupStart: '1', isGroupStartDesc: '' }, { uiSetId: 'tbIf_Order_Info_XiFan_New', columnName: 'feeAmount', columnDesc: '费用', columnProp: 'feeAmount', isVisible: '1', isVisibleDesc: '', sortNo: '99', queryCondition: '0', queryConditionDesc: '', sortNoQuery: '99', controlType: '02', controlTypeDesc: '', typeId: 'Dept_Type_KD', defaultValue: '01', required: '0', requiredDesc: '', isUnique: '0', isUniqueDesc: '', dataType: '01', dataTypeDesc: '', newDisabled: '0', editDisabled: '0', editDisabledDesc: '', queryVisible: '1', queryVisibleDesc: '', sortNoResult: '11', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '0', isFixColDesc: '', colWidth: '120', isCross: '0', isCrossDesc: '', isGroupStart: '1', isGroupStartDesc: '' }, { uiSetId: 'tbIf_Order_Info_XiFan_New', columnName: 'orderNo', columnDesc: '订单号', columnProp: 'orderNo', isVisible: '1', isVisibleDesc: '', sortNo: '99', queryCondition: '0', queryConditionDesc: '', sortNoQuery: '99', controlType: '02', controlTypeDesc: '', typeId: 'Dept_Type_KD', defaultValue: '01', required: '0', requiredDesc: '', isUnique: '0', isUniqueDesc: '', dataType: '01', dataTypeDesc: '', newDisabled: '0', editDisabled: '0', editDisabledDesc: '', queryVisible: '1', queryVisibleDesc: '', sortNoResult: '11', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '0', isFixColDesc: '', colWidth: '120', isCross: '0', isCrossDesc: '', isGroupStart: '1', isGroupStartDesc: '' }];
        this.orderInfoList = [{ transDt: '20180730', feeAmount: 100, orderNo: 'xxxxxxxxxxxxxxxx' }];
        this.page.totalElements = this.orderInfoList.length;
        this.loadCurrentPageHistory();
        this.setVisible('04');
      }
    },
    // 点击去支付按钮
    toPay: function toPay() {
      if (true) {
        this.checkPayTime();
      } else {
        this.setVisible('03');
      }
    },
    // 校验商户缴费期
    checkPayTime: function checkPayTime() {
      var self = this;
      self.axios.get('/pay/checkToPay', { params: {
          deptId: self.global.deptId // 1000003
        } }).then(function (response) {
        if (response.data.return_msg === 'SUCCESS') {
          // 设置账期列表
          if (self.feeList.length > 0) {
            self.termList = [];
            self.feeList.forEach(function (item) {
              self.termList.push(item.term);
            });
            self.getDeptSet();
          } else {
            self.$alert('无待缴账单！');
          }
        } else {
          self.$alert(response.data.prop);
        }
      }, function (response) {}).catch(function (error) {
        console.log(error);
      });
    },
    // 获取机构支付配置
    getDeptSet: function getDeptSet() {
      var self = this;
      self.axios.get('/college/getBaseDeptSetByDeptID', { params: {
          deptId: self.global.deptId
        } }).then(function (response) {
        // 机构配置信息
        if (response.data.result.success === true) {
          self.viDeptSetList = response.data.viDeptSetList;
          if (self.viDeptSetList.length > 0) {
            self.setVisiblePayButton(self.viDeptSetList);
          }
          // 设置全局支付商户参数
          // self.global.merchantListForPay = response.data.viDeptSetList
          // 跳转到支付方式选择页面
          // self.toPayType()
        }
        self.buttonLoad = false;
      }, function (response) {}).catch(function (error) {
        console.log(error);
      });
    },
    // 跳转到支付方式选择页面
    // toPayType: function () {
    //   // 设置支付参数对象
    //   this.global.toPayObj = {
    //     deptId: this.global.deptId,
    //     keyInfo: this.global.curStudent.uid,
    //     termList: this.termList,
    //     totalFeeAmount: this.totalFeeAmount,
    //     sourcePage: 'myBillXiFanNew'
    //   }
    //   this.$router.push('/payType')
    //   this.route = [{ path: '/payType', component: () => import('@/components/XiFan/PayType.vue'), meta: { title: '支付页面' } }]
    //   this.$router.addRoutes(this.route)
    // },
    setVisiblePayButton: function setVisiblePayButton(merchantList) {
      var self = this;
      // 设置支付方式的显示隐藏
      self.buttonVisibleUnion = false;
      self.buttonVisibleWX = false;
      self.buttonVisibleZFB = false;
      // 商户配置信息
      if (merchantList.length > 0) {
        merchantList.forEach(function (e) {
          if (e.payKind === '01') {
            // 银联
            self.payTypeUnion = e.payType;
            self.buttonVisibleUnion = true;
          }
          if (e.payKind === '02') {
            // 微信
            self.payType = e.payType;
            self.buttonVisibleWX = true;
          }
          if (e.payKind === '03') {
            // 支付宝
            self.payTypeZFB = e.payType;
            self.buttonVisibleZFB = true;
          }
          if (e.payKind === '07') {
            // 浦发新微信
            self.payTypePFWX = e.payType;
            self.buttonVisiblePFWX = true;
          }
          if (e.payKind === '08') {
            // 浦发新支付宝
            self.payTypePFZFB = e.payType;
            self.buttonVisiblePFZFB = true;
          }
          if (e.payType === '98') {
            // 暂无用
            self.payTypeHTT = e.payType;
            self.buttonVisibleHTT = true;
          }
          if (e.payKind === '04') {
            // 代扣
            self.payTypeZJ = e.payType;
            self.buttonVisibleZJ = true;
          }
        });
      }
      self.setVisible('10');
    },
    doPay: function doPay(payType) {
      if (true) {
        var self = this;
        var payUrl = '';
        var validType = '02';
        self.axios.post('/college/getOrderInfoIsExpired', {
          keyInfo: self.curStudent.uid,
          deptId: self.global.deptId,
          term: self.termList[0]
        }).then(function (response) {
          if (response.data.result.success) {
            // 根据不同支付方式访问不同的发起交易服务
            self.axios.post('/pay/toPay', {
              keyInfo: self.curStudent.uid,
              deptId: self.global.deptId,
              payType: payType,
              feeTermList: self.termList,
              validType: validType,
              userName: self.global.curStudent.studentName
            }).then(function (response) {
              if (response.data.result.success) {
                if (payType === '09') {
                  self.$alert('申请提交成功！');
                  self.route = [{ path: '/offlinePay', component: function component() {
                      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 122));
                    }, meta: { title: '线下缴费' } }];
                  self.$router.addRoutes(self.route);
                  self.$router.push('/offlinePay');
                  return;
                }
                console.log('self.feeSum', self.feeSum);
                if (self.feeSum.feeAmount < 0) {
                  self.$alert('实缴金额为负值，' + self.feeSum.feeAmount + ' 元，不允许支付！');
                  return;
                }
                if (self.feeSum.feeAmount === 0) {
                  self.$alert('实缴金额为 ' + self.feeSum.feeAmount + ' 元，不允许支付！');
                  return;
                }
                var payKind = self.viDeptSetList.filter(function (item) {
                  return item.payType === payType;
                })[0].payKind;
                if (payKind === '02') {
                  // 微信支付
                  payUrl += self.global.payUrl + 'pay/doPayForUrl?';
                  payUrl += 'payType=' + payType;
                  payUrl += '&orderNo=' + response.data.orderNo;
                  payUrl += '&deptId=' + response.data.deptId;
                  payUrl += '&openId=' + self.global.curUser.openId;
                  payUrl += '&qrCodeType=' + 'WXPAY';
                  payUrl += '&payChannel=01';
                  // 二维码
                  console.log('===wx支付地址===', payUrl);
                  self.qrContent = payUrl;
                  self.setVisible('11');
                } else if (payKind === '03') {
                  payUrl += self.global.payUrl + 'pay/doPayForUrl?';
                  payUrl += 'payType=' + payType;
                  payUrl += '&orderNo=' + response.data.orderNo;
                  payUrl += '&deptId=' + response.data.deptId;
                  payUrl += '&openId=' + self.global.curUser.openId;
                  payUrl += '&qrCodeType=' + 'ALIPAY';
                  payUrl += '&payChannel=01';
                  // 二维码
                  console.log('===支付宝支付地址===', payUrl);
                  self.qrContent = payUrl;
                  self.setVisible('11');
                } else if (payKind === '07') {
                  // 浦发微信支付 新版 opNJK1tn-GZEhIudaMdrRmr4wYs0
                  payUrl += self.global.payUrl + 'pay/doPayForUrl?';
                  payUrl += 'payType=' + payType;
                  payUrl += '&orderNo=' + response.data.orderNo;
                  payUrl += '&deptId=' + response.data.deptId;
                  payUrl += '&openId=' + self.global.curUser.openId;
                  payUrl += '&qrCodeType=' + 'WXPAY';
                  payUrl += '&payChannel=01';
                  console.log('===pfwx支付地址===', payUrl);
                  self.qrContent = payUrl;
                  self.setVisible('11');
                } else if (payKind === '08') {
                  // 浦发支付宝支付 新版 opNJK1tn-GZEhIudaMdrRmr4wYs0
                  payUrl += self.global.payUrl + 'pay/doPayForUrl?';
                  payUrl += 'payType=' + payType;
                  payUrl += '&orderNo=' + response.data.orderNo;
                  payUrl += '&deptId=' + response.data.deptId;
                  payUrl += '&openId=' + self.global.curUser.openId;
                  payUrl += '&qrCodeType=' + 'ALIPAY';
                  payUrl += '&payChannel=01';
                  console.log('===pfzfb支付地址===', payUrl);
                  self.qrContent = payUrl;
                  self.setVisible('11');
                } else {
                  payUrl = self.global.payUrl + 'pay/doPay?' + 'payType=' + self.payTypeUnion + '&orderNo=' + response.data.orderNo + '&deptId=' + response.data.deptId + '&openId=&payChannel=02';
                  window.location.href = payUrl;
                }
              } else {
                self.$alert(response.data.result.msg);
              }
            }).catch(function (error) {
              console.log(error);
            });
          } else {
            self.$alert(response.data.result.msg);
            // 超时，重新加载选宿舍基础信息，进入选宿舍界面
            self.initThis();
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        this.setVisible('01');
      }
    },
    back: function back(type) {
      if (this.global.dormConfigSet !== 1) {
        if (type === '09') {
          this.setVisible('07');
        } else {
          this.setVisible(type);
        }
      } else {
        this.setVisible(type);
      }
    },
    // 数据字典筛选器
    modeSelector: function modeSelector(typeId) {
      var _this3 = this;

      var list = [];
      switch (typeId) {
        case 'Dorm_Set':
          list = this.modeSelectList.filter(function (item) {
            return item.typeId === typeId && item.parentModeId === _this3.dormChooseForm.flatsName;
          });
          break;
        case 'Room':
          list = this.modeSelectList.filter(function (item) {
            return item.typeId === typeId && item.parentModeId === _this3.dormChooseForm.dormSet;
          });
          break;
        case 'Bed':
          list = this.modeSelectList.filter(function (item) {
            return item.typeId === typeId && item.parentModeId === _this3.dormChooseForm.roomNo && item.modeValue === _this3.dormChooseForm.flatsName;
          });
          break;
        default:
          list = this.modeSelectList.filter(function (element) {
            return element.typeId === typeId;
          });
          break;
      }
      return list;
    },
    // 编辑窗体禁用 01 新增 02 修改
    getDisableEdit: function getDisableEdit(propName, formName) {
      var disabled = false;
      // 宿舍类型
      if (this.dormChooseForm.flatsName === '') {
        if (propName === 'dormSet' || propName === 'roomNo' || propName === 'bedNo') {
          disabled = true;
        }
      } else {
        if (propName === 'dormSet') {
          disabled = false;
        }
      }
      // 宿舍
      if (this.dormChooseForm.dormSet === '') {
        if (propName === 'roomNo' || propName === 'bedNo') {
          disabled = true;
        }
      } else {
        if (propName === 'roomNo') {
          disabled = false;
        }
      }

      // 床位
      if (this.dormChooseForm.roomNo === '') {
        if (propName === 'bedNo') {
          disabled = true;
        }
      } else {
        disabled = false;
      }
      return disabled;
    },
    // 校验选择宿舍窗体
    validForm: function validForm() {
      var valid = true;
      if (this.dormChooseForm.dormSet === '') {
        this.$alert('请选择公寓等级！');
        return false;
      }
      if (this.dormChooseForm.flasName === '') {
        this.$alert('请选择公寓楼！');
        return false;
      }
      if (this.dormChooseForm.roomNo === '') {
        this.$alert('请选择宿舍！');
        return false;
      }
      if (this.dormChooseForm.bedNo === '') {
        this.$alert('请选择床位！');
        return false;
      }
      if (this.bedDiagram === '') {
        this.$alert('选择的床位出现异常！');
        return false;
      }
      return valid;
    },
    // 校验选择军训服窗体
    validClothForm: function validClothForm() {
      var valid = true;
      // if (this.clothChooseForm.coatSize === '') {
      //   this.$alert('请选择迷彩服尺码！')
      //   return false
      // }
      // if (this.clothChooseForm.shirtSize === '') {
      //   this.$alert('请选择迷彩衫尺码！')
      //   return false
      // }
      // if (this.clothChooseForm.shoesSize === '') {
      //   this.$alert('请选择鞋子尺码！')
      //   return false
      // }
      return valid;
    },
    // 选择宿舍
    chooseDorm: function chooseDorm() {
      var _this4 = this;

      if (true) {
        if (this.validForm()) {
          var self = this;
          // 根据选择的床位筛选当前的宿舍床位对象（为了取ID）
          this.chosenDorm = this.dormList.filter(function (item) {
            return item.flatsName === _this4.dormChooseForm.flatsName && item.roomNo === _this4.dormChooseForm.roomNo && item.bedNo === _this4.dormChooseForm.bedNo;
          })[0];
          // 校验所选宿舍是否已经被其他人所选
          self.axios.post('/college/lockDormBed', {
            bedId: self.chosenDorm.id,
            keyInfo: self.curStudent.uid
          }).then(function (response) {
            if (response.data.result.success === true) {
              if (self.global.dormConfigSet === 1) {
                self.setVisible('09');
              } else {
                // 选择衣服
                // self.setVisible('08')
                self.chooseOther();
              }
            } else {
              self.$alert(response.data.result.msg);
            }
          }, function (response) {}).catch(function (error) {
            console.log(error);
          });
        }
      } else {
        this.setVisible('09');
      }
    },
    // 选择军训服装
    chooseOther: function chooseOther() {
      if (true) {
        if (this.validClothForm()) {
          // 校验选择服装
          // 创建订单
          this.createOrderInfo();
        }
      } else {
        this.setVisible('02');
      }
    },
    // 选择公寓用品
    chooseDormConfig: function chooseDormConfig() {
      var self = this;
      if (true) {
        if (this.validDormConfigForm()) {
          // 计算宿舍用品配置费用
          var totalAmt = 0;
          self.feeList = self.feeList.filter(function (item) {
            return item.feeNo !== '公寓用品费';
          });
          if (self.dormConfigCheckList.length > 0) {
            self.dormConfigCheckList.filter(function (item) {
              var dormConfigList = self.dormConfigList.filter(function (d) {
                return d.modeId === item;
              });
              if (dormConfigList.length > 0) {
                totalAmt = totalAmt + Number(dormConfigList[0].modeValue);
              }
            });
            self.feeList.push({ 'feeNo': '公寓用品费', 'feeAmount': totalAmt });
          }
          this.setVisible('08');
        } else {
          this.setVisible('07');
        }
      } else {
        this.setVisible('08');
      }
    },
    validDormConfigForm: function validDormConfigForm() {
      var mustSelectList = this.dormConfigList.filter(function (item) {
        return item.field1 === '01';
      });
      var str = '';
      mustSelectList.filter(function (item) {
        str = str + item.modeId + '、';
      });
      if (str.length > 0) {
        str = str.substr(0, str.length - 1);
      }
      if (this.dormConfigCheckList.length < mustSelectList.length) {
        this.$alert(str + '选项为必选选项');
        return false;
      } else {
        return true;
      }
    },
    // 创建订单
    createOrderInfo: function createOrderInfo() {
      if (true) {
        var self = this;

        if (self.global.curStudent.trainingLevel === '专升本') {
          self.dormItemVisible = true;
          self.clothItemVisible = false;
        } else {
          self.dormItemVisible = true;
          self.clothItemVisible = true;
        }

        var selectedDormConfigStr = '';
        self.dormConfigCheckList.filter(function (item) {
          selectedDormConfigStr = selectedDormConfigStr + item + ',';
        });

        var order = {};
        order.studentName = this.curStudent.studentName;
        order.uid = this.curStudent.uid;
        order.bedId = this.chosenDorm.id;
        order.coatSize = this.clothChooseForm.coatSize;
        order.shirtSize = this.clothChooseForm.shirtSize;
        order.shoesSize = this.clothChooseForm.shoesSize;

        // 保险开关
        order.insuranceSet = this.global.insuranceSet;
        // 宿舍配置用品开关
        order.dormConfigSet = this.global.dormConfigSet;
        // 宿舍用品已选配置
        order.selectedDormConfigStr = selectedDormConfigStr;

        // order.dormConfigFee = totalAmt
        // order.clothFee = clothAmt
        // 校验所选宿舍是否已经被其他人所选
        self.axios.post('/college/addXFOrderInfo', order).then(function (response) {
          if (response.data.result.success === true) {
            self.feeList = response.data.orderInfoList;
            var sort = {};
            sort.prop = 'field10';
            sort.order = 'ascending';
            self.feeList = self.Ginkgo.sortList(self.feeList, sort);
            if (response.data.orderInfoSumList.length > 0) {
              self.feeSum = response.data.orderInfoSumList[0];
            }
            self.addDormConfigOrderInfo(order.uid, order.studentName);
            self.setVisible('02');
          } else {
            self.$alert(response.data.result.msg);
          }
        }, function (response) {}).catch(function (error) {
          console.log(error);
        });
      }
    },
    addDormConfigOrderInfo: function addDormConfigOrderInfo(uid, studentName) {
      var _this5 = this;

      var self = this;
      var dormConfigOrderInfo = [];
      self.dormConfigCheckList.filter(function (item) {
        self.dormConfigList.filter(function (d) {
          if (item === d.modeId) {
            dormConfigOrderInfo.push({
              uid: uid,
              studentName: studentName,
              goods: d.modeId + d.modeName,
              amt: d.modeValue,
              enrollmentYear: _this5.global.curStudent.enrollmentYear
            });
          }
        });
      });
      self.axios.post('/college/addSelectedDormConfig', dormConfigOrderInfo).then(function (response) {
        if (response.data.result.success === true) {} else {
          self.$alert(response.data.result.msg);
        }
      });
    },
    // 下一步
    nextStep: function nextStep(optName) {
      if (optName === 'Dorm') {
        this.chooseDorm();
        this.initMustSelectedValue();
      } else if (optName === 'DormConfig') {
        this.dormConfigCheckList.sort();
        this.chooseDormConfig();
      } else {
        this.chooseOther();
      }
    },
    // 初始化必选项
    initMustSelectedValue: function initMustSelectedValue() {
      var _this6 = this;

      if (this.global.dormConfigSet === 1) {
        this.dormConfigCheckList = [];
        var mustSelectList = this.dormConfigList.filter(function (item) {
          return item.field1 === '01';
        });
        mustSelectList.filter(function (item) {
          _this6.dormConfigCheckList.push(item.modeId);
        });
      } else {
        this.dormConfigCheckList = this.dormConfigList.map(function (item) {
          return item.modeId;
        });
      }
    },
    clickImg: function clickImg(e) {
      this.showImg = true;
      // 获取当前图片地址
      this.imgSrc = e.currentTarget.src;
    },
    viewImg: function viewImg() {
      this.showImg = false;
    },
    showWechatImg: function showWechatImg() {
      this.dialogFormVisible = true;
    },
    handleSelect: function handleSelect(index, indexPath) {
      if (true) {
        if (index === '/MyBill') {
          this.validOrderInfo();
        }
        if (index === '/MyBillHistory') {
          this.tableData = [];
          this.getHistory();
        }
        if (index === '/Exit') {
          this.$router.push('/LoginXiFan');
          this.route = [{ path: '/LoginXiFan', component: __webpack_require__(69), meta: { title: '缴费登录' } }];
          this.$router.addRoutes(this.route);
        }
        if (index === '/Print') {
          this.termMsg = '待打印！';
          this.setVisible('06');
          this.getOrderInfoList();
        }
        if (index === '/OfflinePay') {
          // 跳转到线下缴费页面
          this.$router.push('/offlinePay');
          this.route = [{ path: '/offlinePay', component: function component() {
              return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 122));
            }, meta: { title: '线下缴费' } }];
          this.$router.addRoutes(this.route);
        }
        if (index === '/Receive') {
          // 跳转到公寓用品领取页面
          this.$router.push('/receive');
          this.route = [{ path: '/receive', component: __webpack_require__(572), meta: { title: '公寓用品领取' } }];
          this.$router.addRoutes(this.route);
        }
        if (index === '/Card') {
          // 跳转到银行卡信息维护页面
          this.$router.push('/card');
          this.route = [{ path: '/card', component: __webpack_require__(151), meta: { title: '银行卡信息维护' } }];
          this.$router.addRoutes(this.route);
        }
      } else {
        if (index === '/MyBill') {
          this.setVisible('02');
        }
        if (index === '/Exit') {
          this.$router.push('/LoginXiFan');
          this.route = [{ path: '/LoginXiFan', component: require('./LoginXiFan.vue'), meta: { title: '缴费登录' } }];
          this.$router.addRoutes(this.route);
        }
        if (index === '/Print') {
          this.toPrint();
        }
        if (index === '/OfflinePay') {
          // 跳转到线下缴费页面
          this.$router.push('/offlinePay');
          this.route = [{ path: '/offlinePay', component: function component() {
              return import('@/components/XiFan/NewStudent/OfflinePay.vue');
            }, meta: { title: '线下缴费' } }];
          this.$router.addRoutes(this.route);
        }
      }
    },
    // 根据费用类型获取对应的缴费历史记录
    getHistoryByType: function getHistoryByType(type) {
      var self = this;
      // this.orderInfoListByType = this.orderInfoList.filter(item => item.field12 === type)
      this.orderInfoListByType = this.orderInfoList;
      // 首次默认排序
      self.handleSortChangeHistory(self.sort);
      // 分页处理
      self.page.totalElements = self.orderInfoListByType.length;
      self.loadCurrentPageHistory();
      // 设置当前选中行
      self.setCurrentRowHistory();
    },
    // 获取查询结果配置
    getUISetQueryResult: function getUISetQueryResult(form) {
      var setId = form === '01' ? 'tbIf_Order_Info_XiFan_New' : 'tbIf_Order_Info_XiFan_Exam';
      var sort = { prop: 'sortNoResult', order: 'ascending' };

      var list = this.uiSetItemList.filter(function (element) {
        return element.uiSetId === setId && element.queryVisible === '1';
      });

      return this.Ginkgo.sortList(list, sort);
    },
    // 列数据格式化
    dataFormatHistory: function dataFormatHistory(row, column, cellValue) {
      var columnProp = column.property;
      // 根据列的property(绑定的字段属性)回查列设置
      var formatString = this.getUISetQueryResult('01').filter(function (element) {
        return element.columnProp === columnProp;
      })[0].formatString;

      return this.Ginkgo.format(cellValue, formatString);
    },
    // 列可见性
    getHeaderVisible: function getHeaderVisible(item, level, fixed) {
      return this.Ginkgo.getHeaderVisible(item, level, fixed);
    },
    // 获取同组记录
    getHeaderGroup: function getHeaderGroup(item, level, form) {
      return this.Ginkgo.getHeaderGroup(item, level, this.getUISetQueryResult(form));
    },
    // 排序(参数var={prop,order}) order: ascending  descending
    handleSortChangeHistory: function handleSortChangeHistory(val) {
      this.sort = val;
      var sorts = this.Ginkgo.cloneObj(this.sortSet);
      sorts.pop(); // 删除最后一个对象（最后一个对象根据界面列点击改变）
      sorts.push(val);
      this.orderInfoListByType = this.Ginkgo.sort(this.orderInfoListByType, sorts);
      this.loadCurrentPageHistory();
    },
    // 选中当前行
    setCurrentRowHistory: function setCurrentRowHistory() {
      if (this.currentIndex !== -1) {
        this.$refs.resultTable.setCurrentRow(this.tableData[this.currentIndex]);
      }
    },
    // 加载当前页内容
    loadCurrentPageHistory: function loadCurrentPageHistory() {
      this.tableData = this.orderInfoListByType.slice(this.page.number * this.page.size, (this.page.number + 1) * this.page.size);
    },
    // 查询结果每页显示条数改变事件
    handleSizeChangeHistory: function handleSizeChangeHistory(val) {
      this.page.size = val;
      this.loadCurrentPageHistory();
    },
    // 页码改变事件
    handleCurrentChangeHistory: function handleCurrentChangeHistory(val) {
      this.page.number = val - 1;
      this.loadCurrentPageHistory();
    },
    // 切换dormSetForm的取值
    setDormSet: function setDormSet(dormSet) {
      var listDorm = this.dormSetList.filter(function (item) {
        return item.flatsName + item.dormSet + item.dormStandard + item.direction === dormSet;
      });
      if (listDorm.length > 0) {
        this.dormSetForm = listDorm[0];
        this.effectDrawing = this.global.staticUploadAddr + this.dormSetForm.effectDrawing;
        this.bedDiagram = this.global.staticUploadAddr + this.dormSetForm.bedDiagram;
      } else {
        this.dormSetForm = {};
        this.effectDrawing = '';
        this.bedDiagram = '';
      }
    },
    // 宿舍类型下拉框change
    handleDormSetChange: function handleDormSetChange(val) {
      console.log('ttttttttt', val);
      if (val) {
        this.setDormSet(val);
        this.dormChooseForm.roomNo = '';
        this.dormChooseForm.bedNo = '';
      }
    },
    // 宿舍下拉框change
    handleFlatsChange: function handleFlatsChange(val) {
      var list = this.modeSelector('Dorm_Set');
      if (list.length > 0) {
        this.dormChooseForm.dormSet = list[0].modeId;
        this.setDormSet(this.dormChooseForm.dormSet);
      }
      this.dormChooseForm.roomNo = '';
      this.dormChooseForm.bedNo = '';
    },
    // 床位下拉框change
    handleRoomChange: function handleRoomChange(val) {
      this.dormChooseForm.bedNo = '';
    },
    // 操作列可见性
    getOpVisible: function getOpVisible(form) {
      return this.Ginkgo.getOpVisible(this.getUISetQueryResult(form));
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ 658:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(125);

var _stringify2 = _interopRequireDefault(_stringify);

var _vueQr = __webpack_require__(193);

var _vueQr2 = _interopRequireDefault(_vueQr);

var _noticeBar = __webpack_require__(148);

var _noticeBar2 = _interopRequireDefault(_noticeBar);

__webpack_require__(149);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'MyBillXiFanZSB', // ?
  components: { vueQr: _vueQr2.default, vanNoticeBar: _noticeBar2.default },
  data: function data() {
    return {
      profile: 'prod',

      termMsg: '无欠费信息！',
      imgSrc: '',
      dormList: [], // 当前可选宿舍列表
      chosenDorm: {}, // 当前选择的宿舍列表
      modeSelectList: [],

      curStudent: {},
      payTerm: {
        stdt: 0, // 缴费开始日期
        endt: 0, // 缴费结束日期
        academicYear: '', // 学年
        term: '', // 学期
        isPayTerm: ''
      },
      tableData: [], // table绑定数据
      uiSetItemList: [], // 原始
      termList: [], // 账期列表
      orderInfoList: [], // 缴费历史
      orderInfoListByType: [], // 各类型缴费历史
      // 控制属性
      feeListVisible: false,
      queryFormVisible: false,
      isAllTermPay: false,
      feeListHistoryVisible: false,
      tabSelected: 'default', // 默认显示本期账单
      formLabelWidth: '80px',
      // 标签图片
      infoVisible: false,

      feeList: [],
      feeSum: {},

      payRule: '',
      channelFlag: '01',
      merchantCode: '',
      // 分页对象
      page: this.Ginkgo.cloneObj(this.global.page),
      payTypeVisible: false,
      payButtonDisable: false,
      // 查询窗体
      uiSetList: [],
      route: [],
      // ！！！初始排序对象
      sort: {},
      sortSet: [],
      // 选宿舍窗体
      dormSetForm: {}, // 宿舍类型配置信息
      dormSetList: [], // 宿舍类型下拉框
      dormChooseForm: { // 选宿舍
        dormSet: '',
        flatsName: '',
        roomNo: '',
        bedNo: ''
      },
      // 属性
      dialogFormVisible: false,
      chooseDormVisible: true,
      showImg: false,
      // 打印报到单
      orderInfoRow: {},
      classRow: {},
      dormRow: {},
      // 公寓相关图片
      effectDrawing: this.global.staticResourceAddr + 'gsvxifanvuem/newStu/4rj.jpg',
      bedDiagram: this.global.staticResourceAddr + 'gsvxifanvuem/newStu/10001.png',
      size_Img: this.global.staticResourceAddr + 'gsvxifanvuem/newStu/sgcm.jpg',
      weixin: this.global.staticResourceAddr + 'gsvvuepc/zft2Code.jpg',

      financeOffice: {},
      apartmentOffice: {},
      deanOffice: {},
      admissionsOffice: {},
      technicalSupport: {},
      informationManagementCenter: {},
      customerService: {},
      dormConfigList: [],
      dormConfigCheckList: [],
      dormConfig: '',
      fourBedSum: '0', // 四人间总数
      fourBedRmi: '0', // 六人间剩余
      sixBedSum: '0', // 六人间总数
      sixBedRmi: '0', // 四人间剩余
      // 支付相关
      payVisible: false,

      scanVisible: false,
      qrContent: '',
      qrImage: '',

      buttonVisibleWX: false,
      buttonVisibleZFB: false,
      buttonVisibleUnion: false,
      buttonVisiblePFWX: false,
      buttonVisiblePFZFB: false,

      payType: '',
      payTypeZFB: '',
      payTypeUnion: '01',
      payTypeHTT: '',
      payTypeZJ: '',
      payTypeUnionWX: '',
      payTypePFWX: '',
      payTypePFZFB: '',
      // 图片
      wx: this.global.staticResourceAddr + 'gsvxifanvuem/' + this.global.theme + '/images/wx.png',
      yl: this.global.staticResourceAddr + 'gsvxifanvuem/' + this.global.theme + '/images/yl.png',
      zfb: this.global.staticResourceAddr + 'gsvxifanvuem/' + this.global.theme + '/images/zfb.png',
      // 提示信息
      tipText: ''
    };
  },
  mounted: function mounted() {
    if (true) {
      var self = this;
      this.curStudent = this.global.curStudent;
      self.getMode();
      self.getUISet();
      // 验证缴费期限
      var isPayTerm = this.validPayTerm();
      if (isPayTerm) {
        // 判断是否从贷款页面跳转过来
        if (this.global.isLoan === '1') {
          this.global.isLoan = '0';
          this.initThis();
        } else {
          // 校验账单
          this.validOrderInfo();
        }
      } else {
        this.setVisible('06'); // 提示信息
      }
    } else {
      this.getUISet();
      if (this.global.isLoan === '1') {
        // 从贷款页面过来
        // 进入缴费流程
        this.global.isLoan = '0';
        this.initThis();
      } else {
        this.validPayTerm(); // 校验该学生是否交过费用
      }
    }
  },
  watch: {
    'dormChooseForm.dormSet': 'handleDormSetChange',
    'dormChooseForm.flatsName': 'handleFlatsChange',
    'dormChooseForm.roomNo': 'handleRoomChange',
    tabSelected: 'handleSelect'
  },
  methods: {
    // 校验是否在缴费期中
    validPayTerm: function validPayTerm() {
      var _this = this;

      var self = this;
      var termInfo = [];
      if (this.global.curStudent.trainingLevel === '专升本') {
        termInfo = this.modeSelector('CM_ZSBStuPayTime').filter(function (item) {
          return item.modeValue.substring(0, 4) === _this.curStudent.enrollmentYear.toString();
        });
      } else {
        termInfo = this.modeSelector('CM_NewStuPayTime').filter(function (item) {
          return item.modeValue.substring(0, 4) === _this.curStudent.enrollmentYear.toString();
        });
      }
      if (termInfo.length > 0) {
        self.payTerm.stdt = termInfo[0].field2;
        self.payTerm.endt = termInfo[0].field3;
        self.payTerm.academicYear = termInfo[0].modeValue;
        self.payTerm.term = termInfo[0].field1;

        // 添加通知信息
        self.tipText = termInfo[0].field4;
        var newDate = self.Ginkgo.dateToInt(new Date());
        if (newDate >= self.payTerm.stdt && newDate <= self.payTerm.endt) {
          self.global.curUser.schoolYear = termInfo[0].modeValue.substring(0, 4);
          return true;
        } else {
          self.termMsg = termInfo[0].field4 || termInfo[0].field4 !== '' ? termInfo[0].field4 : '缴费未开始！';
          return false;
        }
      } else {
        self.termMsg = '缴费未开始！';
        return false;
      }
    },
    // 获取学生历史缴费信息
    getOrderInfoList: function getOrderInfoList() {
      var self = this;
      var request = {};
      request.deptId = self.global.deptId;
      request.keyInfo = self.global.curStudent.uid;
      var str = (0, _stringify2.default)(request);
      return self.axios.post('/iif/getOrderInfoForHistoryByEncrypt', this.Ginkgo.encrypt(str)).then(function (response) {
        var backJson = JSON.parse(self.Ginkgo.rsaDecrypt(response.data));
        if (backJson.result.success === true) {
          var curYear = self.Ginkgo.getTimeStamp(new Date()).substr(0, 4);
          self.orderInfoList = backJson.orderInfoList.filter(function (item) {
            return item.field4 === curYear;
          });
          self.orderInfoListByType = self.orderInfoList.filter(function (item) {
            return item.field12 === '04';
          });
          if (self.orderInfoListByType.length > 0) {
            self.orderInfoRow = self.orderInfoListByType[0];
            self.getDormConfigInfo();
          } else {
            self.$alert('请先缴费！');
          }
        }
      }, function (response) {}).catch(function (error) {
        console.log(error);
      });
    },
    // 获取公寓用品配置
    getDormConfigInfo: function getDormConfigInfo() {
      var self = this;
      self.axios.get('/college/getSelectedDormConfig', { params: {
          studentName: self.global.curStudent.studentName,
          uid: self.global.curStudent.uid
        } }).then(function (response) {
        if (response.data.result.success === true) {
          self.selectedDormConfigList = response.data.dormConfigList;
          self.dormConfig = '';
          if (self.selectedDormConfigList.length > 0) {
            self.selectedDormConfigList.filter(function (item) {
              if (item.goods === self.selectedDormConfigList[self.selectedDormConfigList.length - 1].goods) {
                self.dormConfig += item.goods.substring(1);
              } else {
                self.dormConfig += item.goods.substring(1);
                self.dormConfig += '、';
              }
            });
          }
          self.getPrintList();
        }
      });
    },
    // 获取打印所需数据
    getPrintList: function getPrintList() {
      var self = this;
      self.axios.all([self.getClassList(), self.getDormList()]).then(self.axios.spread(function (classDivd, dorm) {
        if (classDivd.data.result.success === true && dorm.data.result.success === true) {
          self.classRow = classDivd.data.classDivdList[0];
          self.dormRow = dorm.data.viXFDormOneList[0];
          self.toPrintZSB();
        } else {
          self.$alert('报到单信息获取失败！');
        }
      }));
    },
    // 获取学生所选班级
    getClassList: function getClassList() {
      var self = this;
      return self.axios.get('/college/getClassDivdOne', { params: {
          keyInfo: self.global.curStudent.uid,
          schoolYear: self.curStudent.enrollmentYear
        } });
    },
    // 获取学生所选床位
    getDormList: function getDormList() {
      var self = this;
      return self.axios.get('/college/getViXFDorm', { params: {
          bedId: self.orderInfoRow.field13
        } });
    },
    toPrintZSB: function toPrintZSB() {
      var _this2 = this;

      var sort = { prop: 'field10', order: 'ascending' };
      var feelist = this.Ginkgo.sortList(this.orderInfoListByType, sort);
      var feeReducelist = this.orderInfoList.filter(function (item) {
        return item.field12 === '05';
      });
      // 计算金额
      var feeAmount = 0.0;
      for (var index = 0; index < feelist.length; index++) {
        feeAmount = feeAmount + parseFloat(feelist[index].feeAmount) * 100;
      }
      feeAmount = feeAmount / 100;
      var codestr = '';
      codestr += '';
      codestr += '<div style="width: 85%; height: 350px;margin: 0 auto;font-size:12px;">' + '<h1 style="color: rgb(9, 9, 9);height: 60px;line-height: 30px;text-align: center;margin-bottom: 10px;margin-top: 10px;font-size: 20px;">西安翻译学院新生入学报到单</h1>' + '<p style="color: rgb(9, 9, 9);width:50%;height:100px;float: left;line-height: 35px;text-align: left; ">' + '学号：' + this.curStudent.studentNo + '<br/>姓名：' + this.curStudent.studentName + '<br/>性别：' + this.curStudent.sex + '<br/>考生号：' + this.curStudent.examNo + '<br/>校园E卡通号：' + this.curStudent.studentNo + '<br/>年级：' + this.curStudent.enrollmentYear + '<br/>院（系）/部：' + this.orderInfoRow.field9 + '</p>' + '<p style="color: rgb(9, 9, 9);width:50%;height:100px;float: left;line-height: 35px;text-align: left; ">' + '专业：' + this.curStudent.majorMatr + '<br/>班级：' + this.classRow.className + '<br/>培养类别：' + this.curStudent.trainingLevel + '<br/>培养对象：' + this.curStudent.trainingObject + '<br/>联系电话：' + this.curStudent.phone + '<br/>缴费日期：' + this.Ginkgo.getToday(feelist[0].transDt.toString()) + '<br/>交费金额：' + feeAmount + '</p></div>';

      // 明细排版
      codestr += '<div><table style="color: rgb(9, 9, 9);width: 85%; margin: 0 auto; text-align: center;border-collapse:collapse;" border="1";>' + '<tr style="height:36px;font-size:14px;"><td>收费项目</td><td>收费标准(元)</td><td>收费项目</td><td>收费标准(元)</td></tr>';

      for (var i = 0; i < feelist.length; i++) {
        if (i % 2 === 0) {
          codestr = codestr + '<tr style="height:36px;font-size:12px;">';
        }
        codestr = codestr + '<td>' + feelist[i].feeNo + '</td><td>' + feelist[i].feeAmount + '</td>';
        if (i % 2 === 1) {
          codestr = codestr + '</tr>';
        }
        if (i % 2 === 0 && i === feelist.length - 1) {
          codestr = codestr + '<td></td><td></td>' + '</tr>';
        }
      }
      // codestr += feelist.length > 0 ? ('<tr style="height:36px;font-size:12px;"><td>' + feelist[0].feeNo + '</td><td>' + feelist[0].feeAmount + '</td>' + (feelist.length > 1 ? ('<td>' + feelist[1].feeNo + '</td><td>' + feelist[1].feeAmount + '</td>') : '<td></td><td></td>') + '</tr>') : ''
      // codestr += feelist.length > 2 ? ('<tr style="height:36px;font-size:12px;"><td>' + feelist[2].feeNo + '</td><td>' + feelist[2].feeAmount + '</td>' + (feelist.length > 3 ? ('<td>' + feelist[3].feeNo + '</td><td>' + feelist[3].feeAmount + '</td>') : '<td></td><td></td>') + '</tr>') : ''
      // codestr += feelist.length > 4 ? ('<tr style="height:36px;font-size:12px;"><td>' + feelist[4].feeNo + '</td><td>' + feelist[4].feeAmount + '</td>' + (feelist.length > 5 ? ('<td>' + feelist[5].feeNo + '</td><td>' + feelist[5].feeAmount + '</td>') : '<td></td><td></td>') + '</tr>') : ''
      // codestr += feelist.length > 6 ? ('<tr style="height:36px;font-size:12px;"><td>' + feelist[6].feeNo + '</td><td>' + feelist[6].feeAmount + '</td>' + (feelist.length > 7 ? ('<td>' + feelist[7].feeNo + '</td><td>' + feelist[7].feeAmount + '</td>') : '<td></td><td></td>') + '</tr>') : ''

      if (feeReducelist.length > 0) {
        codestr += '<tr style="height:36px;font-size:12px;"><td>' + feeReducelist[0].feeNo + '</td><td>' + feeReducelist[0].feeAmount + '</td>';
        if (feeReducelist.length > 1) {
          codestr += '<td>' + feeReducelist[1].feeNo + '</td><td>' + feeReducelist[1].feeAmount + '</td></tr>';
        } else {
          codestr += '<td></td><td></td></tr>';
        }
      }
      if (feeReducelist.length > 2) {
        codestr += '<tr style="height:36px;font-size:12px;"><td>' + feeReducelist[2].feeNo + '</td><td>' + feeReducelist[2].feeAmount + '</td>';
        if (feeReducelist.length > 3) {
          codestr += '<td>' + feeReducelist[3].feeNo + '</td><td>' + feeReducelist[3].feeAmount + '</td></tr>';
        } else {
          codestr += '<td></td><td></td></tr>';
        }
      }
      codestr += '</table></div>' + '<table style="width: 85%; margin: 0 auto;color: rgb(9, 9, 9);text-align: center;border-collapse:collapse;font-size:10px;" border="1">' + '<tr><td style="width: 20%;height: 80px;">01</td><td style="width:40%;">公寓中心<br/>(分配宿舍)</td><td>公寓楼：' + this.dormRow.flatsName + '<br/>房间号：' + this.dormRow.roomNo + '<br/>床位号：' + this.dormRow.bedNo + '</td></tr>' + '<tr><td style="width: 20%;height: 80px;">03</td><td style="width:40%;">其他<br/>(到辅导员处报到)</td><td></td></tr></table>';
      this.$confirm('确定要打印学号为' + this.curStudent.studentNo + '，姓名为' + this.curStudent.studentName + '的报到单吗?(请使用谷歌浏览器打印)', '提示', {
        confirmButtonText: '确定（请打印两份）',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var newWindow = window.open('_blank'); // 打开新窗口
        newWindow.document.write(codestr); // 向文档写入HTML表达式或者JavaScript代码
        newWindow.document.close(); // 关闭document的输出流, 显示选定的数据
        newWindow.print(); // 打印当前窗口
        setTimeout(newWindow.close(), 0);
        _this2.termMsg = '打印完成！';
        return true;
      }).catch(function (error) {
        console.log(error);
      });
    },
    setVisible: function setVisible(showType) {
      if (showType === '01') {
        // 登录显示
        this.queryFormVisible = true;
        this.feeListVisible = false;
        this.infoVisible = false;
        this.payTypeVisible = false;
        this.feeListHistoryVisible = false;
        this.chooseDormVisible = false;
        this.chooseDormConfigVisible = false;
      }
      if (showType === '02') {
        // 费用信息
        this.queryFormVisible = false;
        this.feeListVisible = true;
        this.infoVisible = false;
        this.payTypeVisible = false;
        this.feeListHistoryVisible = false;
        this.chooseDormVisible = false;
        this.chooseDormConfigVisible = false;
        this.payVisible = false;
      }
      if (showType === '03') {
        // 支付按钮
        this.queryFormVisible = false;
        this.feeListVisible = false;
        this.infoVisible = false;
        this.payTypeVisible = true;
        this.feeListHistoryVisible = false;
        this.chooseDormVisible = false;
        this.chooseDormConfigVisible = false;
      }
      if (showType === '04') {
        // 缴费历史
        this.queryFormVisible = false;
        this.feeListVisible = false;
        this.infoVisible = false;
        this.payTypeVisible = false;
        this.feeListHistoryVisible = true;
        this.chooseDormVisible = false;
        this.chooseDormConfigVisible = false;
      }
      if (showType === '06') {
        // 提示信息
        this.queryFormVisible = false;
        this.feeListVisible = false;
        this.infoVisible = true;
        this.payTypeVisible = false;
        this.feeListHistoryVisible = false;
        this.chooseDormVisible = false;
        this.chooseDormConfigVisible = false;
      }
      if (showType === '07') {
        // 选宿舍
        this.queryFormVisible = false;
        this.feeListVisible = false;
        this.infoVisible = false;
        this.payTypeVisible = false;
        this.feeListHistoryVisible = false;
        this.chooseDormVisible = true;
        this.chooseDormConfigVisible = false;
      }
      if (showType === '08') {
        // 选服装
        this.queryFormVisible = false;
        this.feeListVisible = false;
        this.infoVisible = false;
        this.payTypeVisible = false;
        this.feeListHistoryVisible = false;
        this.chooseDormVisible = false;
        this.chooseOtherVisible = true;
        this.chooseDormConfigVisible = false;
      }
      if (showType === '09') {
        // 选宿舍用品
        this.queryFormVisible = false;
        this.feeListVisible = false;
        this.infoVisible = false;
        this.payTypeVisible = false;
        this.feeListHistoryVisible = false;
        this.chooseDormVisible = false;
        this.chooseDormConfigVisible = true;
      }
      if (showType === '10') {
        // 支付页面
        this.queryFormVisible = false;
        this.feeListVisible = false;
        this.infoVisible = false;
        this.payTypeVisible = false;
        this.feeListHistoryVisible = false;
        this.chooseDormVisible = false;
        this.chooseOtherVisible = false;
        this.chooseDormConfigVisible = false;
        this.payVisible = true;
        this.scanVisible = false;
      }
      if (showType === '11') {
        // 支付页面
        this.payVisible = false;
        this.scanVisible = true;
      }
    },
    // 初始化数据字典
    getMode: function getMode() {
      var self = this;
      self.modeSelectList = self.global.modeList;
    },
    // 加载界面配置
    getUISet: function getUISet() {
      if (true) {
        var self = this;
        self.uiSetItemList = self.global.uiSetItemList;
        self.uiSetList = self.global.uiSetList;
      } else {
        this.uiSetList = [{ uiSetId: 'vi_House_PayFeeOif', uiSetName: '范例', uiSetType: '01', uiSetTypeDesc: '管理', colWidthOpt: '125', exportTextSet: '', crossItemNo: 'feeNo', crossItemName: 'feeName', mergeCell: '', sortSet: 'building,01', remark: '', itemList: null }];
        this.uiSetItemList = [{ uiSetId: 'vi_House_PayFeeOif', columnName: 'Dept_ID', columnDesc: '机构ID', columnProp: 'deptId', isVisible: '0', sortNo: '01', queryCondition: '0', sortNoQuery: '01', controlType: '02', controlTypeDesc: null, typeId: 'Dept', defaultValue: '', required: '0', isUnique: '1', dataType: '01', dataTypeDesc: null, matchType: '01', matchTypeDesc: null, newDisabled: '0', editDisabled: '0', queryVisible: '0', sortNoResult: '01', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '1', colWidth: '120', isCross: '0', isGroupStart: '1', defaultValueCond: '', exportSql: '1', placeHolder: '', setIdList: null }, { uiSetId: 'vi_House_PayFeeOif', columnName: 'Dept_NO', columnDesc: '机构号', columnProp: 'deptNo', isVisible: '0', sortNo: '01|01', queryCondition: '0', sortNoQuery: '01', controlType: '02', controlTypeDesc: null, typeId: 'Dept', defaultValue: '', required: '0', isUnique: '1', dataType: '01', dataTypeDesc: null, matchType: '01', matchTypeDesc: null, newDisabled: '0', editDisabled: '0', queryVisible: '0', sortNoResult: '01|01', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '1', colWidth: '120', isCross: '0', isGroupStart: '1', defaultValueCond: '', exportSql: '1', placeHolder: '', setIdList: null }, { uiSetId: 'vi_House_PayFeeOif', columnName: 'Dept_Name', columnDesc: '机构', columnProp: 'deptName', isVisible: '0', sortNo: '01|02', queryCondition: '0', sortNoQuery: '01', controlType: '02', controlTypeDesc: null, typeId: 'Dept', defaultValue: '', required: '0', isUnique: '1', dataType: '01', dataTypeDesc: null, matchType: '01', matchTypeDesc: null, newDisabled: '0', editDisabled: '0', queryVisible: '1', sortNoResult: '01|02', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '1', colWidth: '120', isCross: '0', isGroupStart: '1', defaultValueCond: '', exportSql: '1', placeHolder: '', setIdList: null }, { uiSetId: 'vi_House_PayFeeOif', columnName: 'Room_Type', columnDesc: '公寓等级', columnProp: 'dormSet', isVisible: '1', sortNo: '02', queryCondition: '0', sortNoQuery: '02', controlType: '02', controlTypeDesc: null, typeId: 'House_Info', defaultValue: '', required: '0', isUnique: '1', dataType: '01', dataTypeDesc: null, matchType: '01', matchTypeDesc: null, newDisabled: '0', editDisabled: '0', queryVisible: '1', sortNoResult: '02', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '1', colWidth: '120', isCross: '0', isGroupStart: '1', defaultValueCond: '', exportSql: '1', placeHolder: '', setIdList: null }, { uiSetId: 'vi_House_PayFeeOif', columnName: 'Building', columnDesc: '公寓楼', columnProp: 'building', isVisible: '1', sortNo: '03', queryCondition: '0', sortNoQuery: '02', controlType: '02', controlTypeDesc: null, typeId: 'House_Info', defaultValue: '', required: '0', isUnique: '1', dataType: '01', dataTypeDesc: null, matchType: '01', matchTypeDesc: null, newDisabled: '0', editDisabled: '0', queryVisible: '1', sortNoResult: '03', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '1', colWidth: '120', isCross: '0', isGroupStart: '1', defaultValueCond: '', exportSql: '1', placeHolder: '', setIdList: null }, { uiSetId: 'vi_House_PayFeeOif', columnName: 'Room', columnDesc: '宿舍号', columnProp: 'room', isVisible: '1', sortNo: '04', queryCondition: '0', sortNoQuery: '02', controlType: '02', controlTypeDesc: null, typeId: 'House_Info', defaultValue: '', required: '0', isUnique: '1', dataType: '01', dataTypeDesc: null, matchType: '01', matchTypeDesc: null, newDisabled: '0', editDisabled: '1', queryVisible: '1', sortNoResult: '04', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '1', colWidth: '120', isCross: '0', isGroupStart: '1', defaultValueCond: '', exportSql: '1', placeHolder: '', setIdList: null }, { uiSetId: 'vi_House_PayFeeOif', columnName: 'Beds', columnDesc: '床位号', columnProp: 'beds', isVisible: '1', sortNo: '05', queryCondition: '0', sortNoQuery: '02', controlType: '02', controlTypeDesc: null, typeId: 'House_Info', defaultValue: '', required: '0', isUnique: '1', dataType: '01', dataTypeDesc: null, matchType: '01', matchTypeDesc: null, newDisabled: '0', editDisabled: '0', queryVisible: '1', sortNoResult: '05', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '1', colWidth: '120', isCross: '0', isGroupStart: '1', defaultValueCond: '', exportSql: '1', placeHolder: '', setIdList: null }, { uiSetId: 'vi_Clothing_PayFeeOif', columnName: 'Clothes', columnDesc: '迷彩服号', columnProp: 'clothes', isVisible: '1', sortNo: '01', queryCondition: '0', sortNoQuery: '02', controlType: '02', controlTypeDesc: null, typeId: 'Clothes_Size', defaultValue: '', required: '0', isUnique: '1', dataType: '01', dataTypeDesc: null, matchType: '01', matchTypeDesc: null, newDisabled: '0', editDisabled: '0', queryVisible: '1', sortNoResult: '05', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '1', colWidth: '120', isCross: '0', isGroupStart: '1', defaultValueCond: '', exportSql: '1', placeHolder: '', setIdList: null }, { uiSetId: 'vi_Clothing_PayFeeOif', columnName: 'Dress', columnDesc: '迷彩衫号', columnProp: 'dress', isVisible: '1', sortNo: '02', queryCondition: '0', sortNoQuery: '02', controlType: '02', controlTypeDesc: null, typeId: 'Dress_Size', defaultValue: '', required: '0', isUnique: '1', dataType: '01', dataTypeDesc: null, matchType: '01', matchTypeDesc: null, newDisabled: '0', editDisabled: '0', queryVisible: '1', sortNoResult: '05', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '1', colWidth: '120', isCross: '0', isGroupStart: '1', defaultValueCond: '', exportSql: '1', placeHolder: '', setIdList: null }, { uiSetId: 'vi_Clothing_PayFeeOif', columnName: 'Shoes', columnDesc: '鞋子尺码', columnProp: 'shoes', isVisible: '1', sortNo: '05', queryCondition: '0', sortNoQuery: '02', controlType: '02', controlTypeDesc: null, typeId: 'Shoes_Size', defaultValue: '', required: '0', isUnique: '1', dataType: '01', dataTypeDesc: null, matchType: '01', matchTypeDesc: null, newDisabled: '0', editDisabled: '0', queryVisible: '1', sortNoResult: '05', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '1', colWidth: '120', isCross: '0', isGroupStart: '1', defaultValueCond: '', exportSql: '1', placeHolder: '', setIdList: null }];
      }
    },
    // 加载所有可选宿舍，并进行数据字典化（宿舍类型Type_ID:Dorm_Set;公寓Type_ID:Flats;房间Type_ID:Room;床位Type_ID:Bed;）
    getDorm: function getDorm() {
      var self = this;
      return self.axios.post('/college/getViXFDormForChoose', {
        enrollmentYear: this.curStudent.enrollmentYear,
        majorName: this.curStudent.majorName,
        trainingLevel: this.curStudent.trainingLevel,
        sex: this.curStudent.sex,
        keyInfo: this.curStudent.uid
      });
    },
    // 校验该学生是否缴过费
    validOrderInfo: function validOrderInfo() {
      var self = this;
      if (true) {
        this.axios.post('/college/getXFOrderInfoForCheck', {
          field1: this.curStudent.studentName,
          keyInfo: this.curStudent.uid,
          field12: '04',
          statusCode: '00'
        }).then(function (response) {
          if (response.data.result.success === true) {
            if (response.data.orderInfoList.length > 0) {
              // 有缴费记录
              self.termMsg = '已缴费！';
              self.setVisible('06'); // 提示信息
            } else {
              // 进入贷款页面
              self.toLoan();
            }
          } else {
            self.$alert('系统错误！');
          }
        }, function (response) {}).catch(function (error) {
          console.log(error);
        });
      } else {
        this.toLoan();
      }
    },
    toLoan: function toLoan() {
      // 登录页面
      this.$router.push('/LoanXiFanNew');
      this.route = [{ path: '/LoanXiFanNew', component: __webpack_require__(278), meta: { title: '生源地贷款' } }];
      this.$router.addRoutes(this.route);
    },
    // 加载缴费基础信息
    initThis: function initThis() {
      if (true) {
        var self = this;
        self.getMode();
        self.axios.post('/college/getViXFDormBedCountForNew', {
          schoolYear: self.curStudent.enrollmentYear,
          majorName: self.curStudent.majorName,
          trainingLevel: self.curStudent.trainingLevel,
          sex: self.curStudent.sex
        }).then(function (response) {
          console.log(response);
          if (response.data.result.success === true) {
            self.fourBedSum = response.data.viXFDormList[0].fourBedSum;
            self.fourBedRmi = response.data.viXFDormList[0].fourBedRmi;
            self.sixBedSum = response.data.viXFDormList[0].sixBedSum;
            self.sixBedRmi = response.data.viXFDormList[0].sixBedRmi;
          }
        });
        self.getDormConfig();
        self.axios.all([self.getDorm()]).then(this.axios.spread(function (dorm) {
          if (dorm.data.result.success === true) {
            self.dormList = dorm.data.viXFDormList;
            self.modeSelectList = self.modeSelectList.concat(dorm.data.modeList);
            self.dormSetList = dorm.data.viXFDormSetList;
            // 初始化宿舍选择
            if (self.modeSelector('Flats').length > 0) {
              // 公寓选择初始化成第一个公寓
              self.dormChooseForm.flatsName = self.modeSelector('Flats')[0].modeId;
              // 宿舍配置初始化成该公寓的首个类型
              if (self.modeSelector('Dorm_Set').length > 0) {
                // 初始化宿舍配置为首个公寓首个宿舍类型的信息
                self.dormChooseForm.dormSet = self.modeSelector('Dorm_Set')[0].modeId;
                // 根据所选宿舍类型加载宿舍类型信息
                self.setDormSet(self.dormChooseForm.dormSet);
              }
            }
          }
          if (self.dormList.length > 0) {
            self.setVisible('07'); // 选宿舍
          } else {
            self.termMsg = '无可选宿舍床位！';
            self.setVisible('06'); // 提示信息
          }
        }));
      } else {
        this.dormSetForm = {
          dormSet: '',
          price: '1000',
          dormStandard: '',
          roomSet: '',
          pubAreaSet: '',
          region: '',
          remark: ''
        };
      }
    },
    // 重置编辑窗体
    resetForm: function resetForm() {
      this.setVisible('01');
    },
    // 获取学生历史缴费信息
    getHistory: function getHistory() {
      if (true) {
        var self = this;
        var request = {};
        request.deptId = self.global.deptId;
        request.keyInfo = self.global.curStudent.uid;
        var str = (0, _stringify2.default)(request);
        self.axios.post('/iif/getOrderInfoForHistoryByEncrypt', this.Ginkgo.encrypt(str)).then(function (response) {
          var backJson = JSON.parse(self.Ginkgo.rsaDecrypt(response.data));
          if (backJson.result.success === true) {
            var curYear = self.Ginkgo.getTimeStamp(new Date()).substr(0, 4);
            self.orderInfoList = backJson.orderInfoList.filter(function (item) {
              return item.field4 === curYear;
            });
            self.getHistoryByType('04');
            self.setVisible('04');
          }
        }, function (response) {}).catch(function (error) {
          console.log(error);
        });
      } else {
        this.uiSetItemList = [{ uiSetId: 'tbIf_Order_Info_XiFan_New', columnName: 'transDt', columnDesc: '日期', columnProp: 'transDt', isVisible: '1', isVisibleDesc: '', sortNo: '99', queryCondition: '0', queryConditionDesc: '', sortNoQuery: '99', controlType: '02', controlTypeDesc: '', typeId: 'Dept_Type_KD', defaultValue: '01', required: '0', requiredDesc: '', isUnique: '0', isUniqueDesc: '', dataType: '01', dataTypeDesc: '', newDisabled: '0', editDisabled: '0', editDisabledDesc: '', queryVisible: '1', queryVisibleDesc: '', sortNoResult: '11', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '0', isFixColDesc: '', colWidth: '120', isCross: '0', isCrossDesc: '', isGroupStart: '1', isGroupStartDesc: '' }, { uiSetId: 'tbIf_Order_Info_XiFan_New', columnName: 'feeAmount', columnDesc: '费用', columnProp: 'feeAmount', isVisible: '1', isVisibleDesc: '', sortNo: '99', queryCondition: '0', queryConditionDesc: '', sortNoQuery: '99', controlType: '02', controlTypeDesc: '', typeId: 'Dept_Type_KD', defaultValue: '01', required: '0', requiredDesc: '', isUnique: '0', isUniqueDesc: '', dataType: '01', dataTypeDesc: '', newDisabled: '0', editDisabled: '0', editDisabledDesc: '', queryVisible: '1', queryVisibleDesc: '', sortNoResult: '11', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '0', isFixColDesc: '', colWidth: '120', isCross: '0', isCrossDesc: '', isGroupStart: '1', isGroupStartDesc: '' }, { uiSetId: 'tbIf_Order_Info_XiFan_New', columnName: 'orderNo', columnDesc: '订单号', columnProp: 'orderNo', isVisible: '1', isVisibleDesc: '', sortNo: '99', queryCondition: '0', queryConditionDesc: '', sortNoQuery: '99', controlType: '02', controlTypeDesc: '', typeId: 'Dept_Type_KD', defaultValue: '01', required: '0', requiredDesc: '', isUnique: '0', isUniqueDesc: '', dataType: '01', dataTypeDesc: '', newDisabled: '0', editDisabled: '0', editDisabledDesc: '', queryVisible: '1', queryVisibleDesc: '', sortNoResult: '11', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '0', isFixColDesc: '', colWidth: '120', isCross: '0', isCrossDesc: '', isGroupStart: '1', isGroupStartDesc: '' }];
        this.orderInfoList = [{ transDt: '20180730', feeAmount: 100, orderNo: 'xxxxxxxxxxxxxxxx' }];
        this.page.totalElements = this.orderInfoList.length;
        this.loadCurrentPageHistory();
        this.setVisible('04');
      }
    },
    // 点击去支付按钮
    toPay: function toPay() {
      if (true) {
        this.checkPayTime();
      } else {
        this.setVisible('03');
      }
    },
    // 校验商户缴费期
    checkPayTime: function checkPayTime() {
      var self = this;
      self.axios.get('/pay/checkToPay', { params: {
          deptId: self.global.deptId // 1000003
        } }).then(function (response) {
        if (response.data.return_msg === 'SUCCESS') {
          // 设置账期列表
          if (self.feeList.length > 0) {
            self.termList = [];
            self.feeList.forEach(function (item) {
              self.termList.push(item.term);
            });
            self.getDeptSet();
          } else {
            self.$alert('无待缴账单！');
          }
        } else {
          self.$alert(response.data.prop);
        }
      }, function (response) {}).catch(function (error) {
        console.log(error);
      });
    },
    // 获取机构支付配置
    getDeptSet: function getDeptSet() {
      var self = this;
      self.axios.get('/college/getBaseDeptSetByDeptID', { params: {
          deptId: self.global.deptId
        } }).then(function (response) {
        // 机构配置信息
        if (response.data.result.success === true) {
          self.viDeptSetList = response.data.viDeptSetList;
          if (self.viDeptSetList.length > 0) {
            self.setVisiblePayButton(self.viDeptSetList);
          }
        }
        self.buttonLoad = false;
      }, function (response) {}).catch(function (error) {
        console.log(error);
      });
    },
    setVisiblePayButton: function setVisiblePayButton(merchantList) {
      var self = this;
      // 取微信支付相关参数
      var wxPayType = merchantList.filter(function (item) {
        return item.payKind === '02';
      }); // payKind：01 银联; 02 微信; 03 支付宝; 04 代扣;
      if (wxPayType.length > 0) {
        // 有且仅有一个
        self.channelFlag = wxPayType[0].channelFlag;
        self.merchantCode = wxPayType[0].merchantCode;
      }
      // 设置支付方式的显示隐藏
      self.buttonVisibleUnion = false;
      self.buttonVisibleWX = false;
      self.buttonVisibleZFB = false;
      // 商户配置信息
      if (merchantList.length > 0) {
        merchantList.forEach(function (e) {
          if (e.payKind === '01') {
            // 银联
            self.payTypeUnion = e.payType;
            self.buttonVisibleUnion = true;
          }
          if (e.payKind === '02') {
            // 微信
            self.payType = e.payType;
            self.buttonVisibleWX = true;
          }
          if (e.payKind === '03') {
            // 支付宝
            self.payTypeZFB = e.payType;
            self.buttonVisibleZFB = true;
          }
          if (e.payKind === '07') {
            // 浦发新微信
            self.payTypePFWX = e.payType;
            self.buttonVisiblePFWX = true;
          }
          if (e.payKind === '08') {
            // 浦发新支付宝
            self.payTypePFZFB = e.payType;
            self.buttonVisiblePFZFB = true;
          }
          if (e.payType === '98') {
            // 暂无用
            self.payTypeHTT = e.payType;
            self.buttonVisibleHTT = true;
          }
          if (e.payKind === '04') {
            // 代扣
            self.payTypeZJ = e.payType;
            self.buttonVisibleZJ = true;
          }
        });
      }
      if (self.feeSum.feeAmount < 0) {
        self.$alert('实缴金额为负值，' + self.feeSum.feeAmount + ' 元，不允许支付！');
        self.payButtonDisable = true;
      } else if (self.feeSum.feeAmount === 0) {
        self.$alert('实缴金额为 ' + self.feeSum.feeAmount + ' 元，不允许支付！');
        self.payButtonDisable = true;
      } else {
        self.payButtonDisable = false;
      }
      self.setVisible('10');
    },
    doPay: function doPay(payType) {
      if (true) {
        var self = this;
        var payUrl = '';
        var validType = '02';
        self.axios.post('/college/getOrderInfoIsExpired', {
          keyInfo: self.curStudent.uid,
          deptId: self.global.deptId,
          term: self.termList[0]
        }).then(function (response) {
          if (response.data.result.success) {
            // 根据不同支付方式访问不同的发起交易服务
            self.axios.post('/pay/toPay', {
              keyInfo: self.curStudent.uid,
              deptId: self.global.deptId,
              payType: payType,
              feeTermList: self.termList,
              validType: validType
            }).then(function (response) {
              if (response.data.result.success) {
                var payKind = self.viDeptSetList.filter(function (item) {
                  return item.payType === payType;
                })[0].payKind;
                if (payKind === '02') {
                  // 微信支付
                  payUrl += self.global.payUrl + 'pay/doPayForUrl?';
                  payUrl += 'payType=' + payType;
                  payUrl += '&orderNo=' + response.data.orderNo;
                  payUrl += '&deptId=' + response.data.deptId;
                  payUrl += '&openId=' + self.global.curUser.openId;
                  payUrl += '&qrCodeType=' + 'WXPAY';
                  payUrl += '&payChannel=01';
                  // 二维码
                  console.log('===wx支付地址===', payUrl);
                  self.qrContent = payUrl;
                  // self.qrImage = self.wx
                  self.setVisible('11');
                } else if (payKind === '03') {
                  payUrl += self.global.payUrl + 'pay/doPayForUrl?';
                  payUrl += 'payType=' + payType;
                  payUrl += '&orderNo=' + response.data.orderNo;
                  payUrl += '&deptId=' + response.data.deptId;
                  payUrl += '&openId=' + self.global.curUser.openId;
                  payUrl += '&qrCodeType=' + 'ALIPAY';
                  payUrl += '&payChannel=01';
                  // 二维码
                  console.log('===支付宝支付地址===', payUrl);
                  self.qrContent = payUrl;
                  // self.qrImage = self.zfb
                  self.setVisible('11');
                } else if (payKind === '07') {
                  // 浦发微信支付 新版 opNJK1tn-GZEhIudaMdrRmr4wYs0
                  payUrl += self.global.payUrl + 'pay/doPayForUrl?';
                  payUrl += 'payType=' + payType;
                  payUrl += '&orderNo=' + response.data.orderNo;
                  payUrl += '&deptId=' + response.data.deptId;
                  payUrl += '&openId=' + self.global.curUser.openId;
                  payUrl += '&qrCodeType=' + 'WXPAY';
                  payUrl += '&payChannel=01';
                  console.log('===pfwx支付地址===', payUrl);
                  self.qrContent = payUrl;
                  self.setVisible('11');
                } else if (payKind === '08') {
                  // 浦发支付宝支付 新版 opNJK1tn-GZEhIudaMdrRmr4wYs0
                  payUrl += self.global.payUrl + 'pay/doPayForUrl?';
                  payUrl += 'payType=' + payType;
                  payUrl += '&orderNo=' + response.data.orderNo;
                  payUrl += '&deptId=' + response.data.deptId;
                  payUrl += '&openId=' + self.global.curUser.openId;
                  payUrl += '&qrCodeType=' + 'ALIPAY';
                  payUrl += '&payChannel=01';
                  console.log('===pfzfb支付地址===', payUrl);
                  self.qrContent = payUrl;
                  self.setVisible('11');
                } else {
                  payUrl = self.global.payUrl + 'pay/doPay?' + 'payType=' + self.payTypeUnion + '&orderNo=' + response.data.orderNo + '&deptId=' + response.data.deptId + '&openId=&payChannel=02';
                  window.location.href = payUrl;
                }
              } else {
                self.$alert(response.data.result.msg);
              }
            }).catch(function (error) {
              console.log(error);
            });
          } else {
            self.$alert(response.data.result.msg);
            // 超时，重新加载选宿舍基础信息，进入选宿舍界面
            self.initThis();
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        this.setVisible('01');
      }
    },
    back: function back(type) {
      if (this.global.curStudent.trainingLevel === '专升本') {
        if (this.global.dormConfigSet !== 1) {
          if (type === '09') {
            this.setVisible('07');
          } else {
            this.setVisible(type);
          }
        } else {
          this.setVisible(type);
        }
      } else {
        this.setVisible('07');
      }
    },
    // 数据字典筛选器
    modeSelector: function modeSelector(typeId) {
      var _this3 = this;

      var list = [];
      switch (typeId) {
        case 'Dorm_Set':
          list = this.modeSelectList.filter(function (item) {
            return item.typeId === typeId && item.parentModeId === _this3.dormChooseForm.flatsName;
          });
          break;
        case 'Room':
          list = this.modeSelectList.filter(function (item) {
            return item.typeId === typeId && item.parentModeId === _this3.dormChooseForm.dormSet;
          });
          break;
        case 'Bed':
          list = this.modeSelectList.filter(function (item) {
            return item.typeId === typeId && item.parentModeId === _this3.dormChooseForm.roomNo && item.modeValue === _this3.dormChooseForm.flatsName;
          });
          break;
        default:
          list = this.modeSelectList.filter(function (element) {
            return element.typeId === typeId;
          });
          break;
      }
      return list;
    },
    // 编辑窗体禁用 01 新增 02 修改
    getDisableEdit: function getDisableEdit(propName, formName) {
      var disabled = false;
      // 宿舍类型
      if (this.dormChooseForm.flatsName === '') {
        if (propName === 'dormSet' || propName === 'roomNo' || propName === 'bedNo') {
          disabled = true;
        }
      } else {
        if (propName === 'dormSet') {
          disabled = false;
        }
      }
      // 宿舍
      if (this.dormChooseForm.dormSet === '') {
        if (propName === 'roomNo' || propName === 'bedNo') {
          disabled = true;
        }
      } else {
        if (propName === 'roomNo') {
          disabled = false;
        }
      }

      // 床位
      if (this.dormChooseForm.roomNo === '') {
        if (propName === 'bedNo') {
          disabled = true;
        }
      } else {
        disabled = false;
      }
      return disabled;
    },
    // 校验选择宿舍窗体
    validForm: function validForm() {
      var valid = true;
      if (this.dormChooseForm.dormSet === '') {
        this.$alert('请选择公寓等级！');
        return false;
      }
      if (this.dormChooseForm.flasName === '') {
        this.$alert('请选择公寓楼！');
        return false;
      }
      if (this.dormChooseForm.roomNo === '') {
        this.$alert('请选择宿舍！');
        return false;
      }
      if (this.dormChooseForm.bedNo === '') {
        this.$alert('请选择床位！');
        return false;
      }
      if (this.bedDiagram === '') {
        this.$alert('选择的床位出现异常！');
        return false;
      }
      return valid;
    },
    // 选择宿舍
    chooseDorm: function chooseDorm() {
      var _this4 = this;

      if (true) {
        if (this.validForm()) {
          var self = this;
          // 根据选择的床位筛选当前的宿舍床位对象（为了取ID）
          this.chosenDorm = this.dormList.filter(function (item) {
            return item.flatsName === _this4.dormChooseForm.flatsName && item.roomNo === _this4.dormChooseForm.roomNo && item.bedNo === _this4.dormChooseForm.bedNo;
          })[0];
          // 校验所选宿舍是否已经被其他人所选
          self.axios.post('/college/lockDormBed', {
            bedId: this.chosenDorm.id,
            keyInfo: self.curStudent.uid
          }).then(function (response) {
            if (response.data.result.success === true) {
              // 创建订单
              if (self.global.curStudent.trainingLevel === '专升本') {
                if (self.global.dormConfigSet === 1) {
                  self.setVisible('09');
                } else {
                  // 创建订单
                  self.createOrderInfo();
                }
              } else {
                self.createOrderInfo();
              }
            } else {
              self.$alert(response.data.result.msg);
            }
          }, function (response) {}).catch(function (error) {
            console.log(error);
          });
        }
      } else {
        this.setVisible('02');
      }
    },
    // 创建订单
    createOrderInfo: function createOrderInfo() {
      if (true) {
        var self = this;

        if (self.global.curStudent.trainingLevel === '专升本') {
          self.dormItemVisible = true;
          self.clothItemVisible = false;
        } else {
          self.dormItemVisible = true;
          self.clothItemVisible = true;
        }

        var selectedDormConfigStr = '';
        self.dormConfigCheckList.filter(function (item) {
          selectedDormConfigStr = selectedDormConfigStr + item + ',';
        });
        var order = {};
        order.studentName = this.curStudent.studentName;
        order.uid = this.curStudent.uid;
        order.bedId = this.chosenDorm.id;

        order.coatSize = '';
        order.shirtSize = '';
        order.shoesSize = '';
        // order.dormConfigFee = 0

        // 保险开关
        order.insuranceSet = this.global.insuranceSet;
        // 宿舍配置用品开关
        order.dormConfigSet = this.global.dormConfigSet;
        // 宿舍用品已选配置
        order.selectedDormConfigStr = selectedDormConfigStr;

        // 校验所选宿舍是否已经被其他人所选
        self.axios.post('/college/addXFOrderInfo', order).then(function (response) {
          if (response.data.result.success === true) {
            self.feeList = response.data.orderInfoList;
            var sort = {};
            sort.prop = 'field10';
            sort.order = 'ascending';
            self.feeList = self.Ginkgo.sortList(self.feeList, sort);
            if (response.data.orderInfoSumList.length > 0) {
              self.feeSum = response.data.orderInfoSumList[0];
            }
            // self.addDormConfigOrderInfo(order.uid, order.studentName)
            self.setVisible('02');
          } else {
            self.$alert(response.data.result.msg);
          }
        }, function (response) {}).catch(function (error) {
          console.log(error);
        });
      }
    },
    addDormConfigOrderInfo: function addDormConfigOrderInfo(uid, studentName) {
      var _this5 = this;

      var self = this;
      var dormConfigOrderInfo = [];
      self.dormConfigCheckList.filter(function (item) {
        self.dormConfigList.filter(function (d) {
          if (item === d.modeId) {
            dormConfigOrderInfo.push({
              uid: uid,
              studentName: studentName,
              goods: d.modeId + d.modeName,
              amt: d.modeValue,
              enrollmentYear: _this5.global.curStudent.enrollmentYear
            });
          }
        });
      });
      self.axios.post('/college/addSelectedDormConfig', dormConfigOrderInfo).then(function (response) {
        if (response.data.result.success === true) {} else {
          self.$alert(response.data.result.msg);
        }
      });
    },
    getDormValue: function getDormValue(option) {
      var dormConfigList = this.dormConfigList.filter(function (item) {
        return item.modeId === option;
      });
      if (dormConfigList.length > 0) {
        return dormConfigList[0].modeValue;
      }
      return '';
    },
    getDormLabel: function getDormLabel(option) {
      var dormConfigList = this.dormConfigList.filter(function (item) {
        return item.modeId === option;
      });
      if (dormConfigList.length > 0) {
        return dormConfigList[0].modeId + '：(' + dormConfigList[0].modeName + ')';
      }
      return '';
    },
    getDormConfig: function getDormConfig() {
      var self = this;
      self.dormConfigList = self.modeSelectList.filter(function (item) {
        return item.typeId === 'Dorm_Supply_Config';
      });
      self.dormConfigList.filter(function (item) {
        if (item.field1 === '01') {
          self.dormConfigCheckList.push(item.value);
        }
      });
    },
    // 下一步
    nextStep: function nextStep(optName) {
      if (optName === 'Dorm') {
        this.chooseDorm();
        this.initMustSelectedValue();
      } else if (optName === 'DormConfig') {
        this.dormConfigCheckList.sort();
        this.chooseDormConfig();
      }
    },
    // 初始化必选项
    initMustSelectedValue: function initMustSelectedValue() {
      var _this6 = this;

      if (this.global.curStudent.trainingLevel === '专升本') {
        if (this.global.dormConfigSet === 1) {
          this.dormConfigCheckList = [];
          var mustSelectList = this.dormConfigList.filter(function (item) {
            return item.field1 === '01';
          });
          mustSelectList.filter(function (item) {
            _this6.dormConfigCheckList.push(item.modeId);
          });
        } else {
          this.dormConfigCheckList = this.dormConfigList.map(function (item) {
            return item.modeId;
          });
        }
      } else {
        this.dormConfigCheckList = [];
      }
    },
    // 选择公寓用品
    chooseDormConfig: function chooseDormConfig() {
      // var self = this
      if (true) {
        // if (this.validDormConfigForm()) {
        //   // 计算宿舍用品配置费用
        //   let totalAmt = 0
        //   self.feeList = self.feeList.filter(item => item.feeNo !== '公寓用品费')
        //   if (self.dormConfigCheckList.length > 0) {
        //     self.dormConfigCheckList.filter(item => {
        //       let dormConfigList = self.dormConfigList.filter(d => d.modeId === item)
        //       if (dormConfigList.length > 0) {
        //         totalAmt = totalAmt + Number(dormConfigList[0].modeValue)
        //       }
        //     })
        //     self.feeList.push({'feeNo': '公寓用品费', 'feeAmount': totalAmt})
        //   }
        //   this.createOrderInfo()
        // } else {
        //   this.setVisible('07')
        // }
        this.createOrderInfo();
      } else {
        this.setVisible('02');
      }
    },
    validDormConfigForm: function validDormConfigForm() {
      var mustSelectList = this.dormConfigList.filter(function (item) {
        return item.field1 === '01';
      });
      var str = '';
      mustSelectList.filter(function (item) {
        str = str + item.modeId + '、';
      });
      if (str.length > 0) {
        str = str.substr(0, str.length - 1);
      }
      if (this.dormConfigCheckList.length < mustSelectList.length) {
        this.$alert(str + '选项为必选选项');
        return false;
      } else {
        return true;
      }
    },
    handleDormConfigChange: function handleDormConfigChange() {
      var mustSelectList = this.dormConfigList.filter(function (item) {
        return item.field1 === '01';
      });
      var selectedList = this.dormConfigCheckList.filter(function (item) {
        return mustSelectList.filter(function (item1) {
          return item1.modeId === item;
        }).length;
      });
      if (selectedList.length < mustSelectList.length) {
        var dormConfigCheckList = [];
        mustSelectList.forEach(function (item) {
          dormConfigCheckList.push(item.modeId);
        });
        this.dormConfigCheckList.forEach(function (item) {
          var tmpList = mustSelectList.filter(function (item1) {
            return item === item1.modeId;
          });
          if (tmpList.length > 0) {
            if (tmpList[0].field1 === '00') {
              dormConfigCheckList.push(item);
            }
          } else {
            dormConfigCheckList.push(item);
          }
        });
        this.dormConfigCheckList = dormConfigCheckList;
        var str = '';
        mustSelectList.filter(function (item) {
          str = str + item.modeId + '、';
        });
        if (str.length > 0) {
          str = str.substr(0, str.length - 1);
        }
        this.$alert(str + '选项为必选选项');
      }
    },
    clickImg: function clickImg(e) {
      this.showImg = true;
      // 获取当前图片地址
      this.imgSrc = e.currentTarget.src;
    },
    viewImg: function viewImg() {
      this.showImg = false;
    },
    showWechatImg: function showWechatImg() {
      this.dialogFormVisible = true;
    },
    handleSelect: function handleSelect(index, indexPath) {
      if (true) {
        if (index === '/MyBill') {
          this.validPayTerm();
        }
        if (index === '/MyBillHistory') {
          this.tableData = [];
          this.getHistory();
        }
        if (index === '/Card') {
          // 跳转到银行卡信息维护页面
          this.$router.push('/card');
          this.route = [{ path: '/card', component: __webpack_require__(151), meta: { title: '银行卡信息维护' } }];
          this.$router.addRoutes(this.route);
        }
        if (index === '/Exit') {
          this.$router.push('/LoginXiFan');
          this.route = [{ path: '/LoginXiFan', component: __webpack_require__(69), meta: { title: '缴费登录' } }];
          this.$router.addRoutes(this.route);
        }
        if (index === '/Print') {
          this.termMsg = '待打印！';
          this.setVisible('06');
          this.getOrderInfoList();
        }
      } else {
        if (index === '/MyBill') {
          this.setVisible('02');
        }
        if (index === '/Exit') {
          this.$router.push('/LoginXiFan');
          this.route = [{ path: '/LoginXiFan', component: require('./LoginXiFan.vue'), meta: { title: '缴费登录' } }];
          this.$router.addRoutes(this.route);
        }
        if (index === '/Print') {
          this.toPrint();
        }
      }
    },
    // 根据费用类型获取对应的缴费历史记录
    getHistoryByType: function getHistoryByType(type) {
      var self = this;
      // this.orderInfoListByType = this.orderInfoList.filter(item => item.field12 === type)
      this.orderInfoListByType = this.orderInfoList;
      // 首次默认排序
      self.handleSortChangeHistory(self.sort);
      // 分页处理
      self.page.totalElements = self.orderInfoListByType.length;
      self.loadCurrentPageHistory();
      // 设置当前选中行
      self.setCurrentRowHistory();
    },
    // 获取查询结果配置
    getUISetQueryResult: function getUISetQueryResult(form) {
      var setId = form === '01' ? 'tbIf_Order_Info_XiFan_New' : 'tbIf_Order_Info_XiFan_Exam';
      var sort = { prop: 'sortNoResult', order: 'ascending' };

      var list = this.uiSetItemList.filter(function (element) {
        return element.uiSetId === setId && element.queryVisible === '1';
      });

      return this.Ginkgo.sortList(list, sort);
    },
    // 列数据格式化
    dataFormatHistory: function dataFormatHistory(row, column, cellValue) {
      var columnProp = column.property;
      // 根据列的property(绑定的字段属性)回查列设置
      var formatString = this.getUISetQueryResult('01').filter(function (element) {
        return element.columnProp === columnProp;
      })[0].formatString;

      return this.Ginkgo.format(cellValue, formatString);
    },
    // 列可见性
    getHeaderVisible: function getHeaderVisible(item, level, fixed) {
      return this.Ginkgo.getHeaderVisible(item, level, fixed);
    },
    // 获取同组记录
    getHeaderGroup: function getHeaderGroup(item, level, form) {
      return this.Ginkgo.getHeaderGroup(item, level, this.getUISetQueryResult(form));
    },
    // 排序(参数var={prop,order}) order: ascending  descending
    handleSortChangeHistory: function handleSortChangeHistory(val) {
      this.sort = val;
      var sorts = this.Ginkgo.cloneObj(this.sortSet);
      sorts.pop(); // 删除最后一个对象（最后一个对象根据界面列点击改变）
      sorts.push(val);
      this.orderInfoListByType = this.Ginkgo.sort(this.orderInfoListByType, sorts);
      this.loadCurrentPageHistory();
    },
    // 选中当前行
    setCurrentRowHistory: function setCurrentRowHistory() {
      if (this.currentIndex !== -1) {
        this.$refs.resultTable.setCurrentRow(this.tableData[this.currentIndex]);
      }
    },
    // 加载当前页内容
    loadCurrentPageHistory: function loadCurrentPageHistory() {
      this.tableData = this.orderInfoListByType.slice(this.page.number * this.page.size, (this.page.number + 1) * this.page.size);
    },
    // 查询结果每页显示条数改变事件
    handleSizeChangeHistory: function handleSizeChangeHistory(val) {
      this.page.size = val;
      this.loadCurrentPageHistory();
    },
    // 页码改变事件
    handleCurrentChangeHistory: function handleCurrentChangeHistory(val) {
      this.page.number = val - 1;
      this.loadCurrentPageHistory();
    },
    // 切换dormSetForm的取值
    setDormSet: function setDormSet(dormSet) {
      var listDorm = this.dormSetList.filter(function (item) {
        return item.flatsName + item.dormSet + item.dormStandard + item.direction === dormSet;
      });
      if (listDorm.length > 0) {
        this.dormSetForm = listDorm[0];
        this.effectDrawing = this.global.staticUploadAddr + this.dormSetForm.effectDrawing;
        this.bedDiagram = this.global.staticUploadAddr + this.dormSetForm.bedDiagram;
      } else {
        this.dormSetForm = {};
        this.effectDrawing = '';
        this.bedDiagram = '';
      }
    },
    // 宿舍类型下拉框change
    handleDormSetChange: function handleDormSetChange(val) {
      console.log('ttttttttt', val);
      if (val) {
        this.setDormSet(val);
        this.dormChooseForm.roomNo = '';
        this.dormChooseForm.bedNo = '';
      }
    },
    // 宿舍下拉框change
    handleFlatsChange: function handleFlatsChange(val) {
      var list = this.modeSelector('Dorm_Set');
      if (list.length > 0) {
        this.dormChooseForm.dormSet = list[0].modeId;
        this.setDormSet(this.dormChooseForm.dormSet);
      }
      this.dormChooseForm.roomNo = '';
      this.dormChooseForm.bedNo = '';
    },
    // 床位下拉框change
    handleRoomChange: function handleRoomChange(val) {
      this.dormChooseForm.bedNo = '';
    },
    // 操作列可见性
    getOpVisible: function getOpVisible(form) {
      return this.Ginkgo.getOpVisible(this.getUISetQueryResult(form));
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ 659:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(125);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'MyBillXiFan', // ?
  data: function data() {
    return {
      form: {
        studentType: '02',
        studentName: '',
        studentNo: '',
        idCard: ''
      },
      viewForm: {
        studentNo: '',
        studentName: '',
        majorMatr: '',
        className: '',
        academicYear: '',
        term: '',
        termNM: '',
        enrollmentYear: 0, // 学籍
        deptName: '', // 院系
        trainingLevel: '', // 培养层次
        tuition: 0,
        houseFees: 0,
        totals: 0,
        payableAmount: 0,
        feeAmount: 0,
        reduceAmount: 0 // 减免总金额
      },
      payTerm: {
        stdt: 0, // 缴费开始日期
        endt: 0, // 缴费结束日期
        academicYear: '', // 学年
        term: '', // 学期
        isPayTerm: ''
      },
      tableData: [], // table绑定数据
      uiSetItemList: [], // 原始
      feeData: [], // 费用明细
      termList: [], // 账期列表
      reduceList: [], // 减免账单
      orderInfoList: [], // 缴费历史
      orderInfoListByType: [], // 各类型缴费历史
      viDeptSetList: [],
      modeSelectList: [],
      multipleSelection: [],
      checked: false,
      payTypeUnion: '01', // 银联支付
      feeType: '01', // 学期缴费
      feeTypeVisible: false, // 缴费类型
      feeList: [], // 费用数据
      radio: '0',
      backVisible: false, // 返回按钮
      // 分页对象
      page: this.Ginkgo.cloneObj(this.global.page),
      // ！！！初始排序对象
      sort: {},
      sortSet: [],
      photo: '',
      dialogFormVisible: false,
      semesterPayVisible: false,
      feePayType_UN: false,
      payButtonDisable: false,
      feeListHistoryVisible: false,
      billVisible: false,
      termVisible: false,
      termMsg: '不在缴费期内',
      examBillVisible: false,
      examListHistoryVisible: false,
      weixin: this.global.staticResourceAddr + 'gsvvuepc/zft2Code.jpg',

      financeOffice: {},
      apartmentOffice: {},
      deanOffice: {},
      admissionsOffice: {},
      technicalSupport: {},
      informationManagementCenter: {},
      customerService: {}
    };
  },
  mounted: function mounted() {
    if (true) {
      this.getMode();
      this.getUISet();
      this.getDeptSet();
      this.getHistory();
      this.viewForm.studentNo = this.global.curStudent.studentNo;
      this.viewForm.studentName = this.global.curStudent.studentName;
      this.viewForm.majorMatr = this.global.curStudent.majorMatr;
      this.viewForm.className = this.global.curStudent.className;
      this.viewForm.enrollmentYear = this.global.curStudent.enrollmentYear;
      this.viewForm.trainingLevel = this.global.curStudent.trainingLevel;
      this.viewForm.deptName = this.global.curStudent.deptName;
      if (this.global.curStudent.studentType === '02') {
        // 老生校验缴费期
        this.checkTerm();
      }
    } else {
      this.viewForm = {
        studentNo: '17611070628',
        studentName: '陈彦羽',
        majorMatr: '学前教育',
        className: '三七班',
        academicYear: '2018',
        term: '0',
        tuition: 1520,
        houseFees: 1200,
        totals: 0,
        payableAmount: 0,
        feeAmount: 0
      };
      this.viewForm.tuition = this.Ginkgo.format(this.viewForm.tuition, 'money');
      this.viewForm.houseFees = this.Ginkgo.format(this.viewForm.houseFees, 'money');
      this.viewForm.payableAmount = this.Ginkgo.format(this.viewForm.tuition + this.viewForm.houseFees, 'money');
      this.viewForm.feeAmount = this.Ginkgo.format(this.viewForm.tuition + this.viewForm.houseFees, 'money');
      this.setVisible('01');
    }
  },
  methods: {
    // 初始化数据字典
    getMode: function getMode() {
      var self = this;
      self.modeSelectList = self.global.modeList;
    },
    // 加载界面配置
    getUISet: function getUISet() {
      var self = this;
      self.uiSetItemList = self.global.uiSetItemList;
      self.uiSetList = self.global.uiSetList;
    },
    // 获取机构支付配置
    getDeptSet: function getDeptSet() {
      var self = this;
      self.axios.get('/college/getBaseDeptSetByDeptID', { params: {
          deptId: self.global.deptId
        } }).then(function (response) {
        // 机构配置信息
        if (response.data.result.success === true) {
          self.viDeptSetList = response.data.viDeptSetList;
        }
        self.buttonLoad = false;
      }, function (response) {}).catch(function (error) {
        console.log(error);
      });
    },
    setVisible: function setVisible(showType) {
      if (showType === '01') {
        // 基础缴费我的账单，显示账单信息
        this.semesterPayVisible = true;
        this.feePayType_UN = true;
        this.feeListHistoryVisible = false;
        this.billVisible = true;
        this.termVisible = false;
        this.examBillVisible = false;
        this.examListHistoryVisible = false;
        this.payButtonDisable = true;
        this.feeTypeVisible = false;
      }
      if (showType === '02') {
        // 提示信息
        this.semesterPayVisible = true;
        this.feePayType_UN = false;
        this.feeListHistoryVisible = false;
        this.billVisible = false;
        this.termVisible = true;
        this.examBillVisible = false;
        this.examListHistoryVisible = false;
        this.payButtonDisable = true;
        this.feeTypeVisible = false;
      }
      if (showType === '03') {
        // 历史账单（基础缴费）
        this.feeListHistoryVisible = true;
        this.semesterPayVisible = true;
        this.feePayType_UN = false;
        this.billVisible = false;
        this.termVisible = false;
        this.examBillVisible = false;
        this.examListHistoryVisible = false;
        this.payButtonDisable = true;
        this.feeTypeVisible = false;
      }
      if (showType === '04') {
        // 考试缴费账单，显示账单信息
        this.semesterPayVisible = true;
        this.examBillVisible = true;
        this.feePayType_UN = true;
        this.feeListHistoryVisible = false;
        this.billVisible = false;
        this.termVisible = false;
        this.examListHistoryVisible = false;
        this.payButtonDisable = true;
        this.feeTypeVisible = false;
      }
      if (showType === '06') {
        // 历史账单（考试缴费）
        this.feeListHistoryVisible = false;
        this.semesterPayVisible = true;
        this.feePayType_UN = false;
        this.billVisible = false;
        this.termVisible = false;
        this.examBillVisible = false;
        this.examListHistoryVisible = true;
        this.payButtonDisable = true;
        this.feeTypeVisible = false;
      }
      if (showType === '07') {
        // 账期选择
        this.feeListHistoryVisible = false;
        this.semesterPayVisible = false;
        this.feePayType_UN = false;
        this.billVisible = false;
        this.termVisible = false;
        this.examBillVisible = false;
        this.examListHistoryVisible = false;
        this.payButtonDisable = false;
        this.feeTypeVisible = true;
      }
    },
    back: function back(type) {
      this.setVisible('07');
    },
    isShow: function isShow(row, event, column) {
      if (row.isExpanded === 0) {
        this.$refs.feeResultTable.toggleRowExpansion(row, true);
        row.isExpanded = 1;
      } else {
        this.$refs.feeResultTable.toggleRowExpansion(row, false);
        row.isExpanded = 0;
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      var self = this;
      self.viewForm.totals = 0;
      self.termList = [];
      val.forEach(function (e) {
        self.viewForm.totals = self.viewForm.totals + Number(e.feeAmount);
        self.termList.push(e.term);
      });
      if (self.viewForm.totals === 0) {
        self.payButtonDisable = true;
      } else {
        self.payButtonDisable = false;
      }
    },

    // 校验是否在缴费期中
    checkTerm: function checkTerm() {
      var self = this;
      var termInfo = this.modeSelectList.filter(function (element) {
        return element.typeId === 'CM_OldStuPayTime';
      });
      self.payTerm.stdt = termInfo[0].field2;
      self.payTerm.endt = termInfo[0].field3;
      self.payTerm.academicYear = termInfo[0].modeValue.substring(0, 4);
      self.viewForm.academicYear = termInfo[0].modeValue;
      var newDate = self.Ginkgo.dateToInt(new Date());
      if (newDate >= self.payTerm.stdt && newDate <= self.payTerm.endt) {
        self.global.curUser.schoolYear = termInfo[0].modeValue.substring(0, 4);
        self.payTerm.isPayTerm = '1'; // 是在缴费期内
        self.checkTermMode('0');
      } else {
        if (!termInfo[0].field4) {
          self.termMsg = '不在缴费期内';
        } else {
          self.termMsg = termInfo[0].field4;
        }
        self.payTerm.isPayTerm = '0';
        console.log('payTerm:', self.payTerm);
        self.setVisible('02');
      }
    },
    toLoan: function toLoan() {
      // 登录页面
      this.$router.push('/LoanXiFan');
      this.route = [{ path: '/LoanXiFan', component: __webpack_require__(277), meta: { title: '生源地贷款' } }];
      this.$router.addRoutes(this.route);
    },
    // 校验学期数据字典
    checkTermMode: function checkTermMode(type) {
      var termRow = this.modeSelectList.filter(function (element) {
        return element.typeId === 'Term_XF' && element.modeId === type;
      })[0];
      console.log('termRow', termRow);
      this.viewForm.term = termRow.modeId;
      this.viewForm.termNM = termRow.modeName;
      this.payTerm.term = termRow.modeId;
      console.log('viewForm', this.viewForm);
      if (this.global.curStudent.isYearFee === '1') {
        // 学年缴费
        this.billGetNew();
      } else {
        this.billGet();
      }
    },
    // 校验老生导入费用是否在缴费期中
    checkTermOldStuImp: function checkTermOldStuImp() {
      var self = this;
      var termInfo = this.modeSelectList.filter(function (element) {
        return element.typeId === 'CM_OldStuImpPayTime';
      });
      console.log('termInfo:', termInfo);
      var stdt = termInfo[0].field2;
      var endt = termInfo[0].field3;
      var newDate = self.Ginkgo.dateToInt(new Date());
      if (newDate >= stdt && newDate <= endt) {
        self.setVisible('04');
        self.examBillGet();
      } else {
        if (!termInfo[0].field4) {
          self.termMsg = '不在缴费期内';
        } else {
          self.termMsg = termInfo[0].field4;
        }
        self.setVisible('02');
      }
    },
    // 新收费方式
    billGetNew: function billGetNew() {
      // 账单查询
      var self = this;
      // 初始化
      var request = {};
      request.idIf = '60';
      request.deptId = self.global.deptId;
      request.itemList = [{ paramName: 'studentNo', paramValue: self.global.curStudent.studentNo }, { paramName: 'studYear', paramValue: self.payTerm.academicYear }, { paramName: 'studTerm', paramValue: '0' }];
      this.axios.post('/iif/accessIfForHttp', request).then(function (response) {
        if (response.data.result.success === true) {
          var obj = response.data.responseObj;
          if (obj.result.success === true) {
            // 已缴费
            var studBill = obj.studBillList.filter(function (item) {
              return item.feeNo === 'SF01';
            })[0];
            if (studBill.feeAmount > 0 && studBill.paidfeeAmount === studBill.feeAmount) {
              self.termMsg = '已缴费！';
              self.setVisible('02');
            } else if (studBill.paidfeeAmount > 0) {
              self.termMsg = '账单设置不正确，存在已交金额，请联系学校！';
              self.setVisible('02');
            } else {
              if (self.global.isLoan === '1') {
                self.global.isLoan = '0';
                self.setVisible('01');
                self.feeData = obj.studBillList;
                self.reduceGet();
              } else {
                // 进入贷款页面
                self.toLoan();
              }
            }
          } else {
            self.termMsg = obj.result.msg;
            self.setVisible('02');
          }
        } else {
          self.$alert(response.data.result.msg);
        }
      }, function (response) {}).catch(function (error) {
        console.log(error);
      });
    },
    billGet: function billGet() {
      // 账单查询
      var self = this;
      // 初始化
      var request = {};
      request.idIf = '60';
      request.deptId = self.global.deptId;
      request.itemList = [{ paramName: 'studentNo', paramValue: self.global.curStudent.studentNo }, { paramName: 'studYear', paramValue: self.payTerm.academicYear }, { paramName: 'studTerm', paramValue: '0' }];
      this.axios.post('/iif/accessIfForHttp', request).then(function (response) {
        if (response.data.result.success === true) {
          var obj = response.data.responseObj;
          if (obj.result.success === true) {
            self.feeList = obj.studBillList;
            var studBill = obj.studBillList.filter(function (item) {
              return item.feeNo === 'SF01';
            })[0];
            // 选学期未缴费
            if (studBill.paidfeeAmount === 0) {
              if (self.global.isLoan === '0') {
                // 进入贷款页面
                self.toLoan();
              } else {
                // 显示账期选择
                self.global.isLoan = '0';
                self.backVisible = true;
                self.setVisible('07');
              }
            }
            // 第二学期
            if (studBill.paidfeeAmount > 0 && studBill.paidfeeAmount < studBill.feeAmount) {
              // 先校验欠费金额
              var termRow = self.modeSelectList.filter(function (element) {
                return element.typeId === 'Term_XF' && element.modeId === '1';
              })[0];
              console.log('termRow', termRow);
              self.viewForm.term = termRow.modeId;
              self.viewForm.termNM = termRow.modeName;
              self.payTerm.term = termRow.modeId;
              self.queryOrderInfoXiFan('1');
            }
            // 已缴费
            if (studBill.paidfeeAmount === studBill.feeAmount) {
              self.termMsg = '已缴费！';
              self.setVisible('02');
            }
          } else {
            self.termMsg = obj.result.msg;
            self.setVisible('02');
          }
        } else {
          self.$alert(response.data.result.msg);
        }
      }, function (response) {}).catch(function (error) {
        console.log(error);
      });
    },
    // 下一步 显示账单
    nextFee: function nextFee() {
      var self = this;
      this.feeData = [];
      // 选学年
      if (this.radio === '0') {
        this.feeData = this.feeList;
        this.reduceGet();
        this.setVisible('01');
      }
      // 选学期
      if (this.radio === '1') {
        // 显示账单
        var tmpList = [];
        var feeListTemp = this.Ginkgo.cloneObj(this.feeList);
        feeListTemp.forEach(function (ele) {
          if (ele.feeNo === 'SF01' || ele.feeNo === 'SF02') {
            ele.feeAmount = ele.feeAmount / 2;
            tmpList.push(ele);
          } else {
            tmpList.push(ele);
          }
        });
        self.feeData = tmpList;
        self.reduceGet();
        self.setVisible('01');
        // 新增西翻账单
        self.addOrderInfoXiFan();
      }
    },
    // 获取订单信息
    queryOrderInfoXiFan: function queryOrderInfoXiFan(term) {
      var self = this;
      if (true) {
        this.axios.post('/college/getStudBillXiFan', {
          studNo: self.global.curStudent.studentNo,
          studYear: self.payTerm.academicYear,
          studTerm: term
        }).then(function (response) {
          if (response.data.result.success === true) {
            var feeList = response.data.studBillXiFanList;
            if (feeList.length !== 0) {
              var feeAmountSum = 0;
              var feeAmountSum2 = 0;
              // 本地库账单
              for (var index = 0; index < feeList.length; index++) {
                feeAmountSum = feeAmountSum + Number(feeList[index].feeAmount);
              }
              // 西翻库账单
              for (var _index = 0; _index < self.feeList.length; _index++) {
                if (self.feeList[_index].feeNo === 'SF01' || self.feeList[_index].feeNo === 'SF02') {
                  feeAmountSum2 = feeAmountSum2 + (Number(self.feeList[_index].feeAmount) - Number(self.feeList[_index].paidfeeAmount));
                }
              }
              if (feeAmountSum === feeAmountSum2) {
                self.feeData = feeList;
                self.reduceGet();
                self.setVisible('01');
              } else {
                self.termMsg = '欠费金额有变动，请联系学校！';
                self.setVisible('02');
              }
            } else {
              self.termMsg = '找不到本地订单！';
              self.setVisible('02');
            }
          } else {
            self.$alert('Error 服务异常！');
          }
        }, function (response) {}).catch(function (error) {
          console.log(error);
        });
      }
    },
    // 新增订单信息
    addOrderInfoXiFan: function addOrderInfoXiFan() {
      var self = this;
      var tmpList = [];
      var tmpRow = {};
      var feeListTemp = this.Ginkgo.cloneObj(this.feeList);
      feeListTemp.forEach(function (ele) {
        tmpRow = {};
        tmpRow.studNo = self.global.curStudent.studentNo;
        tmpRow.studYear = ele.studYear;
        tmpRow.studTerm = '0';
        tmpRow.feeNo = ele.feeNo;
        tmpRow.feeName = ele.feeName;
        if (ele.feeNo === 'SF01' || ele.feeNo === 'SF02') {
          tmpRow.feeAmount = ele.feeAmount / 2;
        } else {
          tmpRow.feeAmount = ele.feeAmount;
        }
        tmpList.push(tmpRow);
        if (ele.feeNo === 'SF01' || ele.feeNo === 'SF02') {
          tmpRow = {};
          tmpRow.studNo = self.global.curStudent.studentNo;
          tmpRow.studYear = ele.studYear;
          tmpRow.studTerm = '1';
          tmpRow.feeNo = ele.feeNo;
          tmpRow.feeName = ele.feeName;
          tmpRow.feeAmount = ele.feeAmount / 2;
          tmpList.push(tmpRow);
        }
      });
      if (true) {
        this.axios.post('/college/addStudBillXiFan', tmpList).then(function (response) {
          if (response.data.result.success === true) {
            console.log('订单新增成功');
          }
        }, function (response) {}).catch(function (error) {
          console.log(error);
        });
      }
    },
    // 减免账单查询
    reduceGet: function reduceGet() {
      if (true) {
        var self = this;
        self.axios.get('/college/getOrderInfoXiFan', { params: {
            deptId: self.global.deptId,
            term: '',
            keyInfo: self.global.curStudent.studentNo,
            statusCode: '02',
            field1: '',
            field2: '减免',
            field3: '',
            field4: self.viewForm.academicYear,
            field5: '',
            field6: '',
            field7: '',
            field8: '',
            field9: '',
            field10: ''
          } }).then(function (response) {
          if (response.data.result.success === true) {
            self.reduceList = response.data.orderInfoList;
            self.viewForm.payableAmount = 0;
            self.viewForm.feeAmount = 0;
            self.viewForm.reduceAmount = 0;
            for (var index = 0; index < self.feeData.length; index++) {
              self.viewForm.payableAmount = self.viewForm.payableAmount + Number(self.feeData[index].feeAmount);
              self.viewForm.feeAmount = self.viewForm.feeAmount + Number(self.feeData[index].feeAmount);
            }
            if (self.reduceList.length !== 0) {
              // 如果减免账单不为空，根据减免信息计算实缴金额
              for (var _index2 = 0; _index2 < self.reduceList.length; _index2++) {
                self.viewForm.feeAmount = self.viewForm.feeAmount - Math.abs(Number(self.reduceList[_index2].feeAmount));
                self.viewForm.reduceAmount = self.viewForm.reduceAmount + Number(self.reduceList[_index2].feeAmount);
              }
              console.log('self.viewForm:', self.viewForm);
            }
            if (self.viewForm.feeAmount < 0) {
              self.$alert('实缴金额为负值！');
              self.payButtonDisable = true;
            } else if (self.viewForm.feeAmount === 0) {
              self.$alert('实缴金额为0！');
              self.payButtonDisable = true;
            } else {
              self.payButtonDisable = false;
            }
          }
        }, function (response) {}).catch(function (error) {
          console.log(error);
        });
      }
    },
    toPay: function toPay() {
      this.checkPayTime();
    },
    checkPayTime: function checkPayTime() {
      var self = this;
      // self.buttonLoad = true
      self.axios.get('/pay/checkToPay', { params: {
          deptId: self.global.deptId // 1000003
        } }).then(function (response) {
        if (response.data.return_msg === 'SUCCESS') {
          if (self.feeType === '01') {
            // 学期缴费创建订单
            self.createOrderInfo();
          } else {
            // 考试缴费
            self.unionPay();
          }
          // self.buttonLoad = false
        } else {
          // self.buttonLoad = false
          self.$alert(response.data.prop);
        }
      }, function (response) {}).catch(function (error) {
        console.log(error);
      });
    },
    // 生成订单信息
    createOrderInfo: function createOrderInfo() {
      var _this = this;

      var self = this;
      var orderInfoList = [];
      this.termList = [];
      this.feeData.forEach(function (element) {
        var orderInfo = _this.Ginkgo.resetForm(_this.uiSetItemList, 'tbIf_Order_Info_Common');
        orderInfo.id = 0;
        orderInfo.transDt = 0;
        orderInfo.term = _this.Ginkgo.getTimeStamp() + _this.viewForm.academicYear + _this.viewForm.term + element.feeName; // 处理账期
        orderInfo.statusCode = '02'; // 初始核准状态
        orderInfo.field12 = '01'; // 老生学期缴费
        orderInfo.deptId = self.global.deptId;
        orderInfo.keyInfo = _this.viewForm.studentNo;
        orderInfo.field1 = _this.viewForm.studentName;
        orderInfo.field2 = _this.viewForm.majorMatr;
        orderInfo.field3 = _this.viewForm.className;
        orderInfo.field4 = _this.viewForm.academicYear;
        orderInfo.field5 = _this.viewForm.term;
        orderInfo.field6 = _this.viewForm.termNM;
        orderInfo.field7 = _this.viewForm.enrollmentYear;
        orderInfo.field8 = _this.viewForm.trainingLevel;
        orderInfo.field9 = _this.viewForm.deptName;
        orderInfo.feeNo = element.feeName;
        orderInfo.field10 = element.feeNo;
        orderInfo.payableAmount = element.feeAmount;
        orderInfo.feeAmount = element.feeAmount;
        orderInfo.remark = '银行数据导入';
        orderInfo.idIf = 60;
        orderInfoList.push(orderInfo);
        _this.termList.push(orderInfo.term);
      });
      if (this.reduceList.length > 0) {
        this.reduceList.forEach(function (ele) {
          self.termList.push(ele.term);
        });
      }
      this.axios.post('/iif/addOrderInfoList', orderInfoList).then(function (response) {
        if (response.data.result.success === true) {
          self.unionPay();
          // self.buttonLoad = false
        } else {
          // self.buttonLoad = false
          self.$alert('生成账单失败！');
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    unionPay: function unionPay() {
      var self = this;
      var validType = '01';
      if (this.feeType === '01') {
        // 学期缴费
        validType = '02';
      }
      self.axios.post('/pay/toPay', {
        keyInfo: self.viewForm.studentNo,
        deptId: self.global.deptId,
        payType: self.payTypeUnion,
        feeTermList: self.termList,
        channelType: '02',
        validType: validType
      }).then(function (response) {
        // self.buttonLoad = false
        if (response.data.result.success === true) {
          var payUrl = self.global.payUrl + 'pay/doPay?' + 'payType=' + self.payTypeUnion + '&orderNo=' + response.data.orderNo + '&deptId=' + response.data.deptId + '&openId=&payChannel=02';
          window.location.href = payUrl;
        } else {
          self.$alert(response.data.result.msg);
        }
      }).catch(function (error) {
        // self.buttonLoad = false
        console.log(error);
      });
    },
    showWechatImg: function showWechatImg() {
      this.dialogFormVisible = true;
    },
    handleSelect: function handleSelect(index, indexPath) {
      if (true) {
        if (index === '/MyBill') {
          this.feeType = '01';
          if (this.payTerm.isPayTerm === '1') {
            this.viewForm.totals = 0;
            this.viewForm.feeAmount = 0;
            this.viewForm.reduceAmount = 0;
            this.viewForm.payableAmount = 0;
            this.feeData = [];
            this.setVisible('01');
            this.checkTermMode('0');
          } else {
            this.setVisible('02');
          }
        }
        if (index === '/MyBillExam') {
          this.feeType = '02';
          this.viewForm.totals = 0;
          this.feeData = [];
          this.checkTermOldStuImp();
        }
        if (index === '/MyBillHistory') {
          this.tableData = [];
          this.setVisible('03');
          this.getHistoryByType('01');
        }
        if (index === '/MyBillHistoryExam') {
          this.tableData = [];
          this.setVisible('06');
          this.getHistoryByType('02');
        }
        if (index === '/Card') {
          this.$router.push('/card');
          this.route = [{ path: '/card', component: __webpack_require__(151), meta: { title: '银行卡信息维护' } }];
          this.$router.addRoutes(this.route);
        }
        if (index === '/Exit') {
          this.$router.push('/LoginXiFan');
          this.route = [{ path: '/LoginXiFan', component: __webpack_require__(69), meta: { title: '缴费登录' } }];
          this.$router.addRoutes(this.route);
        }
      } else {
        if (index === '/MyBill') {
          this.setVisible('02');
        }
        if (index === '/Exit') {
          this.$router.push('/LoginXiFan');
          this.route = [{ path: '/LoginXiFan', component: require('./LoginXiFan.vue'), meta: { title: '缴费登录' } }];
          this.$router.addRoutes(this.route);
        }
      }
    },
    // 获取学生历史缴费信息
    getHistory: function getHistory() {
      if (true) {
        var self = this;
        var request = {};
        request.deptId = self.global.deptId;
        request.keyInfo = self.global.curStudent.studentNo;
        var str = (0, _stringify2.default)(request);
        this.axios.post('/iif/getOrderInfoForHistoryByEncrypt', this.Ginkgo.encrypt(str)).then(function (response) {
          var backJson = JSON.parse(self.Ginkgo.rsaDecrypt(response.data));
          if (backJson.result.success === true) {
            self.orderInfoList = backJson.orderInfoList;
          }
        }, function (response) {}).catch(function (error) {
          console.log(error);
        });
      } else {
        this.uiSetItemList = [{ uiSetId: 'tbIf_Order_Info_XiFan', columnName: 'transDt', columnDesc: '日期', columnProp: 'transDt', isVisible: '1', isVisibleDesc: '', sortNo: '99', queryCondition: '0', queryConditionDesc: '', sortNoQuery: '99', controlType: '02', controlTypeDesc: '', typeId: 'Dept_Type_KD', defaultValue: '01', required: '0', requiredDesc: '', isUnique: '0', isUniqueDesc: '', dataType: '01', dataTypeDesc: '', newDisabled: '0', editDisabled: '0', editDisabledDesc: '', queryVisible: '1', queryVisibleDesc: '', sortNoResult: '11', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '0', isFixColDesc: '', colWidth: '120', isCross: '0', isCrossDesc: '', isGroupStart: '1', isGroupStartDesc: '' }, { uiSetId: 'tbIf_Order_Info_XiFan', columnName: 'feeAmount', columnDesc: '费用', columnProp: 'feeAmount', isVisible: '1', isVisibleDesc: '', sortNo: '99', queryCondition: '0', queryConditionDesc: '', sortNoQuery: '99', controlType: '02', controlTypeDesc: '', typeId: 'Dept_Type_KD', defaultValue: '01', required: '0', requiredDesc: '', isUnique: '0', isUniqueDesc: '', dataType: '01', dataTypeDesc: '', newDisabled: '0', editDisabled: '0', editDisabledDesc: '', queryVisible: '1', queryVisibleDesc: '', sortNoResult: '11', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '0', isFixColDesc: '', colWidth: '120', isCross: '0', isCrossDesc: '', isGroupStart: '1', isGroupStartDesc: '' }, { uiSetId: 'tbIf_Order_Info_XiFan', columnName: 'orderNo', columnDesc: '订单号', columnProp: 'orderNo', isVisible: '1', isVisibleDesc: '', sortNo: '99', queryCondition: '0', queryConditionDesc: '', sortNoQuery: '99', controlType: '02', controlTypeDesc: '', typeId: 'Dept_Type_KD', defaultValue: '01', required: '0', requiredDesc: '', isUnique: '0', isUniqueDesc: '', dataType: '01', dataTypeDesc: '', newDisabled: '0', editDisabled: '0', editDisabledDesc: '', queryVisible: '1', queryVisibleDesc: '', sortNoResult: '11', alignType: 'left', formatString: '', columnType: '01', buttonType: '', commandName: '', isFixCol: '0', isFixColDesc: '', colWidth: '120', isCross: '0', isCrossDesc: '', isGroupStart: '1', isGroupStartDesc: '' }];
        this.orderInfoList = [{ transDt: '20180730', feeAmount: 100, orderNo: 'xxxxxxxxxxxxxxxx' }];
        this.page.totalElements = this.orderInfoList.length;
        this.loadCurrentPageHistory();
        this.setVisible('03');
      }
    },
    // 根据费用类型获取对应的缴费历史记录
    getHistoryByType: function getHistoryByType(type) {
      var self = this;
      this.orderInfoListByType = this.orderInfoList.filter(function (item) {
        return item.field12 === type;
      });
      // 首次默认排序
      self.handleSortChangeHistory(self.sort);
      // 分页处理
      self.page.totalElements = self.orderInfoListByType.length;
      self.loadCurrentPageHistory();
      // 设置当前选中行
      self.setCurrentRowHistory();
    },
    // 获取考试缴费账单
    examBillGet: function examBillGet() {
      if (true) {
        var self = this;
        self.axios.get('/iif/getOrderInfoCheck', { params: {
            deptId: self.global.deptId,
            keyInfo: self.global.curStudent.studentNo
          } }).then(function (response) {
          if (response.data.result.success === true) {
            if (response.data.orderInfoList.length > 0) {
              self.feeData = response.data.orderInfoList.filter(function (item) {
                return item.field12 === '02';
              });
              for (var index = 0; index < self.feeData.length; index++) {
                self.feeData[index].field6 = false;
              }
            } else {
              self.payButtonDisable = true;
            }
          }
        }, function (response) {}).catch(function (error) {
          console.log(error);
        });
      }
    },
    // 获取查询结果配置
    getUISetQueryResult: function getUISetQueryResult(form) {
      var setId = form === '01' ? 'tbIf_Order_Info_XiFan' : 'tbIf_Order_Info_XiFan_Exam';
      var sort = { prop: 'sortNoResult', order: 'ascending' };

      var list = this.uiSetItemList.filter(function (element) {
        return element.uiSetId === setId && element.queryVisible === '1';
      });

      return this.Ginkgo.sortList(list, sort);
    },
    // 列数据格式化
    dataFormatHistory: function dataFormatHistory(row, column, cellValue) {
      var columnProp = column.property;
      // 根据列的property(绑定的字段属性)回查列设置
      var formatString = this.getUISetQueryResult('01').filter(function (element) {
        return element.columnProp === columnProp;
      })[0].formatString;

      return this.Ginkgo.format(cellValue, formatString);
    },
    dataFormatExamHistory: function dataFormatExamHistory(row, column, cellValue) {
      var columnProp = column.property;
      // 根据列的property(绑定的字段属性)回查列设置
      var formatString = this.getUISetQueryResult('02').filter(function (element) {
        return element.columnProp === columnProp;
      })[0].formatString;

      return this.Ginkgo.format(cellValue, formatString);
    },
    // 列可见性
    getHeaderVisible: function getHeaderVisible(item, level, fixed) {
      return this.Ginkgo.getHeaderVisible(item, level, fixed);
    },
    // 获取同组记录
    getHeaderGroup: function getHeaderGroup(item, level, form) {
      return this.Ginkgo.getHeaderGroup(item, level, this.getUISetQueryResult(form));
    },
    // 排序(参数var={prop,order}) order: ascending  descending
    handleSortChangeHistory: function handleSortChangeHistory(val) {
      this.sort = val;
      var sorts = this.Ginkgo.cloneObj(this.sortSet);
      sorts.pop(); // 删除最后一个对象（最后一个对象根据界面列点击改变）
      sorts.push(val);
      this.orderInfoListByType = this.Ginkgo.sort(this.orderInfoListByType, sorts);
      this.loadCurrentPageHistory();
    },
    // 选中当前行
    setCurrentRowHistory: function setCurrentRowHistory() {
      if (this.currentIndex !== -1) {
        this.$refs.resultTable.setCurrentRow(this.tableData[this.currentIndex]);
      }
    },
    // 加载当前页内容
    loadCurrentPageHistory: function loadCurrentPageHistory() {
      this.tableData = this.orderInfoListByType.slice(this.page.number * this.page.size, (this.page.number + 1) * this.page.size);
    },
    // 查询结果每页显示条数改变事件
    handleSizeChangeHistory: function handleSizeChangeHistory(val) {
      this.page.size = val;
      this.loadCurrentPageHistory();
    },
    // 页码改变事件
    handleCurrentChangeHistory: function handleCurrentChangeHistory(val) {
      this.page.number = val - 1;
      this.loadCurrentPageHistory();
    }
  }
};

/***/ }),

/***/ 660:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'OfflinePay',
  data: function data() {
    return {
      curStudent: {},
      applyList: []
    };
  },
  mounted: function mounted() {
    this.curStudent = this.global.curStudent;
    this.loadApplyList();
  },
  methods: {
    handleSelect: function handleSelect(index) {
      var self = this;
      if (index === '/MyBill') {
        self.$router.push('/myBillXiFanNew');
      } else if (index === '/OfflinePay') {
        // 已经在当前页面,不需要跳转
      } else if (index === '/Exit') {
        self.$router.push('/');
      }
    },
    // 加载申请记录
    loadApplyList: function loadApplyList() {
      var self = this;
      self.axios.post('/pay/queryAllFeeApply', {
        uid: self.curStudent.uid
      }).then(function (response) {
        if (response.data.result.success) {
          self.applyList = response.data.applyList || [];
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    // 状态码转中文
    formatStatus: function formatStatus(code) {
      var map = {
        '00': '已通过',
        '01': '待审核',
        '02': '已拒绝/失效'
      };
      return map[code] || code;
    },
    // 状态标签类型
    getStatusTagType: function getStatusTagType(dataStatus) {
      var map = {
        '00': 'success',
        '01': 'warning',
        '02': 'danger'
      };
      return map[dataStatus] || 'default';
    },
    // 格式化时间
    formatTime: function formatTime(time) {
      if (!time || time.length < 14) return time || '';
      return time.substring(0, 4) + '-' + time.substring(4, 6) + '-' + time.substring(6, 8) + ' ' + time.substring(8, 10) + ':' + time.substring(10, 12) + ':' + time.substring(12, 14);
    }
  }
};

/***/ }),

/***/ 661:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _noticeBar = __webpack_require__(148);

var _noticeBar2 = _interopRequireDefault(_noticeBar);

__webpack_require__(149);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'Card',
  components: { vanNoticeBar: _noticeBar2.default },
  data: function data() {
    var _this = this;

    var validateBankCard = function validateBankCard(rule, value, callback) {
      if (!_this.Ginkgo.validateBankCard(value)) {
        callback(new Error('银行卡号格式有误!'));
      } else {
        callback();
      }
    };
    var validateBankNo = function validateBankNo(rule, value, callback) {
      if (!_this.Ginkgo.validateBankNo(value)) {
        callback(new Error('开户行联行号格式有误!'));
      } else {
        callback();
      }
    };
    return {
      mainVisible: true,
      formVisible: false,
      cardList: [],
      form: {
        acnm: '',
        acno: '',
        bankNm: '',
        bankNo: ''
      },
      rules: {
        'acnm': [{ required: true, message: '请输入账户名称', trigger: 'blur' }],
        'acno': [{ required: true, message: '请输入账户号', trigger: 'blur' }, { validator: validateBankCard, trigger: 'blur' }],
        'bankNm': [{ required: true, message: '请输入开户行', trigger: 'blur' }],
        'bankNo': [{ required: true, message: '请输入开户行联行号', trigger: 'blur' }, { validator: validateBankNo, trigger: 'blur' }]
      }
    };
  },
  mounted: function mounted() {
    if (true) {
      var self = this;
      // 判断学号信息
      if (this.global.curStudent.studentNo === '') {
        // 提醒没缴费，先去缴费
        self.$confirm('您还未缴费，是否进行缴费!', '提示', {
          confirmButtonText: '确定'
        }).then(function () {
          self.$router.push('/myBillXiFanNew');
          self.route = [{ path: '/myBillXiFanNew', component: __webpack_require__(150), meta: { title: '新生缴费页面' } }];
          self.$router.addRoutes(self.route);
        }).catch(function () {
          self.$router.go(-1);
          // self.$router.push('/newStudent')
        });
      } else {
        // 查学生银行卡信息
        self.query();
      }
    }
  },
  methods: {
    handleSelect: function handleSelect(index, indexPath) {
      if (index === '/Exit') {
        this.$router.push('/LoginXiFan');
      }
      if (index === '/Index') {
        this.$router.go(-1);
      }
    },
    query: function query() {
      var self = this;
      var obj = {};
      obj.studentNo = this.global.curStudent.studentNo;
      this.axios.post('/college/getStudentCard', obj).then(function (response) {
        if (response.data.result.success === true) {
          self.cardList = response.data.dataList;
          self.cardList.forEach(function (item) {
            item.acnoformat = self.formatBankCard(item.acno);
          });
        } else {
          self.$alert('银行卡信息查询失败！' + response.data.result.msg);
        }
      }, function (response) {}).catch(function (error) {
        console.log(error);
      });
    },
    handleClick: function handleClick(val) {
      var self = this;
      if (val === 'save') {
        if (this.cardList.length > 0) {
          self.$alert('目前仅支持添加一张银行卡！');
        } else {
          self.setVisible('02');
        }
      } else {
        if (this.cardList.length > 0 && this.cardList[0].isEdit === '00') {
          var obj = self.Ginkgo.cloneObj(this.cardList[0]);
          self.$refs['form'].resetFields();
          self.form.acnm = obj.acnm;
          self.form.acno = obj.acno;
          self.form.bankNm = obj.bankNm;
          self.form.bankNo = obj.bankNo;
          self.setVisible('02');
        } else {
          self.$alert('当前银行卡信息不支持修改！');
        }
      }
    },
    save: function save() {
      var _this2 = this;

      var self = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this2.form.studentName = _this2.global.curStudent.studentName;
          _this2.form.studentNo = _this2.global.curStudent.studentNo;
          _this2.form.uid = _this2.global.curStudent.uid;
          _this2.form.dataDt = _this2.Ginkgo.getTimeStamp(new Date());
          _this2.form.statusCode = '00';
          _this2.form.isEdit = '00';
          _this2.axios.post('/college/saveStudentCard', _this2.form).then(function (response) {
            if (response.data.result.success === true) {
              self.query();
              self.setVisible('01');
              self.$message({ type: 'success', message: '银行卡信息维护成功!' });
            } else {
              self.$alert('银行卡信息维护失败！' + response.data.result.msg);
            }
          }, function (response) {}).catch(function (error) {
            console.log(error);
          });
        }
      });
    },
    setVisible: function setVisible(showType) {
      if (showType === '01') {
        // 银行卡展示页面
        this.mainVisible = true;
        this.formVisible = false;
      } else if (showType === '02') {
        // 表单页面
        this.mainVisible = false;
        if (!this.form.acnm || this.form.acnm === '') {
          this.form.acnm = this.global.curStudent.studentName;
        }
        this.formVisible = true;
      }
    },
    formatBankCard: function formatBankCard(cardNo) {
      // 先去除所有非数字字符，避免干扰
      var pureCard = cardNo.replace(/\D/g, '');
      // 每4位加空格，最后去除末尾空格
      return pureCard.replace(/(\d{4})(?=\d)/g, '$1 ').trim();
    }
  }
};

/***/ }),

/***/ 662:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _decimal = __webpack_require__(906);

var _decimal2 = _interopRequireDefault(_decimal);

var _vueQr = __webpack_require__(193);

var _vueQr2 = _interopRequireDefault(_vueQr);

var _noticeBar = __webpack_require__(148);

var _noticeBar2 = _interopRequireDefault(_noticeBar);

__webpack_require__(149);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'receive',
  components: { vueQr: _vueQr2.default, vanNoticeBar: _noticeBar2.default },
  data: function data() {
    return {
      curStudent: [],
      mainVisible: false,
      tipVisible: false,
      printVisible: false,

      tipText: '',
      dormOrderInfo: {},
      dormModeSelectList: {}, // 选中的数据字典
      claimApplyList: [], // 已经提交的领用单

      modeSelectList: [],
      dormConfigList: [], // 公寓用品字典
      dormConfigCheckList: [], // 公寓用品已选择
      checkMoney: 0,
      refundMoney: 0,

      cardInfo: [],
      form: {
        id: '',
        acnm: '',
        acno: '',
        bankNm: ''
      },
      dormRow: {}, // 床位信息
      isClaim: '', // 领用状态
      isApplyTime: false // 是否在领用期
    };
  },
  mounted: function mounted() {
    var self = this;
    if (true) {
      this.curStudent = this.global.curStudent;
      this.getMode();
      this.isApplyTime = this.getIsApplyTime();
      // 判断是否在公寓用品领用时间
      if (!this.isApplyTime) {
        // 不在领用期直接查领用历史
        this.getClaimApply();
      } else {
        // 校验学生是否已经缴费
        this.axios.all([this.getStudentCard(), this.validOrderInfo()]).then(this.axios.spread(function (card, order) {
          if (card.data.result.success === true) {
            self.cardInfo = card.data.dataList;
            if (self.cardInfo.length > 0) {
              self.form = self.cardInfo[0];
            }
          }
          if (order.data.result.success === true) {
            if (order.data.orderInfoList.length > 0) {
              // 有缴费记录
              self.dormOrderInfo = order.data.orderInfoList.filter(function (item) {
                return item.feeNo === '宿舍用品费';
              })[0];
              self.getClaimApply();
            } else {
              // 提醒没缴费，先去缴费
              self.$confirm('您还未缴费，是否进行缴费!', '提示', {
                confirmButtonText: '确定'
              }).then(function () {
                self.$router.push('/myBillXiFanNew');
                self.route = [{ path: '/myBillXiFanNew', component: __webpack_require__(150), meta: { title: '新生缴费页面' } }];
                self.$router.addRoutes(self.route);
              }).catch(function () {
                self.$router.go(-1);
              });
            }
          } else {
            self.$alert('系统错误！' + order.data.result.msg);
          }
        }));
      }
    }
  },
  watch: {
    tabSelected: 'handleSelect',
    'dormConfigCheckList': 'handleCheck'
  },
  methods: {
    // 判断是否在公寓用品领用时间
    getIsApplyTime: function getIsApplyTime() {
      var self = this;
      var receiveInfo = self.modeSelector('CM_Block_Receive_Time').filter(function (item) {
        return item.modeValue.substring(0, 4) === self.curStudent.enrollmentYear.toString();
      });
      if (receiveInfo.length > 0) {
        self.tipText = receiveInfo[0].field4;
        var newDate = self.Ginkgo.dateToInt(new Date());
        if (newDate >= receiveInfo[0].field2 && newDate <= receiveInfo[0].field3) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    handleSelect: function handleSelect(index, indexPath) {
      if (index === '/Exit') {
        this.$router.push('/LoginXiFan');
      } else if (index === '/Index') {
        this.$router.go(-1);
      }
    },
    // 查是否维护银行卡信息
    getStudentCard: function getStudentCard() {
      // var self = this
      var obj = {};
      obj.studentName = this.global.curStudent.studentName;
      obj.studentNo = this.global.curStudent.studentNo;
      return this.axios.post('/college/getStudentCard', obj);
    },
    validOrderInfo: function validOrderInfo() {
      return this.axios.post('/college/getXFOrderInfoForCheck', {
        field1: this.global.curStudent.studentName,
        keyInfo: this.global.curStudent.uid,
        field12: '04',
        statusCode: '00'
      });
    },
    // 查领用单
    getClaimApply: function getClaimApply() {
      var self = this;
      var obj = {};
      obj.studentName = this.global.curStudent.studentName;
      obj.studentNo = this.global.curStudent.studentNo;
      this.axios.post('/college/getClaim', obj).then(function (response) {
        if (response.data.result.success === true) {
          self.claimApplyList = response.data.dataList;
          // 计算退费
          self.refundMoney = 0;
          self.claimApplyList.forEach(function (item) {
            if (item.applyStatus === '01') {
              self.refundMoney = (0, _decimal2.default)(self.refundMoney).plus((0, _decimal2.default)(item.feeAmount)).toString();
            }
          });
          // 判断是否在领用期
          if (self.isApplyTime) {
            if (self.claimApplyList.length > 0) {
              self.isClaim = self.claimApplyList[0].isClaim;
              self.setVisible('01');
            } else {
              // 默认全选
              self.dormConfigList.forEach(function (element) {
                self.dormConfigCheckList.push(element.modeId);
              });
              // 显示公寓用品领取页面
              self.setVisible('00');
            }
          } else {
            if (self.claimApplyList.length > 0) {
              self.isClaim = self.claimApplyList[0].isClaim;
            }
            self.setVisible('01');
          }
        } else {
          self.$alert('领用单查询错误！' + response.data.result.msg);
        }
      });
    },
    // 初始化数据字典
    getMode: function getMode() {
      var self = this;
      self.modeSelectList = self.global.modeList;
      // 初始化公寓用品
      self.dormConfigList = self.modeSelectList.filter(function (item) {
        return item.typeId === 'Apart_Supply_Kind';
      });
      // 默认全选
      self.dormConfigList.forEach(function (element) {
        self.dormConfigCheckList.push(element.modeId);
      });
    },
    handleCheck: function handleCheck(val) {
      var _this = this;

      if (this.dormOrderInfo.feeAmount) {
        this.checkMoney = 0;
        this.refundMoney = 0;
        this.dormModeSelectList = this.dormConfigList.filter(function (item1) {
          return val.some(function (item2) {
            return item2 === item1.modeId;
          });
        });
        this.dormModeSelectList.forEach(function (item) {
          _this.checkMoney = (0, _decimal2.default)(_this.checkMoney).plus((0, _decimal2.default)(item.modeValue)).toString();
        });
        this.refundMoney = (0, _decimal2.default)(this.dormOrderInfo.feeAmount).minus((0, _decimal2.default)(this.checkMoney)).toString();
      }
    },
    submit: function submit() {
      // if (this.form.acno === '') {
      //   this.$confirm('银行卡信息为空，是否去维护银行卡信息!', '提示', {
      //     confirmButtonText: '确定'
      //   }).then(() => {
      //     this.$router.push('/card')
      //     this.route = [{ path: '/card', component: require('@/components/XiFan/NewStudent/card'), meta: { title: '银行卡信息维护页面' } }]
      //     this.$router.addRoutes(this.route)
      //   })
      // } else {
      //   this.doSubmit()
      // }
      this.doSubmit();
    },
    // 领取提交
    doSubmit: function doSubmit() {
      var _this2 = this;

      var self = this;
      var saveList = [];
      this.dormConfigList.forEach(function (item) {
        var obj = {};
        obj.studentName = _this2.global.curStudent.studentName;
        obj.studentNo = _this2.global.curStudent.studentNo;
        obj.applyTm = _this2.Ginkgo.getTimeStamp(new Date());
        obj.supplyId = item.modeId;
        obj.isClaim = '01';
        obj.dormNumber = _this2.dormOrderInfo.field13;
        obj.orderNo = _this2.dormOrderInfo.orderNo;
        // 判断是否领用
        if (_this2.dormConfigCheckList.includes(item.modeId)) {
          obj.applyStatus = '00';
        } else {
          obj.applyStatus = '01';
        }
        obj.cardId = _this2.form.id;
        saveList.push(obj);
      });
      this.axios.post('/college/saveClaimAll', saveList).then(function (response) {
        if (response.data.result.success === true) {
          self.getClaimApply();
        } else {
          self.$alert('提交失败！' + response.data.result.msg);
        }
      }, function (response) {}).catch(function (error) {
        console.log(error);
      });
    },
    update: function update() {
      var _this3 = this;

      this.dormConfigCheckList = [];
      this.claimApplyList.forEach(function (item) {
        if (item.applyStatus === '00') {
          _this3.dormConfigCheckList.push(item.supplyId);
        }
      });
      this.setVisible('00');
    },
    toPrint: function toPrint() {
      var self = this;
      self.axios.all([self.getDormList()]).then(self.axios.spread(function (dorm) {
        if (dorm.data.result.success === true) {
          self.dormRow = dorm.data.viXFDormOneList[0];
          // 计算退费
          self.refundMoney = 0;
          self.claimApplyList.forEach(function (item) {
            if (item.applyStatus === '01') {
              self.refundMoney = (0, _decimal2.default)(self.refundMoney).plus((0, _decimal2.default)(item.feeAmount)).toString();
            }
          });
          self.doPrint();
        }
      }));
    },
    doPrint: function doPrint() {
      var _this4 = this;

      var self = this;
      var codestr = '';
      self.$nextTick(function () {
        codestr = _this4.$refs.printContent.innerHTML;
      });
      this.$confirm('确定要打印学号为' + this.curStudent.studentNo + '，姓名为' + this.curStudent.studentName + '的公寓用品领用单吗?(请使用谷歌浏览器打印)', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var newWindow = window.open('_blank'); // 打开新窗口
        // 向文档写入HTML表达式或者JavaScript代码
        newWindow.document.write(codestr);
        newWindow.document.close(); // 关闭document的输出流, 显示选定的数据
        newWindow.print(); // 打印当前窗口
        setTimeout(newWindow.close(), 0);
        self.termMsg = '打印完成！';
        return true;
      }).catch(function (error) {
        console.log(error);
      });
    },
    // 获取学生所选床位
    getDormList: function getDormList() {
      var self = this;
      return self.axios.get('/college/getViXFDorm', { params: {
          bedId: self.dormOrderInfo.field13
        } });
    },
    setVisible: function setVisible(showType) {
      if (showType === '00') {
        // 首页
        this.mainVisible = true;
        this.tipVisible = false;
      } else if (showType === '01') {
        // 提示页
        this.mainVisible = false;
        this.tipVisible = true;
      } else if (showType === '02') {
        // 打印页
        this.tipVisible = false;
        this.printVisible = true;
      }
    },
    // 数据字典筛选器
    modeSelector: function modeSelector(typeId) {
      return this.modeSelectList.filter(function (element) {
        return element.typeId === typeId;
      });
    }
  }
};

/***/ }),

/***/ 663:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'PayType',
  data: function data() {
    return {
      // 控制参数
      buttonVisibleWX: false,
      buttonVisibleZFB: false,
      buttonVisibleUnion: false,
      buttonVisiblePFWX: false,
      buttonVisiblePFZFB: false,

      payType: '',
      payTypeZFB: '',
      payTypeUnion: '01',
      payTypePFWX: '',
      payTypePFZFB: '',
      // 图片
      wx: this.global.staticResourceAddr + 'gsvxifanvuem/' + this.global.theme + '/images/wx.png',
      yl: this.global.staticResourceAddr + 'gsvxifanvuem/' + this.global.theme + '/images/yl.png',
      zfb: this.global.staticResourceAddr + 'gsvxifanvuem/' + this.global.theme + '/images/zfb.png'
    };
  },
  mounted: function mounted() {
    console.log('merchantListForPay', this.global.merchantListForPay);
    if (this.global.merchantListForPay.length > 0) {
      this.setVisiblePayButton(this.global.merchantListForPay);
    }
  },
  methods: {
    back: function back() {
      this.$router.push({ path: '/' + this.global.toPayObj.sourcePage });
    },
    setVisiblePayButton: function setVisiblePayButton(merchantList) {
      var self = this;
      // 设置支付方式的显示隐藏
      self.buttonVisibleUnion = false;
      self.buttonVisibleWX = false;
      self.buttonVisibleZFB = false;
      self.buttonVisiblePFWX = false;
      self.buttonVisiblePFZFB = false;
      // 商户配置信息
      if (merchantList.length > 0) {
        merchantList.forEach(function (e) {
          if (e.payKind === '01') {
            // 银联
            self.payTypeUnion = e.payType;
            self.buttonVisibleUnion = true;
          }
          if (e.payKind === '02') {
            // 微信
            self.payType = e.payType;
            self.buttonVisibleWX = true;
          }
          if (e.payKind === '03') {
            // 支付宝
            self.payTypeZFB = e.payType;
            self.buttonVisibleZFB = true;
          }
          if (e.payKind === '07') {
            // 浦发新微信
            self.payTypePFWX = e.payType;
            self.buttonVisiblePFWX = true;
          }
          if (e.payKind === '08') {
            // 浦发新支付宝
            self.payTypePFZFB = e.payType;
            self.buttonVisiblePFZFB = true;
          }
        });
      }
    },
    // 支付
    doPay: function doPay(payType) {
      var self = this;
      var payUrl = '';
      // 根据不同支付方式访问不同的发起交易服务
      self.axios.post('/pay/toPay', {
        keyInfo: self.global.toPayObj.keyInfo,
        deptId: self.global.toPayObj.deptId,
        payType: payType,
        feeTermList: self.global.toPayObj.termList,
        validType: '02',
        userName: self.global.curStudent.studentName
      }).then(function (response) {
        if (response.data.result.success) {
          // 线下缴费：跳转到申请查询界面
          if (payType === '09') {
            self.$alert('申请提交成功！');
            self.route = [{ path: '/offlinePay', component: function component() {
                return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 122));
              }, meta: { title: '线下缴费' } }];
            self.$router.addRoutes(self.route);
            self.$router.push('/offlinePay');
            return;
          }
          var payKind = self.global.merchantListForPay.filter(function (item) {
            return item.payType === payType;
          })[0].payKind;
          if (payKind === '02') {
            // 微信支付
            payUrl += self.global.payUrl + 'pay/doPayForUrl?';
            payUrl += 'payType=' + payType;
            payUrl += '&orderNo=' + response.data.orderNo;
            payUrl += '&deptId=' + response.data.deptId;
            payUrl += '&openId=' + self.global.curUser.openId;
            payUrl += '&qrCodeType=' + 'WXPAY';
            payUrl += '&payChannel=01';
          } else if (payKind === '03') {
            // 支付宝
            payUrl += self.global.payUrl + 'pay/doPayForUrl?';
            payUrl += 'payType=' + payType;
            payUrl += '&orderNo=' + response.data.orderNo;
            payUrl += '&deptId=' + response.data.deptId;
            payUrl += '&openId=' + self.global.curUser.openId;
            payUrl += '&qrCodeType=' + 'ALIPAY';
            payUrl += '&payChannel=01';
          } else if (payKind === '07') {
            // 浦发微信支付 新版
            payUrl += self.global.payUrl + 'pay/doPayForUrl?';
            payUrl += 'payType=' + payType;
            payUrl += '&orderNo=' + response.data.orderNo;
            payUrl += '&deptId=' + response.data.deptId;
            payUrl += '&openId=' + self.global.curUser.openId;
            payUrl += '&qrCodeType=' + 'WXPAY';
            payUrl += '&payChannel=01';
          } else if (payKind === '08') {
            // 浦发支付宝支付 新版
            payUrl += self.global.payUrl + 'pay/doPayForUrl?';
            payUrl += 'payType=' + payType;
            payUrl += '&orderNo=' + response.data.orderNo;
            payUrl += '&deptId=' + response.data.deptId;
            payUrl += '&openId=' + self.global.curUser.openId;
            payUrl += '&qrCodeType=' + 'ALIPAY';
            payUrl += '&payChannel=01';
          } else {
            // 银联
            // 拼接支付地址
            payUrl += self.global.payUrl + 'pay/doPay?';
            payUrl += 'payType=' + payType;
            payUrl += '&orderNo=' + response.data.orderNo;
            payUrl += '&deptId=' + response.data.deptId;
            payUrl += '&openId=' + self.global.curUser.openId;
            payUrl += '&payChannel=01';
          }
          window.location.href = payUrl;
        } else {
          self.$alert(response.data.result.msg);
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
};

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1200)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(655),
  /* template */
  __webpack_require__(1268),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

},[1322]);


// WEBPACK FOOTER //
// js/app.1ed2200708fddf49f801.js